(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired5a1"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired5a1"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("e3ROS", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $a3cb17f824e5d730$export$ffb0004e005737fa; }, function (v) { return $a3cb17f824e5d730$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $a3cb17f824e5d730$export$34b9dba7ce09269b; }, function (v) { return $a3cb17f824e5d730$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $a3cb17f824e5d730$export$25062201e9e25d76; }, function (v) { return $a3cb17f824e5d730$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a3cb17f824e5d730$export$ffb0004e005737fa;
var $a3cb17f824e5d730$export$34b9dba7ce09269b;
var $a3cb17f824e5d730$export$25062201e9e25d76;
"use strict";

var $4rNTR = parcelRequire("4rNTR");
var $a3cb17f824e5d730$var$k = Symbol.for("react.element"), $a3cb17f824e5d730$var$l = Symbol.for("react.fragment"), $a3cb17f824e5d730$var$m = Object.prototype.hasOwnProperty, $a3cb17f824e5d730$var$n = $4rNTR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $a3cb17f824e5d730$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $a3cb17f824e5d730$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$a3cb17f824e5d730$var$m.call(a, b) && !$a3cb17f824e5d730$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $a3cb17f824e5d730$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $a3cb17f824e5d730$var$n.current
    };
}
$a3cb17f824e5d730$export$ffb0004e005737fa = $a3cb17f824e5d730$var$l;
$a3cb17f824e5d730$export$34b9dba7ce09269b = $a3cb17f824e5d730$var$q;
$a3cb17f824e5d730$export$25062201e9e25d76 = $a3cb17f824e5d730$var$q;

});
parcelRegister("4rNTR", function(module, exports) {
"use strict";

module.exports = (parcelRequire("b25UG"));

});
parcelRegister("b25UG", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $808477d741187731$export$dca3b0875bd9a954; }, function (v) { return $808477d741187731$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $808477d741187731$export$16fa2f45be04daa8; }, function (v) { return $808477d741187731$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $808477d741187731$export$ffb0004e005737fa; }, function (v) { return $808477d741187731$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $808477d741187731$export$e2c29f18771995cb; }, function (v) { return $808477d741187731$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $808477d741187731$export$221d75b3f55bb0bd; }, function (v) { return $808477d741187731$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $808477d741187731$export$5f8d39834fd61797; }, function (v) { return $808477d741187731$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $808477d741187731$export$74bf444e3cd11ea5; }, function (v) { return $808477d741187731$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $808477d741187731$export$ae55be85d98224ed; }, function (v) { return $808477d741187731$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $808477d741187731$export$e530037191fcd5d7; }, function (v) { return $808477d741187731$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $808477d741187731$export$fd42f52fd3ae1109; }, function (v) { return $808477d741187731$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $808477d741187731$export$c8a8987d4410bf2d; }, function (v) { return $808477d741187731$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $808477d741187731$export$d38cd72104c1f0e9; }, function (v) { return $808477d741187731$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $808477d741187731$export$7d1e3a5e95ceca43; }, function (v) { return $808477d741187731$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $808477d741187731$export$257a8862b851cb5b; }, function (v) { return $808477d741187731$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $808477d741187731$export$a8257692ac88316c; }, function (v) { return $808477d741187731$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $808477d741187731$export$488013bae63b21da; }, function (v) { return $808477d741187731$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $808477d741187731$export$7c73462e0d25e514; }, function (v) { return $808477d741187731$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $808477d741187731$export$7568632d0d33d16d; }, function (v) { return $808477d741187731$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $808477d741187731$export$88948ce120ea2619; }, function (v) { return $808477d741187731$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $808477d741187731$export$35808ee640e87ca7; }, function (v) { return $808477d741187731$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $808477d741187731$export$fae74005e78b1a27; }, function (v) { return $808477d741187731$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $808477d741187731$export$dc8fbce3eb94dc1e; }, function (v) { return $808477d741187731$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $808477d741187731$export$6a7bc4e911dc01cf; }, function (v) { return $808477d741187731$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $808477d741187731$export$6d9c69b0de29b591; }, function (v) { return $808477d741187731$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $808477d741187731$export$f680877a34711e37; }, function (v) { return $808477d741187731$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $808477d741187731$export$d5a552a76deda3c2; }, function (v) { return $808477d741187731$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $808477d741187731$export$aaabe4eda9ed9969; }, function (v) { return $808477d741187731$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $808477d741187731$export$e5c5a5f917a5871c; }, function (v) { return $808477d741187731$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $808477d741187731$export$1538c33de8887b59; }, function (v) { return $808477d741187731$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $808477d741187731$export$13e3392192263954; }, function (v) { return $808477d741187731$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $808477d741187731$export$b8f5890fc79d6aca; }, function (v) { return $808477d741187731$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $808477d741187731$export$60241385465d0a34; }, function (v) { return $808477d741187731$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $808477d741187731$export$306c0aa65ff9ec16; }, function (v) { return $808477d741187731$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $808477d741187731$export$7b286972b8d8ccbf; }, function (v) { return $808477d741187731$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $808477d741187731$export$83d89fbfd8236492; }, function (v) { return $808477d741187731$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $Ml1eZ = parcelRequire("Ml1eZ");
var $808477d741187731$export$dca3b0875bd9a954;
var $808477d741187731$export$16fa2f45be04daa8;
var $808477d741187731$export$ffb0004e005737fa;
var $808477d741187731$export$e2c29f18771995cb;
var $808477d741187731$export$221d75b3f55bb0bd;
var $808477d741187731$export$5f8d39834fd61797;
var $808477d741187731$export$74bf444e3cd11ea5;
var $808477d741187731$export$ae55be85d98224ed;
var $808477d741187731$export$e530037191fcd5d7;
var $808477d741187731$export$fd42f52fd3ae1109;
var $808477d741187731$export$c8a8987d4410bf2d;
var $808477d741187731$export$d38cd72104c1f0e9;
var $808477d741187731$export$7d1e3a5e95ceca43;
var $808477d741187731$export$257a8862b851cb5b;
var $808477d741187731$export$a8257692ac88316c;
var $808477d741187731$export$488013bae63b21da;
var $808477d741187731$export$7c73462e0d25e514;
var $808477d741187731$export$7568632d0d33d16d;
var $808477d741187731$export$88948ce120ea2619;
var $808477d741187731$export$35808ee640e87ca7;
var $808477d741187731$export$fae74005e78b1a27;
var $808477d741187731$export$dc8fbce3eb94dc1e;
var $808477d741187731$export$6a7bc4e911dc01cf;
var $808477d741187731$export$6d9c69b0de29b591;
var $808477d741187731$export$f680877a34711e37;
var $808477d741187731$export$d5a552a76deda3c2;
var $808477d741187731$export$aaabe4eda9ed9969;
var $808477d741187731$export$e5c5a5f917a5871c;
var $808477d741187731$export$1538c33de8887b59;
var $808477d741187731$export$13e3392192263954;
var $808477d741187731$export$b8f5890fc79d6aca;
var $808477d741187731$export$60241385465d0a34;
var $808477d741187731$export$306c0aa65ff9ec16;
var $808477d741187731$export$7b286972b8d8ccbf;
var $808477d741187731$export$83d89fbfd8236492;
"use strict";
var $808477d741187731$var$l = Symbol.for("react.element"), $808477d741187731$var$n = Symbol.for("react.portal"), $808477d741187731$var$p = Symbol.for("react.fragment"), $808477d741187731$var$q = Symbol.for("react.strict_mode"), $808477d741187731$var$r = Symbol.for("react.profiler"), $808477d741187731$var$t = Symbol.for("react.provider"), $808477d741187731$var$u = Symbol.for("react.context"), $808477d741187731$var$v = Symbol.for("react.forward_ref"), $808477d741187731$var$w = Symbol.for("react.suspense"), $808477d741187731$var$x = Symbol.for("react.memo"), $808477d741187731$var$y = Symbol.for("react.lazy"), $808477d741187731$var$z = Symbol.iterator;
function $808477d741187731$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $808477d741187731$var$z && a[$808477d741187731$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $808477d741187731$var$B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $808477d741187731$var$C = Object.assign, $808477d741187731$var$D = {};
function $808477d741187731$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $808477d741187731$var$D;
    this.updater = e || $808477d741187731$var$B;
}
$808477d741187731$var$E.prototype.isReactComponent = {};
$808477d741187731$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$808477d741187731$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $808477d741187731$var$F() {}
$808477d741187731$var$F.prototype = $808477d741187731$var$E.prototype;
function $808477d741187731$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $808477d741187731$var$D;
    this.updater = e || $808477d741187731$var$B;
}
var $808477d741187731$var$H = $808477d741187731$var$G.prototype = new $808477d741187731$var$F;
$808477d741187731$var$H.constructor = $808477d741187731$var$G;
$808477d741187731$var$C($808477d741187731$var$H, $808477d741187731$var$E.prototype);
$808477d741187731$var$H.isPureReactComponent = !0;
var $808477d741187731$var$I = Array.isArray, $808477d741187731$var$J = Object.prototype.hasOwnProperty, $808477d741187731$var$K = {
    current: null
}, $808477d741187731$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $808477d741187731$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$808477d741187731$var$J.call(b, d) && !$808477d741187731$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $808477d741187731$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $808477d741187731$var$K.current
    };
}
function $808477d741187731$var$N(a, b) {
    return {
        $$typeof: $808477d741187731$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $808477d741187731$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $808477d741187731$var$l;
}
function $808477d741187731$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $808477d741187731$var$P = /\/+/g;
function $808477d741187731$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $808477d741187731$var$escape("" + a.key) : b.toString(36);
}
function $808477d741187731$var$R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, $Ml1eZ._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $808477d741187731$var$l:
                case $808477d741187731$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $808477d741187731$var$Q(h, 0) : d, $808477d741187731$var$I(c) ? (e = "", null != a && (e = a.replace($808477d741187731$var$P, "$&/") + "/"), $808477d741187731$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($808477d741187731$var$O(c) && (c = $808477d741187731$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($808477d741187731$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($808477d741187731$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $808477d741187731$var$Q(k, g);
        h += $808477d741187731$var$R(k, b, e, f, c);
    }
    else if (f = $808477d741187731$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $808477d741187731$var$Q(k, g++), h += $808477d741187731$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $808477d741187731$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $808477d741187731$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $808477d741187731$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $808477d741187731$var$U = {
    current: null
}, $808477d741187731$var$V = {
    transition: null
}, $808477d741187731$var$W = {
    ReactCurrentDispatcher: $808477d741187731$var$U,
    ReactCurrentBatchConfig: $808477d741187731$var$V,
    ReactCurrentOwner: $808477d741187731$var$K
};
$808477d741187731$export$dca3b0875bd9a954 = {
    map: $808477d741187731$var$S,
    forEach: function forEach(a, b, e) {
        $808477d741187731$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        $808477d741187731$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $808477d741187731$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$808477d741187731$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$808477d741187731$export$16fa2f45be04daa8 = $808477d741187731$var$E;
$808477d741187731$export$ffb0004e005737fa = $808477d741187731$var$p;
$808477d741187731$export$e2c29f18771995cb = $808477d741187731$var$r;
$808477d741187731$export$221d75b3f55bb0bd = $808477d741187731$var$G;
$808477d741187731$export$5f8d39834fd61797 = $808477d741187731$var$q;
$808477d741187731$export$74bf444e3cd11ea5 = $808477d741187731$var$w;
$808477d741187731$export$ae55be85d98224ed = $808477d741187731$var$W;
$808477d741187731$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $808477d741187731$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $808477d741187731$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$808477d741187731$var$J.call(b, f) && !$808477d741187731$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $808477d741187731$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$808477d741187731$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $808477d741187731$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $808477d741187731$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$808477d741187731$export$c8a8987d4410bf2d = $808477d741187731$var$M;
$808477d741187731$export$d38cd72104c1f0e9 = function(a) {
    var b = $808477d741187731$var$M.bind(null, a);
    b.type = a;
    return b;
};
$808477d741187731$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$808477d741187731$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $808477d741187731$var$v,
        render: a
    };
};
$808477d741187731$export$a8257692ac88316c = $808477d741187731$var$O;
$808477d741187731$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $808477d741187731$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $808477d741187731$var$T
    };
};
$808477d741187731$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $808477d741187731$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$808477d741187731$export$7568632d0d33d16d = function(a) {
    var b = $808477d741187731$var$V.transition;
    $808477d741187731$var$V.transition = {};
    try {
        a();
    } finally{
        $808477d741187731$var$V.transition = b;
    }
};
$808477d741187731$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$808477d741187731$export$35808ee640e87ca7 = function(a, b) {
    return $808477d741187731$var$U.current.useCallback(a, b);
};
$808477d741187731$export$fae74005e78b1a27 = function(a) {
    return $808477d741187731$var$U.current.useContext(a);
};
$808477d741187731$export$dc8fbce3eb94dc1e = function() {};
$808477d741187731$export$6a7bc4e911dc01cf = function(a) {
    return $808477d741187731$var$U.current.useDeferredValue(a);
};
$808477d741187731$export$6d9c69b0de29b591 = function(a, b) {
    return $808477d741187731$var$U.current.useEffect(a, b);
};
$808477d741187731$export$f680877a34711e37 = function() {
    return $808477d741187731$var$U.current.useId();
};
$808477d741187731$export$d5a552a76deda3c2 = function(a, b, e) {
    return $808477d741187731$var$U.current.useImperativeHandle(a, b, e);
};
$808477d741187731$export$aaabe4eda9ed9969 = function(a, b) {
    return $808477d741187731$var$U.current.useInsertionEffect(a, b);
};
$808477d741187731$export$e5c5a5f917a5871c = function(a, b) {
    return $808477d741187731$var$U.current.useLayoutEffect(a, b);
};
$808477d741187731$export$1538c33de8887b59 = function(a, b) {
    return $808477d741187731$var$U.current.useMemo(a, b);
};
$808477d741187731$export$13e3392192263954 = function(a, b, e) {
    return $808477d741187731$var$U.current.useReducer(a, b, e);
};
$808477d741187731$export$b8f5890fc79d6aca = function(a) {
    return $808477d741187731$var$U.current.useRef(a);
};
$808477d741187731$export$60241385465d0a34 = function(a) {
    return $808477d741187731$var$U.current.useState(a);
};
$808477d741187731$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $808477d741187731$var$U.current.useSyncExternalStore(a, b, e);
};
$808477d741187731$export$7b286972b8d8ccbf = function() {
    return $808477d741187731$var$U.current.useTransition();
};
$808477d741187731$export$83d89fbfd8236492 = "18.2.0";

});
parcelRegister("Ml1eZ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0914c9bf65a97a35$export$5f0017c582d45a2d; });
function $0914c9bf65a97a35$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});




parcelRegister("1njCK", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $1007295417eb09fd$export$ae55be85d98224ed; }, function (v) { return $1007295417eb09fd$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $1007295417eb09fd$export$d39a5bbd09211389; }, function (v) { return $1007295417eb09fd$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $1007295417eb09fd$export$882461b6382ed46c; }, function (v) { return $1007295417eb09fd$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $1007295417eb09fd$export$466bfc07425424d5; }, function (v) { return $1007295417eb09fd$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $1007295417eb09fd$export$cd75ccfd720a3cd4; }, function (v) { return $1007295417eb09fd$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $1007295417eb09fd$export$fa8d919ba61d84db; }, function (v) { return $1007295417eb09fd$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $1007295417eb09fd$export$757ceba2d55c277e; }, function (v) { return $1007295417eb09fd$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $1007295417eb09fd$export$b3890eb0ae9dca99; }, function (v) { return $1007295417eb09fd$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $1007295417eb09fd$export$502457920280e6be; }, function (v) { return $1007295417eb09fd$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $1007295417eb09fd$export$c78a37762a8d58e1; }, function (v) { return $1007295417eb09fd$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $1007295417eb09fd$export$dc54d992c10e8a18; }, function (v) { return $1007295417eb09fd$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $1007295417eb09fd$export$83d89fbfd8236492; }, function (v) { return $1007295417eb09fd$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $Ml1eZ = parcelRequire("Ml1eZ");
var $1007295417eb09fd$export$ae55be85d98224ed;
var $1007295417eb09fd$export$d39a5bbd09211389;
var $1007295417eb09fd$export$882461b6382ed46c;
var $1007295417eb09fd$export$466bfc07425424d5;
var $1007295417eb09fd$export$cd75ccfd720a3cd4;
var $1007295417eb09fd$export$fa8d919ba61d84db;
var $1007295417eb09fd$export$757ceba2d55c277e;
var $1007295417eb09fd$export$b3890eb0ae9dca99;
var $1007295417eb09fd$export$502457920280e6be;
var $1007295417eb09fd$export$c78a37762a8d58e1;
var $1007295417eb09fd$export$dc54d992c10e8a18;
var $1007295417eb09fd$export$83d89fbfd8236492;
"use strict";

var $4rNTR = parcelRequire("4rNTR");

var $aDU7V = parcelRequire("aDU7V");
function $1007295417eb09fd$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $1007295417eb09fd$var$da = new Set, $1007295417eb09fd$var$ea = {};
function $1007295417eb09fd$var$fa(a, b) {
    $1007295417eb09fd$var$ha(a, b);
    $1007295417eb09fd$var$ha(a + "Capture", b);
}
function $1007295417eb09fd$var$ha(a, b) {
    $1007295417eb09fd$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$1007295417eb09fd$var$da.add(b[a]);
}
var $1007295417eb09fd$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $1007295417eb09fd$var$ja = Object.prototype.hasOwnProperty, $1007295417eb09fd$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $1007295417eb09fd$var$la = {}, $1007295417eb09fd$var$ma = {};
function $1007295417eb09fd$var$oa(a) {
    if ($1007295417eb09fd$var$ja.call($1007295417eb09fd$var$ma, a)) return !0;
    if ($1007295417eb09fd$var$ja.call($1007295417eb09fd$var$la, a)) return !1;
    if ($1007295417eb09fd$var$ka.test(a)) return $1007295417eb09fd$var$ma[a] = !0;
    $1007295417eb09fd$var$la[a] = !0;
    return !1;
}
function $1007295417eb09fd$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $Ml1eZ._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $1007295417eb09fd$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $1007295417eb09fd$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $1007295417eb09fd$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $1007295417eb09fd$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $1007295417eb09fd$var$z[a] = new $1007295417eb09fd$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $1007295417eb09fd$var$z[b] = new $1007295417eb09fd$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $1007295417eb09fd$var$z[a] = new $1007295417eb09fd$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $1007295417eb09fd$var$z[a] = new $1007295417eb09fd$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $1007295417eb09fd$var$z[a] = new $1007295417eb09fd$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $1007295417eb09fd$var$z[a] = new $1007295417eb09fd$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $1007295417eb09fd$var$z[a] = new $1007295417eb09fd$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $1007295417eb09fd$var$z[a] = new $1007295417eb09fd$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $1007295417eb09fd$var$z[a] = new $1007295417eb09fd$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $1007295417eb09fd$var$ra = /[\-:]([a-z])/g;
function $1007295417eb09fd$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($1007295417eb09fd$var$ra, $1007295417eb09fd$var$sa);
    $1007295417eb09fd$var$z[b] = new $1007295417eb09fd$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($1007295417eb09fd$var$ra, $1007295417eb09fd$var$sa);
    $1007295417eb09fd$var$z[b] = new $1007295417eb09fd$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($1007295417eb09fd$var$ra, $1007295417eb09fd$var$sa);
    $1007295417eb09fd$var$z[b] = new $1007295417eb09fd$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $1007295417eb09fd$var$z[a] = new $1007295417eb09fd$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$1007295417eb09fd$var$z.xlinkHref = new $1007295417eb09fd$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $1007295417eb09fd$var$z[a] = new $1007295417eb09fd$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $1007295417eb09fd$var$ta(a, b, c, d) {
    var e = $1007295417eb09fd$var$z.hasOwnProperty(b) ? $1007295417eb09fd$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $1007295417eb09fd$var$qa(b, c, e, d) && (c = null), d || null === e ? $1007295417eb09fd$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $1007295417eb09fd$var$ua = $4rNTR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $1007295417eb09fd$var$va = Symbol.for("react.element"), $1007295417eb09fd$var$wa = Symbol.for("react.portal"), $1007295417eb09fd$var$ya = Symbol.for("react.fragment"), $1007295417eb09fd$var$za = Symbol.for("react.strict_mode"), $1007295417eb09fd$var$Aa = Symbol.for("react.profiler"), $1007295417eb09fd$var$Ba = Symbol.for("react.provider"), $1007295417eb09fd$var$Ca = Symbol.for("react.context"), $1007295417eb09fd$var$Da = Symbol.for("react.forward_ref"), $1007295417eb09fd$var$Ea = Symbol.for("react.suspense"), $1007295417eb09fd$var$Fa = Symbol.for("react.suspense_list"), $1007295417eb09fd$var$Ga = Symbol.for("react.memo"), $1007295417eb09fd$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $1007295417eb09fd$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $1007295417eb09fd$var$Ja = Symbol.iterator;
function $1007295417eb09fd$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1007295417eb09fd$var$Ja && a[$1007295417eb09fd$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1007295417eb09fd$var$A = Object.assign, $1007295417eb09fd$var$La;
function $1007295417eb09fd$var$Ma(a) {
    if (void 0 === $1007295417eb09fd$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $1007295417eb09fd$var$La = b && b[1] || "";
    }
    return "\n" + $1007295417eb09fd$var$La + a;
}
var $1007295417eb09fd$var$Na = !1;
function $1007295417eb09fd$var$Oa(a, b) {
    if (!a || $1007295417eb09fd$var$Na) return "";
    $1007295417eb09fd$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $1007295417eb09fd$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $1007295417eb09fd$var$Ma(a) : "";
}
function $1007295417eb09fd$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $1007295417eb09fd$var$Ma(a.type);
        case 16:
            return $1007295417eb09fd$var$Ma("Lazy");
        case 13:
            return $1007295417eb09fd$var$Ma("Suspense");
        case 19:
            return $1007295417eb09fd$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $1007295417eb09fd$var$Oa(a.type, !1), a;
        case 11:
            return a = $1007295417eb09fd$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $1007295417eb09fd$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $1007295417eb09fd$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $1007295417eb09fd$var$ya:
            return "Fragment";
        case $1007295417eb09fd$var$wa:
            return "Portal";
        case $1007295417eb09fd$var$Aa:
            return "Profiler";
        case $1007295417eb09fd$var$za:
            return "StrictMode";
        case $1007295417eb09fd$var$Ea:
            return "Suspense";
        case $1007295417eb09fd$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $1007295417eb09fd$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $1007295417eb09fd$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $1007295417eb09fd$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $1007295417eb09fd$var$Ga:
            return b = a.displayName || null, null !== b ? b : $1007295417eb09fd$var$Qa(a.type) || "Memo";
        case $1007295417eb09fd$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $1007295417eb09fd$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $1007295417eb09fd$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $1007295417eb09fd$var$Qa(b);
        case 8:
            return b === $1007295417eb09fd$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $1007295417eb09fd$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $Ml1eZ._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $1007295417eb09fd$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $1007295417eb09fd$var$Ua(a) {
    var b = $1007295417eb09fd$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $1007295417eb09fd$var$Va(a) {
    a._valueTracker || (a._valueTracker = $1007295417eb09fd$var$Ua(a));
}
function $1007295417eb09fd$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $1007295417eb09fd$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $1007295417eb09fd$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $1007295417eb09fd$var$Ya(a, b) {
    var c = b.checked;
    return $1007295417eb09fd$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $1007295417eb09fd$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $1007295417eb09fd$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $1007295417eb09fd$var$ab(a, b) {
    b = b.checked;
    null != b && $1007295417eb09fd$var$ta(a, "checked", b, !1);
}
function $1007295417eb09fd$var$bb(a, b) {
    $1007295417eb09fd$var$ab(a, b);
    var c = $1007295417eb09fd$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $1007295417eb09fd$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $1007295417eb09fd$var$cb(a, b.type, $1007295417eb09fd$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $1007295417eb09fd$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $1007295417eb09fd$var$cb(a, b, c) {
    if ("number" !== b || $1007295417eb09fd$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $1007295417eb09fd$var$eb = Array.isArray;
function $1007295417eb09fd$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $1007295417eb09fd$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $1007295417eb09fd$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($1007295417eb09fd$var$p(91));
    return $1007295417eb09fd$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $1007295417eb09fd$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($1007295417eb09fd$var$p(92));
            if ($1007295417eb09fd$var$eb(c)) {
                if (1 < c.length) throw Error($1007295417eb09fd$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $1007295417eb09fd$var$Sa(c)
    };
}
function $1007295417eb09fd$var$ib(a, b) {
    var c = $1007295417eb09fd$var$Sa(b.value), d = $1007295417eb09fd$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $1007295417eb09fd$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $1007295417eb09fd$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $1007295417eb09fd$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $1007295417eb09fd$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $1007295417eb09fd$var$mb, $1007295417eb09fd$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $1007295417eb09fd$var$mb = $1007295417eb09fd$var$mb || document.createElement("div");
        $1007295417eb09fd$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $1007295417eb09fd$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $1007295417eb09fd$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $1007295417eb09fd$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $1007295417eb09fd$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($1007295417eb09fd$var$pb).forEach(function(a) {
    $1007295417eb09fd$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $1007295417eb09fd$var$pb[b] = $1007295417eb09fd$var$pb[a];
    });
});
function $1007295417eb09fd$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $1007295417eb09fd$var$pb.hasOwnProperty(a) && $1007295417eb09fd$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $1007295417eb09fd$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $1007295417eb09fd$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $1007295417eb09fd$var$tb = $1007295417eb09fd$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $1007295417eb09fd$var$ub(a, b) {
    if (b) {
        if ($1007295417eb09fd$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($1007295417eb09fd$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($1007295417eb09fd$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($1007295417eb09fd$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($1007295417eb09fd$var$p(62));
    }
}
function $1007295417eb09fd$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $1007295417eb09fd$var$wb = null;
function $1007295417eb09fd$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $1007295417eb09fd$var$yb = null, $1007295417eb09fd$var$zb = null, $1007295417eb09fd$var$Ab = null;
function $1007295417eb09fd$var$Bb(a) {
    if (a = $1007295417eb09fd$var$Cb(a)) {
        if ("function" !== typeof $1007295417eb09fd$var$yb) throw Error($1007295417eb09fd$var$p(280));
        var b = a.stateNode;
        b && (b = $1007295417eb09fd$var$Db(b), $1007295417eb09fd$var$yb(a.stateNode, a.type, b));
    }
}
function $1007295417eb09fd$var$Eb(a) {
    $1007295417eb09fd$var$zb ? $1007295417eb09fd$var$Ab ? $1007295417eb09fd$var$Ab.push(a) : $1007295417eb09fd$var$Ab = [
        a
    ] : $1007295417eb09fd$var$zb = a;
}
function $1007295417eb09fd$var$Fb() {
    if ($1007295417eb09fd$var$zb) {
        var a = $1007295417eb09fd$var$zb, b = $1007295417eb09fd$var$Ab;
        $1007295417eb09fd$var$Ab = $1007295417eb09fd$var$zb = null;
        $1007295417eb09fd$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$1007295417eb09fd$var$Bb(b[a]);
    }
}
function $1007295417eb09fd$var$Gb(a, b) {
    return a(b);
}
function $1007295417eb09fd$var$Hb() {}
var $1007295417eb09fd$var$Ib = !1;
function $1007295417eb09fd$var$Jb(a, b, c) {
    if ($1007295417eb09fd$var$Ib) return a(b, c);
    $1007295417eb09fd$var$Ib = !0;
    try {
        return $1007295417eb09fd$var$Gb(a, b, c);
    } finally{
        if ($1007295417eb09fd$var$Ib = !1, null !== $1007295417eb09fd$var$zb || null !== $1007295417eb09fd$var$Ab) $1007295417eb09fd$var$Hb(), $1007295417eb09fd$var$Fb();
    }
}
function $1007295417eb09fd$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $1007295417eb09fd$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($1007295417eb09fd$var$p(231, b, typeof c === "undefined" ? "undefined" : (0, $Ml1eZ._)(c)));
    return c;
}
var $1007295417eb09fd$var$Lb = !1;
if ($1007295417eb09fd$var$ia) try {
    var $1007295417eb09fd$var$Mb = {};
    Object.defineProperty($1007295417eb09fd$var$Mb, "passive", {
        get: function get() {
            $1007295417eb09fd$var$Lb = !0;
        }
    });
    window.addEventListener("test", $1007295417eb09fd$var$Mb, $1007295417eb09fd$var$Mb);
    window.removeEventListener("test", $1007295417eb09fd$var$Mb, $1007295417eb09fd$var$Mb);
} catch (a) {
    $1007295417eb09fd$var$Lb = !1;
}
function $1007295417eb09fd$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $1007295417eb09fd$var$Ob = !1, $1007295417eb09fd$var$Pb = null, $1007295417eb09fd$var$Qb = !1, $1007295417eb09fd$var$Rb = null, $1007295417eb09fd$var$Sb = {
    onError: function onError(a) {
        $1007295417eb09fd$var$Ob = !0;
        $1007295417eb09fd$var$Pb = a;
    }
};
function $1007295417eb09fd$var$Tb(a, b, c, d, e, f, g, h, k) {
    $1007295417eb09fd$var$Ob = !1;
    $1007295417eb09fd$var$Pb = null;
    $1007295417eb09fd$var$Nb.apply($1007295417eb09fd$var$Sb, arguments);
}
function $1007295417eb09fd$var$Ub(a, b, c, d, e, f, g, h, k) {
    $1007295417eb09fd$var$Tb.apply(this, arguments);
    if ($1007295417eb09fd$var$Ob) {
        if ($1007295417eb09fd$var$Ob) {
            var l = $1007295417eb09fd$var$Pb;
            $1007295417eb09fd$var$Ob = !1;
            $1007295417eb09fd$var$Pb = null;
        } else throw Error($1007295417eb09fd$var$p(198));
        $1007295417eb09fd$var$Qb || ($1007295417eb09fd$var$Qb = !0, $1007295417eb09fd$var$Rb = l);
    }
}
function $1007295417eb09fd$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $1007295417eb09fd$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $1007295417eb09fd$var$Xb(a) {
    if ($1007295417eb09fd$var$Vb(a) !== a) throw Error($1007295417eb09fd$var$p(188));
}
function $1007295417eb09fd$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $1007295417eb09fd$var$Vb(a);
        if (null === b) throw Error($1007295417eb09fd$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $1007295417eb09fd$var$Xb(e), a;
                if (f === d) return $1007295417eb09fd$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($1007295417eb09fd$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($1007295417eb09fd$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($1007295417eb09fd$var$p(190));
    }
    if (3 !== c.tag) throw Error($1007295417eb09fd$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $1007295417eb09fd$var$Zb(a) {
    a = $1007295417eb09fd$var$Yb(a);
    return null !== a ? $1007295417eb09fd$var$$b(a) : null;
}
function $1007295417eb09fd$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $1007295417eb09fd$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $1007295417eb09fd$var$ac = $aDU7V.unstable_scheduleCallback, $1007295417eb09fd$var$bc = $aDU7V.unstable_cancelCallback, $1007295417eb09fd$var$cc = $aDU7V.unstable_shouldYield, $1007295417eb09fd$var$dc = $aDU7V.unstable_requestPaint, $1007295417eb09fd$var$B = $aDU7V.unstable_now, $1007295417eb09fd$var$ec = $aDU7V.unstable_getCurrentPriorityLevel, $1007295417eb09fd$var$fc = $aDU7V.unstable_ImmediatePriority, $1007295417eb09fd$var$gc = $aDU7V.unstable_UserBlockingPriority, $1007295417eb09fd$var$hc = $aDU7V.unstable_NormalPriority, $1007295417eb09fd$var$ic = $aDU7V.unstable_LowPriority, $1007295417eb09fd$var$jc = $aDU7V.unstable_IdlePriority, $1007295417eb09fd$var$kc = null, $1007295417eb09fd$var$lc = null;
function $1007295417eb09fd$var$mc(a) {
    if ($1007295417eb09fd$var$lc && "function" === typeof $1007295417eb09fd$var$lc.onCommitFiberRoot) try {
        $1007295417eb09fd$var$lc.onCommitFiberRoot($1007295417eb09fd$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $1007295417eb09fd$var$oc = Math.clz32 ? Math.clz32 : $1007295417eb09fd$var$nc, $1007295417eb09fd$var$pc = Math.log, $1007295417eb09fd$var$qc = Math.LN2;
function $1007295417eb09fd$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($1007295417eb09fd$var$pc(a) / $1007295417eb09fd$var$qc | 0) | 0;
}
var $1007295417eb09fd$var$rc = 64, $1007295417eb09fd$var$sc = 4194304;
function $1007295417eb09fd$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $1007295417eb09fd$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $1007295417eb09fd$var$tc(h) : (f &= g, 0 !== f && (d = $1007295417eb09fd$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $1007295417eb09fd$var$tc(g) : 0 !== f && (d = $1007295417eb09fd$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $1007295417eb09fd$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $1007295417eb09fd$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $1007295417eb09fd$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $1007295417eb09fd$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $1007295417eb09fd$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $1007295417eb09fd$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $1007295417eb09fd$var$yc() {
    var a = $1007295417eb09fd$var$rc;
    $1007295417eb09fd$var$rc <<= 1;
    0 === ($1007295417eb09fd$var$rc & 4194240) && ($1007295417eb09fd$var$rc = 64);
    return a;
}
function $1007295417eb09fd$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $1007295417eb09fd$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $1007295417eb09fd$var$oc(b);
    a[b] = c;
}
function $1007295417eb09fd$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $1007295417eb09fd$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $1007295417eb09fd$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $1007295417eb09fd$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $1007295417eb09fd$var$C = 0;
function $1007295417eb09fd$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $1007295417eb09fd$var$Ec, $1007295417eb09fd$var$Fc, $1007295417eb09fd$var$Gc, $1007295417eb09fd$var$Hc, $1007295417eb09fd$var$Ic, $1007295417eb09fd$var$Jc = !1, $1007295417eb09fd$var$Kc = [], $1007295417eb09fd$var$Lc = null, $1007295417eb09fd$var$Mc = null, $1007295417eb09fd$var$Nc = null, $1007295417eb09fd$var$Oc = new Map, $1007295417eb09fd$var$Pc = new Map, $1007295417eb09fd$var$Qc = [], $1007295417eb09fd$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $1007295417eb09fd$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $1007295417eb09fd$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $1007295417eb09fd$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $1007295417eb09fd$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $1007295417eb09fd$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $1007295417eb09fd$var$Pc.delete(b.pointerId);
    }
}
function $1007295417eb09fd$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $1007295417eb09fd$var$Cb(b), null !== b && $1007295417eb09fd$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $1007295417eb09fd$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $1007295417eb09fd$var$Lc = $1007295417eb09fd$var$Tc($1007295417eb09fd$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $1007295417eb09fd$var$Mc = $1007295417eb09fd$var$Tc($1007295417eb09fd$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $1007295417eb09fd$var$Nc = $1007295417eb09fd$var$Tc($1007295417eb09fd$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $1007295417eb09fd$var$Oc.set(f, $1007295417eb09fd$var$Tc($1007295417eb09fd$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $1007295417eb09fd$var$Pc.set(f, $1007295417eb09fd$var$Tc($1007295417eb09fd$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $1007295417eb09fd$var$Vc(a) {
    var b = $1007295417eb09fd$var$Wc(a.target);
    if (null !== b) {
        var c = $1007295417eb09fd$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $1007295417eb09fd$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $1007295417eb09fd$var$Ic(a.priority, function() {
                        $1007295417eb09fd$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $1007295417eb09fd$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $1007295417eb09fd$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $1007295417eb09fd$var$wb = d;
            c.target.dispatchEvent(d);
            $1007295417eb09fd$var$wb = null;
        } else return b = $1007295417eb09fd$var$Cb(c), null !== b && $1007295417eb09fd$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $1007295417eb09fd$var$Zc(a, b, c) {
    $1007295417eb09fd$var$Xc(a) && c.delete(b);
}
function $1007295417eb09fd$var$$c() {
    $1007295417eb09fd$var$Jc = !1;
    null !== $1007295417eb09fd$var$Lc && $1007295417eb09fd$var$Xc($1007295417eb09fd$var$Lc) && ($1007295417eb09fd$var$Lc = null);
    null !== $1007295417eb09fd$var$Mc && $1007295417eb09fd$var$Xc($1007295417eb09fd$var$Mc) && ($1007295417eb09fd$var$Mc = null);
    null !== $1007295417eb09fd$var$Nc && $1007295417eb09fd$var$Xc($1007295417eb09fd$var$Nc) && ($1007295417eb09fd$var$Nc = null);
    $1007295417eb09fd$var$Oc.forEach($1007295417eb09fd$var$Zc);
    $1007295417eb09fd$var$Pc.forEach($1007295417eb09fd$var$Zc);
}
function $1007295417eb09fd$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $1007295417eb09fd$var$Jc || ($1007295417eb09fd$var$Jc = !0, $aDU7V.unstable_scheduleCallback($aDU7V.unstable_NormalPriority, $1007295417eb09fd$var$$c)));
}
function $1007295417eb09fd$var$bd(a) {
    function b(b) {
        return $1007295417eb09fd$var$ad(b, a);
    }
    if (0 < $1007295417eb09fd$var$Kc.length) {
        $1007295417eb09fd$var$ad($1007295417eb09fd$var$Kc[0], a);
        for(var c = 1; c < $1007295417eb09fd$var$Kc.length; c++){
            var d = $1007295417eb09fd$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $1007295417eb09fd$var$Lc && $1007295417eb09fd$var$ad($1007295417eb09fd$var$Lc, a);
    null !== $1007295417eb09fd$var$Mc && $1007295417eb09fd$var$ad($1007295417eb09fd$var$Mc, a);
    null !== $1007295417eb09fd$var$Nc && $1007295417eb09fd$var$ad($1007295417eb09fd$var$Nc, a);
    $1007295417eb09fd$var$Oc.forEach(b);
    $1007295417eb09fd$var$Pc.forEach(b);
    for(c = 0; c < $1007295417eb09fd$var$Qc.length; c++)d = $1007295417eb09fd$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $1007295417eb09fd$var$Qc.length && (c = $1007295417eb09fd$var$Qc[0], null === c.blockedOn);)$1007295417eb09fd$var$Vc(c), null === c.blockedOn && $1007295417eb09fd$var$Qc.shift();
}
var $1007295417eb09fd$var$cd = $1007295417eb09fd$var$ua.ReactCurrentBatchConfig, $1007295417eb09fd$var$dd = !0;
function $1007295417eb09fd$var$ed(a, b, c, d) {
    var e = $1007295417eb09fd$var$C, f = $1007295417eb09fd$var$cd.transition;
    $1007295417eb09fd$var$cd.transition = null;
    try {
        $1007295417eb09fd$var$C = 1, $1007295417eb09fd$var$fd(a, b, c, d);
    } finally{
        $1007295417eb09fd$var$C = e, $1007295417eb09fd$var$cd.transition = f;
    }
}
function $1007295417eb09fd$var$gd(a, b, c, d) {
    var e = $1007295417eb09fd$var$C, f = $1007295417eb09fd$var$cd.transition;
    $1007295417eb09fd$var$cd.transition = null;
    try {
        $1007295417eb09fd$var$C = 4, $1007295417eb09fd$var$fd(a, b, c, d);
    } finally{
        $1007295417eb09fd$var$C = e, $1007295417eb09fd$var$cd.transition = f;
    }
}
function $1007295417eb09fd$var$fd(a, b, c, d) {
    if ($1007295417eb09fd$var$dd) {
        var e = $1007295417eb09fd$var$Yc(a, b, c, d);
        if (null === e) $1007295417eb09fd$var$hd(a, b, d, $1007295417eb09fd$var$id, c), $1007295417eb09fd$var$Sc(a, d);
        else if ($1007295417eb09fd$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($1007295417eb09fd$var$Sc(a, d), b & 4 && -1 < $1007295417eb09fd$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $1007295417eb09fd$var$Cb(e);
                null !== f && $1007295417eb09fd$var$Ec(f);
                f = $1007295417eb09fd$var$Yc(a, b, c, d);
                null === f && $1007295417eb09fd$var$hd(a, b, d, $1007295417eb09fd$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $1007295417eb09fd$var$hd(a, b, d, null, c);
    }
}
var $1007295417eb09fd$var$id = null;
function $1007295417eb09fd$var$Yc(a, b, c, d) {
    $1007295417eb09fd$var$id = null;
    a = $1007295417eb09fd$var$xb(d);
    a = $1007295417eb09fd$var$Wc(a);
    if (null !== a) {
        if (b = $1007295417eb09fd$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $1007295417eb09fd$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $1007295417eb09fd$var$id = a;
    return null;
}
function $1007295417eb09fd$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($1007295417eb09fd$var$ec()){
                case $1007295417eb09fd$var$fc:
                    return 1;
                case $1007295417eb09fd$var$gc:
                    return 4;
                case $1007295417eb09fd$var$hc:
                case $1007295417eb09fd$var$ic:
                    return 16;
                case $1007295417eb09fd$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $1007295417eb09fd$var$kd = null, $1007295417eb09fd$var$ld = null, $1007295417eb09fd$var$md = null;
function $1007295417eb09fd$var$nd() {
    if ($1007295417eb09fd$var$md) return $1007295417eb09fd$var$md;
    var a, b = $1007295417eb09fd$var$ld, c = b.length, d, e = "value" in $1007295417eb09fd$var$kd ? $1007295417eb09fd$var$kd.value : $1007295417eb09fd$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $1007295417eb09fd$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $1007295417eb09fd$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $1007295417eb09fd$var$pd() {
    return !0;
}
function $1007295417eb09fd$var$qd() {
    return !1;
}
function $1007295417eb09fd$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $1007295417eb09fd$var$pd : $1007295417eb09fd$var$qd;
        this.isPropagationStopped = $1007295417eb09fd$var$qd;
        return this;
    }
    $1007295417eb09fd$var$A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $Ml1eZ._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $1007295417eb09fd$var$pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $Ml1eZ._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $1007295417eb09fd$var$pd);
        },
        persist: function persist() {},
        isPersistent: $1007295417eb09fd$var$pd
    });
    return b;
}
var $1007295417eb09fd$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $1007295417eb09fd$var$td = $1007295417eb09fd$var$rd($1007295417eb09fd$var$sd), $1007295417eb09fd$var$ud = $1007295417eb09fd$var$A({}, $1007295417eb09fd$var$sd, {
    view: 0,
    detail: 0
}), $1007295417eb09fd$var$vd = $1007295417eb09fd$var$rd($1007295417eb09fd$var$ud), $1007295417eb09fd$var$wd, $1007295417eb09fd$var$xd, $1007295417eb09fd$var$yd, $1007295417eb09fd$var$Ad = $1007295417eb09fd$var$A({}, $1007295417eb09fd$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $1007295417eb09fd$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $1007295417eb09fd$var$yd && ($1007295417eb09fd$var$yd && "mousemove" === a.type ? ($1007295417eb09fd$var$wd = a.screenX - $1007295417eb09fd$var$yd.screenX, $1007295417eb09fd$var$xd = a.screenY - $1007295417eb09fd$var$yd.screenY) : $1007295417eb09fd$var$xd = $1007295417eb09fd$var$wd = 0, $1007295417eb09fd$var$yd = a);
        return $1007295417eb09fd$var$wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $1007295417eb09fd$var$xd;
    }
}), $1007295417eb09fd$var$Bd = $1007295417eb09fd$var$rd($1007295417eb09fd$var$Ad), $1007295417eb09fd$var$Cd = $1007295417eb09fd$var$A({}, $1007295417eb09fd$var$Ad, {
    dataTransfer: 0
}), $1007295417eb09fd$var$Dd = $1007295417eb09fd$var$rd($1007295417eb09fd$var$Cd), $1007295417eb09fd$var$Ed = $1007295417eb09fd$var$A({}, $1007295417eb09fd$var$ud, {
    relatedTarget: 0
}), $1007295417eb09fd$var$Fd = $1007295417eb09fd$var$rd($1007295417eb09fd$var$Ed), $1007295417eb09fd$var$Gd = $1007295417eb09fd$var$A({}, $1007295417eb09fd$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $1007295417eb09fd$var$Hd = $1007295417eb09fd$var$rd($1007295417eb09fd$var$Gd), $1007295417eb09fd$var$Id = $1007295417eb09fd$var$A({}, $1007295417eb09fd$var$sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $1007295417eb09fd$var$Jd = $1007295417eb09fd$var$rd($1007295417eb09fd$var$Id), $1007295417eb09fd$var$Kd = $1007295417eb09fd$var$A({}, $1007295417eb09fd$var$sd, {
    data: 0
}), $1007295417eb09fd$var$Ld = $1007295417eb09fd$var$rd($1007295417eb09fd$var$Kd), $1007295417eb09fd$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $1007295417eb09fd$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $1007295417eb09fd$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $1007295417eb09fd$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $1007295417eb09fd$var$Od[a]) ? !!b[a] : !1;
}
function $1007295417eb09fd$var$zd() {
    return $1007295417eb09fd$var$Pd;
}
var $1007295417eb09fd$var$Qd = $1007295417eb09fd$var$A({}, $1007295417eb09fd$var$ud, {
    key: function key(a) {
        if (a.key) {
            var b = $1007295417eb09fd$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $1007295417eb09fd$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $1007295417eb09fd$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $1007295417eb09fd$var$zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $1007295417eb09fd$var$od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $1007295417eb09fd$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $1007295417eb09fd$var$Rd = $1007295417eb09fd$var$rd($1007295417eb09fd$var$Qd), $1007295417eb09fd$var$Sd = $1007295417eb09fd$var$A({}, $1007295417eb09fd$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $1007295417eb09fd$var$Td = $1007295417eb09fd$var$rd($1007295417eb09fd$var$Sd), $1007295417eb09fd$var$Ud = $1007295417eb09fd$var$A({}, $1007295417eb09fd$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $1007295417eb09fd$var$zd
}), $1007295417eb09fd$var$Vd = $1007295417eb09fd$var$rd($1007295417eb09fd$var$Ud), $1007295417eb09fd$var$Wd = $1007295417eb09fd$var$A({}, $1007295417eb09fd$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $1007295417eb09fd$var$Xd = $1007295417eb09fd$var$rd($1007295417eb09fd$var$Wd), $1007295417eb09fd$var$Yd = $1007295417eb09fd$var$A({}, $1007295417eb09fd$var$Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $1007295417eb09fd$var$Zd = $1007295417eb09fd$var$rd($1007295417eb09fd$var$Yd), $1007295417eb09fd$var$$d = [
    9,
    13,
    27,
    32
], $1007295417eb09fd$var$ae = $1007295417eb09fd$var$ia && "CompositionEvent" in window, $1007295417eb09fd$var$be = null;
$1007295417eb09fd$var$ia && "documentMode" in document && ($1007295417eb09fd$var$be = document.documentMode);
var $1007295417eb09fd$var$ce = $1007295417eb09fd$var$ia && "TextEvent" in window && !$1007295417eb09fd$var$be, $1007295417eb09fd$var$de = $1007295417eb09fd$var$ia && (!$1007295417eb09fd$var$ae || $1007295417eb09fd$var$be && 8 < $1007295417eb09fd$var$be && 11 >= $1007295417eb09fd$var$be), $1007295417eb09fd$var$ee = String.fromCharCode(32), $1007295417eb09fd$var$fe = !1;
function $1007295417eb09fd$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $1007295417eb09fd$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $1007295417eb09fd$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $1007295417eb09fd$var$ie = !1;
function $1007295417eb09fd$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $1007295417eb09fd$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $1007295417eb09fd$var$fe = !0;
            return $1007295417eb09fd$var$ee;
        case "textInput":
            return a = b.data, a === $1007295417eb09fd$var$ee && $1007295417eb09fd$var$fe ? null : a;
        default:
            return null;
    }
}
function $1007295417eb09fd$var$ke(a, b) {
    if ($1007295417eb09fd$var$ie) return "compositionend" === a || !$1007295417eb09fd$var$ae && $1007295417eb09fd$var$ge(a, b) ? (a = $1007295417eb09fd$var$nd(), $1007295417eb09fd$var$md = $1007295417eb09fd$var$ld = $1007295417eb09fd$var$kd = null, $1007295417eb09fd$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $1007295417eb09fd$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $1007295417eb09fd$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $1007295417eb09fd$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$1007295417eb09fd$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $1007295417eb09fd$var$ne(a, b, c, d) {
    $1007295417eb09fd$var$Eb(d);
    b = $1007295417eb09fd$var$oe(b, "onChange");
    0 < b.length && (c = new $1007295417eb09fd$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $1007295417eb09fd$var$pe = null, $1007295417eb09fd$var$qe = null;
function $1007295417eb09fd$var$re(a) {
    $1007295417eb09fd$var$se(a, 0);
}
function $1007295417eb09fd$var$te(a) {
    var b = $1007295417eb09fd$var$ue(a);
    if ($1007295417eb09fd$var$Wa(b)) return a;
}
function $1007295417eb09fd$var$ve(a, b) {
    if ("change" === a) return b;
}
var $1007295417eb09fd$var$we = !1;
if ($1007295417eb09fd$var$ia) {
    var $1007295417eb09fd$var$xe;
    if ($1007295417eb09fd$var$ia) {
        var $1007295417eb09fd$var$ye = "oninput" in document;
        if (!$1007295417eb09fd$var$ye) {
            var $1007295417eb09fd$var$ze = document.createElement("div");
            $1007295417eb09fd$var$ze.setAttribute("oninput", "return;");
            $1007295417eb09fd$var$ye = "function" === typeof $1007295417eb09fd$var$ze.oninput;
        }
        $1007295417eb09fd$var$xe = $1007295417eb09fd$var$ye;
    } else $1007295417eb09fd$var$xe = !1;
    $1007295417eb09fd$var$we = $1007295417eb09fd$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $1007295417eb09fd$var$Ae() {
    $1007295417eb09fd$var$pe && ($1007295417eb09fd$var$pe.detachEvent("onpropertychange", $1007295417eb09fd$var$Be), $1007295417eb09fd$var$qe = $1007295417eb09fd$var$pe = null);
}
function $1007295417eb09fd$var$Be(a) {
    if ("value" === a.propertyName && $1007295417eb09fd$var$te($1007295417eb09fd$var$qe)) {
        var b = [];
        $1007295417eb09fd$var$ne(b, $1007295417eb09fd$var$qe, a, $1007295417eb09fd$var$xb(a));
        $1007295417eb09fd$var$Jb($1007295417eb09fd$var$re, b);
    }
}
function $1007295417eb09fd$var$Ce(a, b, c) {
    "focusin" === a ? ($1007295417eb09fd$var$Ae(), $1007295417eb09fd$var$pe = b, $1007295417eb09fd$var$qe = c, $1007295417eb09fd$var$pe.attachEvent("onpropertychange", $1007295417eb09fd$var$Be)) : "focusout" === a && $1007295417eb09fd$var$Ae();
}
function $1007295417eb09fd$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $1007295417eb09fd$var$te($1007295417eb09fd$var$qe);
}
function $1007295417eb09fd$var$Ee(a, b) {
    if ("click" === a) return $1007295417eb09fd$var$te(b);
}
function $1007295417eb09fd$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $1007295417eb09fd$var$te(b);
}
function $1007295417eb09fd$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $1007295417eb09fd$var$He = "function" === typeof Object.is ? Object.is : $1007295417eb09fd$var$Ge;
function $1007295417eb09fd$var$Ie(a, b) {
    if ($1007295417eb09fd$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$1007295417eb09fd$var$ja.call(b, e) || !$1007295417eb09fd$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $1007295417eb09fd$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $1007295417eb09fd$var$Ke(a, b) {
    var c = $1007295417eb09fd$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $1007295417eb09fd$var$Je(c);
    }
}
function $1007295417eb09fd$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $1007295417eb09fd$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $1007295417eb09fd$var$Me() {
    for(var a = window, b = $1007295417eb09fd$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $1007295417eb09fd$var$Xa(a.document);
    }
    return b;
}
function $1007295417eb09fd$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $1007295417eb09fd$var$Oe(a) {
    var b = $1007295417eb09fd$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $1007295417eb09fd$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $1007295417eb09fd$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $1007295417eb09fd$var$Ke(c, f);
                var g = $1007295417eb09fd$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $1007295417eb09fd$var$Pe = $1007295417eb09fd$var$ia && "documentMode" in document && 11 >= document.documentMode, $1007295417eb09fd$var$Qe = null, $1007295417eb09fd$var$Re = null, $1007295417eb09fd$var$Se = null, $1007295417eb09fd$var$Te = !1;
function $1007295417eb09fd$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $1007295417eb09fd$var$Te || null == $1007295417eb09fd$var$Qe || $1007295417eb09fd$var$Qe !== $1007295417eb09fd$var$Xa(d) || (d = $1007295417eb09fd$var$Qe, "selectionStart" in d && $1007295417eb09fd$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $1007295417eb09fd$var$Se && $1007295417eb09fd$var$Ie($1007295417eb09fd$var$Se, d) || ($1007295417eb09fd$var$Se = d, d = $1007295417eb09fd$var$oe($1007295417eb09fd$var$Re, "onSelect"), 0 < d.length && (b = new $1007295417eb09fd$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $1007295417eb09fd$var$Qe)));
}
function $1007295417eb09fd$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $1007295417eb09fd$var$We = {
    animationend: $1007295417eb09fd$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $1007295417eb09fd$var$Ve("Animation", "AnimationIteration"),
    animationstart: $1007295417eb09fd$var$Ve("Animation", "AnimationStart"),
    transitionend: $1007295417eb09fd$var$Ve("Transition", "TransitionEnd")
}, $1007295417eb09fd$var$Xe = {}, $1007295417eb09fd$var$Ye = {};
$1007295417eb09fd$var$ia && ($1007295417eb09fd$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $1007295417eb09fd$var$We.animationend.animation, delete $1007295417eb09fd$var$We.animationiteration.animation, delete $1007295417eb09fd$var$We.animationstart.animation), "TransitionEvent" in window || delete $1007295417eb09fd$var$We.transitionend.transition);
function $1007295417eb09fd$var$Ze(a) {
    if ($1007295417eb09fd$var$Xe[a]) return $1007295417eb09fd$var$Xe[a];
    if (!$1007295417eb09fd$var$We[a]) return a;
    var b = $1007295417eb09fd$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $1007295417eb09fd$var$Ye) return $1007295417eb09fd$var$Xe[a] = b[c];
    return a;
}
var $1007295417eb09fd$var$$e = $1007295417eb09fd$var$Ze("animationend"), $1007295417eb09fd$var$af = $1007295417eb09fd$var$Ze("animationiteration"), $1007295417eb09fd$var$bf = $1007295417eb09fd$var$Ze("animationstart"), $1007295417eb09fd$var$cf = $1007295417eb09fd$var$Ze("transitionend"), $1007295417eb09fd$var$df = new Map, $1007295417eb09fd$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $1007295417eb09fd$var$ff(a, b) {
    $1007295417eb09fd$var$df.set(a, b);
    $1007295417eb09fd$var$fa(b, [
        a
    ]);
}
for(var $1007295417eb09fd$var$gf = 0; $1007295417eb09fd$var$gf < $1007295417eb09fd$var$ef.length; $1007295417eb09fd$var$gf++){
    var $1007295417eb09fd$var$hf = $1007295417eb09fd$var$ef[$1007295417eb09fd$var$gf], $1007295417eb09fd$var$jf = $1007295417eb09fd$var$hf.toLowerCase(), $1007295417eb09fd$var$kf = $1007295417eb09fd$var$hf[0].toUpperCase() + $1007295417eb09fd$var$hf.slice(1);
    $1007295417eb09fd$var$ff($1007295417eb09fd$var$jf, "on" + $1007295417eb09fd$var$kf);
}
$1007295417eb09fd$var$ff($1007295417eb09fd$var$$e, "onAnimationEnd");
$1007295417eb09fd$var$ff($1007295417eb09fd$var$af, "onAnimationIteration");
$1007295417eb09fd$var$ff($1007295417eb09fd$var$bf, "onAnimationStart");
$1007295417eb09fd$var$ff("dblclick", "onDoubleClick");
$1007295417eb09fd$var$ff("focusin", "onFocus");
$1007295417eb09fd$var$ff("focusout", "onBlur");
$1007295417eb09fd$var$ff($1007295417eb09fd$var$cf, "onTransitionEnd");
$1007295417eb09fd$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$1007295417eb09fd$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$1007295417eb09fd$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$1007295417eb09fd$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$1007295417eb09fd$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$1007295417eb09fd$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$1007295417eb09fd$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$1007295417eb09fd$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$1007295417eb09fd$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$1007295417eb09fd$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $1007295417eb09fd$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $1007295417eb09fd$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($1007295417eb09fd$var$lf));
function $1007295417eb09fd$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $1007295417eb09fd$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $1007295417eb09fd$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $1007295417eb09fd$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $1007295417eb09fd$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($1007295417eb09fd$var$Qb) throw a = $1007295417eb09fd$var$Rb, $1007295417eb09fd$var$Qb = !1, $1007295417eb09fd$var$Rb = null, a;
}
function $1007295417eb09fd$var$D(a, b) {
    var c = b[$1007295417eb09fd$var$of];
    void 0 === c && (c = b[$1007295417eb09fd$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($1007295417eb09fd$var$pf(b, a, 2, !1), c.add(d));
}
function $1007295417eb09fd$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $1007295417eb09fd$var$pf(c, a, d, b);
}
var $1007295417eb09fd$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $1007295417eb09fd$var$sf(a) {
    if (!a[$1007295417eb09fd$var$rf]) {
        a[$1007295417eb09fd$var$rf] = !0;
        $1007295417eb09fd$var$da.forEach(function(b) {
            "selectionchange" !== b && ($1007295417eb09fd$var$mf.has(b) || $1007295417eb09fd$var$qf(b, !1, a), $1007295417eb09fd$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$1007295417eb09fd$var$rf] || (b[$1007295417eb09fd$var$rf] = !0, $1007295417eb09fd$var$qf("selectionchange", !1, b));
    }
}
function $1007295417eb09fd$var$pf(a, b, c, d) {
    switch($1007295417eb09fd$var$jd(b)){
        case 1:
            var e = $1007295417eb09fd$var$ed;
            break;
        case 4:
            e = $1007295417eb09fd$var$gd;
            break;
        default:
            e = $1007295417eb09fd$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$1007295417eb09fd$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $1007295417eb09fd$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $1007295417eb09fd$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $1007295417eb09fd$var$Jb(function() {
        var _$d = f, _$e = $1007295417eb09fd$var$xb(c), g = [];
        a: {
            var h = $1007295417eb09fd$var$df.get(a);
            if (void 0 !== h) {
                var k = $1007295417eb09fd$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $1007295417eb09fd$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $1007295417eb09fd$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $1007295417eb09fd$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $1007295417eb09fd$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $1007295417eb09fd$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $1007295417eb09fd$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $1007295417eb09fd$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $1007295417eb09fd$var$Vd;
                        break;
                    case $1007295417eb09fd$var$$e:
                    case $1007295417eb09fd$var$af:
                    case $1007295417eb09fd$var$bf:
                        k = $1007295417eb09fd$var$Hd;
                        break;
                    case $1007295417eb09fd$var$cf:
                        k = $1007295417eb09fd$var$Xd;
                        break;
                    case "scroll":
                        k = $1007295417eb09fd$var$vd;
                        break;
                    case "wheel":
                        k = $1007295417eb09fd$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $1007295417eb09fd$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $1007295417eb09fd$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $1007295417eb09fd$var$Kb(w, x), null != F && t.push($1007295417eb09fd$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $1007295417eb09fd$var$wb && (n = c.relatedTarget || c.fromElement) && ($1007295417eb09fd$var$Wc(n) || n[$1007295417eb09fd$var$uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? $1007295417eb09fd$var$Wc(n) : null, null !== n && (J = $1007295417eb09fd$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = $1007295417eb09fd$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $1007295417eb09fd$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $1007295417eb09fd$var$ue(k);
                        u = null == n ? h : $1007295417eb09fd$var$ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $1007295417eb09fd$var$Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $1007295417eb09fd$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $1007295417eb09fd$var$vf(F))u++;
                            for(; 0 < w - u;)t = $1007295417eb09fd$var$vf(t), w--;
                            for(; 0 < u - w;)x = $1007295417eb09fd$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $1007295417eb09fd$var$vf(t);
                                x = $1007295417eb09fd$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $1007295417eb09fd$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $1007295417eb09fd$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? $1007295417eb09fd$var$ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $1007295417eb09fd$var$ve;
                else if ($1007295417eb09fd$var$me(h)) {
                    if ($1007295417eb09fd$var$we) na = $1007295417eb09fd$var$Fe;
                    else {
                        na = $1007295417eb09fd$var$De;
                        var xa = $1007295417eb09fd$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $1007295417eb09fd$var$Ee);
                if (na && (na = na(a, _$d))) {
                    $1007295417eb09fd$var$ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $1007295417eb09fd$var$cb(h, "number", h.value);
            }
            xa = _$d ? $1007295417eb09fd$var$ue(_$d) : window;
            switch(a){
                case "focusin":
                    if ($1007295417eb09fd$var$me(xa) || "true" === xa.contentEditable) $1007295417eb09fd$var$Qe = xa, $1007295417eb09fd$var$Re = _$d, $1007295417eb09fd$var$Se = null;
                    break;
                case "focusout":
                    $1007295417eb09fd$var$Se = $1007295417eb09fd$var$Re = $1007295417eb09fd$var$Qe = null;
                    break;
                case "mousedown":
                    $1007295417eb09fd$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $1007295417eb09fd$var$Te = !1;
                    $1007295417eb09fd$var$Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($1007295417eb09fd$var$Pe) break;
                case "keydown":
                case "keyup":
                    $1007295417eb09fd$var$Ue(g, c, _$e);
            }
            var $a;
            if ($1007295417eb09fd$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $1007295417eb09fd$var$ie ? $1007295417eb09fd$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($1007295417eb09fd$var$de && "ko" !== c.locale && ($1007295417eb09fd$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $1007295417eb09fd$var$ie && ($a = $1007295417eb09fd$var$nd()) : ($1007295417eb09fd$var$kd = _$e, $1007295417eb09fd$var$ld = "value" in $1007295417eb09fd$var$kd ? $1007295417eb09fd$var$kd.value : $1007295417eb09fd$var$kd.textContent, $1007295417eb09fd$var$ie = !0)), xa = $1007295417eb09fd$var$oe(_$d, ba), 0 < xa.length && (ba = new $1007295417eb09fd$var$Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $1007295417eb09fd$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $1007295417eb09fd$var$ce ? $1007295417eb09fd$var$je(a, c) : $1007295417eb09fd$var$ke(a, c)) _$d = $1007295417eb09fd$var$oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $1007295417eb09fd$var$Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        $1007295417eb09fd$var$se(g, b);
    });
}
function $1007295417eb09fd$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $1007295417eb09fd$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $1007295417eb09fd$var$Kb(a, c), null != f && d.unshift($1007295417eb09fd$var$tf(a, f, e)), f = $1007295417eb09fd$var$Kb(a, b), null != f && d.push($1007295417eb09fd$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $1007295417eb09fd$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $1007295417eb09fd$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $1007295417eb09fd$var$Kb(c, f), null != k && g.unshift($1007295417eb09fd$var$tf(c, k, h))) : e || (k = $1007295417eb09fd$var$Kb(c, f), null != k && g.push($1007295417eb09fd$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $1007295417eb09fd$var$xf = /\r\n?/g, $1007295417eb09fd$var$yf = /\u0000|\uFFFD/g;
function $1007295417eb09fd$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($1007295417eb09fd$var$xf, "\n").replace($1007295417eb09fd$var$yf, "");
}
function $1007295417eb09fd$var$Af(a, b, c) {
    b = $1007295417eb09fd$var$zf(b);
    if ($1007295417eb09fd$var$zf(a) !== b && c) throw Error($1007295417eb09fd$var$p(425));
}
function $1007295417eb09fd$var$Bf() {}
var $1007295417eb09fd$var$Cf = null, $1007295417eb09fd$var$Df = null;
function $1007295417eb09fd$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $1007295417eb09fd$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $1007295417eb09fd$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $1007295417eb09fd$var$Hf = "function" === typeof Promise ? Promise : void 0, $1007295417eb09fd$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $1007295417eb09fd$var$Hf ? function Jf(a) {
    return $1007295417eb09fd$var$Hf.resolve(null).then(a).catch($1007295417eb09fd$var$If);
} : $1007295417eb09fd$var$Ff;
function $1007295417eb09fd$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $1007295417eb09fd$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $1007295417eb09fd$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $1007295417eb09fd$var$bd(b);
}
function $1007295417eb09fd$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $1007295417eb09fd$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $1007295417eb09fd$var$Nf = Math.random().toString(36).slice(2), $1007295417eb09fd$var$Of = "__reactFiber$" + $1007295417eb09fd$var$Nf, $1007295417eb09fd$var$Pf = "__reactProps$" + $1007295417eb09fd$var$Nf, $1007295417eb09fd$var$uf = "__reactContainer$" + $1007295417eb09fd$var$Nf, $1007295417eb09fd$var$of = "__reactEvents$" + $1007295417eb09fd$var$Nf, $1007295417eb09fd$var$Qf = "__reactListeners$" + $1007295417eb09fd$var$Nf, $1007295417eb09fd$var$Rf = "__reactHandles$" + $1007295417eb09fd$var$Nf;
function $1007295417eb09fd$var$Wc(a) {
    var b = a[$1007295417eb09fd$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$1007295417eb09fd$var$uf] || c[$1007295417eb09fd$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $1007295417eb09fd$var$Mf(a); null !== a;){
                if (c = a[$1007295417eb09fd$var$Of]) return c;
                a = $1007295417eb09fd$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $1007295417eb09fd$var$Cb(a) {
    a = a[$1007295417eb09fd$var$Of] || a[$1007295417eb09fd$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $1007295417eb09fd$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($1007295417eb09fd$var$p(33));
}
function $1007295417eb09fd$var$Db(a) {
    return a[$1007295417eb09fd$var$Pf] || null;
}
var $1007295417eb09fd$var$Sf = [], $1007295417eb09fd$var$Tf = -1;
function $1007295417eb09fd$var$Uf(a) {
    return {
        current: a
    };
}
function $1007295417eb09fd$var$E(a) {
    0 > $1007295417eb09fd$var$Tf || (a.current = $1007295417eb09fd$var$Sf[$1007295417eb09fd$var$Tf], $1007295417eb09fd$var$Sf[$1007295417eb09fd$var$Tf] = null, $1007295417eb09fd$var$Tf--);
}
function $1007295417eb09fd$var$G(a, b) {
    $1007295417eb09fd$var$Tf++;
    $1007295417eb09fd$var$Sf[$1007295417eb09fd$var$Tf] = a.current;
    a.current = b;
}
var $1007295417eb09fd$var$Vf = {}, $1007295417eb09fd$var$H = $1007295417eb09fd$var$Uf($1007295417eb09fd$var$Vf), $1007295417eb09fd$var$Wf = $1007295417eb09fd$var$Uf(!1), $1007295417eb09fd$var$Xf = $1007295417eb09fd$var$Vf;
function $1007295417eb09fd$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $1007295417eb09fd$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $1007295417eb09fd$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $1007295417eb09fd$var$$f() {
    $1007295417eb09fd$var$E($1007295417eb09fd$var$Wf);
    $1007295417eb09fd$var$E($1007295417eb09fd$var$H);
}
function $1007295417eb09fd$var$ag(a, b, c) {
    if ($1007295417eb09fd$var$H.current !== $1007295417eb09fd$var$Vf) throw Error($1007295417eb09fd$var$p(168));
    $1007295417eb09fd$var$G($1007295417eb09fd$var$H, b);
    $1007295417eb09fd$var$G($1007295417eb09fd$var$Wf, c);
}
function $1007295417eb09fd$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($1007295417eb09fd$var$p(108, $1007295417eb09fd$var$Ra(a) || "Unknown", e));
    return $1007295417eb09fd$var$A({}, c, d);
}
function $1007295417eb09fd$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $1007295417eb09fd$var$Vf;
    $1007295417eb09fd$var$Xf = $1007295417eb09fd$var$H.current;
    $1007295417eb09fd$var$G($1007295417eb09fd$var$H, a);
    $1007295417eb09fd$var$G($1007295417eb09fd$var$Wf, $1007295417eb09fd$var$Wf.current);
    return !0;
}
function $1007295417eb09fd$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($1007295417eb09fd$var$p(169));
    c ? (a = $1007295417eb09fd$var$bg(a, b, $1007295417eb09fd$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $1007295417eb09fd$var$E($1007295417eb09fd$var$Wf), $1007295417eb09fd$var$E($1007295417eb09fd$var$H), $1007295417eb09fd$var$G($1007295417eb09fd$var$H, a)) : $1007295417eb09fd$var$E($1007295417eb09fd$var$Wf);
    $1007295417eb09fd$var$G($1007295417eb09fd$var$Wf, c);
}
var $1007295417eb09fd$var$eg = null, $1007295417eb09fd$var$fg = !1, $1007295417eb09fd$var$gg = !1;
function $1007295417eb09fd$var$hg(a) {
    null === $1007295417eb09fd$var$eg ? $1007295417eb09fd$var$eg = [
        a
    ] : $1007295417eb09fd$var$eg.push(a);
}
function $1007295417eb09fd$var$ig(a) {
    $1007295417eb09fd$var$fg = !0;
    $1007295417eb09fd$var$hg(a);
}
function $1007295417eb09fd$var$jg() {
    if (!$1007295417eb09fd$var$gg && null !== $1007295417eb09fd$var$eg) {
        $1007295417eb09fd$var$gg = !0;
        var a = 0, b = $1007295417eb09fd$var$C;
        try {
            var c = $1007295417eb09fd$var$eg;
            for($1007295417eb09fd$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $1007295417eb09fd$var$eg = null;
            $1007295417eb09fd$var$fg = !1;
        } catch (e) {
            throw null !== $1007295417eb09fd$var$eg && ($1007295417eb09fd$var$eg = $1007295417eb09fd$var$eg.slice(a + 1)), $1007295417eb09fd$var$ac($1007295417eb09fd$var$fc, $1007295417eb09fd$var$jg), e;
        } finally{
            $1007295417eb09fd$var$C = b, $1007295417eb09fd$var$gg = !1;
        }
    }
    return null;
}
var $1007295417eb09fd$var$kg = [], $1007295417eb09fd$var$lg = 0, $1007295417eb09fd$var$mg = null, $1007295417eb09fd$var$ng = 0, $1007295417eb09fd$var$og = [], $1007295417eb09fd$var$pg = 0, $1007295417eb09fd$var$qg = null, $1007295417eb09fd$var$rg = 1, $1007295417eb09fd$var$sg = "";
function $1007295417eb09fd$var$tg(a, b) {
    $1007295417eb09fd$var$kg[$1007295417eb09fd$var$lg++] = $1007295417eb09fd$var$ng;
    $1007295417eb09fd$var$kg[$1007295417eb09fd$var$lg++] = $1007295417eb09fd$var$mg;
    $1007295417eb09fd$var$mg = a;
    $1007295417eb09fd$var$ng = b;
}
function $1007295417eb09fd$var$ug(a, b, c) {
    $1007295417eb09fd$var$og[$1007295417eb09fd$var$pg++] = $1007295417eb09fd$var$rg;
    $1007295417eb09fd$var$og[$1007295417eb09fd$var$pg++] = $1007295417eb09fd$var$sg;
    $1007295417eb09fd$var$og[$1007295417eb09fd$var$pg++] = $1007295417eb09fd$var$qg;
    $1007295417eb09fd$var$qg = a;
    var d = $1007295417eb09fd$var$rg;
    a = $1007295417eb09fd$var$sg;
    var e = 32 - $1007295417eb09fd$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $1007295417eb09fd$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $1007295417eb09fd$var$rg = 1 << 32 - $1007295417eb09fd$var$oc(b) + e | c << e | d;
        $1007295417eb09fd$var$sg = f + a;
    } else $1007295417eb09fd$var$rg = 1 << f | c << e | d, $1007295417eb09fd$var$sg = a;
}
function $1007295417eb09fd$var$vg(a) {
    null !== a.return && ($1007295417eb09fd$var$tg(a, 1), $1007295417eb09fd$var$ug(a, 1, 0));
}
function $1007295417eb09fd$var$wg(a) {
    for(; a === $1007295417eb09fd$var$mg;)$1007295417eb09fd$var$mg = $1007295417eb09fd$var$kg[--$1007295417eb09fd$var$lg], $1007295417eb09fd$var$kg[$1007295417eb09fd$var$lg] = null, $1007295417eb09fd$var$ng = $1007295417eb09fd$var$kg[--$1007295417eb09fd$var$lg], $1007295417eb09fd$var$kg[$1007295417eb09fd$var$lg] = null;
    for(; a === $1007295417eb09fd$var$qg;)$1007295417eb09fd$var$qg = $1007295417eb09fd$var$og[--$1007295417eb09fd$var$pg], $1007295417eb09fd$var$og[$1007295417eb09fd$var$pg] = null, $1007295417eb09fd$var$sg = $1007295417eb09fd$var$og[--$1007295417eb09fd$var$pg], $1007295417eb09fd$var$og[$1007295417eb09fd$var$pg] = null, $1007295417eb09fd$var$rg = $1007295417eb09fd$var$og[--$1007295417eb09fd$var$pg], $1007295417eb09fd$var$og[$1007295417eb09fd$var$pg] = null;
}
var $1007295417eb09fd$var$xg = null, $1007295417eb09fd$var$yg = null, $1007295417eb09fd$var$I = !1, $1007295417eb09fd$var$zg = null;
function $1007295417eb09fd$var$Ag(a, b) {
    var c = $1007295417eb09fd$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $1007295417eb09fd$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $1007295417eb09fd$var$xg = a, $1007295417eb09fd$var$yg = $1007295417eb09fd$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $1007295417eb09fd$var$xg = a, $1007295417eb09fd$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $1007295417eb09fd$var$qg ? {
                id: $1007295417eb09fd$var$rg,
                overflow: $1007295417eb09fd$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $1007295417eb09fd$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $1007295417eb09fd$var$xg = a, $1007295417eb09fd$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $1007295417eb09fd$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $1007295417eb09fd$var$Eg(a) {
    if ($1007295417eb09fd$var$I) {
        var b = $1007295417eb09fd$var$yg;
        if (b) {
            var c = b;
            if (!$1007295417eb09fd$var$Cg(a, b)) {
                if ($1007295417eb09fd$var$Dg(a)) throw Error($1007295417eb09fd$var$p(418));
                b = $1007295417eb09fd$var$Lf(c.nextSibling);
                var d = $1007295417eb09fd$var$xg;
                b && $1007295417eb09fd$var$Cg(a, b) ? $1007295417eb09fd$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $1007295417eb09fd$var$I = !1, $1007295417eb09fd$var$xg = a);
            }
        } else {
            if ($1007295417eb09fd$var$Dg(a)) throw Error($1007295417eb09fd$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $1007295417eb09fd$var$I = !1;
            $1007295417eb09fd$var$xg = a;
        }
    }
}
function $1007295417eb09fd$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $1007295417eb09fd$var$xg = a;
}
function $1007295417eb09fd$var$Gg(a) {
    if (a !== $1007295417eb09fd$var$xg) return !1;
    if (!$1007295417eb09fd$var$I) return $1007295417eb09fd$var$Fg(a), $1007295417eb09fd$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$1007295417eb09fd$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $1007295417eb09fd$var$yg)) {
        if ($1007295417eb09fd$var$Dg(a)) throw $1007295417eb09fd$var$Hg(), Error($1007295417eb09fd$var$p(418));
        for(; b;)$1007295417eb09fd$var$Ag(a, b), b = $1007295417eb09fd$var$Lf(b.nextSibling);
    }
    $1007295417eb09fd$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($1007295417eb09fd$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $1007295417eb09fd$var$yg = $1007295417eb09fd$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $1007295417eb09fd$var$yg = null;
        }
    } else $1007295417eb09fd$var$yg = $1007295417eb09fd$var$xg ? $1007295417eb09fd$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $1007295417eb09fd$var$Hg() {
    for(var a = $1007295417eb09fd$var$yg; a;)a = $1007295417eb09fd$var$Lf(a.nextSibling);
}
function $1007295417eb09fd$var$Ig() {
    $1007295417eb09fd$var$yg = $1007295417eb09fd$var$xg = null;
    $1007295417eb09fd$var$I = !1;
}
function $1007295417eb09fd$var$Jg(a) {
    null === $1007295417eb09fd$var$zg ? $1007295417eb09fd$var$zg = [
        a
    ] : $1007295417eb09fd$var$zg.push(a);
}
var $1007295417eb09fd$var$Kg = $1007295417eb09fd$var$ua.ReactCurrentBatchConfig;
function $1007295417eb09fd$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $1007295417eb09fd$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $1007295417eb09fd$var$Mg = $1007295417eb09fd$var$Uf(null), $1007295417eb09fd$var$Ng = null, $1007295417eb09fd$var$Og = null, $1007295417eb09fd$var$Pg = null;
function $1007295417eb09fd$var$Qg() {
    $1007295417eb09fd$var$Pg = $1007295417eb09fd$var$Og = $1007295417eb09fd$var$Ng = null;
}
function $1007295417eb09fd$var$Rg(a) {
    var b = $1007295417eb09fd$var$Mg.current;
    $1007295417eb09fd$var$E($1007295417eb09fd$var$Mg);
    a._currentValue = b;
}
function $1007295417eb09fd$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $1007295417eb09fd$var$Tg(a, b) {
    $1007295417eb09fd$var$Ng = a;
    $1007295417eb09fd$var$Pg = $1007295417eb09fd$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($1007295417eb09fd$var$Ug = !0), a.firstContext = null);
}
function $1007295417eb09fd$var$Vg(a) {
    var b = a._currentValue;
    if ($1007295417eb09fd$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $1007295417eb09fd$var$Og) {
            if (null === $1007295417eb09fd$var$Ng) throw Error($1007295417eb09fd$var$p(308));
            $1007295417eb09fd$var$Og = a;
            $1007295417eb09fd$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $1007295417eb09fd$var$Og = $1007295417eb09fd$var$Og.next = a;
    }
    return b;
}
var $1007295417eb09fd$var$Wg = null;
function $1007295417eb09fd$var$Xg(a) {
    null === $1007295417eb09fd$var$Wg ? $1007295417eb09fd$var$Wg = [
        a
    ] : $1007295417eb09fd$var$Wg.push(a);
}
function $1007295417eb09fd$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $1007295417eb09fd$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $1007295417eb09fd$var$Zg(a, d);
}
function $1007295417eb09fd$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $1007295417eb09fd$var$$g = !1;
function $1007295417eb09fd$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $1007295417eb09fd$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $1007295417eb09fd$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $1007295417eb09fd$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($1007295417eb09fd$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $1007295417eb09fd$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $1007295417eb09fd$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $1007295417eb09fd$var$Zg(a, c);
}
function $1007295417eb09fd$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $1007295417eb09fd$var$Cc(a, c);
    }
}
function $1007295417eb09fd$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $1007295417eb09fd$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $1007295417eb09fd$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $1007295417eb09fd$var$A({}, q, r);
                            break a;
                        case 2:
                            $1007295417eb09fd$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $1007295417eb09fd$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $1007295417eb09fd$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($1007295417eb09fd$var$p(191, e));
            e.call(d);
        }
    }
}
var $1007295417eb09fd$var$jh = (new $4rNTR.Component).refs;
function $1007295417eb09fd$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $1007295417eb09fd$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $1007295417eb09fd$var$nh = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $1007295417eb09fd$var$Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $1007295417eb09fd$var$L(), e = $1007295417eb09fd$var$lh(a), f = $1007295417eb09fd$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $1007295417eb09fd$var$dh(a, f, e);
        null !== b && ($1007295417eb09fd$var$mh(b, a, e, d), $1007295417eb09fd$var$eh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $1007295417eb09fd$var$L(), e = $1007295417eb09fd$var$lh(a), f = $1007295417eb09fd$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $1007295417eb09fd$var$dh(a, f, e);
        null !== b && ($1007295417eb09fd$var$mh(b, a, e, d), $1007295417eb09fd$var$eh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $1007295417eb09fd$var$L(), d = $1007295417eb09fd$var$lh(a), e = $1007295417eb09fd$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $1007295417eb09fd$var$dh(a, e, d);
        null !== b && ($1007295417eb09fd$var$mh(b, a, d, c), $1007295417eb09fd$var$eh(b, a, d));
    }
};
function $1007295417eb09fd$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$1007295417eb09fd$var$Ie(c, d) || !$1007295417eb09fd$var$Ie(e, f) : !0;
}
function $1007295417eb09fd$var$ph(a, b, c) {
    var d = !1, e = $1007295417eb09fd$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $1007295417eb09fd$var$Vg(f) : (e = $1007295417eb09fd$var$Zf(b) ? $1007295417eb09fd$var$Xf : $1007295417eb09fd$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $1007295417eb09fd$var$Yf(a, e) : $1007295417eb09fd$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $1007295417eb09fd$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $1007295417eb09fd$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $1007295417eb09fd$var$nh.enqueueReplaceState(b, b.state, null);
}
function $1007295417eb09fd$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $1007295417eb09fd$var$jh;
    $1007295417eb09fd$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $1007295417eb09fd$var$Vg(f) : (f = $1007295417eb09fd$var$Zf(b) ? $1007295417eb09fd$var$Xf : $1007295417eb09fd$var$H.current, e.context = $1007295417eb09fd$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($1007295417eb09fd$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $1007295417eb09fd$var$nh.enqueueReplaceState(e, e.state, null), $1007295417eb09fd$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $1007295417eb09fd$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($1007295417eb09fd$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($1007295417eb09fd$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                _$b === $1007295417eb09fd$var$jh && (_$b = e.refs = {});
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($1007295417eb09fd$var$p(284));
        if (!c._owner) throw Error($1007295417eb09fd$var$p(290, a));
    }
    return a;
}
function $1007295417eb09fd$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($1007295417eb09fd$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $1007295417eb09fd$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $1007295417eb09fd$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $1007295417eb09fd$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $1007295417eb09fd$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $1007295417eb09fd$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $1007295417eb09fd$var$Ha && $1007295417eb09fd$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $1007295417eb09fd$var$sh(a, b, c), d.return = a, d;
        d = $1007295417eb09fd$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $1007295417eb09fd$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $1007295417eb09fd$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $1007295417eb09fd$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $1007295417eb09fd$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $1007295417eb09fd$var$va:
                    return c = $1007295417eb09fd$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $1007295417eb09fd$var$sh(a, null, b), c.return = a, c;
                case $1007295417eb09fd$var$wa:
                    return b = $1007295417eb09fd$var$zh(b, a.mode, c), b.return = a, b;
                case $1007295417eb09fd$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($1007295417eb09fd$var$eb(b) || $1007295417eb09fd$var$Ka(b)) return b = $1007295417eb09fd$var$Ah(b, a.mode, c, null), b.return = a, b;
            $1007295417eb09fd$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $1007295417eb09fd$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $1007295417eb09fd$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $1007295417eb09fd$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($1007295417eb09fd$var$eb(c) || $1007295417eb09fd$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $1007295417eb09fd$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $1007295417eb09fd$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $1007295417eb09fd$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $1007295417eb09fd$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($1007295417eb09fd$var$eb(d) || $1007295417eb09fd$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $1007295417eb09fd$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $1007295417eb09fd$var$I && $1007295417eb09fd$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $1007295417eb09fd$var$I && $1007295417eb09fd$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $1007295417eb09fd$var$I && $1007295417eb09fd$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $1007295417eb09fd$var$Ka(h);
        if ("function" !== typeof l) throw Error($1007295417eb09fd$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($1007295417eb09fd$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $1007295417eb09fd$var$I && $1007295417eb09fd$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $1007295417eb09fd$var$I && $1007295417eb09fd$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $1007295417eb09fd$var$I && $1007295417eb09fd$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $1007295417eb09fd$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $1007295417eb09fd$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $1007295417eb09fd$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $1007295417eb09fd$var$Ha && $1007295417eb09fd$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $1007295417eb09fd$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $1007295417eb09fd$var$ya ? (d = $1007295417eb09fd$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $1007295417eb09fd$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $1007295417eb09fd$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $1007295417eb09fd$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $1007295417eb09fd$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $1007295417eb09fd$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($1007295417eb09fd$var$eb(f)) return n(a, d, f, h);
            if ($1007295417eb09fd$var$Ka(f)) return t(a, d, f, h);
            $1007295417eb09fd$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $1007295417eb09fd$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $1007295417eb09fd$var$Bh = $1007295417eb09fd$var$vh(!0), $1007295417eb09fd$var$Ch = $1007295417eb09fd$var$vh(!1), $1007295417eb09fd$var$Dh = {}, $1007295417eb09fd$var$Eh = $1007295417eb09fd$var$Uf($1007295417eb09fd$var$Dh), $1007295417eb09fd$var$Fh = $1007295417eb09fd$var$Uf($1007295417eb09fd$var$Dh), $1007295417eb09fd$var$Gh = $1007295417eb09fd$var$Uf($1007295417eb09fd$var$Dh);
function $1007295417eb09fd$var$Hh(a) {
    if (a === $1007295417eb09fd$var$Dh) throw Error($1007295417eb09fd$var$p(174));
    return a;
}
function $1007295417eb09fd$var$Ih(a, b) {
    $1007295417eb09fd$var$G($1007295417eb09fd$var$Gh, b);
    $1007295417eb09fd$var$G($1007295417eb09fd$var$Fh, a);
    $1007295417eb09fd$var$G($1007295417eb09fd$var$Eh, $1007295417eb09fd$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $1007295417eb09fd$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $1007295417eb09fd$var$lb(b, a);
    }
    $1007295417eb09fd$var$E($1007295417eb09fd$var$Eh);
    $1007295417eb09fd$var$G($1007295417eb09fd$var$Eh, b);
}
function $1007295417eb09fd$var$Jh() {
    $1007295417eb09fd$var$E($1007295417eb09fd$var$Eh);
    $1007295417eb09fd$var$E($1007295417eb09fd$var$Fh);
    $1007295417eb09fd$var$E($1007295417eb09fd$var$Gh);
}
function $1007295417eb09fd$var$Kh(a) {
    $1007295417eb09fd$var$Hh($1007295417eb09fd$var$Gh.current);
    var b = $1007295417eb09fd$var$Hh($1007295417eb09fd$var$Eh.current);
    var c = $1007295417eb09fd$var$lb(b, a.type);
    b !== c && ($1007295417eb09fd$var$G($1007295417eb09fd$var$Fh, a), $1007295417eb09fd$var$G($1007295417eb09fd$var$Eh, c));
}
function $1007295417eb09fd$var$Lh(a) {
    $1007295417eb09fd$var$Fh.current === a && ($1007295417eb09fd$var$E($1007295417eb09fd$var$Eh), $1007295417eb09fd$var$E($1007295417eb09fd$var$Fh));
}
var $1007295417eb09fd$var$M = $1007295417eb09fd$var$Uf(0);
function $1007295417eb09fd$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $1007295417eb09fd$var$Nh = [];
function $1007295417eb09fd$var$Oh() {
    for(var a = 0; a < $1007295417eb09fd$var$Nh.length; a++)$1007295417eb09fd$var$Nh[a]._workInProgressVersionPrimary = null;
    $1007295417eb09fd$var$Nh.length = 0;
}
var $1007295417eb09fd$var$Ph = $1007295417eb09fd$var$ua.ReactCurrentDispatcher, $1007295417eb09fd$var$Qh = $1007295417eb09fd$var$ua.ReactCurrentBatchConfig, $1007295417eb09fd$var$Rh = 0, $1007295417eb09fd$var$N = null, $1007295417eb09fd$var$O = null, $1007295417eb09fd$var$P = null, $1007295417eb09fd$var$Sh = !1, $1007295417eb09fd$var$Th = !1, $1007295417eb09fd$var$Uh = 0, $1007295417eb09fd$var$Vh = 0;
function $1007295417eb09fd$var$Q() {
    throw Error($1007295417eb09fd$var$p(321));
}
function $1007295417eb09fd$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$1007295417eb09fd$var$He(a[c], b[c])) return !1;
    return !0;
}
function $1007295417eb09fd$var$Xh(a, b, c, d, e, f) {
    $1007295417eb09fd$var$Rh = f;
    $1007295417eb09fd$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $1007295417eb09fd$var$Ph.current = null === a || null === a.memoizedState ? $1007295417eb09fd$var$Yh : $1007295417eb09fd$var$Zh;
    a = c(d, e);
    if ($1007295417eb09fd$var$Th) {
        f = 0;
        do {
            $1007295417eb09fd$var$Th = !1;
            $1007295417eb09fd$var$Uh = 0;
            if (25 <= f) throw Error($1007295417eb09fd$var$p(301));
            f += 1;
            $1007295417eb09fd$var$P = $1007295417eb09fd$var$O = null;
            b.updateQueue = null;
            $1007295417eb09fd$var$Ph.current = $1007295417eb09fd$var$$h;
            a = c(d, e);
        }while ($1007295417eb09fd$var$Th);
    }
    $1007295417eb09fd$var$Ph.current = $1007295417eb09fd$var$ai;
    b = null !== $1007295417eb09fd$var$O && null !== $1007295417eb09fd$var$O.next;
    $1007295417eb09fd$var$Rh = 0;
    $1007295417eb09fd$var$P = $1007295417eb09fd$var$O = $1007295417eb09fd$var$N = null;
    $1007295417eb09fd$var$Sh = !1;
    if (b) throw Error($1007295417eb09fd$var$p(300));
    return a;
}
function $1007295417eb09fd$var$bi() {
    var a = 0 !== $1007295417eb09fd$var$Uh;
    $1007295417eb09fd$var$Uh = 0;
    return a;
}
function $1007295417eb09fd$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $1007295417eb09fd$var$P ? $1007295417eb09fd$var$N.memoizedState = $1007295417eb09fd$var$P = a : $1007295417eb09fd$var$P = $1007295417eb09fd$var$P.next = a;
    return $1007295417eb09fd$var$P;
}
function $1007295417eb09fd$var$di() {
    if (null === $1007295417eb09fd$var$O) {
        var a = $1007295417eb09fd$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $1007295417eb09fd$var$O.next;
    var b = null === $1007295417eb09fd$var$P ? $1007295417eb09fd$var$N.memoizedState : $1007295417eb09fd$var$P.next;
    if (null !== b) $1007295417eb09fd$var$P = b, $1007295417eb09fd$var$O = a;
    else {
        if (null === a) throw Error($1007295417eb09fd$var$p(310));
        $1007295417eb09fd$var$O = a;
        a = {
            memoizedState: $1007295417eb09fd$var$O.memoizedState,
            baseState: $1007295417eb09fd$var$O.baseState,
            baseQueue: $1007295417eb09fd$var$O.baseQueue,
            queue: $1007295417eb09fd$var$O.queue,
            next: null
        };
        null === $1007295417eb09fd$var$P ? $1007295417eb09fd$var$N.memoizedState = $1007295417eb09fd$var$P = a : $1007295417eb09fd$var$P = $1007295417eb09fd$var$P.next = a;
    }
    return $1007295417eb09fd$var$P;
}
function $1007295417eb09fd$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $1007295417eb09fd$var$fi(a) {
    var b = $1007295417eb09fd$var$di(), c = b.queue;
    if (null === c) throw Error($1007295417eb09fd$var$p(311));
    c.lastRenderedReducer = a;
    var d = $1007295417eb09fd$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($1007295417eb09fd$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $1007295417eb09fd$var$N.lanes |= m;
                $1007295417eb09fd$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $1007295417eb09fd$var$He(d, b.memoizedState) || ($1007295417eb09fd$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $1007295417eb09fd$var$N.lanes |= f, $1007295417eb09fd$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $1007295417eb09fd$var$gi(a) {
    var b = $1007295417eb09fd$var$di(), c = b.queue;
    if (null === c) throw Error($1007295417eb09fd$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $1007295417eb09fd$var$He(f, b.memoizedState) || ($1007295417eb09fd$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $1007295417eb09fd$var$hi() {}
function $1007295417eb09fd$var$ii(a, b) {
    var c = $1007295417eb09fd$var$N, d = $1007295417eb09fd$var$di(), e = b(), f = !$1007295417eb09fd$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $1007295417eb09fd$var$Ug = !0);
    d = d.queue;
    $1007295417eb09fd$var$ji($1007295417eb09fd$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $1007295417eb09fd$var$P && $1007295417eb09fd$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $1007295417eb09fd$var$li(9, $1007295417eb09fd$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $1007295417eb09fd$var$R) throw Error($1007295417eb09fd$var$p(349));
        0 !== ($1007295417eb09fd$var$Rh & 30) || $1007295417eb09fd$var$ni(c, b, e);
    }
    return e;
}
function $1007295417eb09fd$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $1007295417eb09fd$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $1007295417eb09fd$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $1007295417eb09fd$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $1007295417eb09fd$var$oi(b) && $1007295417eb09fd$var$pi(a);
}
function $1007295417eb09fd$var$ki(a, b, c) {
    return c(function() {
        $1007295417eb09fd$var$oi(b) && $1007295417eb09fd$var$pi(a);
    });
}
function $1007295417eb09fd$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$1007295417eb09fd$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $1007295417eb09fd$var$pi(a) {
    var b = $1007295417eb09fd$var$Zg(a, 1);
    null !== b && $1007295417eb09fd$var$mh(b, a, 1, -1);
}
function $1007295417eb09fd$var$qi(a) {
    var b = $1007295417eb09fd$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $1007295417eb09fd$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $1007295417eb09fd$var$ri.bind(null, $1007295417eb09fd$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $1007295417eb09fd$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $1007295417eb09fd$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $1007295417eb09fd$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $1007295417eb09fd$var$si() {
    return $1007295417eb09fd$var$di().memoizedState;
}
function $1007295417eb09fd$var$ti(a, b, c, d) {
    var e = $1007295417eb09fd$var$ci();
    $1007295417eb09fd$var$N.flags |= a;
    e.memoizedState = $1007295417eb09fd$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $1007295417eb09fd$var$ui(a, b, c, d) {
    var e = $1007295417eb09fd$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $1007295417eb09fd$var$O) {
        var g = $1007295417eb09fd$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $1007295417eb09fd$var$Wh(d, g.deps)) {
            e.memoizedState = $1007295417eb09fd$var$li(b, c, f, d);
            return;
        }
    }
    $1007295417eb09fd$var$N.flags |= a;
    e.memoizedState = $1007295417eb09fd$var$li(1 | b, c, f, d);
}
function $1007295417eb09fd$var$vi(a, b) {
    return $1007295417eb09fd$var$ti(8390656, 8, a, b);
}
function $1007295417eb09fd$var$ji(a, b) {
    return $1007295417eb09fd$var$ui(2048, 8, a, b);
}
function $1007295417eb09fd$var$wi(a, b) {
    return $1007295417eb09fd$var$ui(4, 2, a, b);
}
function $1007295417eb09fd$var$xi(a, b) {
    return $1007295417eb09fd$var$ui(4, 4, a, b);
}
function $1007295417eb09fd$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $1007295417eb09fd$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $1007295417eb09fd$var$ui(4, 4, $1007295417eb09fd$var$yi.bind(null, b, a), c);
}
function $1007295417eb09fd$var$Ai() {}
function $1007295417eb09fd$var$Bi(a, b) {
    var c = $1007295417eb09fd$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $1007295417eb09fd$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $1007295417eb09fd$var$Ci(a, b) {
    var c = $1007295417eb09fd$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $1007295417eb09fd$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $1007295417eb09fd$var$Di(a, b, c) {
    if (0 === ($1007295417eb09fd$var$Rh & 21)) return a.baseState && (a.baseState = !1, $1007295417eb09fd$var$Ug = !0), a.memoizedState = c;
    $1007295417eb09fd$var$He(c, b) || (c = $1007295417eb09fd$var$yc(), $1007295417eb09fd$var$N.lanes |= c, $1007295417eb09fd$var$hh |= c, a.baseState = !0);
    return b;
}
function $1007295417eb09fd$var$Ei(a, b) {
    var c = $1007295417eb09fd$var$C;
    $1007295417eb09fd$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $1007295417eb09fd$var$Qh.transition;
    $1007295417eb09fd$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $1007295417eb09fd$var$C = c, $1007295417eb09fd$var$Qh.transition = d;
    }
}
function $1007295417eb09fd$var$Fi() {
    return $1007295417eb09fd$var$di().memoizedState;
}
function $1007295417eb09fd$var$Gi(a, b, c) {
    var d = $1007295417eb09fd$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($1007295417eb09fd$var$Hi(a)) $1007295417eb09fd$var$Ii(b, c);
    else if (c = $1007295417eb09fd$var$Yg(a, b, c, d), null !== c) {
        var e = $1007295417eb09fd$var$L();
        $1007295417eb09fd$var$mh(c, a, d, e);
        $1007295417eb09fd$var$Ji(c, b, d);
    }
}
function $1007295417eb09fd$var$ri(a, b, c) {
    var d = $1007295417eb09fd$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($1007295417eb09fd$var$Hi(a)) $1007295417eb09fd$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($1007295417eb09fd$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $1007295417eb09fd$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $1007295417eb09fd$var$Yg(a, b, e, d);
        null !== c && (e = $1007295417eb09fd$var$L(), $1007295417eb09fd$var$mh(c, a, d, e), $1007295417eb09fd$var$Ji(c, b, d));
    }
}
function $1007295417eb09fd$var$Hi(a) {
    var b = a.alternate;
    return a === $1007295417eb09fd$var$N || null !== b && b === $1007295417eb09fd$var$N;
}
function $1007295417eb09fd$var$Ii(a, b) {
    $1007295417eb09fd$var$Th = $1007295417eb09fd$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $1007295417eb09fd$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $1007295417eb09fd$var$Cc(a, c);
    }
}
var $1007295417eb09fd$var$ai = {
    readContext: $1007295417eb09fd$var$Vg,
    useCallback: $1007295417eb09fd$var$Q,
    useContext: $1007295417eb09fd$var$Q,
    useEffect: $1007295417eb09fd$var$Q,
    useImperativeHandle: $1007295417eb09fd$var$Q,
    useInsertionEffect: $1007295417eb09fd$var$Q,
    useLayoutEffect: $1007295417eb09fd$var$Q,
    useMemo: $1007295417eb09fd$var$Q,
    useReducer: $1007295417eb09fd$var$Q,
    useRef: $1007295417eb09fd$var$Q,
    useState: $1007295417eb09fd$var$Q,
    useDebugValue: $1007295417eb09fd$var$Q,
    useDeferredValue: $1007295417eb09fd$var$Q,
    useTransition: $1007295417eb09fd$var$Q,
    useMutableSource: $1007295417eb09fd$var$Q,
    useSyncExternalStore: $1007295417eb09fd$var$Q,
    useId: $1007295417eb09fd$var$Q,
    unstable_isNewReconciler: !1
}, $1007295417eb09fd$var$Yh = {
    readContext: $1007295417eb09fd$var$Vg,
    useCallback: function useCallback(a, b) {
        $1007295417eb09fd$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $1007295417eb09fd$var$Vg,
    useEffect: $1007295417eb09fd$var$vi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $1007295417eb09fd$var$ti(4194308, 4, $1007295417eb09fd$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $1007295417eb09fd$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return $1007295417eb09fd$var$ti(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $1007295417eb09fd$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $1007295417eb09fd$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $1007295417eb09fd$var$Gi.bind(null, $1007295417eb09fd$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = $1007295417eb09fd$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $1007295417eb09fd$var$qi,
    useDebugValue: $1007295417eb09fd$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        return $1007295417eb09fd$var$ci().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = $1007295417eb09fd$var$qi(!1), b = a[0];
        a = $1007295417eb09fd$var$Ei.bind(null, a[1]);
        $1007295417eb09fd$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = $1007295417eb09fd$var$N, e = $1007295417eb09fd$var$ci();
        if ($1007295417eb09fd$var$I) {
            if (void 0 === c) throw Error($1007295417eb09fd$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $1007295417eb09fd$var$R) throw Error($1007295417eb09fd$var$p(349));
            0 !== ($1007295417eb09fd$var$Rh & 30) || $1007295417eb09fd$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $1007295417eb09fd$var$vi($1007295417eb09fd$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $1007295417eb09fd$var$li(9, $1007295417eb09fd$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = $1007295417eb09fd$var$ci(), b = $1007295417eb09fd$var$R.identifierPrefix;
        if ($1007295417eb09fd$var$I) {
            var c = $1007295417eb09fd$var$sg;
            var d = $1007295417eb09fd$var$rg;
            c = (d & ~(1 << 32 - $1007295417eb09fd$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $1007295417eb09fd$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $1007295417eb09fd$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $1007295417eb09fd$var$Zh = {
    readContext: $1007295417eb09fd$var$Vg,
    useCallback: $1007295417eb09fd$var$Bi,
    useContext: $1007295417eb09fd$var$Vg,
    useEffect: $1007295417eb09fd$var$ji,
    useImperativeHandle: $1007295417eb09fd$var$zi,
    useInsertionEffect: $1007295417eb09fd$var$wi,
    useLayoutEffect: $1007295417eb09fd$var$xi,
    useMemo: $1007295417eb09fd$var$Ci,
    useReducer: $1007295417eb09fd$var$fi,
    useRef: $1007295417eb09fd$var$si,
    useState: function useState() {
        return $1007295417eb09fd$var$fi($1007295417eb09fd$var$ei);
    },
    useDebugValue: $1007295417eb09fd$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $1007295417eb09fd$var$di();
        return $1007295417eb09fd$var$Di(b, $1007295417eb09fd$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $1007295417eb09fd$var$fi($1007295417eb09fd$var$ei)[0], b = $1007295417eb09fd$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $1007295417eb09fd$var$hi,
    useSyncExternalStore: $1007295417eb09fd$var$ii,
    useId: $1007295417eb09fd$var$Fi,
    unstable_isNewReconciler: !1
}, $1007295417eb09fd$var$$h = {
    readContext: $1007295417eb09fd$var$Vg,
    useCallback: $1007295417eb09fd$var$Bi,
    useContext: $1007295417eb09fd$var$Vg,
    useEffect: $1007295417eb09fd$var$ji,
    useImperativeHandle: $1007295417eb09fd$var$zi,
    useInsertionEffect: $1007295417eb09fd$var$wi,
    useLayoutEffect: $1007295417eb09fd$var$xi,
    useMemo: $1007295417eb09fd$var$Ci,
    useReducer: $1007295417eb09fd$var$gi,
    useRef: $1007295417eb09fd$var$si,
    useState: function useState() {
        return $1007295417eb09fd$var$gi($1007295417eb09fd$var$ei);
    },
    useDebugValue: $1007295417eb09fd$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $1007295417eb09fd$var$di();
        return null === $1007295417eb09fd$var$O ? b.memoizedState = a : $1007295417eb09fd$var$Di(b, $1007295417eb09fd$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $1007295417eb09fd$var$gi($1007295417eb09fd$var$ei)[0], b = $1007295417eb09fd$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $1007295417eb09fd$var$hi,
    useSyncExternalStore: $1007295417eb09fd$var$ii,
    useId: $1007295417eb09fd$var$Fi,
    unstable_isNewReconciler: !1
};
function $1007295417eb09fd$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $1007295417eb09fd$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $1007295417eb09fd$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $1007295417eb09fd$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $1007295417eb09fd$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $1007295417eb09fd$var$Oi(a, b, c) {
    c = $1007295417eb09fd$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $1007295417eb09fd$var$Pi || ($1007295417eb09fd$var$Pi = !0, $1007295417eb09fd$var$Qi = d);
        $1007295417eb09fd$var$Mi(a, b);
    };
    return c;
}
function $1007295417eb09fd$var$Ri(a, b, c) {
    c = $1007295417eb09fd$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $1007295417eb09fd$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $1007295417eb09fd$var$Mi(a, b);
        "function" !== typeof d && (null === $1007295417eb09fd$var$Si ? $1007295417eb09fd$var$Si = new Set([
            this
        ]) : $1007295417eb09fd$var$Si.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function $1007295417eb09fd$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $1007295417eb09fd$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $1007295417eb09fd$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $1007295417eb09fd$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $1007295417eb09fd$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $1007295417eb09fd$var$ch(-1, 1), b.tag = 2, $1007295417eb09fd$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $1007295417eb09fd$var$Xi = $1007295417eb09fd$var$ua.ReactCurrentOwner, $1007295417eb09fd$var$Ug = !1;
function $1007295417eb09fd$var$Yi(a, b, c, d) {
    b.child = null === a ? $1007295417eb09fd$var$Ch(b, null, c, d) : $1007295417eb09fd$var$Bh(b, a.child, c, d);
}
function $1007295417eb09fd$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $1007295417eb09fd$var$Tg(b, e);
    d = $1007295417eb09fd$var$Xh(a, b, c, d, f, e);
    c = $1007295417eb09fd$var$bi();
    if (null !== a && !$1007295417eb09fd$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $1007295417eb09fd$var$$i(a, b, e);
    $1007295417eb09fd$var$I && c && $1007295417eb09fd$var$vg(b);
    b.flags |= 1;
    $1007295417eb09fd$var$Yi(a, b, d, e);
    return b.child;
}
function $1007295417eb09fd$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$1007295417eb09fd$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $1007295417eb09fd$var$cj(a, b, f, d, e);
        a = $1007295417eb09fd$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $1007295417eb09fd$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $1007295417eb09fd$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $1007295417eb09fd$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $1007295417eb09fd$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($1007295417eb09fd$var$Ie(f, d) && a.ref === b.ref) {
            if ($1007295417eb09fd$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($1007295417eb09fd$var$Ug = !0);
            else return b.lanes = a.lanes, $1007295417eb09fd$var$$i(a, b, e);
        }
    }
    return $1007295417eb09fd$var$dj(a, b, c, d, e);
}
function $1007295417eb09fd$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $1007295417eb09fd$var$G($1007295417eb09fd$var$fj, $1007295417eb09fd$var$gj), $1007295417eb09fd$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $1007295417eb09fd$var$G($1007295417eb09fd$var$fj, $1007295417eb09fd$var$gj), $1007295417eb09fd$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $1007295417eb09fd$var$G($1007295417eb09fd$var$fj, $1007295417eb09fd$var$gj);
            $1007295417eb09fd$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $1007295417eb09fd$var$G($1007295417eb09fd$var$fj, $1007295417eb09fd$var$gj), $1007295417eb09fd$var$gj |= d;
    $1007295417eb09fd$var$Yi(a, b, e, c);
    return b.child;
}
function $1007295417eb09fd$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $1007295417eb09fd$var$dj(a, b, c, d, e) {
    var f = $1007295417eb09fd$var$Zf(c) ? $1007295417eb09fd$var$Xf : $1007295417eb09fd$var$H.current;
    f = $1007295417eb09fd$var$Yf(b, f);
    $1007295417eb09fd$var$Tg(b, e);
    c = $1007295417eb09fd$var$Xh(a, b, c, d, f, e);
    d = $1007295417eb09fd$var$bi();
    if (null !== a && !$1007295417eb09fd$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $1007295417eb09fd$var$$i(a, b, e);
    $1007295417eb09fd$var$I && d && $1007295417eb09fd$var$vg(b);
    b.flags |= 1;
    $1007295417eb09fd$var$Yi(a, b, c, e);
    return b.child;
}
function $1007295417eb09fd$var$ij(a, b, c, d, e) {
    if ($1007295417eb09fd$var$Zf(c)) {
        var f = !0;
        $1007295417eb09fd$var$cg(b);
    } else f = !1;
    $1007295417eb09fd$var$Tg(b, e);
    if (null === b.stateNode) $1007295417eb09fd$var$jj(a, b), $1007295417eb09fd$var$ph(b, c, d), $1007295417eb09fd$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $1007295417eb09fd$var$Vg(l) : (l = $1007295417eb09fd$var$Zf(c) ? $1007295417eb09fd$var$Xf : $1007295417eb09fd$var$H.current, l = $1007295417eb09fd$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $1007295417eb09fd$var$qh(b, g, d, l);
        $1007295417eb09fd$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $1007295417eb09fd$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $1007295417eb09fd$var$Wf.current || $1007295417eb09fd$var$$g ? ("function" === typeof m && ($1007295417eb09fd$var$kh(b, c, m, d), k = b.memoizedState), (h = $1007295417eb09fd$var$$g || $1007295417eb09fd$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $1007295417eb09fd$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $1007295417eb09fd$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $1007295417eb09fd$var$Vg(k) : (k = $1007295417eb09fd$var$Zf(c) ? $1007295417eb09fd$var$Xf : $1007295417eb09fd$var$H.current, k = $1007295417eb09fd$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $1007295417eb09fd$var$qh(b, g, d, k);
        $1007295417eb09fd$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $1007295417eb09fd$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $1007295417eb09fd$var$Wf.current || $1007295417eb09fd$var$$g ? ("function" === typeof y && ($1007295417eb09fd$var$kh(b, c, y, d), n = b.memoizedState), (l = $1007295417eb09fd$var$$g || $1007295417eb09fd$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $1007295417eb09fd$var$kj(a, b, c, d, f, e);
}
function $1007295417eb09fd$var$kj(a, b, c, d, e, f) {
    $1007295417eb09fd$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $1007295417eb09fd$var$dg(b, c, !1), $1007295417eb09fd$var$$i(a, b, f);
    d = b.stateNode;
    $1007295417eb09fd$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $1007295417eb09fd$var$Bh(b, a.child, null, f), b.child = $1007295417eb09fd$var$Bh(b, null, h, f)) : $1007295417eb09fd$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $1007295417eb09fd$var$dg(b, c, !0);
    return b.child;
}
function $1007295417eb09fd$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $1007295417eb09fd$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $1007295417eb09fd$var$ag(a, b.context, !1);
    $1007295417eb09fd$var$Ih(a, b.containerInfo);
}
function $1007295417eb09fd$var$mj(a, b, c, d, e) {
    $1007295417eb09fd$var$Ig();
    $1007295417eb09fd$var$Jg(e);
    b.flags |= 256;
    $1007295417eb09fd$var$Yi(a, b, c, d);
    return b.child;
}
var $1007295417eb09fd$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $1007295417eb09fd$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $1007295417eb09fd$var$pj(a, b, c) {
    var d = b.pendingProps, e = $1007295417eb09fd$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $1007295417eb09fd$var$G($1007295417eb09fd$var$M, e & 1);
    if (null === a) {
        $1007295417eb09fd$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $1007295417eb09fd$var$qj(g, d, 0, null), a = $1007295417eb09fd$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $1007295417eb09fd$var$oj(c), b.memoizedState = $1007295417eb09fd$var$nj, a) : $1007295417eb09fd$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $1007295417eb09fd$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $1007295417eb09fd$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $1007295417eb09fd$var$wh(h, f) : (f = $1007295417eb09fd$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $1007295417eb09fd$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $1007295417eb09fd$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $1007295417eb09fd$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $1007295417eb09fd$var$rj(a, b) {
    b = $1007295417eb09fd$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $1007295417eb09fd$var$tj(a, b, c, d) {
    null !== d && $1007295417eb09fd$var$Jg(d);
    $1007295417eb09fd$var$Bh(b, a.child, null, c);
    a = $1007295417eb09fd$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $1007295417eb09fd$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $1007295417eb09fd$var$Li(Error($1007295417eb09fd$var$p(422))), $1007295417eb09fd$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $1007295417eb09fd$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $1007295417eb09fd$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $1007295417eb09fd$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $1007295417eb09fd$var$oj(g);
        b.memoizedState = $1007295417eb09fd$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $1007295417eb09fd$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($1007295417eb09fd$var$p(419));
        d = $1007295417eb09fd$var$Li(f, d, void 0);
        return $1007295417eb09fd$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($1007295417eb09fd$var$Ug || h) {
        d = $1007295417eb09fd$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $1007295417eb09fd$var$Zg(a, e), $1007295417eb09fd$var$mh(d, a, e, -1));
        }
        $1007295417eb09fd$var$uj();
        d = $1007295417eb09fd$var$Li(Error($1007295417eb09fd$var$p(421)));
        return $1007295417eb09fd$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $1007295417eb09fd$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $1007295417eb09fd$var$yg = $1007295417eb09fd$var$Lf(e.nextSibling);
    $1007295417eb09fd$var$xg = b;
    $1007295417eb09fd$var$I = !0;
    $1007295417eb09fd$var$zg = null;
    null !== a && ($1007295417eb09fd$var$og[$1007295417eb09fd$var$pg++] = $1007295417eb09fd$var$rg, $1007295417eb09fd$var$og[$1007295417eb09fd$var$pg++] = $1007295417eb09fd$var$sg, $1007295417eb09fd$var$og[$1007295417eb09fd$var$pg++] = $1007295417eb09fd$var$qg, $1007295417eb09fd$var$rg = a.id, $1007295417eb09fd$var$sg = a.overflow, $1007295417eb09fd$var$qg = b);
    b = $1007295417eb09fd$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $1007295417eb09fd$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $1007295417eb09fd$var$Sg(a.return, b, c);
}
function $1007295417eb09fd$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $1007295417eb09fd$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $1007295417eb09fd$var$Yi(a, b, d.children, c);
    d = $1007295417eb09fd$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $1007295417eb09fd$var$wj(a, c, b);
            else if (19 === a.tag) $1007295417eb09fd$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $1007295417eb09fd$var$G($1007295417eb09fd$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $1007295417eb09fd$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $1007295417eb09fd$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $1007295417eb09fd$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $1007295417eb09fd$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $1007295417eb09fd$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $1007295417eb09fd$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $1007295417eb09fd$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $1007295417eb09fd$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($1007295417eb09fd$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $1007295417eb09fd$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $1007295417eb09fd$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $1007295417eb09fd$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $1007295417eb09fd$var$lj(b);
            $1007295417eb09fd$var$Ig();
            break;
        case 5:
            $1007295417eb09fd$var$Kh(b);
            break;
        case 1:
            $1007295417eb09fd$var$Zf(b.type) && $1007295417eb09fd$var$cg(b);
            break;
        case 4:
            $1007295417eb09fd$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $1007295417eb09fd$var$G($1007295417eb09fd$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $1007295417eb09fd$var$G($1007295417eb09fd$var$M, $1007295417eb09fd$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $1007295417eb09fd$var$pj(a, b, c);
                $1007295417eb09fd$var$G($1007295417eb09fd$var$M, $1007295417eb09fd$var$M.current & 1);
                a = $1007295417eb09fd$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $1007295417eb09fd$var$G($1007295417eb09fd$var$M, $1007295417eb09fd$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $1007295417eb09fd$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $1007295417eb09fd$var$G($1007295417eb09fd$var$M, $1007295417eb09fd$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $1007295417eb09fd$var$ej(a, b, c);
    }
    return $1007295417eb09fd$var$$i(a, b, c);
}
var $1007295417eb09fd$var$Aj, $1007295417eb09fd$var$Bj, $1007295417eb09fd$var$Cj, $1007295417eb09fd$var$Dj;
$1007295417eb09fd$var$Aj = function Aj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$1007295417eb09fd$var$Bj = function Bj() {};
$1007295417eb09fd$var$Cj = function Cj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $1007295417eb09fd$var$Hh($1007295417eb09fd$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $1007295417eb09fd$var$Ya(a, e);
                d = $1007295417eb09fd$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $1007295417eb09fd$var$A({}, e, {
                    value: void 0
                });
                d = $1007295417eb09fd$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $1007295417eb09fd$var$gb(a, e);
                d = $1007295417eb09fd$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $1007295417eb09fd$var$Bf);
        }
        $1007295417eb09fd$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($1007295417eb09fd$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($1007295417eb09fd$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $1007295417eb09fd$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$1007295417eb09fd$var$Dj = function Dj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $1007295417eb09fd$var$Ej(a, b) {
    if (!$1007295417eb09fd$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $1007295417eb09fd$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $1007295417eb09fd$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $1007295417eb09fd$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $1007295417eb09fd$var$S(b), null;
        case 1:
            return $1007295417eb09fd$var$Zf(b.type) && $1007295417eb09fd$var$$f(), $1007295417eb09fd$var$S(b), null;
        case 3:
            d = b.stateNode;
            $1007295417eb09fd$var$Jh();
            $1007295417eb09fd$var$E($1007295417eb09fd$var$Wf);
            $1007295417eb09fd$var$E($1007295417eb09fd$var$H);
            $1007295417eb09fd$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $1007295417eb09fd$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $1007295417eb09fd$var$zg && ($1007295417eb09fd$var$Gj($1007295417eb09fd$var$zg), $1007295417eb09fd$var$zg = null));
            $1007295417eb09fd$var$Bj(a, b);
            $1007295417eb09fd$var$S(b);
            return null;
        case 5:
            $1007295417eb09fd$var$Lh(b);
            var e = $1007295417eb09fd$var$Hh($1007295417eb09fd$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $1007295417eb09fd$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($1007295417eb09fd$var$p(166));
                    $1007295417eb09fd$var$S(b);
                    return null;
                }
                a = $1007295417eb09fd$var$Hh($1007295417eb09fd$var$Eh.current);
                if ($1007295417eb09fd$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$1007295417eb09fd$var$Of] = b;
                    d[$1007295417eb09fd$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $1007295417eb09fd$var$D("cancel", d);
                            $1007295417eb09fd$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $1007295417eb09fd$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $1007295417eb09fd$var$lf.length; e++)$1007295417eb09fd$var$D($1007295417eb09fd$var$lf[e], d);
                            break;
                        case "source":
                            $1007295417eb09fd$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $1007295417eb09fd$var$D("error", d);
                            $1007295417eb09fd$var$D("load", d);
                            break;
                        case "details":
                            $1007295417eb09fd$var$D("toggle", d);
                            break;
                        case "input":
                            $1007295417eb09fd$var$Za(d, f);
                            $1007295417eb09fd$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $1007295417eb09fd$var$D("invalid", d);
                            break;
                        case "textarea":
                            $1007295417eb09fd$var$hb(d, f), $1007295417eb09fd$var$D("invalid", d);
                    }
                    $1007295417eb09fd$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $1007295417eb09fd$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $1007295417eb09fd$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $1007295417eb09fd$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $1007295417eb09fd$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $1007295417eb09fd$var$Va(d);
                            $1007295417eb09fd$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $1007295417eb09fd$var$Va(d);
                            $1007295417eb09fd$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $1007295417eb09fd$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $1007295417eb09fd$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$1007295417eb09fd$var$Of] = b;
                    a[$1007295417eb09fd$var$Pf] = d;
                    $1007295417eb09fd$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $1007295417eb09fd$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $1007295417eb09fd$var$D("cancel", a);
                                $1007295417eb09fd$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $1007295417eb09fd$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $1007295417eb09fd$var$lf.length; e++)$1007295417eb09fd$var$D($1007295417eb09fd$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $1007295417eb09fd$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $1007295417eb09fd$var$D("error", a);
                                $1007295417eb09fd$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $1007295417eb09fd$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $1007295417eb09fd$var$Za(a, d);
                                e = $1007295417eb09fd$var$Ya(a, d);
                                $1007295417eb09fd$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $1007295417eb09fd$var$A({}, d, {
                                    value: void 0
                                });
                                $1007295417eb09fd$var$D("invalid", a);
                                break;
                            case "textarea":
                                $1007295417eb09fd$var$hb(a, d);
                                e = $1007295417eb09fd$var$gb(a, d);
                                $1007295417eb09fd$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $1007295417eb09fd$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $1007295417eb09fd$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $1007295417eb09fd$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $1007295417eb09fd$var$ob(a, k) : "number" === typeof k && $1007295417eb09fd$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($1007295417eb09fd$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $1007295417eb09fd$var$D("scroll", a) : null != k && $1007295417eb09fd$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $1007295417eb09fd$var$Va(a);
                                $1007295417eb09fd$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $1007295417eb09fd$var$Va(a);
                                $1007295417eb09fd$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $1007295417eb09fd$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $1007295417eb09fd$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $1007295417eb09fd$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $1007295417eb09fd$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $1007295417eb09fd$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $1007295417eb09fd$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($1007295417eb09fd$var$p(166));
                c = $1007295417eb09fd$var$Hh($1007295417eb09fd$var$Gh.current);
                $1007295417eb09fd$var$Hh($1007295417eb09fd$var$Eh.current);
                if ($1007295417eb09fd$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$1007295417eb09fd$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $1007295417eb09fd$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $1007295417eb09fd$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $1007295417eb09fd$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$1007295417eb09fd$var$Of] = b, b.stateNode = d;
            }
            $1007295417eb09fd$var$S(b);
            return null;
        case 13:
            $1007295417eb09fd$var$E($1007295417eb09fd$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($1007295417eb09fd$var$I && null !== $1007295417eb09fd$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $1007295417eb09fd$var$Hg(), $1007295417eb09fd$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $1007295417eb09fd$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($1007295417eb09fd$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($1007295417eb09fd$var$p(317));
                        f[$1007295417eb09fd$var$Of] = b;
                    } else $1007295417eb09fd$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $1007295417eb09fd$var$S(b);
                    f = !1;
                } else null !== $1007295417eb09fd$var$zg && ($1007295417eb09fd$var$Gj($1007295417eb09fd$var$zg), $1007295417eb09fd$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($1007295417eb09fd$var$M.current & 1) ? 0 === $1007295417eb09fd$var$T && ($1007295417eb09fd$var$T = 3) : $1007295417eb09fd$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $1007295417eb09fd$var$S(b);
            return null;
        case 4:
            return $1007295417eb09fd$var$Jh(), $1007295417eb09fd$var$Bj(a, b), null === a && $1007295417eb09fd$var$sf(b.stateNode.containerInfo), $1007295417eb09fd$var$S(b), null;
        case 10:
            return $1007295417eb09fd$var$Rg(b.type._context), $1007295417eb09fd$var$S(b), null;
        case 17:
            return $1007295417eb09fd$var$Zf(b.type) && $1007295417eb09fd$var$$f(), $1007295417eb09fd$var$S(b), null;
        case 19:
            $1007295417eb09fd$var$E($1007295417eb09fd$var$M);
            f = b.memoizedState;
            if (null === f) return $1007295417eb09fd$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $1007295417eb09fd$var$Ej(f, !1);
                else {
                    if (0 !== $1007295417eb09fd$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $1007295417eb09fd$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $1007295417eb09fd$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $1007295417eb09fd$var$G($1007295417eb09fd$var$M, $1007295417eb09fd$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $1007295417eb09fd$var$B() > $1007295417eb09fd$var$Hj && (b.flags |= 128, d = !0, $1007295417eb09fd$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $1007295417eb09fd$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $1007295417eb09fd$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$1007295417eb09fd$var$I) return $1007295417eb09fd$var$S(b), null;
                    } else 2 * $1007295417eb09fd$var$B() - f.renderingStartTime > $1007295417eb09fd$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $1007295417eb09fd$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $1007295417eb09fd$var$B(), b.sibling = null, c = $1007295417eb09fd$var$M.current, $1007295417eb09fd$var$G($1007295417eb09fd$var$M, d ? c & 1 | 2 : c & 1), b;
            $1007295417eb09fd$var$S(b);
            return null;
        case 22:
        case 23:
            return $1007295417eb09fd$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($1007295417eb09fd$var$gj & 1073741824) && ($1007295417eb09fd$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $1007295417eb09fd$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($1007295417eb09fd$var$p(156, b.tag));
}
function $1007295417eb09fd$var$Jj(a, b) {
    $1007295417eb09fd$var$wg(b);
    switch(b.tag){
        case 1:
            return $1007295417eb09fd$var$Zf(b.type) && $1007295417eb09fd$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $1007295417eb09fd$var$Jh(), $1007295417eb09fd$var$E($1007295417eb09fd$var$Wf), $1007295417eb09fd$var$E($1007295417eb09fd$var$H), $1007295417eb09fd$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $1007295417eb09fd$var$Lh(b), null;
        case 13:
            $1007295417eb09fd$var$E($1007295417eb09fd$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($1007295417eb09fd$var$p(340));
                $1007295417eb09fd$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $1007295417eb09fd$var$E($1007295417eb09fd$var$M), null;
        case 4:
            return $1007295417eb09fd$var$Jh(), null;
        case 10:
            return $1007295417eb09fd$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $1007295417eb09fd$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $1007295417eb09fd$var$Kj = !1, $1007295417eb09fd$var$U = !1, $1007295417eb09fd$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $1007295417eb09fd$var$V = null;
function $1007295417eb09fd$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $1007295417eb09fd$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $1007295417eb09fd$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $1007295417eb09fd$var$W(a, b, d);
    }
}
var $1007295417eb09fd$var$Oj = !1;
function $1007295417eb09fd$var$Pj(a, b) {
    $1007295417eb09fd$var$Cf = $1007295417eb09fd$var$dd;
    a = $1007295417eb09fd$var$Me();
    if ($1007295417eb09fd$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $1007295417eb09fd$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $1007295417eb09fd$var$dd = !1;
    for($1007295417eb09fd$var$V = b; null !== $1007295417eb09fd$var$V;)if (b = $1007295417eb09fd$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $1007295417eb09fd$var$V = a;
    else for(; null !== $1007295417eb09fd$var$V;){
        b = $1007295417eb09fd$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $1007295417eb09fd$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($1007295417eb09fd$var$p(163));
            }
        } catch (F) {
            $1007295417eb09fd$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $1007295417eb09fd$var$V = a;
            break;
        }
        $1007295417eb09fd$var$V = b.return;
    }
    n = $1007295417eb09fd$var$Oj;
    $1007295417eb09fd$var$Oj = !1;
    return n;
}
function $1007295417eb09fd$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $1007295417eb09fd$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $1007295417eb09fd$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $1007295417eb09fd$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $1007295417eb09fd$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $1007295417eb09fd$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$1007295417eb09fd$var$Of], delete b[$1007295417eb09fd$var$Pf], delete b[$1007295417eb09fd$var$of], delete b[$1007295417eb09fd$var$Qf], delete b[$1007295417eb09fd$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $1007295417eb09fd$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $1007295417eb09fd$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $1007295417eb09fd$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $1007295417eb09fd$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $1007295417eb09fd$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($1007295417eb09fd$var$Wj(a, b, c), a = a.sibling; null !== a;)$1007295417eb09fd$var$Wj(a, b, c), a = a.sibling;
}
function $1007295417eb09fd$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($1007295417eb09fd$var$Xj(a, b, c), a = a.sibling; null !== a;)$1007295417eb09fd$var$Xj(a, b, c), a = a.sibling;
}
var $1007295417eb09fd$var$X = null, $1007295417eb09fd$var$Yj = !1;
function $1007295417eb09fd$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$1007295417eb09fd$var$ak(a, b, c), c = c.sibling;
}
function $1007295417eb09fd$var$ak(a, b, c) {
    if ($1007295417eb09fd$var$lc && "function" === typeof $1007295417eb09fd$var$lc.onCommitFiberUnmount) try {
        $1007295417eb09fd$var$lc.onCommitFiberUnmount($1007295417eb09fd$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $1007295417eb09fd$var$U || $1007295417eb09fd$var$Mj(c, b);
        case 6:
            var d = $1007295417eb09fd$var$X, e = $1007295417eb09fd$var$Yj;
            $1007295417eb09fd$var$X = null;
            $1007295417eb09fd$var$Zj(a, b, c);
            $1007295417eb09fd$var$X = d;
            $1007295417eb09fd$var$Yj = e;
            null !== $1007295417eb09fd$var$X && ($1007295417eb09fd$var$Yj ? (a = $1007295417eb09fd$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $1007295417eb09fd$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $1007295417eb09fd$var$X && ($1007295417eb09fd$var$Yj ? (a = $1007295417eb09fd$var$X, c = c.stateNode, 8 === a.nodeType ? $1007295417eb09fd$var$Kf(a.parentNode, c) : 1 === a.nodeType && $1007295417eb09fd$var$Kf(a, c), $1007295417eb09fd$var$bd(a)) : $1007295417eb09fd$var$Kf($1007295417eb09fd$var$X, c.stateNode));
            break;
        case 4:
            d = $1007295417eb09fd$var$X;
            e = $1007295417eb09fd$var$Yj;
            $1007295417eb09fd$var$X = c.stateNode.containerInfo;
            $1007295417eb09fd$var$Yj = !0;
            $1007295417eb09fd$var$Zj(a, b, c);
            $1007295417eb09fd$var$X = d;
            $1007295417eb09fd$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$1007295417eb09fd$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $1007295417eb09fd$var$Nj(c, b, g) : 0 !== (f & 4) && $1007295417eb09fd$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $1007295417eb09fd$var$Zj(a, b, c);
            break;
        case 1:
            if (!$1007295417eb09fd$var$U && ($1007295417eb09fd$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $1007295417eb09fd$var$W(c, b, h);
            }
            $1007295417eb09fd$var$Zj(a, b, c);
            break;
        case 21:
            $1007295417eb09fd$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($1007295417eb09fd$var$U = (d = $1007295417eb09fd$var$U) || null !== c.memoizedState, $1007295417eb09fd$var$Zj(a, b, c), $1007295417eb09fd$var$U = d) : $1007295417eb09fd$var$Zj(a, b, c);
            break;
        default:
            $1007295417eb09fd$var$Zj(a, b, c);
    }
}
function $1007295417eb09fd$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $1007295417eb09fd$var$Lj);
        b.forEach(function(b) {
            var d = $1007295417eb09fd$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $1007295417eb09fd$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $1007295417eb09fd$var$X = h.stateNode;
                        $1007295417eb09fd$var$Yj = !1;
                        break a;
                    case 3:
                        $1007295417eb09fd$var$X = h.stateNode.containerInfo;
                        $1007295417eb09fd$var$Yj = !0;
                        break a;
                    case 4:
                        $1007295417eb09fd$var$X = h.stateNode.containerInfo;
                        $1007295417eb09fd$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $1007295417eb09fd$var$X) throw Error($1007295417eb09fd$var$p(160));
            $1007295417eb09fd$var$ak(f, g, e);
            $1007295417eb09fd$var$X = null;
            $1007295417eb09fd$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $1007295417eb09fd$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$1007295417eb09fd$var$ek(b, a), b = b.sibling;
}
function $1007295417eb09fd$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $1007295417eb09fd$var$dk(b, a);
            $1007295417eb09fd$var$fk(a);
            if (d & 4) {
                try {
                    $1007295417eb09fd$var$Qj(3, a, a.return), $1007295417eb09fd$var$Rj(3, a);
                } catch (t) {
                    $1007295417eb09fd$var$W(a, a.return, t);
                }
                try {
                    $1007295417eb09fd$var$Qj(5, a, a.return);
                } catch (t) {
                    $1007295417eb09fd$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $1007295417eb09fd$var$dk(b, a);
            $1007295417eb09fd$var$fk(a);
            d & 512 && null !== c && $1007295417eb09fd$var$Mj(c, c.return);
            break;
        case 5:
            $1007295417eb09fd$var$dk(b, a);
            $1007295417eb09fd$var$fk(a);
            d & 512 && null !== c && $1007295417eb09fd$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $1007295417eb09fd$var$ob(e, "");
                } catch (t) {
                    $1007295417eb09fd$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $1007295417eb09fd$var$ab(e, f);
                    $1007295417eb09fd$var$vb(h, g);
                    var l = $1007295417eb09fd$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $1007295417eb09fd$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $1007295417eb09fd$var$nb(e, q) : "children" === m ? $1007295417eb09fd$var$ob(e, q) : $1007295417eb09fd$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $1007295417eb09fd$var$bb(e, f);
                            break;
                        case "textarea":
                            $1007295417eb09fd$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $1007295417eb09fd$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $1007295417eb09fd$var$fb(e, !!f.multiple, f.defaultValue, !0) : $1007295417eb09fd$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$1007295417eb09fd$var$Pf] = f;
                } catch (t) {
                    $1007295417eb09fd$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $1007295417eb09fd$var$dk(b, a);
            $1007295417eb09fd$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($1007295417eb09fd$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $1007295417eb09fd$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $1007295417eb09fd$var$dk(b, a);
            $1007295417eb09fd$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $1007295417eb09fd$var$bd(b.containerInfo);
            } catch (t) {
                $1007295417eb09fd$var$W(a, a.return, t);
            }
            break;
        case 4:
            $1007295417eb09fd$var$dk(b, a);
            $1007295417eb09fd$var$fk(a);
            break;
        case 13:
            $1007295417eb09fd$var$dk(b, a);
            $1007295417eb09fd$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($1007295417eb09fd$var$gk = $1007295417eb09fd$var$B()));
            d & 4 && $1007295417eb09fd$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($1007295417eb09fd$var$U = (l = $1007295417eb09fd$var$U) || m, $1007295417eb09fd$var$dk(b, a), $1007295417eb09fd$var$U = l) : $1007295417eb09fd$var$dk(b, a);
            $1007295417eb09fd$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($1007295417eb09fd$var$V = a, m = a.child; null !== m;){
                    for(q = $1007295417eb09fd$var$V = m; null !== $1007295417eb09fd$var$V;){
                        r = $1007295417eb09fd$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $1007295417eb09fd$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $1007295417eb09fd$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $1007295417eb09fd$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $1007295417eb09fd$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $1007295417eb09fd$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $1007295417eb09fd$var$V = y) : $1007295417eb09fd$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $1007295417eb09fd$var$rb("display", g));
                            } catch (t) {
                                $1007295417eb09fd$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $1007295417eb09fd$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $1007295417eb09fd$var$dk(b, a);
            $1007295417eb09fd$var$fk(a);
            d & 4 && $1007295417eb09fd$var$bk(a);
            break;
        case 21:
            break;
        default:
            $1007295417eb09fd$var$dk(b, a), $1007295417eb09fd$var$fk(a);
    }
}
function $1007295417eb09fd$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($1007295417eb09fd$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($1007295417eb09fd$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($1007295417eb09fd$var$ob(e, ""), d.flags &= -33);
                    var f = $1007295417eb09fd$var$Vj(a);
                    $1007295417eb09fd$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $1007295417eb09fd$var$Vj(a);
                    $1007295417eb09fd$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($1007295417eb09fd$var$p(161));
            }
        } catch (k) {
            $1007295417eb09fd$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $1007295417eb09fd$var$ik(a, b, c) {
    $1007295417eb09fd$var$V = a;
    $1007295417eb09fd$var$jk(a, b, c);
}
function $1007295417eb09fd$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $1007295417eb09fd$var$V;){
        var e = $1007295417eb09fd$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $1007295417eb09fd$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $1007295417eb09fd$var$U;
                h = $1007295417eb09fd$var$Kj;
                var l = $1007295417eb09fd$var$U;
                $1007295417eb09fd$var$Kj = g;
                if (($1007295417eb09fd$var$U = k) && !l) for($1007295417eb09fd$var$V = e; null !== $1007295417eb09fd$var$V;)g = $1007295417eb09fd$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $1007295417eb09fd$var$kk(e) : null !== k ? (k.return = g, $1007295417eb09fd$var$V = k) : $1007295417eb09fd$var$kk(e);
                for(; null !== f;)$1007295417eb09fd$var$V = f, $1007295417eb09fd$var$jk(f, b, c), f = f.sibling;
                $1007295417eb09fd$var$V = e;
                $1007295417eb09fd$var$Kj = h;
                $1007295417eb09fd$var$U = l;
            }
            $1007295417eb09fd$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $1007295417eb09fd$var$V = f) : $1007295417eb09fd$var$lk(a, b, c);
    }
}
function $1007295417eb09fd$var$lk(a) {
    for(; null !== $1007295417eb09fd$var$V;){
        var b = $1007295417eb09fd$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $1007295417eb09fd$var$U || $1007295417eb09fd$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$1007295417eb09fd$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $1007295417eb09fd$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $1007295417eb09fd$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $1007295417eb09fd$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $1007295417eb09fd$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($1007295417eb09fd$var$p(163));
                }
                $1007295417eb09fd$var$U || b.flags & 512 && $1007295417eb09fd$var$Sj(b);
            } catch (r) {
                $1007295417eb09fd$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $1007295417eb09fd$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $1007295417eb09fd$var$V = c;
            break;
        }
        $1007295417eb09fd$var$V = b.return;
    }
}
function $1007295417eb09fd$var$hk(a) {
    for(; null !== $1007295417eb09fd$var$V;){
        var b = $1007295417eb09fd$var$V;
        if (b === a) {
            $1007295417eb09fd$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $1007295417eb09fd$var$V = c;
            break;
        }
        $1007295417eb09fd$var$V = b.return;
    }
}
function $1007295417eb09fd$var$kk(a) {
    for(; null !== $1007295417eb09fd$var$V;){
        var b = $1007295417eb09fd$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $1007295417eb09fd$var$Rj(4, b);
                    } catch (k) {
                        $1007295417eb09fd$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $1007295417eb09fd$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $1007295417eb09fd$var$Sj(b);
                    } catch (k) {
                        $1007295417eb09fd$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $1007295417eb09fd$var$Sj(b);
                    } catch (k) {
                        $1007295417eb09fd$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $1007295417eb09fd$var$W(b, b.return, k);
        }
        if (b === a) {
            $1007295417eb09fd$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $1007295417eb09fd$var$V = h;
            break;
        }
        $1007295417eb09fd$var$V = b.return;
    }
}
var $1007295417eb09fd$var$mk = Math.ceil, $1007295417eb09fd$var$nk = $1007295417eb09fd$var$ua.ReactCurrentDispatcher, $1007295417eb09fd$var$ok = $1007295417eb09fd$var$ua.ReactCurrentOwner, $1007295417eb09fd$var$pk = $1007295417eb09fd$var$ua.ReactCurrentBatchConfig, $1007295417eb09fd$var$K = 0, $1007295417eb09fd$var$R = null, $1007295417eb09fd$var$Y = null, $1007295417eb09fd$var$Z = 0, $1007295417eb09fd$var$gj = 0, $1007295417eb09fd$var$fj = $1007295417eb09fd$var$Uf(0), $1007295417eb09fd$var$T = 0, $1007295417eb09fd$var$qk = null, $1007295417eb09fd$var$hh = 0, $1007295417eb09fd$var$rk = 0, $1007295417eb09fd$var$sk = 0, $1007295417eb09fd$var$tk = null, $1007295417eb09fd$var$uk = null, $1007295417eb09fd$var$gk = 0, $1007295417eb09fd$var$Hj = Infinity, $1007295417eb09fd$var$vk = null, $1007295417eb09fd$var$Pi = !1, $1007295417eb09fd$var$Qi = null, $1007295417eb09fd$var$Si = null, $1007295417eb09fd$var$wk = !1, $1007295417eb09fd$var$xk = null, $1007295417eb09fd$var$yk = 0, $1007295417eb09fd$var$zk = 0, $1007295417eb09fd$var$Ak = null, $1007295417eb09fd$var$Bk = -1, $1007295417eb09fd$var$Ck = 0;
function $1007295417eb09fd$var$L() {
    return 0 !== ($1007295417eb09fd$var$K & 6) ? $1007295417eb09fd$var$B() : -1 !== $1007295417eb09fd$var$Bk ? $1007295417eb09fd$var$Bk : $1007295417eb09fd$var$Bk = $1007295417eb09fd$var$B();
}
function $1007295417eb09fd$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($1007295417eb09fd$var$K & 2) && 0 !== $1007295417eb09fd$var$Z) return $1007295417eb09fd$var$Z & -$1007295417eb09fd$var$Z;
    if (null !== $1007295417eb09fd$var$Kg.transition) return 0 === $1007295417eb09fd$var$Ck && ($1007295417eb09fd$var$Ck = $1007295417eb09fd$var$yc()), $1007295417eb09fd$var$Ck;
    a = $1007295417eb09fd$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $1007295417eb09fd$var$jd(a.type);
    return a;
}
function $1007295417eb09fd$var$mh(a, b, c, d) {
    if (50 < $1007295417eb09fd$var$zk) throw $1007295417eb09fd$var$zk = 0, $1007295417eb09fd$var$Ak = null, Error($1007295417eb09fd$var$p(185));
    $1007295417eb09fd$var$Ac(a, c, d);
    if (0 === ($1007295417eb09fd$var$K & 2) || a !== $1007295417eb09fd$var$R) a === $1007295417eb09fd$var$R && (0 === ($1007295417eb09fd$var$K & 2) && ($1007295417eb09fd$var$rk |= c), 4 === $1007295417eb09fd$var$T && $1007295417eb09fd$var$Dk(a, $1007295417eb09fd$var$Z)), $1007295417eb09fd$var$Ek(a, d), 1 === c && 0 === $1007295417eb09fd$var$K && 0 === (b.mode & 1) && ($1007295417eb09fd$var$Hj = $1007295417eb09fd$var$B() + 500, $1007295417eb09fd$var$fg && $1007295417eb09fd$var$jg());
}
function $1007295417eb09fd$var$Ek(a, b) {
    var c = a.callbackNode;
    $1007295417eb09fd$var$wc(a, b);
    var d = $1007295417eb09fd$var$uc(a, a === $1007295417eb09fd$var$R ? $1007295417eb09fd$var$Z : 0);
    if (0 === d) null !== c && $1007295417eb09fd$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $1007295417eb09fd$var$bc(c);
        if (1 === b) 0 === a.tag ? $1007295417eb09fd$var$ig($1007295417eb09fd$var$Fk.bind(null, a)) : $1007295417eb09fd$var$hg($1007295417eb09fd$var$Fk.bind(null, a)), $1007295417eb09fd$var$Jf(function() {
            0 === ($1007295417eb09fd$var$K & 6) && $1007295417eb09fd$var$jg();
        }), c = null;
        else {
            switch($1007295417eb09fd$var$Dc(d)){
                case 1:
                    c = $1007295417eb09fd$var$fc;
                    break;
                case 4:
                    c = $1007295417eb09fd$var$gc;
                    break;
                case 16:
                    c = $1007295417eb09fd$var$hc;
                    break;
                case 536870912:
                    c = $1007295417eb09fd$var$jc;
                    break;
                default:
                    c = $1007295417eb09fd$var$hc;
            }
            c = $1007295417eb09fd$var$Gk(c, $1007295417eb09fd$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $1007295417eb09fd$var$Hk(a, b) {
    $1007295417eb09fd$var$Bk = -1;
    $1007295417eb09fd$var$Ck = 0;
    if (0 !== ($1007295417eb09fd$var$K & 6)) throw Error($1007295417eb09fd$var$p(327));
    var c = a.callbackNode;
    if ($1007295417eb09fd$var$Ik() && a.callbackNode !== c) return null;
    var d = $1007295417eb09fd$var$uc(a, a === $1007295417eb09fd$var$R ? $1007295417eb09fd$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $1007295417eb09fd$var$Jk(a, d);
    else {
        b = d;
        var e = $1007295417eb09fd$var$K;
        $1007295417eb09fd$var$K |= 2;
        var f = $1007295417eb09fd$var$Kk();
        if ($1007295417eb09fd$var$R !== a || $1007295417eb09fd$var$Z !== b) $1007295417eb09fd$var$vk = null, $1007295417eb09fd$var$Hj = $1007295417eb09fd$var$B() + 500, $1007295417eb09fd$var$Lk(a, b);
        for(;;)try {
            $1007295417eb09fd$var$Mk();
            break;
        } catch (h) {
            $1007295417eb09fd$var$Nk(a, h);
        }
        $1007295417eb09fd$var$Qg();
        $1007295417eb09fd$var$nk.current = f;
        $1007295417eb09fd$var$K = e;
        null !== $1007295417eb09fd$var$Y ? b = 0 : ($1007295417eb09fd$var$R = null, $1007295417eb09fd$var$Z = 0, b = $1007295417eb09fd$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $1007295417eb09fd$var$xc(a), 0 !== e && (d = e, b = $1007295417eb09fd$var$Ok(a, e)));
        if (1 === b) throw c = $1007295417eb09fd$var$qk, $1007295417eb09fd$var$Lk(a, 0), $1007295417eb09fd$var$Dk(a, d), $1007295417eb09fd$var$Ek(a, $1007295417eb09fd$var$B()), c;
        if (6 === b) $1007295417eb09fd$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$1007295417eb09fd$var$Pk(e) && (b = $1007295417eb09fd$var$Jk(a, d), 2 === b && (f = $1007295417eb09fd$var$xc(a), 0 !== f && (d = f, b = $1007295417eb09fd$var$Ok(a, f))), 1 === b)) throw c = $1007295417eb09fd$var$qk, $1007295417eb09fd$var$Lk(a, 0), $1007295417eb09fd$var$Dk(a, d), $1007295417eb09fd$var$Ek(a, $1007295417eb09fd$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($1007295417eb09fd$var$p(345));
                case 2:
                    $1007295417eb09fd$var$Qk(a, $1007295417eb09fd$var$uk, $1007295417eb09fd$var$vk);
                    break;
                case 3:
                    $1007295417eb09fd$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $1007295417eb09fd$var$gk + 500 - $1007295417eb09fd$var$B(), 10 < b)) {
                        if (0 !== $1007295417eb09fd$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $1007295417eb09fd$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $1007295417eb09fd$var$Ff($1007295417eb09fd$var$Qk.bind(null, a, $1007295417eb09fd$var$uk, $1007295417eb09fd$var$vk), b);
                        break;
                    }
                    $1007295417eb09fd$var$Qk(a, $1007295417eb09fd$var$uk, $1007295417eb09fd$var$vk);
                    break;
                case 4:
                    $1007295417eb09fd$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $1007295417eb09fd$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $1007295417eb09fd$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $1007295417eb09fd$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $1007295417eb09fd$var$Ff($1007295417eb09fd$var$Qk.bind(null, a, $1007295417eb09fd$var$uk, $1007295417eb09fd$var$vk), d);
                        break;
                    }
                    $1007295417eb09fd$var$Qk(a, $1007295417eb09fd$var$uk, $1007295417eb09fd$var$vk);
                    break;
                case 5:
                    $1007295417eb09fd$var$Qk(a, $1007295417eb09fd$var$uk, $1007295417eb09fd$var$vk);
                    break;
                default:
                    throw Error($1007295417eb09fd$var$p(329));
            }
        }
    }
    $1007295417eb09fd$var$Ek(a, $1007295417eb09fd$var$B());
    return a.callbackNode === c ? $1007295417eb09fd$var$Hk.bind(null, a) : null;
}
function $1007295417eb09fd$var$Ok(a, b) {
    var c = $1007295417eb09fd$var$tk;
    a.current.memoizedState.isDehydrated && ($1007295417eb09fd$var$Lk(a, b).flags |= 256);
    a = $1007295417eb09fd$var$Jk(a, b);
    2 !== a && (b = $1007295417eb09fd$var$uk, $1007295417eb09fd$var$uk = c, null !== b && $1007295417eb09fd$var$Gj(b));
    return a;
}
function $1007295417eb09fd$var$Gj(a) {
    null === $1007295417eb09fd$var$uk ? $1007295417eb09fd$var$uk = a : $1007295417eb09fd$var$uk.push.apply($1007295417eb09fd$var$uk, a);
}
function $1007295417eb09fd$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$1007295417eb09fd$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $1007295417eb09fd$var$Dk(a, b) {
    b &= ~$1007295417eb09fd$var$sk;
    b &= ~$1007295417eb09fd$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $1007295417eb09fd$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $1007295417eb09fd$var$Fk(a) {
    if (0 !== ($1007295417eb09fd$var$K & 6)) throw Error($1007295417eb09fd$var$p(327));
    $1007295417eb09fd$var$Ik();
    var b = $1007295417eb09fd$var$uc(a, 0);
    if (0 === (b & 1)) return $1007295417eb09fd$var$Ek(a, $1007295417eb09fd$var$B()), null;
    var c = $1007295417eb09fd$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $1007295417eb09fd$var$xc(a);
        0 !== d && (b = d, c = $1007295417eb09fd$var$Ok(a, d));
    }
    if (1 === c) throw c = $1007295417eb09fd$var$qk, $1007295417eb09fd$var$Lk(a, 0), $1007295417eb09fd$var$Dk(a, b), $1007295417eb09fd$var$Ek(a, $1007295417eb09fd$var$B()), c;
    if (6 === c) throw Error($1007295417eb09fd$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $1007295417eb09fd$var$Qk(a, $1007295417eb09fd$var$uk, $1007295417eb09fd$var$vk);
    $1007295417eb09fd$var$Ek(a, $1007295417eb09fd$var$B());
    return null;
}
function $1007295417eb09fd$var$Rk(a, b) {
    var c = $1007295417eb09fd$var$K;
    $1007295417eb09fd$var$K |= 1;
    try {
        return a(b);
    } finally{
        $1007295417eb09fd$var$K = c, 0 === $1007295417eb09fd$var$K && ($1007295417eb09fd$var$Hj = $1007295417eb09fd$var$B() + 500, $1007295417eb09fd$var$fg && $1007295417eb09fd$var$jg());
    }
}
function $1007295417eb09fd$var$Sk(a) {
    null !== $1007295417eb09fd$var$xk && 0 === $1007295417eb09fd$var$xk.tag && 0 === ($1007295417eb09fd$var$K & 6) && $1007295417eb09fd$var$Ik();
    var b = $1007295417eb09fd$var$K;
    $1007295417eb09fd$var$K |= 1;
    var c = $1007295417eb09fd$var$pk.transition, d = $1007295417eb09fd$var$C;
    try {
        if ($1007295417eb09fd$var$pk.transition = null, $1007295417eb09fd$var$C = 1, a) return a();
    } finally{
        $1007295417eb09fd$var$C = d, $1007295417eb09fd$var$pk.transition = c, $1007295417eb09fd$var$K = b, 0 === ($1007295417eb09fd$var$K & 6) && $1007295417eb09fd$var$jg();
    }
}
function $1007295417eb09fd$var$Ij() {
    $1007295417eb09fd$var$gj = $1007295417eb09fd$var$fj.current;
    $1007295417eb09fd$var$E($1007295417eb09fd$var$fj);
}
function $1007295417eb09fd$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $1007295417eb09fd$var$Gf(c));
    if (null !== $1007295417eb09fd$var$Y) for(c = $1007295417eb09fd$var$Y.return; null !== c;){
        var d = c;
        $1007295417eb09fd$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $1007295417eb09fd$var$$f();
                break;
            case 3:
                $1007295417eb09fd$var$Jh();
                $1007295417eb09fd$var$E($1007295417eb09fd$var$Wf);
                $1007295417eb09fd$var$E($1007295417eb09fd$var$H);
                $1007295417eb09fd$var$Oh();
                break;
            case 5:
                $1007295417eb09fd$var$Lh(d);
                break;
            case 4:
                $1007295417eb09fd$var$Jh();
                break;
            case 13:
                $1007295417eb09fd$var$E($1007295417eb09fd$var$M);
                break;
            case 19:
                $1007295417eb09fd$var$E($1007295417eb09fd$var$M);
                break;
            case 10:
                $1007295417eb09fd$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $1007295417eb09fd$var$Ij();
        }
        c = c.return;
    }
    $1007295417eb09fd$var$R = a;
    $1007295417eb09fd$var$Y = a = $1007295417eb09fd$var$wh(a.current, null);
    $1007295417eb09fd$var$Z = $1007295417eb09fd$var$gj = b;
    $1007295417eb09fd$var$T = 0;
    $1007295417eb09fd$var$qk = null;
    $1007295417eb09fd$var$sk = $1007295417eb09fd$var$rk = $1007295417eb09fd$var$hh = 0;
    $1007295417eb09fd$var$uk = $1007295417eb09fd$var$tk = null;
    if (null !== $1007295417eb09fd$var$Wg) {
        for(b = 0; b < $1007295417eb09fd$var$Wg.length; b++)if (c = $1007295417eb09fd$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $1007295417eb09fd$var$Wg = null;
    }
    return a;
}
function $1007295417eb09fd$var$Nk(a, b) {
    do {
        var c = $1007295417eb09fd$var$Y;
        try {
            $1007295417eb09fd$var$Qg();
            $1007295417eb09fd$var$Ph.current = $1007295417eb09fd$var$ai;
            if ($1007295417eb09fd$var$Sh) {
                for(var d = $1007295417eb09fd$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $1007295417eb09fd$var$Sh = !1;
            }
            $1007295417eb09fd$var$Rh = 0;
            $1007295417eb09fd$var$P = $1007295417eb09fd$var$O = $1007295417eb09fd$var$N = null;
            $1007295417eb09fd$var$Th = !1;
            $1007295417eb09fd$var$Uh = 0;
            $1007295417eb09fd$var$ok.current = null;
            if (null === c || null === c.return) {
                $1007295417eb09fd$var$T = 1;
                $1007295417eb09fd$var$qk = b;
                $1007295417eb09fd$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $1007295417eb09fd$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $1007295417eb09fd$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $1007295417eb09fd$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $1007295417eb09fd$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $1007295417eb09fd$var$Ti(f, l, b);
                            $1007295417eb09fd$var$uj();
                            break a;
                        }
                        k = Error($1007295417eb09fd$var$p(426));
                    }
                } else if ($1007295417eb09fd$var$I && h.mode & 1) {
                    var J = $1007295417eb09fd$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $1007295417eb09fd$var$Wi(J, g, h, f, b);
                        $1007295417eb09fd$var$Jg($1007295417eb09fd$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $1007295417eb09fd$var$Ki(k, h);
                4 !== $1007295417eb09fd$var$T && ($1007295417eb09fd$var$T = 2);
                null === $1007295417eb09fd$var$tk ? $1007295417eb09fd$var$tk = [
                    f
                ] : $1007295417eb09fd$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $1007295417eb09fd$var$Oi(f, k, b);
                            $1007295417eb09fd$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $1007295417eb09fd$var$Si || !$1007295417eb09fd$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $1007295417eb09fd$var$Ri(f, h, b);
                                $1007295417eb09fd$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $1007295417eb09fd$var$Tk(c);
        } catch (na) {
            b = na;
            $1007295417eb09fd$var$Y === c && null !== c && ($1007295417eb09fd$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $1007295417eb09fd$var$Kk() {
    var a = $1007295417eb09fd$var$nk.current;
    $1007295417eb09fd$var$nk.current = $1007295417eb09fd$var$ai;
    return null === a ? $1007295417eb09fd$var$ai : a;
}
function $1007295417eb09fd$var$uj() {
    if (0 === $1007295417eb09fd$var$T || 3 === $1007295417eb09fd$var$T || 2 === $1007295417eb09fd$var$T) $1007295417eb09fd$var$T = 4;
    null === $1007295417eb09fd$var$R || 0 === ($1007295417eb09fd$var$hh & 268435455) && 0 === ($1007295417eb09fd$var$rk & 268435455) || $1007295417eb09fd$var$Dk($1007295417eb09fd$var$R, $1007295417eb09fd$var$Z);
}
function $1007295417eb09fd$var$Jk(a, b) {
    var c = $1007295417eb09fd$var$K;
    $1007295417eb09fd$var$K |= 2;
    var d = $1007295417eb09fd$var$Kk();
    if ($1007295417eb09fd$var$R !== a || $1007295417eb09fd$var$Z !== b) $1007295417eb09fd$var$vk = null, $1007295417eb09fd$var$Lk(a, b);
    for(;;)try {
        $1007295417eb09fd$var$Uk();
        break;
    } catch (e) {
        $1007295417eb09fd$var$Nk(a, e);
    }
    $1007295417eb09fd$var$Qg();
    $1007295417eb09fd$var$K = c;
    $1007295417eb09fd$var$nk.current = d;
    if (null !== $1007295417eb09fd$var$Y) throw Error($1007295417eb09fd$var$p(261));
    $1007295417eb09fd$var$R = null;
    $1007295417eb09fd$var$Z = 0;
    return $1007295417eb09fd$var$T;
}
function $1007295417eb09fd$var$Uk() {
    for(; null !== $1007295417eb09fd$var$Y;)$1007295417eb09fd$var$Vk($1007295417eb09fd$var$Y);
}
function $1007295417eb09fd$var$Mk() {
    for(; null !== $1007295417eb09fd$var$Y && !$1007295417eb09fd$var$cc();)$1007295417eb09fd$var$Vk($1007295417eb09fd$var$Y);
}
function $1007295417eb09fd$var$Vk(a) {
    var b = $1007295417eb09fd$var$Wk(a.alternate, a, $1007295417eb09fd$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $1007295417eb09fd$var$Tk(a) : $1007295417eb09fd$var$Y = b;
    $1007295417eb09fd$var$ok.current = null;
}
function $1007295417eb09fd$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $1007295417eb09fd$var$Fj(c, b, $1007295417eb09fd$var$gj), null !== c) {
                $1007295417eb09fd$var$Y = c;
                return;
            }
        } else {
            c = $1007295417eb09fd$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $1007295417eb09fd$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $1007295417eb09fd$var$T = 6;
                $1007295417eb09fd$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $1007295417eb09fd$var$Y = b;
            return;
        }
        $1007295417eb09fd$var$Y = b = a;
    }while (null !== b);
    0 === $1007295417eb09fd$var$T && ($1007295417eb09fd$var$T = 5);
}
function $1007295417eb09fd$var$Qk(a, b, c) {
    var d = $1007295417eb09fd$var$C, e = $1007295417eb09fd$var$pk.transition;
    try {
        $1007295417eb09fd$var$pk.transition = null, $1007295417eb09fd$var$C = 1, $1007295417eb09fd$var$Xk(a, b, c, d);
    } finally{
        $1007295417eb09fd$var$pk.transition = e, $1007295417eb09fd$var$C = d;
    }
    return null;
}
function $1007295417eb09fd$var$Xk(a, b, c, d) {
    do $1007295417eb09fd$var$Ik();
    while (null !== $1007295417eb09fd$var$xk);
    if (0 !== ($1007295417eb09fd$var$K & 6)) throw Error($1007295417eb09fd$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($1007295417eb09fd$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $1007295417eb09fd$var$Bc(a, f);
    a === $1007295417eb09fd$var$R && ($1007295417eb09fd$var$Y = $1007295417eb09fd$var$R = null, $1007295417eb09fd$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $1007295417eb09fd$var$wk || ($1007295417eb09fd$var$wk = !0, $1007295417eb09fd$var$Gk($1007295417eb09fd$var$hc, function() {
        $1007295417eb09fd$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $1007295417eb09fd$var$pk.transition;
        $1007295417eb09fd$var$pk.transition = null;
        var g = $1007295417eb09fd$var$C;
        $1007295417eb09fd$var$C = 1;
        var h = $1007295417eb09fd$var$K;
        $1007295417eb09fd$var$K |= 4;
        $1007295417eb09fd$var$ok.current = null;
        $1007295417eb09fd$var$Pj(a, c);
        $1007295417eb09fd$var$ek(c, a);
        $1007295417eb09fd$var$Oe($1007295417eb09fd$var$Df);
        $1007295417eb09fd$var$dd = !!$1007295417eb09fd$var$Cf;
        $1007295417eb09fd$var$Df = $1007295417eb09fd$var$Cf = null;
        a.current = c;
        $1007295417eb09fd$var$ik(c, a, e);
        $1007295417eb09fd$var$dc();
        $1007295417eb09fd$var$K = h;
        $1007295417eb09fd$var$C = g;
        $1007295417eb09fd$var$pk.transition = f;
    } else a.current = c;
    $1007295417eb09fd$var$wk && ($1007295417eb09fd$var$wk = !1, $1007295417eb09fd$var$xk = a, $1007295417eb09fd$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($1007295417eb09fd$var$Si = null);
    $1007295417eb09fd$var$mc(c.stateNode, d);
    $1007295417eb09fd$var$Ek(a, $1007295417eb09fd$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($1007295417eb09fd$var$Pi) throw $1007295417eb09fd$var$Pi = !1, a = $1007295417eb09fd$var$Qi, $1007295417eb09fd$var$Qi = null, a;
    0 !== ($1007295417eb09fd$var$yk & 1) && 0 !== a.tag && $1007295417eb09fd$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $1007295417eb09fd$var$Ak ? $1007295417eb09fd$var$zk++ : ($1007295417eb09fd$var$zk = 0, $1007295417eb09fd$var$Ak = a) : $1007295417eb09fd$var$zk = 0;
    $1007295417eb09fd$var$jg();
    return null;
}
function $1007295417eb09fd$var$Ik() {
    if (null !== $1007295417eb09fd$var$xk) {
        var a = $1007295417eb09fd$var$Dc($1007295417eb09fd$var$yk), b = $1007295417eb09fd$var$pk.transition, c = $1007295417eb09fd$var$C;
        try {
            $1007295417eb09fd$var$pk.transition = null;
            $1007295417eb09fd$var$C = 16 > a ? 16 : a;
            if (null === $1007295417eb09fd$var$xk) var d = !1;
            else {
                a = $1007295417eb09fd$var$xk;
                $1007295417eb09fd$var$xk = null;
                $1007295417eb09fd$var$yk = 0;
                if (0 !== ($1007295417eb09fd$var$K & 6)) throw Error($1007295417eb09fd$var$p(331));
                var e = $1007295417eb09fd$var$K;
                $1007295417eb09fd$var$K |= 4;
                for($1007295417eb09fd$var$V = a.current; null !== $1007295417eb09fd$var$V;){
                    var f = $1007295417eb09fd$var$V, g = f.child;
                    if (0 !== ($1007295417eb09fd$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($1007295417eb09fd$var$V = l; null !== $1007295417eb09fd$var$V;){
                                    var m = $1007295417eb09fd$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $1007295417eb09fd$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $1007295417eb09fd$var$V = q;
                                    else for(; null !== $1007295417eb09fd$var$V;){
                                        m = $1007295417eb09fd$var$V;
                                        var r = m.sibling, y = m.return;
                                        $1007295417eb09fd$var$Tj(m);
                                        if (m === l) {
                                            $1007295417eb09fd$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $1007295417eb09fd$var$V = r;
                                            break;
                                        }
                                        $1007295417eb09fd$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $1007295417eb09fd$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $1007295417eb09fd$var$V = g;
                    else b: for(; null !== $1007295417eb09fd$var$V;){
                        f = $1007295417eb09fd$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $1007295417eb09fd$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $1007295417eb09fd$var$V = x;
                            break b;
                        }
                        $1007295417eb09fd$var$V = f.return;
                    }
                }
                var w = a.current;
                for($1007295417eb09fd$var$V = w; null !== $1007295417eb09fd$var$V;){
                    g = $1007295417eb09fd$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $1007295417eb09fd$var$V = u;
                    else b: for(g = w; null !== $1007295417eb09fd$var$V;){
                        h = $1007295417eb09fd$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $1007295417eb09fd$var$Rj(9, h);
                            }
                        } catch (na) {
                            $1007295417eb09fd$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $1007295417eb09fd$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $1007295417eb09fd$var$V = F;
                            break b;
                        }
                        $1007295417eb09fd$var$V = h.return;
                    }
                }
                $1007295417eb09fd$var$K = e;
                $1007295417eb09fd$var$jg();
                if ($1007295417eb09fd$var$lc && "function" === typeof $1007295417eb09fd$var$lc.onPostCommitFiberRoot) try {
                    $1007295417eb09fd$var$lc.onPostCommitFiberRoot($1007295417eb09fd$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $1007295417eb09fd$var$C = c, $1007295417eb09fd$var$pk.transition = b;
        }
    }
    return !1;
}
function $1007295417eb09fd$var$Yk(a, b, c) {
    b = $1007295417eb09fd$var$Ki(c, b);
    b = $1007295417eb09fd$var$Oi(a, b, 1);
    a = $1007295417eb09fd$var$dh(a, b, 1);
    b = $1007295417eb09fd$var$L();
    null !== a && ($1007295417eb09fd$var$Ac(a, 1, b), $1007295417eb09fd$var$Ek(a, b));
}
function $1007295417eb09fd$var$W(a, b, c) {
    if (3 === a.tag) $1007295417eb09fd$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $1007295417eb09fd$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $1007295417eb09fd$var$Si || !$1007295417eb09fd$var$Si.has(d))) {
                a = $1007295417eb09fd$var$Ki(c, a);
                a = $1007295417eb09fd$var$Ri(b, a, 1);
                b = $1007295417eb09fd$var$dh(b, a, 1);
                a = $1007295417eb09fd$var$L();
                null !== b && ($1007295417eb09fd$var$Ac(b, 1, a), $1007295417eb09fd$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $1007295417eb09fd$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $1007295417eb09fd$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $1007295417eb09fd$var$R === a && ($1007295417eb09fd$var$Z & c) === c && (4 === $1007295417eb09fd$var$T || 3 === $1007295417eb09fd$var$T && ($1007295417eb09fd$var$Z & 130023424) === $1007295417eb09fd$var$Z && 500 > $1007295417eb09fd$var$B() - $1007295417eb09fd$var$gk ? $1007295417eb09fd$var$Lk(a, 0) : $1007295417eb09fd$var$sk |= c);
    $1007295417eb09fd$var$Ek(a, b);
}
function $1007295417eb09fd$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $1007295417eb09fd$var$sc, $1007295417eb09fd$var$sc <<= 1, 0 === ($1007295417eb09fd$var$sc & 130023424) && ($1007295417eb09fd$var$sc = 4194304)));
    var c = $1007295417eb09fd$var$L();
    a = $1007295417eb09fd$var$Zg(a, b);
    null !== a && ($1007295417eb09fd$var$Ac(a, b, c), $1007295417eb09fd$var$Ek(a, c));
}
function $1007295417eb09fd$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $1007295417eb09fd$var$Zk(a, c);
}
function $1007295417eb09fd$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($1007295417eb09fd$var$p(314));
    }
    null !== d && d.delete(b);
    $1007295417eb09fd$var$Zk(a, c);
}
var $1007295417eb09fd$var$Wk;
$1007295417eb09fd$var$Wk = function Wk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $1007295417eb09fd$var$Wf.current) $1007295417eb09fd$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $1007295417eb09fd$var$Ug = !1, $1007295417eb09fd$var$zj(a, b, c);
            $1007295417eb09fd$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $1007295417eb09fd$var$Ug = !1, $1007295417eb09fd$var$I && 0 !== (b.flags & 1048576) && $1007295417eb09fd$var$ug(b, $1007295417eb09fd$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $1007295417eb09fd$var$jj(a, b);
            a = b.pendingProps;
            var e = $1007295417eb09fd$var$Yf(b, $1007295417eb09fd$var$H.current);
            $1007295417eb09fd$var$Tg(b, c);
            e = $1007295417eb09fd$var$Xh(null, b, d, a, e, c);
            var f = $1007295417eb09fd$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $1007295417eb09fd$var$Zf(d) ? (f = !0, $1007295417eb09fd$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $1007295417eb09fd$var$ah(b), e.updater = $1007295417eb09fd$var$nh, b.stateNode = e, e._reactInternals = b, $1007295417eb09fd$var$rh(b, d, a, c), b = $1007295417eb09fd$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $1007295417eb09fd$var$I && f && $1007295417eb09fd$var$vg(b), $1007295417eb09fd$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $1007295417eb09fd$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $1007295417eb09fd$var$$k(d);
                a = $1007295417eb09fd$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $1007295417eb09fd$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $1007295417eb09fd$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $1007295417eb09fd$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $1007295417eb09fd$var$aj(null, b, d, $1007295417eb09fd$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($1007295417eb09fd$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $1007295417eb09fd$var$Lg(d, e), $1007295417eb09fd$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $1007295417eb09fd$var$Lg(d, e), $1007295417eb09fd$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $1007295417eb09fd$var$lj(b);
                if (null === a) throw Error($1007295417eb09fd$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $1007295417eb09fd$var$bh(a, b);
                $1007295417eb09fd$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $1007295417eb09fd$var$Ki(Error($1007295417eb09fd$var$p(423)), b);
                        b = $1007295417eb09fd$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $1007295417eb09fd$var$Ki(Error($1007295417eb09fd$var$p(424)), b);
                        b = $1007295417eb09fd$var$mj(a, b, d, c, e);
                        break a;
                    } else for($1007295417eb09fd$var$yg = $1007295417eb09fd$var$Lf(b.stateNode.containerInfo.firstChild), $1007295417eb09fd$var$xg = b, $1007295417eb09fd$var$I = !0, $1007295417eb09fd$var$zg = null, c = $1007295417eb09fd$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $1007295417eb09fd$var$Ig();
                    if (d === e) {
                        b = $1007295417eb09fd$var$$i(a, b, c);
                        break a;
                    }
                    $1007295417eb09fd$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $1007295417eb09fd$var$Kh(b), null === a && $1007295417eb09fd$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $1007295417eb09fd$var$Ef(d, e) ? g = null : null !== f && $1007295417eb09fd$var$Ef(d, f) && (b.flags |= 32), $1007295417eb09fd$var$hj(a, b), $1007295417eb09fd$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $1007295417eb09fd$var$Eg(b), null;
        case 13:
            return $1007295417eb09fd$var$pj(a, b, c);
        case 4:
            return $1007295417eb09fd$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $1007295417eb09fd$var$Bh(b, null, d, c) : $1007295417eb09fd$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $1007295417eb09fd$var$Lg(d, e), $1007295417eb09fd$var$Zi(a, b, d, e, c);
        case 7:
            return $1007295417eb09fd$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $1007295417eb09fd$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $1007295417eb09fd$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $1007295417eb09fd$var$G($1007295417eb09fd$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($1007295417eb09fd$var$He(f.value, g)) {
                        if (f.children === e.children && !$1007295417eb09fd$var$Wf.current) {
                            b = $1007295417eb09fd$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $1007295417eb09fd$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $1007295417eb09fd$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($1007295417eb09fd$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $1007295417eb09fd$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $1007295417eb09fd$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $1007295417eb09fd$var$Tg(b, c), e = $1007295417eb09fd$var$Vg(e), d = d(e), b.flags |= 1, $1007295417eb09fd$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $1007295417eb09fd$var$Lg(d, b.pendingProps), e = $1007295417eb09fd$var$Lg(d.type, e), $1007295417eb09fd$var$aj(a, b, d, e, c);
        case 15:
            return $1007295417eb09fd$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $1007295417eb09fd$var$Lg(d, e), $1007295417eb09fd$var$jj(a, b), b.tag = 1, $1007295417eb09fd$var$Zf(d) ? (a = !0, $1007295417eb09fd$var$cg(b)) : a = !1, $1007295417eb09fd$var$Tg(b, c), $1007295417eb09fd$var$ph(b, d, e), $1007295417eb09fd$var$rh(b, d, e, c), $1007295417eb09fd$var$kj(null, b, d, !0, a, c);
        case 19:
            return $1007295417eb09fd$var$yj(a, b, c);
        case 22:
            return $1007295417eb09fd$var$ej(a, b, c);
    }
    throw Error($1007295417eb09fd$var$p(156, b.tag));
};
function $1007295417eb09fd$var$Gk(a, b) {
    return $1007295417eb09fd$var$ac(a, b);
}
function $1007295417eb09fd$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $1007295417eb09fd$var$Bg(a, b, c, d) {
    return new $1007295417eb09fd$var$al(a, b, c, d);
}
function $1007295417eb09fd$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $1007295417eb09fd$var$$k(a) {
    if ("function" === typeof a) return $1007295417eb09fd$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $1007295417eb09fd$var$Da) return 11;
        if (a === $1007295417eb09fd$var$Ga) return 14;
    }
    return 2;
}
function $1007295417eb09fd$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $1007295417eb09fd$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $1007295417eb09fd$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $1007295417eb09fd$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $1007295417eb09fd$var$ya:
            return $1007295417eb09fd$var$Ah(c.children, e, f, b);
        case $1007295417eb09fd$var$za:
            g = 8;
            e |= 8;
            break;
        case $1007295417eb09fd$var$Aa:
            return a = $1007295417eb09fd$var$Bg(12, c, b, e | 2), a.elementType = $1007295417eb09fd$var$Aa, a.lanes = f, a;
        case $1007295417eb09fd$var$Ea:
            return a = $1007295417eb09fd$var$Bg(13, c, b, e), a.elementType = $1007295417eb09fd$var$Ea, a.lanes = f, a;
        case $1007295417eb09fd$var$Fa:
            return a = $1007295417eb09fd$var$Bg(19, c, b, e), a.elementType = $1007295417eb09fd$var$Fa, a.lanes = f, a;
        case $1007295417eb09fd$var$Ia:
            return $1007295417eb09fd$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $1007295417eb09fd$var$Ba:
                    g = 10;
                    break a;
                case $1007295417eb09fd$var$Ca:
                    g = 9;
                    break a;
                case $1007295417eb09fd$var$Da:
                    g = 11;
                    break a;
                case $1007295417eb09fd$var$Ga:
                    g = 14;
                    break a;
                case $1007295417eb09fd$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($1007295417eb09fd$var$p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $Ml1eZ._)(a), ""));
    }
    b = $1007295417eb09fd$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $1007295417eb09fd$var$Ah(a, b, c, d) {
    a = $1007295417eb09fd$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $1007295417eb09fd$var$qj(a, b, c, d) {
    a = $1007295417eb09fd$var$Bg(22, a, d, b);
    a.elementType = $1007295417eb09fd$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $1007295417eb09fd$var$xh(a, b, c) {
    a = $1007295417eb09fd$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $1007295417eb09fd$var$zh(a, b, c) {
    b = $1007295417eb09fd$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $1007295417eb09fd$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $1007295417eb09fd$var$zc(0);
    this.expirationTimes = $1007295417eb09fd$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $1007295417eb09fd$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $1007295417eb09fd$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $1007295417eb09fd$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $1007295417eb09fd$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $1007295417eb09fd$var$ah(f);
    return a;
}
function $1007295417eb09fd$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $1007295417eb09fd$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $1007295417eb09fd$var$el(a) {
    if (!a) return $1007295417eb09fd$var$Vf;
    a = a._reactInternals;
    a: {
        if ($1007295417eb09fd$var$Vb(a) !== a || 1 !== a.tag) throw Error($1007295417eb09fd$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($1007295417eb09fd$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($1007295417eb09fd$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($1007295417eb09fd$var$Zf(c)) return $1007295417eb09fd$var$bg(a, c, b);
    }
    return b;
}
function $1007295417eb09fd$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $1007295417eb09fd$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $1007295417eb09fd$var$el(null);
    c = a.current;
    d = $1007295417eb09fd$var$L();
    e = $1007295417eb09fd$var$lh(c);
    f = $1007295417eb09fd$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $1007295417eb09fd$var$dh(c, f, e);
    a.current.lanes = e;
    $1007295417eb09fd$var$Ac(a, e, d);
    $1007295417eb09fd$var$Ek(a, d);
    return a;
}
function $1007295417eb09fd$var$gl(a, b, c, d) {
    var e = b.current, f = $1007295417eb09fd$var$L(), g = $1007295417eb09fd$var$lh(e);
    c = $1007295417eb09fd$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $1007295417eb09fd$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $1007295417eb09fd$var$dh(e, b, g);
    null !== a && ($1007295417eb09fd$var$mh(a, e, g, f), $1007295417eb09fd$var$eh(a, e, g));
    return g;
}
function $1007295417eb09fd$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $1007295417eb09fd$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $1007295417eb09fd$var$jl(a, b) {
    $1007295417eb09fd$var$il(a, b);
    (a = a.alternate) && $1007295417eb09fd$var$il(a, b);
}
function $1007295417eb09fd$var$kl() {
    return null;
}
var $1007295417eb09fd$var$ll = "function" === typeof reportError ? reportError : function ll(a) {
    console.error(a);
};
function $1007295417eb09fd$var$ml(a) {
    this._internalRoot = a;
}
$1007295417eb09fd$var$nl.prototype.render = $1007295417eb09fd$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($1007295417eb09fd$var$p(409));
    $1007295417eb09fd$var$gl(a, b, null, null);
};
$1007295417eb09fd$var$nl.prototype.unmount = $1007295417eb09fd$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $1007295417eb09fd$var$Sk(function() {
            $1007295417eb09fd$var$gl(null, a, null, null);
        });
        b[$1007295417eb09fd$var$uf] = null;
    }
};
function $1007295417eb09fd$var$nl(a) {
    this._internalRoot = a;
}
$1007295417eb09fd$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $1007295417eb09fd$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $1007295417eb09fd$var$Qc.length && 0 !== b && b < $1007295417eb09fd$var$Qc[c].priority; c++);
        $1007295417eb09fd$var$Qc.splice(c, 0, a);
        0 === c && $1007295417eb09fd$var$Vc(a);
    }
};
function $1007295417eb09fd$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $1007295417eb09fd$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $1007295417eb09fd$var$ql() {}
function $1007295417eb09fd$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = $1007295417eb09fd$var$hl(g);
                f.call(_$a);
            };
        }
        var g = $1007295417eb09fd$var$fl(b, d, a, 0, null, !1, !1, "", $1007295417eb09fd$var$ql);
        a._reactRootContainer = g;
        a[$1007295417eb09fd$var$uf] = g.current;
        $1007295417eb09fd$var$sf(8 === a.nodeType ? a.parentNode : a);
        $1007295417eb09fd$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = $1007295417eb09fd$var$hl(k);
            h.call(_$a);
        };
    }
    var k = $1007295417eb09fd$var$cl(a, 0, !1, null, null, !1, !1, "", $1007295417eb09fd$var$ql);
    a._reactRootContainer = k;
    a[$1007295417eb09fd$var$uf] = k.current;
    $1007295417eb09fd$var$sf(8 === a.nodeType ? a.parentNode : a);
    $1007295417eb09fd$var$Sk(function() {
        $1007295417eb09fd$var$gl(b, k, c, d);
    });
    return k;
}
function $1007295417eb09fd$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $1007295417eb09fd$var$hl(g);
                h.call(_$a);
            };
        }
        $1007295417eb09fd$var$gl(b, g, a, e);
    } else g = $1007295417eb09fd$var$rl(c, b, a, e, d);
    return $1007295417eb09fd$var$hl(g);
}
$1007295417eb09fd$var$Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $1007295417eb09fd$var$tc(b.pendingLanes);
                0 !== c && ($1007295417eb09fd$var$Cc(b, c | 1), $1007295417eb09fd$var$Ek(b, $1007295417eb09fd$var$B()), 0 === ($1007295417eb09fd$var$K & 6) && ($1007295417eb09fd$var$Hj = $1007295417eb09fd$var$B() + 500, $1007295417eb09fd$var$jg()));
            }
            break;
        case 13:
            $1007295417eb09fd$var$Sk(function() {
                var b = $1007295417eb09fd$var$Zg(a, 1);
                if (null !== b) {
                    var c = $1007295417eb09fd$var$L();
                    $1007295417eb09fd$var$mh(b, a, 1, c);
                }
            }), $1007295417eb09fd$var$jl(a, 1);
    }
};
$1007295417eb09fd$var$Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = $1007295417eb09fd$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $1007295417eb09fd$var$L();
            $1007295417eb09fd$var$mh(b, a, 134217728, c);
        }
        $1007295417eb09fd$var$jl(a, 134217728);
    }
};
$1007295417eb09fd$var$Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = $1007295417eb09fd$var$lh(a), c = $1007295417eb09fd$var$Zg(a, b);
        if (null !== c) {
            var d = $1007295417eb09fd$var$L();
            $1007295417eb09fd$var$mh(c, a, b, d);
        }
        $1007295417eb09fd$var$jl(a, b);
    }
};
$1007295417eb09fd$var$Hc = function Hc() {
    return $1007295417eb09fd$var$C;
};
$1007295417eb09fd$var$Ic = function Ic(a, b) {
    var c = $1007295417eb09fd$var$C;
    try {
        return $1007295417eb09fd$var$C = a, b();
    } finally{
        $1007295417eb09fd$var$C = c;
    }
};
$1007295417eb09fd$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $1007295417eb09fd$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $1007295417eb09fd$var$Db(d);
                        if (!e) throw Error($1007295417eb09fd$var$p(90));
                        $1007295417eb09fd$var$Wa(d);
                        $1007295417eb09fd$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $1007295417eb09fd$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $1007295417eb09fd$var$fb(a, !!c.multiple, b, !1);
    }
};
$1007295417eb09fd$var$Gb = $1007295417eb09fd$var$Rk;
$1007295417eb09fd$var$Hb = $1007295417eb09fd$var$Sk;
var $1007295417eb09fd$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $1007295417eb09fd$var$Cb,
        $1007295417eb09fd$var$ue,
        $1007295417eb09fd$var$Db,
        $1007295417eb09fd$var$Eb,
        $1007295417eb09fd$var$Fb,
        $1007295417eb09fd$var$Rk
    ]
}, $1007295417eb09fd$var$ul = {
    findFiberByHostInstance: $1007295417eb09fd$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $1007295417eb09fd$var$vl = {
    bundleType: $1007295417eb09fd$var$ul.bundleType,
    version: $1007295417eb09fd$var$ul.version,
    rendererPackageName: $1007295417eb09fd$var$ul.rendererPackageName,
    rendererConfig: $1007295417eb09fd$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $1007295417eb09fd$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $1007295417eb09fd$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $1007295417eb09fd$var$ul.findFiberByHostInstance || $1007295417eb09fd$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $1007295417eb09fd$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$1007295417eb09fd$var$wl.isDisabled && $1007295417eb09fd$var$wl.supportsFiber) try {
        $1007295417eb09fd$var$kc = $1007295417eb09fd$var$wl.inject($1007295417eb09fd$var$vl), $1007295417eb09fd$var$lc = $1007295417eb09fd$var$wl;
    } catch (a) {}
}
$1007295417eb09fd$export$ae55be85d98224ed = $1007295417eb09fd$var$tl;
$1007295417eb09fd$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$1007295417eb09fd$var$ol(b)) throw Error($1007295417eb09fd$var$p(200));
    return $1007295417eb09fd$var$dl(a, b, null, c);
};
$1007295417eb09fd$export$882461b6382ed46c = function(a, b) {
    if (!$1007295417eb09fd$var$ol(a)) throw Error($1007295417eb09fd$var$p(299));
    var c = !1, d = "", e = $1007295417eb09fd$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $1007295417eb09fd$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$1007295417eb09fd$var$uf] = b.current;
    $1007295417eb09fd$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $1007295417eb09fd$var$ml(b);
};
$1007295417eb09fd$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($1007295417eb09fd$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($1007295417eb09fd$var$p(268, a));
    }
    a = $1007295417eb09fd$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$1007295417eb09fd$export$cd75ccfd720a3cd4 = function(a) {
    return $1007295417eb09fd$var$Sk(a);
};
$1007295417eb09fd$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$1007295417eb09fd$var$pl(b)) throw Error($1007295417eb09fd$var$p(200));
    return $1007295417eb09fd$var$sl(null, a, b, !0, c);
};
$1007295417eb09fd$export$757ceba2d55c277e = function(a, b, c) {
    if (!$1007295417eb09fd$var$ol(a)) throw Error($1007295417eb09fd$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $1007295417eb09fd$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $1007295417eb09fd$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$1007295417eb09fd$var$uf] = b.current;
    $1007295417eb09fd$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $1007295417eb09fd$var$nl(b);
};
$1007295417eb09fd$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$1007295417eb09fd$var$pl(b)) throw Error($1007295417eb09fd$var$p(200));
    return $1007295417eb09fd$var$sl(null, a, b, !1, c);
};
$1007295417eb09fd$export$502457920280e6be = function(a) {
    if (!$1007295417eb09fd$var$pl(a)) throw Error($1007295417eb09fd$var$p(40));
    return a._reactRootContainer ? ($1007295417eb09fd$var$Sk(function() {
        $1007295417eb09fd$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$1007295417eb09fd$var$uf] = null;
        });
    }), !0) : !1;
};
$1007295417eb09fd$export$c78a37762a8d58e1 = $1007295417eb09fd$var$Rk;
$1007295417eb09fd$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$1007295417eb09fd$var$pl(c)) throw Error($1007295417eb09fd$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($1007295417eb09fd$var$p(38));
    return $1007295417eb09fd$var$sl(a, b, c, !1, d);
};
$1007295417eb09fd$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("aDU7V", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7E5Dv"));

});
parcelRegister("7E5Dv", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $5910a4137e4293a6$export$c4744153514ff05d; }, function (v) { return $5910a4137e4293a6$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $5910a4137e4293a6$export$3e506c1ccc9cc1a7; }, function (v) { return $5910a4137e4293a6$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $5910a4137e4293a6$export$e26fe2ed2fa76875; }, function (v) { return $5910a4137e4293a6$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $5910a4137e4293a6$export$502329bbf4b505b1; }, function (v) { return $5910a4137e4293a6$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $5910a4137e4293a6$export$6e3807111c4874c4; }, function (v) { return $5910a4137e4293a6$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $5910a4137e4293a6$export$c27134553091fb3a; }, function (v) { return $5910a4137e4293a6$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $5910a4137e4293a6$export$33ee1acdc04fd2a2; }, function (v) { return $5910a4137e4293a6$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $5910a4137e4293a6$export$b00a404bbd5edef2; }, function (v) { return $5910a4137e4293a6$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $5910a4137e4293a6$export$8352ce38b91d0c62; }, function (v) { return $5910a4137e4293a6$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $5910a4137e4293a6$export$d66a1c1c77bd778b; }, function (v) { return $5910a4137e4293a6$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $5910a4137e4293a6$export$d3dfb8e4810cb555; }, function (v) { return $5910a4137e4293a6$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $5910a4137e4293a6$export$839f9183b0465a69; }, function (v) { return $5910a4137e4293a6$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $5910a4137e4293a6$export$72fdf0e06517287b; }, function (v) { return $5910a4137e4293a6$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $5910a4137e4293a6$export$4b844e58a3e414b4; }, function (v) { return $5910a4137e4293a6$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $5910a4137e4293a6$export$816d2913ae6b83b1; }, function (v) { return $5910a4137e4293a6$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $5910a4137e4293a6$export$61bcfe829111a1d0; }, function (v) { return $5910a4137e4293a6$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $5910a4137e4293a6$export$7ee8c9beb337bc3f; }, function (v) { return $5910a4137e4293a6$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $5910a4137e4293a6$export$b5836b71941fa3ed; }, function (v) { return $5910a4137e4293a6$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $5910a4137e4293a6$export$cf845f2c119da08a; }, function (v) { return $5910a4137e4293a6$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5910a4137e4293a6$export$c4744153514ff05d;
var $5910a4137e4293a6$export$3e506c1ccc9cc1a7;
var $5910a4137e4293a6$export$e26fe2ed2fa76875;
var $5910a4137e4293a6$export$502329bbf4b505b1;
var $5910a4137e4293a6$export$6e3807111c4874c4;
var $5910a4137e4293a6$export$c27134553091fb3a;
var $5910a4137e4293a6$export$33ee1acdc04fd2a2;
var $5910a4137e4293a6$export$b00a404bbd5edef2;
var $5910a4137e4293a6$export$8352ce38b91d0c62;
var $5910a4137e4293a6$export$d66a1c1c77bd778b;
var $5910a4137e4293a6$export$d3dfb8e4810cb555;
var $5910a4137e4293a6$export$839f9183b0465a69;
var $5910a4137e4293a6$export$72fdf0e06517287b;
var $5910a4137e4293a6$export$4b844e58a3e414b4;
var $5910a4137e4293a6$export$816d2913ae6b83b1;
var $5910a4137e4293a6$export$61bcfe829111a1d0;
var $5910a4137e4293a6$export$7ee8c9beb337bc3f;
var $5910a4137e4293a6$export$b5836b71941fa3ed;
var $5910a4137e4293a6$export$cf845f2c119da08a;
"use strict";
function $5910a4137e4293a6$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $5910a4137e4293a6$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $5910a4137e4293a6$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $5910a4137e4293a6$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $5910a4137e4293a6$var$g(C, c)) n < e && 0 > $5910a4137e4293a6$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $5910a4137e4293a6$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $5910a4137e4293a6$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $5910a4137e4293a6$var$l = performance;
    $5910a4137e4293a6$export$c4744153514ff05d = function() {
        return $5910a4137e4293a6$var$l.now();
    };
} else {
    var $5910a4137e4293a6$var$p = Date, $5910a4137e4293a6$var$q = $5910a4137e4293a6$var$p.now();
    $5910a4137e4293a6$export$c4744153514ff05d = function() {
        return $5910a4137e4293a6$var$p.now() - $5910a4137e4293a6$var$q;
    };
}
var $5910a4137e4293a6$var$r = [], $5910a4137e4293a6$var$t = [], $5910a4137e4293a6$var$u = 1, $5910a4137e4293a6$var$v = null, $5910a4137e4293a6$var$y = 3, $5910a4137e4293a6$var$z = !1, $5910a4137e4293a6$var$A = !1, $5910a4137e4293a6$var$B = !1, $5910a4137e4293a6$var$D = "function" === typeof setTimeout ? setTimeout : null, $5910a4137e4293a6$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $5910a4137e4293a6$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $5910a4137e4293a6$var$G(a) {
    for(var b = $5910a4137e4293a6$var$h($5910a4137e4293a6$var$t); null !== b;){
        if (null === b.callback) $5910a4137e4293a6$var$k($5910a4137e4293a6$var$t);
        else if (b.startTime <= a) $5910a4137e4293a6$var$k($5910a4137e4293a6$var$t), b.sortIndex = b.expirationTime, $5910a4137e4293a6$var$f($5910a4137e4293a6$var$r, b);
        else break;
        b = $5910a4137e4293a6$var$h($5910a4137e4293a6$var$t);
    }
}
function $5910a4137e4293a6$var$H(a) {
    $5910a4137e4293a6$var$B = !1;
    $5910a4137e4293a6$var$G(a);
    if (!$5910a4137e4293a6$var$A) {
        if (null !== $5910a4137e4293a6$var$h($5910a4137e4293a6$var$r)) $5910a4137e4293a6$var$A = !0, $5910a4137e4293a6$var$I($5910a4137e4293a6$var$J);
        else {
            var b = $5910a4137e4293a6$var$h($5910a4137e4293a6$var$t);
            null !== b && $5910a4137e4293a6$var$K($5910a4137e4293a6$var$H, b.startTime - a);
        }
    }
}
function $5910a4137e4293a6$var$J(a, b) {
    $5910a4137e4293a6$var$A = !1;
    $5910a4137e4293a6$var$B && ($5910a4137e4293a6$var$B = !1, $5910a4137e4293a6$var$E($5910a4137e4293a6$var$L), $5910a4137e4293a6$var$L = -1);
    $5910a4137e4293a6$var$z = !0;
    var c = $5910a4137e4293a6$var$y;
    try {
        $5910a4137e4293a6$var$G(b);
        for($5910a4137e4293a6$var$v = $5910a4137e4293a6$var$h($5910a4137e4293a6$var$r); null !== $5910a4137e4293a6$var$v && (!($5910a4137e4293a6$var$v.expirationTime > b) || a && !$5910a4137e4293a6$var$M());){
            var d = $5910a4137e4293a6$var$v.callback;
            if ("function" === typeof d) {
                $5910a4137e4293a6$var$v.callback = null;
                $5910a4137e4293a6$var$y = $5910a4137e4293a6$var$v.priorityLevel;
                var e = d($5910a4137e4293a6$var$v.expirationTime <= b);
                b = $5910a4137e4293a6$export$c4744153514ff05d();
                "function" === typeof e ? $5910a4137e4293a6$var$v.callback = e : $5910a4137e4293a6$var$v === $5910a4137e4293a6$var$h($5910a4137e4293a6$var$r) && $5910a4137e4293a6$var$k($5910a4137e4293a6$var$r);
                $5910a4137e4293a6$var$G(b);
            } else $5910a4137e4293a6$var$k($5910a4137e4293a6$var$r);
            $5910a4137e4293a6$var$v = $5910a4137e4293a6$var$h($5910a4137e4293a6$var$r);
        }
        if (null !== $5910a4137e4293a6$var$v) var w = !0;
        else {
            var m = $5910a4137e4293a6$var$h($5910a4137e4293a6$var$t);
            null !== m && $5910a4137e4293a6$var$K($5910a4137e4293a6$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $5910a4137e4293a6$var$v = null, $5910a4137e4293a6$var$y = c, $5910a4137e4293a6$var$z = !1;
    }
}
var $5910a4137e4293a6$var$N = !1, $5910a4137e4293a6$var$O = null, $5910a4137e4293a6$var$L = -1, $5910a4137e4293a6$var$P = 5, $5910a4137e4293a6$var$Q = -1;
function $5910a4137e4293a6$var$M() {
    return $5910a4137e4293a6$export$c4744153514ff05d() - $5910a4137e4293a6$var$Q < $5910a4137e4293a6$var$P ? !1 : !0;
}
function $5910a4137e4293a6$var$R() {
    if (null !== $5910a4137e4293a6$var$O) {
        var a = $5910a4137e4293a6$export$c4744153514ff05d();
        $5910a4137e4293a6$var$Q = a;
        var b = !0;
        try {
            b = $5910a4137e4293a6$var$O(!0, a);
        } finally{
            b ? $5910a4137e4293a6$var$S() : ($5910a4137e4293a6$var$N = !1, $5910a4137e4293a6$var$O = null);
        }
    } else $5910a4137e4293a6$var$N = !1;
}
var $5910a4137e4293a6$var$S;
if ("function" === typeof $5910a4137e4293a6$var$F) $5910a4137e4293a6$var$S = function S() {
    $5910a4137e4293a6$var$F($5910a4137e4293a6$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $5910a4137e4293a6$var$T = new MessageChannel, $5910a4137e4293a6$var$U = $5910a4137e4293a6$var$T.port2;
    $5910a4137e4293a6$var$T.port1.onmessage = $5910a4137e4293a6$var$R;
    $5910a4137e4293a6$var$S = function S() {
        $5910a4137e4293a6$var$U.postMessage(null);
    };
} else $5910a4137e4293a6$var$S = function S() {
    $5910a4137e4293a6$var$D($5910a4137e4293a6$var$R, 0);
};
function $5910a4137e4293a6$var$I(a) {
    $5910a4137e4293a6$var$O = a;
    $5910a4137e4293a6$var$N || ($5910a4137e4293a6$var$N = !0, $5910a4137e4293a6$var$S());
}
function $5910a4137e4293a6$var$K(a, b) {
    $5910a4137e4293a6$var$L = $5910a4137e4293a6$var$D(function() {
        a($5910a4137e4293a6$export$c4744153514ff05d());
    }, b);
}
$5910a4137e4293a6$export$3e506c1ccc9cc1a7 = 5;
$5910a4137e4293a6$export$e26fe2ed2fa76875 = 1;
$5910a4137e4293a6$export$502329bbf4b505b1 = 4;
$5910a4137e4293a6$export$6e3807111c4874c4 = 3;
$5910a4137e4293a6$export$c27134553091fb3a = null;
$5910a4137e4293a6$export$33ee1acdc04fd2a2 = 2;
$5910a4137e4293a6$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$5910a4137e4293a6$export$8352ce38b91d0c62 = function() {
    $5910a4137e4293a6$var$A || $5910a4137e4293a6$var$z || ($5910a4137e4293a6$var$A = !0, $5910a4137e4293a6$var$I($5910a4137e4293a6$var$J));
};
$5910a4137e4293a6$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $5910a4137e4293a6$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$5910a4137e4293a6$export$d3dfb8e4810cb555 = function() {
    return $5910a4137e4293a6$var$y;
};
$5910a4137e4293a6$export$839f9183b0465a69 = function() {
    return $5910a4137e4293a6$var$h($5910a4137e4293a6$var$r);
};
$5910a4137e4293a6$export$72fdf0e06517287b = function(a) {
    switch($5910a4137e4293a6$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $5910a4137e4293a6$var$y;
    }
    var c = $5910a4137e4293a6$var$y;
    $5910a4137e4293a6$var$y = b;
    try {
        return a();
    } finally{
        $5910a4137e4293a6$var$y = c;
    }
};
$5910a4137e4293a6$export$4b844e58a3e414b4 = function() {};
$5910a4137e4293a6$export$816d2913ae6b83b1 = function() {};
$5910a4137e4293a6$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $5910a4137e4293a6$var$y;
    $5910a4137e4293a6$var$y = a;
    try {
        return b();
    } finally{
        $5910a4137e4293a6$var$y = c;
    }
};
$5910a4137e4293a6$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $5910a4137e4293a6$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $5910a4137e4293a6$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $5910a4137e4293a6$var$f($5910a4137e4293a6$var$t, a), null === $5910a4137e4293a6$var$h($5910a4137e4293a6$var$r) && a === $5910a4137e4293a6$var$h($5910a4137e4293a6$var$t) && ($5910a4137e4293a6$var$B ? ($5910a4137e4293a6$var$E($5910a4137e4293a6$var$L), $5910a4137e4293a6$var$L = -1) : $5910a4137e4293a6$var$B = !0, $5910a4137e4293a6$var$K($5910a4137e4293a6$var$H, c - d))) : (a.sortIndex = e, $5910a4137e4293a6$var$f($5910a4137e4293a6$var$r, a), $5910a4137e4293a6$var$A || $5910a4137e4293a6$var$z || ($5910a4137e4293a6$var$A = !0, $5910a4137e4293a6$var$I($5910a4137e4293a6$var$J)));
    return a;
};
$5910a4137e4293a6$export$b5836b71941fa3ed = $5910a4137e4293a6$var$M;
$5910a4137e4293a6$export$cf845f2c119da08a = function(a) {
    var b = $5910a4137e4293a6$var$y;
    return function() {
        var c = $5910a4137e4293a6$var$y;
        $5910a4137e4293a6$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $5910a4137e4293a6$var$y = c;
        }
    };
};

});



parcelRegister("2nFq9", function(module, exports) {
"use strict";
module.exports = "3.18.0";

});

parcelRegister("1C9Uy", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $12d107301e74211b$export$306c0aa65ff9ec16; }, function (v) { return $12d107301e74211b$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $12d107301e74211b$export$306c0aa65ff9ec16;
"use strict";

var $4rNTR = parcelRequire("4rNTR");
function $12d107301e74211b$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $12d107301e74211b$var$k = "function" === typeof Object.is ? Object.is : $12d107301e74211b$var$h, $12d107301e74211b$var$l = $4rNTR.useState, $12d107301e74211b$var$m = $4rNTR.useEffect, $12d107301e74211b$var$n = $4rNTR.useLayoutEffect, $12d107301e74211b$var$p = $4rNTR.useDebugValue;
function $12d107301e74211b$var$q(a, b) {
    var d = b(), f = $12d107301e74211b$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $12d107301e74211b$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $12d107301e74211b$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $12d107301e74211b$var$m(function() {
        $12d107301e74211b$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $12d107301e74211b$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $12d107301e74211b$var$p(d);
    return d;
}
function $12d107301e74211b$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$12d107301e74211b$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $12d107301e74211b$var$t(a, b) {
    return b();
}
var $12d107301e74211b$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $12d107301e74211b$var$t : $12d107301e74211b$var$q;
$12d107301e74211b$export$306c0aa65ff9ec16 = void 0 !== $4rNTR.useSyncExternalStore ? $4rNTR.useSyncExternalStore : $12d107301e74211b$var$u;

});

var $775bae712b15f178$exports = {};
"use strict";

$775bae712b15f178$exports = (parcelRequire("e3ROS"));


parcelRequire("4rNTR");
var $2c1f774f71163576$export$882461b6382ed46c;
var $2c1f774f71163576$export$757ceba2d55c277e;
"use strict";
var $91d74027e3c53c76$exports = {};
"use strict";
function $91d74027e3c53c76$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($91d74027e3c53c76$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$91d74027e3c53c76$var$checkDCE();

$91d74027e3c53c76$exports = (parcelRequire("1njCK"));


var $2c1f774f71163576$var$i;
$2c1f774f71163576$export$882461b6382ed46c = $91d74027e3c53c76$exports.createRoot;
$2c1f774f71163576$export$757ceba2d55c277e = $91d74027e3c53c76$exports.hydrateRoot;



var $20094f40e815e9de$exports = {};
/*! algoliasearch-lite.umd.js | 4.23.2 | © Algolia, inc. | https://github.com/algolia/algoliasearch-client-javascript */ !function(e, t) {
    $20094f40e815e9de$exports = t();
}($20094f40e815e9de$exports, function() {
    "use strict";
    function e(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e;
    }
    function t(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), r.push.apply(r, n);
        }
        return r;
    }
    function r(r) {
        for(var n = 1; n < arguments.length; n++){
            var o = null != arguments[n] ? arguments[n] : {};
            n % 2 ? t(Object(o), !0).forEach(function(t) {
                e(r, t, o[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(o)) : t(Object(o)).forEach(function(e) {
                Object.defineProperty(r, e, Object.getOwnPropertyDescriptor(o, e));
            });
        }
        return r;
    }
    function n(e, t) {
        if (null == e) return {};
        var r, n, o = function(e, t) {
            if (null == e) return {};
            var r, n, o = {}, a = Object.keys(e);
            for(n = 0; n < a.length; n++)r = a[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
            return o;
        }(e, t);
        if (Object.getOwnPropertySymbols) {
            var a = Object.getOwnPropertySymbols(e);
            for(n = 0; n < a.length; n++)r = a[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
        }
        return o;
    }
    function o(e, t) {
        return function(e) {
            if (Array.isArray(e)) return e;
        }(e) || function(e, t) {
            if (!(Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e))) return;
            var r = [], n = !0, o = !1, a = void 0;
            try {
                for(var u, i = e[Symbol.iterator](); !(n = (u = i.next()).done) && (r.push(u.value), !t || r.length !== t); n = !0);
            } catch (e) {
                o = !0, a = e;
            } finally{
                try {
                    n || null == i.return || i.return();
                } finally{
                    if (o) throw a;
                }
            }
            return r;
        }(e, t) || function() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }();
    }
    function a(e) {
        return function(e) {
            if (Array.isArray(e)) {
                for(var t = 0, r = new Array(e.length); t < e.length; t++)r[t] = e[t];
                return r;
            }
        }(e) || function(e) {
            if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
        }(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance");
        }();
    }
    function u(e) {
        var t, r = "algoliasearch-client-js-".concat(e.key), n = function n() {
            return void 0 === t && (t = e.localStorage || window.localStorage), t;
        }, a = function a() {
            return JSON.parse(n().getItem(r) || "{}");
        }, u = function u(e) {
            n().setItem(r, JSON.stringify(e));
        }, i = function i() {
            var t = e.timeToLive ? 1e3 * e.timeToLive : null, r = a(), n = Object.fromEntries(Object.entries(r).filter(function(e) {
                return void 0 !== o(e, 2)[1].timestamp;
            }));
            if (u(n), t) {
                var i = Object.fromEntries(Object.entries(n).filter(function(e) {
                    var r = o(e, 2)[1], n = (new Date).getTime();
                    return !(r.timestamp + t < n);
                }));
                u(i);
            }
        };
        return {
            get: function get(e, t) {
                var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                    miss: function miss() {
                        return Promise.resolve();
                    }
                };
                return Promise.resolve().then(function() {
                    i();
                    var t = JSON.stringify(e);
                    return a()[t];
                }).then(function(e) {
                    return Promise.all([
                        e ? e.value : t(),
                        void 0 !== e
                    ]);
                }).then(function(e) {
                    var t = o(e, 2), n = t[0], a = t[1];
                    return Promise.all([
                        n,
                        a || r.miss(n)
                    ]);
                }).then(function(e) {
                    return o(e, 1)[0];
                });
            },
            set: function set(e, t) {
                return Promise.resolve().then(function() {
                    var o = a();
                    return o[JSON.stringify(e)] = {
                        timestamp: (new Date).getTime(),
                        value: t
                    }, n().setItem(r, JSON.stringify(o)), t;
                });
            },
            delete: function _delete(e) {
                return Promise.resolve().then(function() {
                    var t = a();
                    delete t[JSON.stringify(e)], n().setItem(r, JSON.stringify(t));
                });
            },
            clear: function clear() {
                return Promise.resolve().then(function() {
                    n().removeItem(r);
                });
            }
        };
    }
    function i(e) {
        var t = a(e.caches), r = t.shift();
        return void 0 === r ? {
            get: function get(e, t) {
                var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                    miss: function miss() {
                        return Promise.resolve();
                    }
                }, n = t();
                return n.then(function(e) {
                    return Promise.all([
                        e,
                        r.miss(e)
                    ]);
                }).then(function(e) {
                    return o(e, 1)[0];
                });
            },
            set: function set(e, t) {
                return Promise.resolve(t);
            },
            delete: function _delete(e) {
                return Promise.resolve();
            },
            clear: function clear() {
                return Promise.resolve();
            }
        } : {
            get: function get(e, n) {
                var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                    miss: function miss() {
                        return Promise.resolve();
                    }
                };
                return r.get(e, n, o).catch(function() {
                    return i({
                        caches: t
                    }).get(e, n, o);
                });
            },
            set: function set(e, n) {
                return r.set(e, n).catch(function() {
                    return i({
                        caches: t
                    }).set(e, n);
                });
            },
            delete: function _delete(e) {
                return r.delete(e).catch(function() {
                    return i({
                        caches: t
                    }).delete(e);
                });
            },
            clear: function clear() {
                return r.clear().catch(function() {
                    return i({
                        caches: t
                    }).clear();
                });
            }
        };
    }
    function s() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
            serializable: !0
        }, t = {};
        return {
            get: function get(r, n) {
                var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                    miss: function miss() {
                        return Promise.resolve();
                    }
                }, a = JSON.stringify(r);
                if (a in t) return Promise.resolve(e.serializable ? JSON.parse(t[a]) : t[a]);
                var u = n(), i = o && o.miss || function() {
                    return Promise.resolve();
                };
                return u.then(function(e) {
                    return i(e);
                }).then(function() {
                    return u;
                });
            },
            set: function set(r, n) {
                return t[JSON.stringify(r)] = e.serializable ? JSON.stringify(n) : n, Promise.resolve(n);
            },
            delete: function _delete(e) {
                return delete t[JSON.stringify(e)], Promise.resolve();
            },
            clear: function clear() {
                return t = {}, Promise.resolve();
            }
        };
    }
    function c(e) {
        for(var t = e.length - 1; t > 0; t--){
            var r = Math.floor(Math.random() * (t + 1)), n = e[t];
            e[t] = e[r], e[r] = n;
        }
        return e;
    }
    function l(e, t) {
        return t ? (Object.keys(t).forEach(function(r) {
            e[r] = t[r](e);
        }), e) : e;
    }
    function f(e) {
        for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)r[n - 1] = arguments[n];
        var o = 0;
        return e.replace(/%s/g, function() {
            return encodeURIComponent(r[o++]);
        });
    }
    var h = {
        WithinQueryParameters: 0,
        WithinHeaders: 1
    };
    function m(e, t) {
        var r = e || {}, n = r.data || {};
        return Object.keys(r).forEach(function(e) {
            -1 === [
                "timeout",
                "headers",
                "queryParameters",
                "data",
                "cacheable"
            ].indexOf(e) && (n[e] = r[e]);
        }), {
            data: Object.entries(n).length > 0 ? n : void 0,
            timeout: r.timeout || t,
            headers: r.headers || {},
            queryParameters: r.queryParameters || {},
            cacheable: r.cacheable
        };
    }
    var d = {
        Read: 1,
        Write: 2,
        Any: 3
    }, p = 1, v = 2, g = 3;
    function y(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : p;
        return r(r({}, e), {}, {
            status: t,
            lastUpdate: Date.now()
        });
    }
    function b(e) {
        return "string" == typeof e ? {
            protocol: "https",
            url: e,
            accept: d.Any
        } : {
            protocol: e.protocol || "https",
            url: e.url,
            accept: e.accept || d.Any
        };
    }
    var O = "GET", P = "POST";
    function q(e, t) {
        return Promise.all(t.map(function(t) {
            return e.get(t, function() {
                return Promise.resolve(y(t));
            });
        })).then(function(e) {
            var r = e.filter(function(e) {
                return function(e) {
                    return e.status === p || Date.now() - e.lastUpdate > 12e4;
                }(e);
            }), n = e.filter(function(e) {
                return function(e) {
                    return e.status === g && Date.now() - e.lastUpdate <= 12e4;
                }(e);
            }), o = [].concat(a(r), a(n));
            return {
                getTimeout: function getTimeout(e, t) {
                    return (0 === n.length && 0 === e ? 1 : n.length + 3 + e) * t;
                },
                statelessHosts: o.length > 0 ? o.map(function(e) {
                    return b(e);
                }) : t
            };
        });
    }
    function j(e, t, n, o) {
        var u = [], i = function(e, t) {
            if (e.method === O || void 0 === e.data && void 0 === t.data) return;
            var _$n = Array.isArray(e.data) ? e.data : r(r({}, e.data), t.data);
            return JSON.stringify(_$n);
        }(n, o), s = function(e, t) {
            var _$n = r(r({}, e.headers), t.headers), _$o = {};
            return Object.keys(_$n).forEach(function(e) {
                var _$t = _$n[e];
                _$o[e.toLowerCase()] = _$t;
            }), _$o;
        }(e, o), c = n.method, l = n.method !== O ? {} : r(r({}, n.data), o.data), f = r(r(r({
            "x-algolia-agent": e.userAgent.value
        }, e.queryParameters), l), o.queryParameters), h = 0, m = function t(r, a) {
            var l = r.pop();
            if (void 0 === l) throw {
                name: "RetryError",
                message: "Unreachable hosts - your application id may be incorrect. If the error persists, contact support@algolia.com.",
                transporterStackTrace: A(u)
            };
            var m = {
                data: i,
                headers: s,
                method: c,
                url: S(l, n.path, f),
                connectTimeout: a(h, e.timeouts.connect),
                responseTimeout: a(h, o.timeout)
            }, d = function d(e) {
                var _$t = {
                    request: m,
                    response: e,
                    host: l,
                    triesLeft: r.length
                };
                return u.push(_$t), _$t;
            }, p = {
                onSuccess: function onSuccess(e) {
                    return function(e) {
                        try {
                            return JSON.parse(e.content);
                        } catch (t) {
                            throw function(e, t) {
                                return {
                                    name: "DeserializationError",
                                    message: e,
                                    response: t
                                };
                            }(t.message, e);
                        }
                    }(e);
                },
                onRetry: function onRetry(n) {
                    var _$o = d(n);
                    return n.isTimedOut && h++, Promise.all([
                        e.logger.info("Retryable failure", x(_$o)),
                        e.hostsCache.set(l, y(l, n.isTimedOut ? g : v))
                    ]).then(function() {
                        return t(r, a);
                    });
                },
                onFail: function onFail(e) {
                    throw d(e), function(e, t) {
                        var _$r = e.content, _$n = e.status, _$o = _$r;
                        try {
                            _$o = JSON.parse(_$r).message;
                        } catch (e) {}
                        return function(e, t, r) {
                            return {
                                name: "ApiError",
                                message: e,
                                status: t,
                                transporterStackTrace: r
                            };
                        }(_$o, _$n, t);
                    }(e, A(u));
                }
            };
            return e.requester.send(m).then(function(e) {
                return function(e, t) {
                    return function(e) {
                        var _$t = e.status;
                        return e.isTimedOut || function(e) {
                            var _$t = e.isTimedOut, _$r = e.status;
                            return !_$t && 0 == ~~_$r;
                        }(e) || 2 != ~~(_$t / 100) && 4 != ~~(_$t / 100);
                    }(e) ? t.onRetry(e) : 2 == ~~(e.status / 100) ? t.onSuccess(e) : t.onFail(e);
                }(e, p);
            });
        };
        return q(e.hostsCache, t).then(function(e) {
            return m(a(e.statelessHosts).reverse(), e.getTimeout);
        });
    }
    function w(e) {
        var t = {
            value: "Algolia for JavaScript (".concat(e, ")"),
            add: function add(e) {
                var r = "; ".concat(e.segment).concat(void 0 !== e.version ? " (".concat(e.version, ")") : "");
                return -1 === t.value.indexOf(r) && (t.value = "".concat(t.value).concat(r)), t;
            }
        };
        return t;
    }
    function S(e, t, r) {
        var n = T(r), o = "".concat(e.protocol, "://").concat(e.url, "/").concat("/" === t.charAt(0) ? t.substr(1) : t);
        return n.length && (o += "?".concat(n)), o;
    }
    function T(e) {
        return Object.keys(e).map(function(t) {
            var r;
            return f("%s=%s", t, (r = e[t], "[object Object]" === Object.prototype.toString.call(r) || "[object Array]" === Object.prototype.toString.call(r) ? JSON.stringify(e[t]) : e[t]));
        }).join("&");
    }
    function A(e) {
        return e.map(function(e) {
            return x(e);
        });
    }
    function x(e) {
        var t = e.request.headers["x-algolia-api-key"] ? {
            "x-algolia-api-key": "*****"
        } : {};
        return r(r({}, e), {}, {
            request: r(r({}, e.request), {}, {
                headers: r(r({}, e.request.headers), t)
            })
        });
    }
    var N = function N(e) {
        var t = e.appId, n = function(e, t, r) {
            var n = {
                "x-algolia-api-key": r,
                "x-algolia-application-id": t
            };
            return {
                headers: function headers() {
                    return e === h.WithinHeaders ? n : {};
                },
                queryParameters: function queryParameters() {
                    return e === h.WithinQueryParameters ? n : {};
                }
            };
        }(void 0 !== e.authMode ? e.authMode : h.WithinHeaders, t, e.apiKey), a = function(e) {
            var t = e.hostsCache, _$r = e.logger, n = e.requester, a = e.requestsCache, u = e.responsesCache, i = e.timeouts, s = e.userAgent, _$c = e.hosts, _$l = e.queryParameters, f = {
                hostsCache: t,
                logger: _$r,
                requester: n,
                requestsCache: a,
                responsesCache: u,
                timeouts: i,
                userAgent: s,
                headers: e.headers,
                queryParameters: _$l,
                hosts: _$c.map(function(e) {
                    return b(e);
                }),
                read: function read(e, t) {
                    var _$r = m(t, f.timeouts.read), n = function n() {
                        return j(f, f.hosts.filter(function(e) {
                            return 0 != (e.accept & d.Read);
                        }), e, _$r);
                    };
                    if (!0 !== (void 0 !== _$r.cacheable ? _$r.cacheable : e.cacheable)) return n();
                    var a = {
                        request: e,
                        mappedRequestOptions: _$r,
                        transporter: {
                            queryParameters: f.queryParameters,
                            headers: f.headers
                        }
                    };
                    return f.responsesCache.get(a, function() {
                        return f.requestsCache.get(a, function() {
                            return f.requestsCache.set(a, n()).then(function(e) {
                                return Promise.all([
                                    f.requestsCache.delete(a),
                                    e
                                ]);
                            }, function(e) {
                                return Promise.all([
                                    f.requestsCache.delete(a),
                                    Promise.reject(e)
                                ]);
                            }).then(function(e) {
                                var _$t = o(e, 2);
                                _$t[0];
                                return _$t[1];
                            });
                        });
                    }, {
                        miss: function miss(e) {
                            return f.responsesCache.set(a, e);
                        }
                    });
                },
                write: function write(e, t) {
                    return j(f, f.hosts.filter(function(e) {
                        return 0 != (e.accept & d.Write);
                    }), e, m(t, f.timeouts.write));
                }
            };
            return f;
        }(r(r({
            hosts: [
                {
                    url: "".concat(t, "-dsn.algolia.net"),
                    accept: d.Read
                },
                {
                    url: "".concat(t, ".algolia.net"),
                    accept: d.Write
                }
            ].concat(c([
                {
                    url: "".concat(t, "-1.algolianet.com")
                },
                {
                    url: "".concat(t, "-2.algolianet.com")
                },
                {
                    url: "".concat(t, "-3.algolianet.com")
                }
            ]))
        }, e), {}, {
            headers: r(r(r({}, n.headers()), {
                "content-type": "application/x-www-form-urlencoded"
            }), e.headers),
            queryParameters: r(r({}, n.queryParameters()), e.queryParameters)
        }));
        return l({
            transporter: a,
            appId: t,
            addAlgoliaAgent: function addAlgoliaAgent(e, t) {
                a.userAgent.add({
                    segment: e,
                    version: t
                });
            },
            clearCache: function clearCache() {
                return Promise.all([
                    a.requestsCache.clear(),
                    a.responsesCache.clear()
                ]).then(function() {});
            }
        }, e.methods);
    }, C = function C(e) {
        return function(t, r) {
            return t.method === O ? e.transporter.read(t, r) : e.transporter.write(t, r);
        };
    }, E = function E(e) {
        return function(t) {
            var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = {
                transporter: e.transporter,
                appId: e.appId,
                indexName: t
            };
            return l(n, r.methods);
        };
    }, J = function J(e) {
        return function(t, n) {
            var o = t.map(function(e) {
                return r(r({}, e), {}, {
                    params: T(e.params || {})
                });
            });
            return e.transporter.read({
                method: P,
                path: "1/indexes/*/queries",
                data: {
                    requests: o
                },
                cacheable: !0
            }, n);
        };
    }, k = function k(e) {
        return function(t, o) {
            return Promise.all(t.map(function(t) {
                var a = t.params, u = a.facetName, i = a.facetQuery, s = n(a, [
                    "facetName",
                    "facetQuery"
                ]);
                return E(e)(t.indexName, {
                    methods: {
                        searchForFacetValues: F
                    }
                }).searchForFacetValues(u, i, r(r({}, o), s));
            }));
        };
    }, I = function I(e) {
        return function(t, r, n) {
            return e.transporter.read({
                method: P,
                path: f("1/answers/%s/prediction", e.indexName),
                data: {
                    query: t,
                    queryLanguages: r
                },
                cacheable: !0
            }, n);
        };
    }, R = function R(e) {
        return function(t, r) {
            return e.transporter.read({
                method: P,
                path: f("1/indexes/%s/query", e.indexName),
                data: {
                    query: t
                },
                cacheable: !0
            }, r);
        };
    }, F = function F(e) {
        return function(t, r, n) {
            return e.transporter.read({
                method: P,
                path: f("1/indexes/%s/facets/%s/query", e.indexName, t),
                data: {
                    facetQuery: r
                },
                cacheable: !0
            }, n);
        };
    }, D = 1, W = 2, H = 3;
    var Q = function Q(e) {
        return function(t, n) {
            var o = t.map(function(e) {
                return r(r({}, e), {}, {
                    threshold: e.threshold || 0
                });
            });
            return e.transporter.read({
                method: P,
                path: "1/indexes/*/recommendations",
                data: {
                    requests: o
                },
                cacheable: !0
            }, n);
        };
    };
    function L(e, t, n) {
        var o, a = {
            appId: e,
            apiKey: t,
            timeouts: {
                connect: 1,
                read: 2,
                write: 30
            },
            requester: {
                send: function send(e) {
                    return new Promise(function(t) {
                        var _$r = new XMLHttpRequest;
                        _$r.open(e.method, e.url, !0), Object.keys(e.headers).forEach(function(t) {
                            return _$r.setRequestHeader(t, e.headers[t]);
                        });
                        var _$n, o = function o(e, n) {
                            return setTimeout(function() {
                                _$r.abort(), t({
                                    status: 0,
                                    content: n,
                                    isTimedOut: !0
                                });
                            }, 1e3 * e);
                        }, a = o(e.connectTimeout, "Connection timeout");
                        _$r.onreadystatechange = function() {
                            _$r.readyState > _$r.OPENED && void 0 === _$n && (clearTimeout(a), _$n = o(e.responseTimeout, "Socket timeout"));
                        }, _$r.onerror = function() {
                            0 === _$r.status && (clearTimeout(a), clearTimeout(_$n), t({
                                content: _$r.responseText || "Network request failed",
                                status: _$r.status,
                                isTimedOut: !1
                            }));
                        }, _$r.onload = function() {
                            clearTimeout(a), clearTimeout(_$n), t({
                                content: _$r.responseText,
                                status: _$r.status,
                                isTimedOut: !1
                            });
                        }, _$r.send(e.data);
                    });
                }
            },
            logger: (o = H, {
                debug: function debug(e, t) {
                    return D >= o && console.debug(e, t), Promise.resolve();
                },
                info: function info(e, t) {
                    return W >= o && console.info(e, t), Promise.resolve();
                },
                error: function error(e, t) {
                    return console.error(e, t), Promise.resolve();
                }
            }),
            responsesCache: s(),
            requestsCache: s({
                serializable: !1
            }),
            hostsCache: i({
                caches: [
                    u({
                        key: "".concat("4.23.2", "-").concat(e)
                    }),
                    s()
                ]
            }),
            userAgent: w("4.23.2").add({
                segment: "Browser",
                version: "lite"
            }),
            authMode: h.WithinQueryParameters
        };
        return N(r(r(r({}, a), n), {}, {
            methods: {
                search: J,
                searchForFacetValues: k,
                multipleQueries: J,
                multipleSearchForFacetValues: k,
                customRequest: C,
                initIndex: function initIndex(e) {
                    return function(t) {
                        return E(e)(t, {
                            methods: {
                                search: R,
                                searchForFacetValues: F,
                                findAnswers: I
                            }
                        });
                    };
                },
                getRecommendations: Q
            }
        }));
    }
    return L.version = "4.23.2", L;
});



var $4rNTR = parcelRequire("4rNTR");

var $4rNTR = parcelRequire("4rNTR");

var $4rNTR = parcelRequire("4rNTR");
var $f765a77f41ff4abf$export$899c7584ba03b94a = /*#__PURE__*/ (0, $4rNTR.createContext)(null);



var $4rNTR = parcelRequire("4rNTR");
var $93aff80651844e0e$export$4b9ddb9c6903c13 = /*#__PURE__*/ (0, $4rNTR.createContext)(null);


var $510c46699c725eb9$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
function $510c46699c725eb9$var$EventEmitter() {
    this._events = this._events || {};
    this._maxListeners = this._maxListeners || undefined;
}
$510c46699c725eb9$exports = $510c46699c725eb9$var$EventEmitter;
// Backwards-compat with node 0.10.x
// EventEmitter.EventEmitter = EventEmitter;
$510c46699c725eb9$var$EventEmitter.prototype._events = undefined;
$510c46699c725eb9$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
$510c46699c725eb9$var$EventEmitter.defaultMaxListeners = 10;
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$510c46699c725eb9$var$EventEmitter.prototype.setMaxListeners = function(n) {
    if (!$510c46699c725eb9$var$isNumber(n) || n < 0 || isNaN(n)) throw TypeError("n must be a positive number");
    this._maxListeners = n;
    return this;
};
$510c46699c725eb9$var$EventEmitter.prototype.emit = function(type) {
    var er, handler, len, args, i, listeners;
    if (!this._events) this._events = {};
    // If there is no 'error' event listener then throw.
    if (type === "error") {
        if (!this._events.error || $510c46699c725eb9$var$isObject(this._events.error) && !this._events.error.length) {
            er = arguments[1];
            if (er instanceof Error) throw er; // Unhandled 'error' event
            else {
                // At least give some kind of context to the user
                var err = new Error('Uncaught, unspecified "error" event. (' + er + ")");
                err.context = er;
                throw err;
            }
        }
    }
    handler = this._events[type];
    if ($510c46699c725eb9$var$isUndefined(handler)) return false;
    if ($510c46699c725eb9$var$isFunction(handler)) switch(arguments.length){
        // fast cases
        case 1:
            handler.call(this);
            break;
        case 2:
            handler.call(this, arguments[1]);
            break;
        case 3:
            handler.call(this, arguments[1], arguments[2]);
            break;
        // slower
        default:
            args = Array.prototype.slice.call(arguments, 1);
            handler.apply(this, args);
    }
    else if ($510c46699c725eb9$var$isObject(handler)) {
        args = Array.prototype.slice.call(arguments, 1);
        listeners = handler.slice();
        len = listeners.length;
        for(i = 0; i < len; i++)listeners[i].apply(this, args);
    }
    return true;
};
$510c46699c725eb9$var$EventEmitter.prototype.addListener = function(type, listener) {
    var m;
    if (!$510c46699c725eb9$var$isFunction(listener)) throw TypeError("listener must be a function");
    if (!this._events) this._events = {};
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (this._events.newListener) this.emit("newListener", type, $510c46699c725eb9$var$isFunction(listener.listener) ? listener.listener : listener);
    if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
    else if ($510c46699c725eb9$var$isObject(this._events[type])) // If we've already got an array, just append.
    this._events[type].push(listener);
    else // Adding the second element, need to change to array.
    this._events[type] = [
        this._events[type],
        listener
    ];
    // Check for listener leak
    if ($510c46699c725eb9$var$isObject(this._events[type]) && !this._events[type].warned) {
        if (!$510c46699c725eb9$var$isUndefined(this._maxListeners)) m = this._maxListeners;
        else m = $510c46699c725eb9$var$EventEmitter.defaultMaxListeners;
        if (m && m > 0 && this._events[type].length > m) {
            this._events[type].warned = true;
            console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[type].length);
            if (typeof console.trace === "function") // not supported in IE 10
            console.trace();
        }
    }
    return this;
};
$510c46699c725eb9$var$EventEmitter.prototype.on = $510c46699c725eb9$var$EventEmitter.prototype.addListener;
$510c46699c725eb9$var$EventEmitter.prototype.once = function(type, listener) {
    if (!$510c46699c725eb9$var$isFunction(listener)) throw TypeError("listener must be a function");
    var fired = false;
    function g() {
        this.removeListener(type, g);
        if (!fired) {
            fired = true;
            listener.apply(this, arguments);
        }
    }
    g.listener = listener;
    this.on(type, g);
    return this;
};
// emits a 'removeListener' event iff the listener was removed
$510c46699c725eb9$var$EventEmitter.prototype.removeListener = function(type, listener) {
    var list, position, length, i;
    if (!$510c46699c725eb9$var$isFunction(listener)) throw TypeError("listener must be a function");
    if (!this._events || !this._events[type]) return this;
    list = this._events[type];
    length = list.length;
    position = -1;
    if (list === listener || $510c46699c725eb9$var$isFunction(list.listener) && list.listener === listener) {
        delete this._events[type];
        if (this._events.removeListener) this.emit("removeListener", type, listener);
    } else if ($510c46699c725eb9$var$isObject(list)) {
        for(i = length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
            position = i;
            break;
        }
        if (position < 0) return this;
        if (list.length === 1) {
            list.length = 0;
            delete this._events[type];
        } else list.splice(position, 1);
        if (this._events.removeListener) this.emit("removeListener", type, listener);
    }
    return this;
};
$510c46699c725eb9$var$EventEmitter.prototype.removeAllListeners = function(type) {
    var key, listeners;
    if (!this._events) return this;
    // not listening for removeListener, no need to emit
    if (!this._events.removeListener) {
        if (arguments.length === 0) this._events = {};
        else if (this._events[type]) delete this._events[type];
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        for(key in this._events){
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = {};
        return this;
    }
    listeners = this._events[type];
    if ($510c46699c725eb9$var$isFunction(listeners)) this.removeListener(type, listeners);
    else if (listeners) // LIFO order
    while(listeners.length)this.removeListener(type, listeners[listeners.length - 1]);
    delete this._events[type];
    return this;
};
$510c46699c725eb9$var$EventEmitter.prototype.listeners = function(type) {
    var ret;
    if (!this._events || !this._events[type]) ret = [];
    else if ($510c46699c725eb9$var$isFunction(this._events[type])) ret = [
        this._events[type]
    ];
    else ret = this._events[type].slice();
    return ret;
};
$510c46699c725eb9$var$EventEmitter.prototype.listenerCount = function(type) {
    if (this._events) {
        var evlistener = this._events[type];
        if ($510c46699c725eb9$var$isFunction(evlistener)) return 1;
        else if (evlistener) return evlistener.length;
    }
    return 0;
};
$510c46699c725eb9$var$EventEmitter.listenerCount = function(emitter, type) {
    return emitter.listenerCount(type);
};
function $510c46699c725eb9$var$isFunction(arg) {
    return typeof arg === "function";
}
function $510c46699c725eb9$var$isNumber(arg) {
    return typeof arg === "number";
}
function $510c46699c725eb9$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
function $510c46699c725eb9$var$isUndefined(arg) {
    return arg === void 0;
}


var $154f73342ab39590$exports = {};
"use strict";
var $ef22465501782220$exports = {};
"use strict";

var $e6e2bb60b64380ea$exports = {};
"use strict";

var $0a179e04f2f2d4bb$exports = {};
"use strict";
function $0a179e04f2f2d4bb$var$inherits(ctor, superCtor) {
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
}
$0a179e04f2f2d4bb$exports = $0a179e04f2f2d4bb$var$inherits;


/**
 * A DerivedHelper is a way to create sub requests to
 * Algolia from a main helper.
 * @class
 * @classdesc The DerivedHelper provides an event based interface for search callbacks:
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 * @param {AlgoliaSearchHelper} mainHelper the main helper
 * @param {function} fn the function to create the derived state for search
 * @param {function} recommendFn the function to create the derived state for recommendations
 */ function $e6e2bb60b64380ea$var$DerivedHelper(mainHelper, fn, recommendFn) {
    this.main = mainHelper;
    this.fn = fn;
    this.recommendFn = recommendFn;
    this.lastResults = null;
    this.lastRecommendResults = null;
}
$0a179e04f2f2d4bb$exports($e6e2bb60b64380ea$var$DerivedHelper, $510c46699c725eb9$exports);
/**
 * Detach this helper from the main helper
 * @return {undefined}
 * @throws Error if the derived helper is already detached
 */ $e6e2bb60b64380ea$var$DerivedHelper.prototype.detach = function() {
    this.removeAllListeners();
    this.main.detachDerivedHelper(this);
};
$e6e2bb60b64380ea$var$DerivedHelper.prototype.getModifiedState = function(parameters) {
    return this.fn(parameters);
};
$e6e2bb60b64380ea$var$DerivedHelper.prototype.getModifiedRecommendState = function(parameters) {
    return this.recommendFn(parameters);
};
$e6e2bb60b64380ea$exports = $e6e2bb60b64380ea$var$DerivedHelper;


var $49f03fd1dace76b5$exports = {};
"use strict";
/**
 * Replaces a leading - with \-
 * @private
 * @param {any} value the facet value to replace
 * @returns {any} the escaped facet value or the value if it was not a string
 */ function $49f03fd1dace76b5$var$escapeFacetValue(value) {
    if (typeof value !== "string") return value;
    return String(value).replace(/^-/, "\\-");
}
/**
 * Replaces a leading \- with -
 * @private
 * @param {any} value the escaped facet value
 * @returns {any} the unescaped facet value or the value if it was not a string
 */ function $49f03fd1dace76b5$var$unescapeFacetValue(value) {
    if (typeof value !== "string") return value;
    return value.replace(/^\\-/, "-");
}
$49f03fd1dace76b5$exports = {
    escapeFacetValue: $49f03fd1dace76b5$var$escapeFacetValue,
    unescapeFacetValue: $49f03fd1dace76b5$var$unescapeFacetValue
};


var $ef22465501782220$require$escapeFacetValue = $49f03fd1dace76b5$exports.escapeFacetValue;

var $35783371e549f033$exports = {};
"use strict";
function $35783371e549f033$var$clone(value) {
    if (typeof value === "object" && value !== null) return $35783371e549f033$var$_merge(Array.isArray(value) ? [] : {}, value);
    return value;
}
function $35783371e549f033$var$isObjectOrArrayOrFunction(value) {
    return typeof value === "function" || Array.isArray(value) || Object.prototype.toString.call(value) === "[object Object]";
}
function $35783371e549f033$var$_merge(target, source) {
    if (target === source) return target;
    // eslint-disable-next-line no-restricted-syntax
    for(var key in source){
        if (!Object.prototype.hasOwnProperty.call(source, key) || key === "__proto__" || key === "constructor") continue;
        var sourceVal = source[key];
        var targetVal = target[key];
        if (typeof targetVal !== "undefined" && typeof sourceVal === "undefined") continue;
        if ($35783371e549f033$var$isObjectOrArrayOrFunction(targetVal) && $35783371e549f033$var$isObjectOrArrayOrFunction(sourceVal)) target[key] = $35783371e549f033$var$_merge(targetVal, sourceVal);
        else target[key] = $35783371e549f033$var$clone(sourceVal);
    }
    return target;
}
/**
 * This method is like Object.assign, but recursively merges own and inherited
 * enumerable keyed properties of source objects into the destination object.
 *
 * NOTE: this behaves like lodash/merge, but:
 * - does mutate functions if they are a source
 * - treats non-plain objects as plain
 * - does not work for circular objects
 * - treats sparse arrays as sparse
 * - does not convert Array-like objects (Arguments, NodeLists, etc.) to arrays
 *
 * @param {Object} target The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 */ function $35783371e549f033$var$merge(target) {
    if (!$35783371e549f033$var$isObjectOrArrayOrFunction(target)) target = {};
    for(var i = 1, l = arguments.length; i < l; i++){
        var source = arguments[i];
        if ($35783371e549f033$var$isObjectOrArrayOrFunction(source)) $35783371e549f033$var$_merge(target, source);
    }
    return target;
}
$35783371e549f033$exports = $35783371e549f033$var$merge;


var $47eb2399d0baf1bd$exports = {};
"use strict";
function $47eb2399d0baf1bd$var$objectHasKeys(obj) {
    return obj && Object.keys(obj).length > 0;
}
$47eb2399d0baf1bd$exports = $47eb2399d0baf1bd$var$objectHasKeys;


var $f254195a30803f63$exports = {};
"use strict";
// https://github.com/babel/babel/blob/3aaafae053fa75febb3aa45d45b6f00646e30ba4/packages/babel-helpers/src/helpers.js#L604-L620
function $f254195a30803f63$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source === null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key;
    var i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        // eslint-disable-next-line no-continue
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
$f254195a30803f63$exports = $f254195a30803f63$var$_objectWithoutPropertiesLoose;


var $5f5e985ab36777f0$exports = {};
"use strict";
/**
 * RecommendParameters is the data structure that contains all the information
 * usable for getting recommendations from the Algolia API. It doesn't do the
 * search itself, nor does it contains logic about the parameters.
 * It is an immutable object, therefore it has been created in a way that each
 * changes does not change the object itself but returns a copy with the
 * modification.
 * This object should probably not be instantiated outside of the helper. It
 * will be provided when needed.
 * @constructor
 * @classdesc contains all the parameters for recommendations
 * @param {RecommendParametersOptions} opts the options to create the object
 */ function $5f5e985ab36777f0$var$RecommendParameters(opts) {
    opts = opts || {};
    this.params = opts.params || [];
}
$5f5e985ab36777f0$var$RecommendParameters.prototype = {
    constructor: $5f5e985ab36777f0$var$RecommendParameters,
    addParams: function addParams(params) {
        var newParams = this.params.slice();
        var existingParamsIndex = this.params.findIndex(function(currentParams) {
            return currentParams.$$id === params.$$id;
        });
        if (existingParamsIndex !== -1) newParams.splice(existingParamsIndex, 1, params);
        else newParams.push(params);
        return new $5f5e985ab36777f0$var$RecommendParameters({
            params: newParams
        });
    },
    removeParams: function removeParams(id) {
        return new $5f5e985ab36777f0$var$RecommendParameters({
            params: this.params.filter(function(param) {
                return param.$$id !== id;
            })
        });
    },
    addFrequentlyBoughtTogether: function addFrequentlyBoughtTogether(params) {
        return this.addParams(Object.assign({}, params, {
            model: "bought-together"
        }));
    },
    addRelatedProducts: function addRelatedProducts(params) {
        return this.addParams(Object.assign({}, params, {
            model: "related-products"
        }));
    },
    addTrendingItems: function addTrendingItems(params) {
        return this.addParams(Object.assign({}, params, {
            model: "trending-items"
        }));
    },
    addTrendingFacets: function addTrendingFacets(params) {
        return this.addParams(Object.assign({}, params, {
            model: "trending-facets"
        }));
    },
    addLookingSimilar: function addLookingSimilar(params) {
        return this.addParams(Object.assign({}, params, {
            model: "looking-similar"
        }));
    },
    _buildQueries: function _buildQueries(indexName) {
        return this.params.map(function(params) {
            var query = Object.assign({}, params, {
                indexName: indexName
            });
            delete query.$$id;
            return query;
        });
    }
};
$5f5e985ab36777f0$exports = $5f5e985ab36777f0$var$RecommendParameters;


var $915525af975e011b$exports = {};
"use strict";

function $915525af975e011b$var$sortObject(obj) {
    return Object.keys(obj).sort().reduce(function(acc, curr) {
        acc[curr] = obj[curr];
        return acc;
    }, {});
}
var $915525af975e011b$var$requestBuilder = {
    /**
   * Get all the queries to send to the client, those queries can used directly
   * with the Algolia client.
   * @private
   * @param  {string} index The name of the index
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object[]} The queries
   */ _getQueries: function getQueries(index, state) {
        var queries = [];
        // One query for the hits
        queries.push({
            indexName: index,
            params: $915525af975e011b$var$requestBuilder._getHitsSearchParams(state)
        });
        // One for each disjunctive facets
        state.getRefinedDisjunctiveFacets().forEach(function(refinedFacet) {
            queries.push({
                indexName: index,
                params: $915525af975e011b$var$requestBuilder._getDisjunctiveFacetSearchParams(state, refinedFacet)
            });
        });
        // More to get the parent levels of the hierarchical facets when refined
        state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
            var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
            var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            // If we are deeper than level 0 (starting from `beer > IPA`)
            // we want to get all parent values
            if (currentRefinement.length > 0 && currentRefinement[0].split(separator).length > 1) {
                // We generate a map of the filters we will use for our facet values queries
                var filtersMap = currentRefinement[0].split(separator).slice(0, -1).reduce(function createFiltersMap(map, segment, level) {
                    return map.concat({
                        attribute: hierarchicalFacet.attributes[level],
                        value: level === 0 ? segment : [
                            map[map.length - 1].value,
                            segment
                        ].join(separator)
                    });
                }, []);
                filtersMap.forEach(function(filter, level) {
                    var params = $915525af975e011b$var$requestBuilder._getDisjunctiveFacetSearchParams(state, filter.attribute, level === 0);
                    // Keep facet filters unrelated to current hierarchical attributes
                    function hasHierarchicalFacetFilter(value) {
                        return hierarchicalFacet.attributes.some(function(attribute) {
                            return attribute === value.split(":")[0];
                        });
                    }
                    var filteredFacetFilters = (params.facetFilters || []).reduce(function(acc, facetFilter) {
                        if (Array.isArray(facetFilter)) {
                            var filtered = facetFilter.filter(function(filterValue) {
                                return !hasHierarchicalFacetFilter(filterValue);
                            });
                            if (filtered.length > 0) acc.push(filtered);
                        }
                        if (typeof facetFilter === "string" && !hasHierarchicalFacetFilter(facetFilter)) acc.push(facetFilter);
                        return acc;
                    }, []);
                    var parent = filtersMap[level - 1];
                    if (level > 0) params.facetFilters = filteredFacetFilters.concat(parent.attribute + ":" + parent.value);
                    else params.facetFilters = filteredFacetFilters.length > 0 ? filteredFacetFilters : undefined;
                    queries.push({
                        indexName: index,
                        params: params
                    });
                });
            }
        });
        return queries;
    },
    /**
   * Build search parameters used to fetch hits
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object.<string, any>} The search parameters for hits
   */ _getHitsSearchParams: function _getHitsSearchParams(state) {
        var facets = state.facets.concat(state.disjunctiveFacets).concat($915525af975e011b$var$requestBuilder._getHitsHierarchicalFacetsAttributes(state)).sort();
        var facetFilters = $915525af975e011b$var$requestBuilder._getFacetFilters(state);
        var numericFilters = $915525af975e011b$var$requestBuilder._getNumericFilters(state);
        var tagFilters = $915525af975e011b$var$requestBuilder._getTagFilters(state);
        var additionalParams = {
            facets: facets.indexOf("*") > -1 ? [
                "*"
            ] : facets,
            tagFilters: tagFilters
        };
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        return $915525af975e011b$var$sortObject($35783371e549f033$exports({}, state.getQueryParams(), additionalParams));
    },
    /**
   * Build search parameters used to fetch a disjunctive facet
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} facet the associated facet name
   * @param  {boolean} hierarchicalRootLevel ?? FIXME
   * @return {object} The search parameters for a disjunctive facet
   */ _getDisjunctiveFacetSearchParams: function _getDisjunctiveFacetSearchParams(state, facet, hierarchicalRootLevel) {
        var facetFilters = $915525af975e011b$var$requestBuilder._getFacetFilters(state, facet, hierarchicalRootLevel);
        var numericFilters = $915525af975e011b$var$requestBuilder._getNumericFilters(state, facet);
        var tagFilters = $915525af975e011b$var$requestBuilder._getTagFilters(state);
        var additionalParams = {
            hitsPerPage: 0,
            page: 0,
            analytics: false,
            clickAnalytics: false
        };
        if (tagFilters.length > 0) additionalParams.tagFilters = tagFilters;
        var hierarchicalFacet = state.getHierarchicalFacetByName(facet);
        if (hierarchicalFacet) additionalParams.facets = $915525af975e011b$var$requestBuilder._getDisjunctiveHierarchicalFacetAttribute(state, hierarchicalFacet, hierarchicalRootLevel);
        else additionalParams.facets = facet;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        return $915525af975e011b$var$sortObject($35783371e549f033$exports({}, state.getQueryParams(), additionalParams));
    },
    /**
   * Return the numeric filters in an algolia request fashion
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @param {string} [facetName] the name of the attribute for which the filters should be excluded
   * @return {string[]} the numeric filters in the algolia format
   */ _getNumericFilters: function _getNumericFilters(state, facetName) {
        if (state.numericFilters) return state.numericFilters;
        var numericFilters = [];
        Object.keys(state.numericRefinements).forEach(function(attribute) {
            var operators = state.numericRefinements[attribute] || {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator] || [];
                if (facetName !== attribute) values.forEach(function(value) {
                    if (Array.isArray(value)) {
                        var vs = value.map(function(v) {
                            return attribute + operator + v;
                        });
                        numericFilters.push(vs);
                    } else numericFilters.push(attribute + operator + value);
                });
            });
        });
        return numericFilters;
    },
    /**
   * Return the tags filters depending on which format is used, either tagFilters or tagRefinements
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @return {string} Tag filters in a single string
   */ _getTagFilters: function _getTagFilters(state) {
        if (state.tagFilters) return state.tagFilters;
        return state.tagRefinements.join(",");
    },
    /**
   * Build facetFilters parameter based on current refinements. The array returned
   * contains strings representing the facet filters in the algolia format.
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} [facet] if set, the current disjunctive facet
   * @param  {boolean} [hierarchicalRootLevel] ?? FIXME
   * @return {array.<string>} The facet filters in the algolia format
   */ _getFacetFilters: function _getFacetFilters(state, facet, hierarchicalRootLevel) {
        var facetFilters = [];
        var facetsRefinements = state.facetsRefinements || {};
        Object.keys(facetsRefinements).sort().forEach(function(facetName) {
            var facetValues = facetsRefinements[facetName] || [];
            facetValues.slice().sort().forEach(function(facetValue) {
                facetFilters.push(facetName + ":" + facetValue);
            });
        });
        var facetsExcludes = state.facetsExcludes || {};
        Object.keys(facetsExcludes).sort().forEach(function(facetName) {
            var facetValues = facetsExcludes[facetName] || [];
            facetValues.sort().forEach(function(facetValue) {
                facetFilters.push(facetName + ":-" + facetValue);
            });
        });
        var disjunctiveFacetsRefinements = state.disjunctiveFacetsRefinements || {};
        Object.keys(disjunctiveFacetsRefinements).sort().forEach(function(facetName) {
            var facetValues = disjunctiveFacetsRefinements[facetName] || [];
            if (facetName === facet || !facetValues || facetValues.length === 0) return;
            var orFilters = [];
            facetValues.slice().sort().forEach(function(facetValue) {
                orFilters.push(facetName + ":" + facetValue);
            });
            facetFilters.push(orFilters);
        });
        var hierarchicalFacetsRefinements = state.hierarchicalFacetsRefinements || {};
        Object.keys(hierarchicalFacetsRefinements).sort().forEach(function(facetName) {
            var facetValues = hierarchicalFacetsRefinements[facetName] || [];
            var facetValue = facetValues[0];
            if (facetValue === undefined) return;
            var hierarchicalFacet = state.getHierarchicalFacetByName(facetName);
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeToRefine;
            var attributesIndex;
            // we ask for parent facet values only when the `facet` is the current hierarchical facet
            if (facet === facetName) {
                // if we are at the root level already, no need to ask for facet values, we get them from
                // the hits query
                if (facetValue.indexOf(separator) === -1 || !rootPath && hierarchicalRootLevel === true || rootPath && rootPath.split(separator).length === facetValue.split(separator).length) return;
                if (!rootPath) {
                    attributesIndex = facetValue.split(separator).length - 2;
                    facetValue = facetValue.slice(0, facetValue.lastIndexOf(separator));
                } else {
                    attributesIndex = rootPath.split(separator).length - 1;
                    facetValue = rootPath;
                }
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            } else {
                attributesIndex = facetValue.split(separator).length - 1;
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            }
            if (attributeToRefine) facetFilters.push([
                attributeToRefine + ":" + facetValue
            ]);
        });
        return facetFilters;
    },
    _getHitsHierarchicalFacetsAttributes: function _getHitsHierarchicalFacetsAttributes(state) {
        var out = [];
        return state.hierarchicalFacets.reduce(// ask for as much levels as there's hierarchical refinements
        function getHitsAttributesForHierarchicalFacet(allAttributes, hierarchicalFacet) {
            var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0];
            // if no refinement, ask for root level
            if (!hierarchicalRefinement) {
                allAttributes.push(hierarchicalFacet.attributes[0]);
                return allAttributes;
            }
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var level = hierarchicalRefinement.split(separator).length;
            var newAttributes = hierarchicalFacet.attributes.slice(0, level + 1);
            return allAttributes.concat(newAttributes);
        }, out);
    },
    _getDisjunctiveHierarchicalFacetAttribute: function _getDisjunctiveHierarchicalFacetAttribute(state, hierarchicalFacet, rootLevel) {
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        if (rootLevel === true) {
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeIndex = 0;
            if (rootPath) attributeIndex = rootPath.split(separator).length;
            return [
                hierarchicalFacet.attributes[attributeIndex]
            ];
        }
        var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0] || "";
        // if refinement is 'beers > IPA > Flying dog',
        // then we want `facets: ['beers > IPA']` as disjunctive facet (parent level values)
        var parentLevel = hierarchicalRefinement.split(separator).length - 1;
        return hierarchicalFacet.attributes.slice(0, parentLevel + 1);
    },
    getSearchForFacetQuery: function getSearchForFacetQuery(facetName, query, maxFacetHits, state) {
        var stateForSearchForFacetValues = state.isDisjunctiveFacet(facetName) ? state.clearRefinements(facetName) : state;
        var searchForFacetSearchParameters = {
            facetQuery: query,
            facetName: facetName
        };
        if (typeof maxFacetHits === "number") searchForFacetSearchParameters.maxFacetHits = maxFacetHits;
        return $915525af975e011b$var$sortObject($35783371e549f033$exports({}, $915525af975e011b$var$requestBuilder._getHitsSearchParams(stateForSearchForFacetValues), searchForFacetSearchParameters));
    }
};
$915525af975e011b$exports = $915525af975e011b$var$requestBuilder;


var $42c6a8b833b5bd3a$exports = {};
"use strict";
var $e8574be1cb58b6cf$exports = {};
"use strict";
// NOTE: this behaves like lodash/defaults, but doesn't mutate the target
// it also preserve keys order
$e8574be1cb58b6cf$exports = function defaultsPure() {
    var sources = Array.prototype.slice.call(arguments);
    return sources.reduceRight(function(acc, source) {
        Object.keys(Object(source)).forEach(function(key) {
            if (source[key] === undefined) return;
            if (acc[key] !== undefined) // remove if already added, so that we can add it in correct order
            delete acc[key];
            acc[key] = source[key];
        });
        return acc;
    }, {});
};


var $d02ab4ee8a5630b4$exports = {};
"use strict";
// @MAJOR can be replaced by native Array#find when we change support
$d02ab4ee8a5630b4$exports = function find(array, comparator) {
    if (!Array.isArray(array)) return undefined;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return array[i];
    }
    return undefined;
};


var $1e2f65f1489ad0ab$exports = {};
"use strict";
function $1e2f65f1489ad0ab$var$intersection(arr1, arr2) {
    return arr1.filter(function(value, index) {
        return arr2.indexOf(value) > -1 && arr1.indexOf(value) === index /* skips duplicates */ ;
    });
}
$1e2f65f1489ad0ab$exports = $1e2f65f1489ad0ab$var$intersection;





var $1c31000d5d7cb0d9$exports = {};
"use strict";
function $1c31000d5d7cb0d9$var$valToNumber(v) {
    if (typeof v === "number") return v;
    else if (typeof v === "string") return parseFloat(v);
    else if (Array.isArray(v)) return v.map($1c31000d5d7cb0d9$var$valToNumber);
    throw new Error("The value should be a number, a parsable string or an array of those.");
}
$1c31000d5d7cb0d9$exports = $1c31000d5d7cb0d9$var$valToNumber;


var $597ab8925208806f$exports = {};
"use strict";
$597ab8925208806f$exports = function isValidUserToken(userToken) {
    if (userToken === null) return false;
    return /^[a-zA-Z0-9_-]{1,64}$/.test(userToken);
};


var $a04e05c4a0558547$exports = {};
"use strict";



var $a04e05c4a0558547$var$lib = {
    /**
   * Adds a refinement to a RefinementList
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement, if the value is not a string it will be converted
   * @return {RefinementList} a new and updated refinement list
   */ addRefinement: function addRefinement(refinementList, attribute, value) {
        if ($a04e05c4a0558547$var$lib.isRefined(refinementList, attribute, value)) return refinementList;
        var valueAsString = "" + value;
        var facetRefinement = !refinementList[attribute] ? [
            valueAsString
        ] : refinementList[attribute].concat(valueAsString);
        var mod = {};
        mod[attribute] = facetRefinement;
        return $e8574be1cb58b6cf$exports({}, mod, refinementList);
    },
    /**
   * Removes refinement(s) for an attribute:
   *  - if the value is specified removes the refinement for the value on the attribute
   *  - if no value is specified removes all the refinements for this attribute
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} [value] the value of the refinement
   * @return {RefinementList} a new and updated refinement lst
   */ removeRefinement: function removeRefinement(refinementList, attribute, value) {
        if (value === undefined) // we use the "filter" form of clearRefinement, since it leaves empty values as-is
        // the form with a string will remove the attribute completely
        return $a04e05c4a0558547$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f;
        });
        var valueAsString = "" + value;
        return $a04e05c4a0558547$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f && valueAsString === v;
        });
    },
    /**
   * Toggles the refinement value for an attribute.
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement
   * @return {RefinementList} a new and updated list
   */ toggleRefinement: function toggleRefinement(refinementList, attribute, value) {
        if (value === undefined) throw new Error("toggleRefinement should be used with a value");
        if ($a04e05c4a0558547$var$lib.isRefined(refinementList, attribute, value)) return $a04e05c4a0558547$var$lib.removeRefinement(refinementList, attribute, value);
        return $a04e05c4a0558547$var$lib.addRefinement(refinementList, attribute, value);
    },
    /**
   * Clear all or parts of a RefinementList. Depending on the arguments, three
   * kinds of behavior can happen:
   *  - if no attribute is provided: clears the whole list
   *  - if an attribute is provided as a string: clears the list for the specific attribute
   *  - if an attribute is provided as a function: discards the elements for which the function returns true
   * @param {RefinementList} refinementList the initial list
   * @param {string} [attribute] the attribute or function to discard
   * @param {string} [refinementType] optional parameter to give more context to the attribute function
   * @return {RefinementList} a new and updated refinement list
   */ clearRefinement: function clearRefinement(refinementList, attribute, refinementType) {
        if (attribute === undefined) {
            // return the same object if the list is already empty
            // this is mainly for tests, as it doesn't have much impact on performance
            if (!$47eb2399d0baf1bd$exports(refinementList)) return refinementList;
            return {};
        } else if (typeof attribute === "string") return $f254195a30803f63$exports(refinementList, [
            attribute
        ]);
        else if (typeof attribute === "function") {
            var hasChanged = false;
            var newRefinementList = Object.keys(refinementList).reduce(function(memo, key) {
                var values = refinementList[key] || [];
                var facetList = values.filter(function(value) {
                    return !attribute(value, key, refinementType);
                });
                if (facetList.length !== values.length) hasChanged = true;
                memo[key] = facetList;
                return memo;
            }, {});
            if (hasChanged) return newRefinementList;
            return refinementList;
        }
        // We return nothing if the attribute is not undefined, a string or a function,
        // as it is not a valid value for a refinement
        return undefined;
    },
    /**
   * Test if the refinement value is used for the attribute. If no refinement value
   * is provided, test if the refinementList contains any refinement for the
   * given attribute.
   * @param {RefinementList} refinementList the list of refinement
   * @param {string} attribute name of the attribute
   * @param {string} [refinementValue] value of the filter/refinement
   * @return {boolean} true if the attribute is refined, false otherwise
   */ isRefined: function isRefined(refinementList, attribute, refinementValue) {
        var containsRefinements = Boolean(refinementList[attribute]) && refinementList[attribute].length > 0;
        if (refinementValue === undefined || !containsRefinements) return containsRefinements;
        var refinementValueAsString = "" + refinementValue;
        return refinementList[attribute].indexOf(refinementValueAsString) !== -1;
    }
};
$a04e05c4a0558547$exports = $a04e05c4a0558547$var$lib;


/**
 * isEqual, but only for numeric refinement values, possible values:
 * - 5
 * - [5]
 * - [[5]]
 * - [[5,5],[4]]
 * @param {any} a numeric refinement value
 * @param {any} b numeric refinement value
 * @return {boolean} true if the values are equal
 */ function $42c6a8b833b5bd3a$var$isEqualNumericRefinement(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) return a.length === b.length && a.every(function(el, i) {
        return $42c6a8b833b5bd3a$var$isEqualNumericRefinement(b[i], el);
    });
    return a === b;
}
/**
 * like _.find but using deep equality to be able to use it
 * to find arrays.
 * @private
 * @param {any[]} array array to search into (elements are base or array of base)
 * @param {any} searchedValue the value we're looking for (base or array of base)
 * @return {any} the searched value or undefined
 */ function $42c6a8b833b5bd3a$var$findArray(array, searchedValue) {
    return $d02ab4ee8a5630b4$exports(array, function(currentValue) {
        return $42c6a8b833b5bd3a$var$isEqualNumericRefinement(currentValue, searchedValue);
    });
}
/**
 * The facet list is the structure used to store the list of values used to
 * filter a single attribute.
 * @typedef {string[]} SearchParameters.FacetList
 */ /**
 * Structure to store numeric filters with the operator as the key. The supported operators
 * are `=`, `>`, `<`, `>=`, `<=` and `!=`.
 * @typedef {Object.<string, Array.<number|number[]>>} SearchParameters.OperatorList
 */ /**
 * SearchParameters is the data structure that contains all the information
 * usable for making a search to Algolia API. It doesn't do the search itself,
 * nor does it contains logic about the parameters.
 * It is an immutable object, therefore it has been created in a way that each
 * changes does not change the object itself but returns a copy with the
 * modification.
 * This object should probably not be instantiated outside of the helper. It will
 * be provided when needed. This object is documented for reference as you'll
 * get it from events generated by the {@link AlgoliaSearchHelper}.
 * If need be, instantiate the Helper from the factory function {@link SearchParameters.make}
 * @constructor
 * @classdesc contains all the parameters of a search
 * @param {object|SearchParameters} newParameters existing parameters or partial object
 * for the properties of a new SearchParameters
 * @see SearchParameters.make
 * @example <caption>SearchParameters of the first query in
 *   <a href="http://demos.algolia.com/instant-search-demo/">the instant search demo</a></caption>
{
   "query": "",
   "disjunctiveFacets": [
      "customerReviewCount",
      "category",
      "salePrice_range",
      "manufacturer"
  ],
   "maxValuesPerFacet": 30,
   "page": 0,
   "hitsPerPage": 10,
   "facets": [
      "type",
      "shipping"
  ]
}
 */ function $42c6a8b833b5bd3a$var$SearchParameters(newParameters) {
    var params = newParameters ? $42c6a8b833b5bd3a$var$SearchParameters._parseNumbers(newParameters) : {};
    if (params.userToken !== undefined && !$597ab8925208806f$exports(params.userToken)) // eslint-disable-next-line no-console
    console.warn("[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}");
    /**
   * This attribute contains the list of all the conjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.facets = params.facets || [];
    /**
   * This attribute contains the list of all the disjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.disjunctiveFacets = params.disjunctiveFacets || [];
    /**
   * This attribute contains the list of all the hierarchical facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * Hierarchical facets are a sub type of disjunctive facets that
   * let you filter faceted attributes hierarchically.
   * @member {string[]|object[]}
   */ this.hierarchicalFacets = params.hierarchicalFacets || [];
    // Refinements
    /**
   * This attribute contains all the filters that need to be
   * applied on the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsRefinements = params.facetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * excluded from the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters excluded for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsExcludes = params.facetsExcludes || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the disjunctive facets. Each facet must be properly
   * defined in the `disjunctiveFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.disjunctiveFacetsRefinements = params.disjunctiveFacetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the numeric attributes.
   *
   * The key is the name of the attribute, and the value is the
   * filters to apply to this attribute.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `numericFilters` attribute.
   * @member {Object.<string, SearchParameters.OperatorList>}
   */ this.numericRefinements = params.numericRefinements || {};
    /**
   * This attribute contains all the tags used to refine the query.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `tagFilters` attribute.
   * @member {string[]}
   */ this.tagRefinements = params.tagRefinements || [];
    /**
   * This attribute contains all the filters that need to be
   * applied on the hierarchical facets. Each facet must be properly
   * defined in the `hierarchicalFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name. The FacetList values
   * are structured as a string that contain the values for each level
   * separated by the configured separator.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.hierarchicalFacetsRefinements = params.hierarchicalFacetsRefinements || {};
    // eslint-disable-next-line consistent-this
    var self = this;
    Object.keys(params).forEach(function(paramName) {
        var isKeyKnown = $42c6a8b833b5bd3a$var$SearchParameters.PARAMETERS.indexOf(paramName) !== -1;
        var isValueDefined = params[paramName] !== undefined;
        if (!isKeyKnown && isValueDefined) self[paramName] = params[paramName];
    });
}
/**
 * List all the properties in SearchParameters and therefore all the known Algolia properties
 * This doesn't contain any beta/hidden features.
 * @private
 */ $42c6a8b833b5bd3a$var$SearchParameters.PARAMETERS = Object.keys(new $42c6a8b833b5bd3a$var$SearchParameters());
/**
 * @private
 * @param {object} partialState full or part of a state
 * @return {object} a new object with the number keys as number
 */ $42c6a8b833b5bd3a$var$SearchParameters._parseNumbers = function(partialState) {
    // Do not parse numbers again in SearchParameters, they ought to be parsed already
    if (partialState instanceof $42c6a8b833b5bd3a$var$SearchParameters) return partialState;
    var numbers = {};
    var numberKeys = [
        "aroundPrecision",
        "aroundRadius",
        "getRankingInfo",
        "minWordSizefor2Typos",
        "minWordSizefor1Typo",
        "page",
        "maxValuesPerFacet",
        "distinct",
        "minimumAroundRadius",
        "hitsPerPage",
        "minProximity"
    ];
    numberKeys.forEach(function(k) {
        var value = partialState[k];
        if (typeof value === "string") {
            var parsedValue = parseFloat(value);
            // global isNaN is ok to use here, value is only number or NaN
            numbers[k] = isNaN(parsedValue) ? value : parsedValue;
        }
    });
    // there's two formats of insideBoundingBox, we need to parse
    // the one which is an array of float geo rectangles
    if (Array.isArray(partialState.insideBoundingBox)) numbers.insideBoundingBox = partialState.insideBoundingBox.map(function(geoRect) {
        if (Array.isArray(geoRect)) return geoRect.map(function(value) {
            return parseFloat(value);
        });
        return geoRect;
    });
    if (partialState.numericRefinements) {
        var numericRefinements = {};
        Object.keys(partialState.numericRefinements).forEach(function(attribute) {
            var operators = partialState.numericRefinements[attribute] || {};
            numericRefinements[attribute] = {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator];
                var parsedValues = values.map(function(v) {
                    if (Array.isArray(v)) return v.map(function(vPrime) {
                        if (typeof vPrime === "string") return parseFloat(vPrime);
                        return vPrime;
                    });
                    else if (typeof v === "string") return parseFloat(v);
                    return v;
                });
                numericRefinements[attribute][operator] = parsedValues;
            });
        });
        numbers.numericRefinements = numericRefinements;
    }
    return $35783371e549f033$exports(partialState, numbers);
};
/**
 * Factory for SearchParameters
 * @param {object|SearchParameters} newParameters existing parameters or partial
 * object for the properties of a new SearchParameters
 * @return {SearchParameters} frozen instance of SearchParameters
 */ $42c6a8b833b5bd3a$var$SearchParameters.make = function makeSearchParameters(newParameters) {
    var instance = new $42c6a8b833b5bd3a$var$SearchParameters(newParameters);
    var hierarchicalFacets = newParameters.hierarchicalFacets || [];
    hierarchicalFacets.forEach(function(facet) {
        if (facet.rootPath) {
            var currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length > 0 && currentRefinement[0].indexOf(facet.rootPath) !== 0) instance = instance.clearRefinements(facet.name);
            // get it again in case it has been cleared
            currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length === 0) instance = instance.toggleHierarchicalFacetRefinement(facet.name, facet.rootPath);
        }
    });
    return instance;
};
/**
 * Validates the new parameters based on the previous state
 * @param {SearchParameters} currentState the current state
 * @param {object|SearchParameters} parameters the new parameters to set
 * @return {Error|null} Error if the modification is invalid, null otherwise
 */ $42c6a8b833b5bd3a$var$SearchParameters.validate = function(currentState, parameters) {
    var params = parameters || {};
    if (currentState.tagFilters && params.tagRefinements && params.tagRefinements.length > 0) return new Error("[Tags] Cannot switch from the managed tag API to the advanced API. It is probably an error, if it is really what you want, you should first clear the tags with clearTags method.");
    if (currentState.tagRefinements.length > 0 && params.tagFilters) return new Error("[Tags] Cannot switch from the advanced tag API to the managed API. It is probably an error, if it is not, you should first clear the tags with clearTags method.");
    if (currentState.numericFilters && params.numericRefinements && $47eb2399d0baf1bd$exports(params.numericRefinements)) return new Error("[Numeric filters] Can't switch from the advanced to the managed API. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    if ($47eb2399d0baf1bd$exports(currentState.numericRefinements) && params.numericFilters) return new Error("[Numeric filters] Can't switch from the managed API to the advanced. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    return null;
};
$42c6a8b833b5bd3a$var$SearchParameters.prototype = {
    constructor: $42c6a8b833b5bd3a$var$SearchParameters,
    /**
   * Remove all refinements (disjunctive + conjunctive + excludes + numeric filters)
   * @method
   * @param {undefined|string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {SearchParameters} new instance with filters cleared
   */ clearRefinements: function clearRefinements(attribute) {
        var patch = {
            numericRefinements: this._clearNumericRefinements(attribute),
            facetsRefinements: $a04e05c4a0558547$exports.clearRefinement(this.facetsRefinements, attribute, "conjunctiveFacet"),
            facetsExcludes: $a04e05c4a0558547$exports.clearRefinement(this.facetsExcludes, attribute, "exclude"),
            disjunctiveFacetsRefinements: $a04e05c4a0558547$exports.clearRefinement(this.disjunctiveFacetsRefinements, attribute, "disjunctiveFacet"),
            hierarchicalFacetsRefinements: $a04e05c4a0558547$exports.clearRefinement(this.hierarchicalFacetsRefinements, attribute, "hierarchicalFacet")
        };
        if (patch.numericRefinements === this.numericRefinements && patch.facetsRefinements === this.facetsRefinements && patch.facetsExcludes === this.facetsExcludes && patch.disjunctiveFacetsRefinements === this.disjunctiveFacetsRefinements && patch.hierarchicalFacetsRefinements === this.hierarchicalFacetsRefinements) return this;
        return this.setQueryParameters(patch);
    },
    /**
   * Remove all the refined tags from the SearchParameters
   * @method
   * @return {SearchParameters} new instance with tags cleared
   */ clearTags: function clearTags() {
        if (this.tagFilters === undefined && this.tagRefinements.length === 0) return this;
        return this.setQueryParameters({
            tagFilters: undefined,
            tagRefinements: []
        });
    },
    /**
   * Set the index.
   * @method
   * @param {string} index the index name
   * @return {SearchParameters} new instance
   */ setIndex: function setIndex(index) {
        if (index === this.index) return this;
        return this.setQueryParameters({
            index: index
        });
    },
    /**
   * Query setter
   * @method
   * @param {string} newQuery value for the new query
   * @return {SearchParameters} new instance
   */ setQuery: function setQuery(newQuery) {
        if (newQuery === this.query) return this;
        return this.setQueryParameters({
            query: newQuery
        });
    },
    /**
   * Page setter
   * @method
   * @param {number} newPage new page number
   * @return {SearchParameters} new instance
   */ setPage: function setPage(newPage) {
        if (newPage === this.page) return this;
        return this.setQueryParameters({
            page: newPage
        });
    },
    /**
   * Facets setter
   * The facets are the simple facets, used for conjunctive (and) faceting.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for conjunctive faceting
   * @return {SearchParameters} new instance
   */ setFacets: function setFacets(facets) {
        return this.setQueryParameters({
            facets: facets
        });
    },
    /**
   * Disjunctive facets setter
   * Change the list of disjunctive (or) facets the helper chan handle.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for disjunctive faceting
   * @return {SearchParameters} new instance
   */ setDisjunctiveFacets: function setDisjunctiveFacets(facets) {
        return this.setQueryParameters({
            disjunctiveFacets: facets
        });
    },
    /**
   * HitsPerPage setter
   * Hits per page represents the number of hits retrieved for this query
   * @method
   * @param {number} n number of hits retrieved per page of results
   * @return {SearchParameters} new instance
   */ setHitsPerPage: function setHitsPerPage(n) {
        if (this.hitsPerPage === n) return this;
        return this.setQueryParameters({
            hitsPerPage: n
        });
    },
    /**
   * typoTolerance setter
   * Set the value of typoTolerance
   * @method
   * @param {string} typoTolerance new value of typoTolerance ("true", "false", "min" or "strict")
   * @return {SearchParameters} new instance
   */ setTypoTolerance: function setTypoTolerance(typoTolerance) {
        if (this.typoTolerance === typoTolerance) return this;
        return this.setQueryParameters({
            typoTolerance: typoTolerance
        });
    },
    /**
   * Add a numeric filter for a given attribute
   * When value is an array, they are combined with OR
   * When value is a single value, it will combined with AND
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} operator operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number | number[]} value value of the filter
   * @return {SearchParameters} new instance
   * @example
   * // for price = 50 or 40
   * state.addNumericRefinement('price', '=', [50, 40]);
   * @example
   * // for size = 38 and 40
   * state.addNumericRefinement('size', '=', 38);
   * state.addNumericRefinement('size', '=', 40);
   */ addNumericRefinement: function addNumericRefinement(attribute, operator, value) {
        var val = $1c31000d5d7cb0d9$exports(value);
        if (this.isNumericRefined(attribute, operator, val)) return this;
        var mod = $35783371e549f033$exports({}, this.numericRefinements);
        mod[attribute] = $35783371e549f033$exports({}, mod[attribute]);
        if (mod[attribute][operator]) {
            // Array copy
            mod[attribute][operator] = mod[attribute][operator].slice();
            // Add the element. Concat can't be used here because value can be an array.
            mod[attribute][operator].push(val);
        } else mod[attribute][operator] = [
            val
        ];
        return this.setQueryParameters({
            numericRefinements: mod
        });
    },
    /**
   * Get the list of conjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getConjunctiveRefinements: function getConjunctiveRefinements(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsRefinements[facetName] || [];
    },
    /**
   * Get the list of disjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getDisjunctiveRefinements: function getDisjunctiveRefinements(facetName) {
        if (!this.isDisjunctiveFacet(facetName)) return [];
        return this.disjunctiveFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of hierarchical refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getHierarchicalRefinement: function getHierarchicalRefinement(facetName) {
        // we send an array but we currently do not support multiple
        // hierarchicalRefinements for a hierarchicalFacet
        return this.hierarchicalFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of exclude refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getExcludeRefinements: function getExcludeRefinements(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsExcludes[facetName] || [];
    },
    /**
   * Remove all the numeric filter for a given (attribute, operator)
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} [operator] operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number} [number] the value to be removed
   * @return {SearchParameters} new instance
   */ removeNumericRefinement: function removeNumericRefinement(attribute, operator, number) {
        var paramValue = number;
        if (paramValue !== undefined) {
            if (!this.isNumericRefined(attribute, operator, paramValue)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator && $42c6a8b833b5bd3a$var$isEqualNumericRefinement(value.val, $1c31000d5d7cb0d9$exports(paramValue));
                })
            });
        } else if (operator !== undefined) {
            if (!this.isNumericRefined(attribute, operator)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator;
                })
            });
        }
        if (!this.isNumericRefined(attribute)) return this;
        return this.setQueryParameters({
            numericRefinements: this._clearNumericRefinements(function(value, key) {
                return key === attribute;
            })
        });
    },
    /**
   * Get the list of numeric refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {SearchParameters.OperatorList} list of refinements
   */ getNumericRefinements: function getNumericRefinements(facetName) {
        return this.numericRefinements[facetName] || {};
    },
    /**
   * Return the current refinement for the (attribute, operator)
   * @param {string} attribute attribute in the record
   * @param {string} operator operator applied on the refined values
   * @return {Array.<number|number[]>} refined values
   */ getNumericRefinement: function getNumericRefinement(attribute, operator) {
        return this.numericRefinements[attribute] && this.numericRefinements[attribute][operator];
    },
    /**
   * Clear numeric filters.
   * @method
   * @private
   * @param {string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {Object.<string, OperatorList>} new numeric refinements
   */ _clearNumericRefinements: function _clearNumericRefinements(attribute) {
        if (attribute === undefined) {
            if (!$47eb2399d0baf1bd$exports(this.numericRefinements)) return this.numericRefinements;
            return {};
        } else if (typeof attribute === "string") return $f254195a30803f63$exports(this.numericRefinements, [
            attribute
        ]);
        else if (typeof attribute === "function") {
            var hasChanged = false;
            var numericRefinements = this.numericRefinements;
            var newNumericRefinements = Object.keys(numericRefinements).reduce(function(memo, key) {
                var operators = numericRefinements[key];
                var operatorList = {};
                operators = operators || {};
                Object.keys(operators).forEach(function(operator) {
                    var values = operators[operator] || [];
                    var outValues = [];
                    values.forEach(function(value) {
                        var predicateResult = attribute({
                            val: value,
                            op: operator
                        }, key, "numeric");
                        if (!predicateResult) outValues.push(value);
                    });
                    if (outValues.length !== values.length) hasChanged = true;
                    operatorList[operator] = outValues;
                });
                memo[key] = operatorList;
                return memo;
            }, {});
            if (hasChanged) return newNumericRefinements;
            return this.numericRefinements;
        }
        // We return nothing if the attribute is not undefined, a string or a function,
        // as it is not a valid value for a refinement
        return undefined;
    },
    /**
   * Add a facet to the facets attribute of the helper configuration, if it
   * isn't already present.
   * @method
   * @param {string} facet facet name to add
   * @return {SearchParameters} new instance
   */ addFacet: function addFacet(facet) {
        if (this.isConjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            facets: this.facets.concat([
                facet
            ])
        });
    },
    /**
   * Add a disjunctive facet to the disjunctiveFacets attribute of the helper
   * configuration, if it isn't already present.
   * @method
   * @param {string} facet disjunctive facet name to add
   * @return {SearchParameters} new instance
   */ addDisjunctiveFacet: function addDisjunctiveFacet(facet) {
        if (this.isDisjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.concat([
                facet
            ])
        });
    },
    /**
   * Add a hierarchical facet to the hierarchicalFacets attribute of the helper
   * configuration.
   * @method
   * @param {object} hierarchicalFacet hierarchical facet to add
   * @return {SearchParameters} new instance
   * @throws will throw an error if a hierarchical facet with the same name was already declared
   */ addHierarchicalFacet: function addHierarchicalFacet(hierarchicalFacet) {
        if (this.isHierarchicalFacet(hierarchicalFacet.name)) throw new Error("Cannot declare two hierarchical facets with the same name: `" + hierarchicalFacet.name + "`");
        return this.setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.concat([
                hierarchicalFacet
            ])
        });
    },
    /**
   * Add a refinement on a "normal" facet
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addFacetRefinement: function addFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if ($a04e05c4a0558547$exports.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $a04e05c4a0558547$exports.addRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Exclude a value from a "normal" facet
   * @method
   * @param {string} facet attribute to apply the exclusion on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addExcludeRefinement: function addExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if ($a04e05c4a0558547$exports.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $a04e05c4a0558547$exports.addRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Adds a refinement on a disjunctive facet.
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addDisjunctiveFacetRefinement: function addDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + " is not defined in the disjunctiveFacets attribute of the helper configuration");
        if ($a04e05c4a0558547$exports.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $a04e05c4a0558547$exports.addRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * addTagRefinement adds a tag to the list used to filter the results
   * @param {string} tag tag to be added
   * @return {SearchParameters} new instance
   */ addTagRefinement: function addTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.concat(tag)
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Remove a facet from the facets attribute of the helper configuration, if it
   * is present.
   * @method
   * @param {string} facet facet name to remove
   * @return {SearchParameters} new instance
   */ removeFacet: function removeFacet(facet) {
        if (!this.isConjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            facets: this.facets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a disjunctive facet from the disjunctiveFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet disjunctive facet name to remove
   * @return {SearchParameters} new instance
   */ removeDisjunctiveFacet: function removeDisjunctiveFacet(facet) {
        if (!this.isDisjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a hierarchical facet from the hierarchicalFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet hierarchical facet name to remove
   * @return {SearchParameters} new instance
   */ removeHierarchicalFacet: function removeHierarchicalFacet(facet) {
        if (!this.isHierarchicalFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.filter(function(f) {
                return f.name !== facet;
            })
        });
    },
    /**
   * Remove a refinement set on facet. If a value is provided, it will clear the
   * refinement for the given value, otherwise it will clear all the refinement
   * values for the faceted attribute.
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} [value] value used to filter
   * @return {SearchParameters} new instance
   */ removeFacetRefinement: function removeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if (!$a04e05c4a0558547$exports.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $a04e05c4a0558547$exports.removeRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Remove a negative refinement on a facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */ removeExcludeRefinement: function removeExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if (!$a04e05c4a0558547$exports.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $a04e05c4a0558547$exports.removeRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Remove a refinement on a disjunctive facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */ removeDisjunctiveFacetRefinement: function removeDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + " is not defined in the disjunctiveFacets attribute of the helper configuration");
        if (!$a04e05c4a0558547$exports.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $a04e05c4a0558547$exports.removeRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Remove a tag from the list of tag refinements
   * @method
   * @param {string} tag the tag to remove
   * @return {SearchParameters} new instance
   */ removeTagRefinement: function removeTagRefinement(tag) {
        if (!this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.filter(function(t) {
                return t !== tag;
            })
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   * @deprecated since version 2.19.0, see {@link SearchParameters#toggleFacetRefinement}
   */ toggleRefinement: function toggleRefinement(facet, value) {
        return this.toggleFacetRefinement(facet, value);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   */ toggleFacetRefinement: function toggleFacetRefinement(facet, value) {
        if (this.isHierarchicalFacet(facet)) return this.toggleHierarchicalFacetRefinement(facet, value);
        else if (this.isConjunctiveFacet(facet)) return this.toggleConjunctiveFacetRefinement(facet, value);
        else if (this.isDisjunctiveFacet(facet)) return this.toggleDisjunctiveFacetRefinement(facet, value);
        throw new Error("Cannot refine the undeclared facet " + facet + "; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets");
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleConjunctiveFacetRefinement: function toggleConjunctiveFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        return this.setQueryParameters({
            facetsRefinements: $a04e05c4a0558547$exports.toggleRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleExcludeFacetRefinement: function toggleExcludeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        return this.setQueryParameters({
            facetsExcludes: $a04e05c4a0558547$exports.toggleRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleDisjunctiveFacetRefinement: function toggleDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + " is not defined in the disjunctiveFacets attribute of the helper configuration");
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $a04e05c4a0558547$exports.toggleRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleHierarchicalFacetRefinement: function toggleHierarchicalFacetRefinement(facet, value) {
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + " is not defined in the hierarchicalFacets attribute of the helper configuration");
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facet));
        var mod = {};
        var upOneOrMultipleLevel = this.hierarchicalFacetsRefinements[facet] !== undefined && this.hierarchicalFacetsRefinements[facet].length > 0 && // remove current refinement:
        // refinement was 'beer > IPA', call is toggleRefine('beer > IPA'), refinement should be `beer`
        (this.hierarchicalFacetsRefinements[facet][0] === value || // remove a parent refinement of the current refinement:
        //  - refinement was 'beer > IPA > Flying dog'
        //  - call is toggleRefine('beer > IPA')
        //  - refinement should be `beer`
        this.hierarchicalFacetsRefinements[facet][0].indexOf(value + separator) === 0);
        if (upOneOrMultipleLevel) {
            if (value.indexOf(separator) === -1) // go back to root level
            mod[facet] = [];
            else mod[facet] = [
                value.slice(0, value.lastIndexOf(separator))
            ];
        } else mod[facet] = [
            value
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $e8574be1cb58b6cf$exports({}, mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Adds a refinement on a hierarchical facet.
   * @param {string} facet the facet name
   * @param {string} path the hierarchical facet path
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is refined
   */ addHierarchicalFacetRefinement: function addHierarchicalFacetRefinement(facet, path) {
        if (this.isHierarchicalFacetRefined(facet)) throw new Error(facet + " is already refined.");
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + " is not defined in the hierarchicalFacets attribute of the helper configuration.");
        var mod = {};
        mod[facet] = [
            path
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $e8574be1cb58b6cf$exports({}, mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Removes the refinement set on a hierarchical facet.
   * @param {string} facet the facet name
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is not refined
   */ removeHierarchicalFacetRefinement: function removeHierarchicalFacetRefinement(facet) {
        if (!this.isHierarchicalFacetRefined(facet)) return this;
        var mod = {};
        mod[facet] = [];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $e8574be1cb58b6cf$exports({}, mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Switch the tag refinement
   * @method
   * @param {string} tag the tag to remove or add
   * @return {SearchParameters} new instance
   */ toggleTagRefinement: function toggleTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this.removeTagRefinement(tag);
        return this.addTagRefinement(tag);
    },
    /**
   * Test if the facet name is from one of the disjunctive facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a disjunctive facet
   */ isDisjunctiveFacet: function isDisjunctiveFacet(facet) {
        return this.disjunctiveFacets.indexOf(facet) > -1;
    },
    /**
   * Test if the facet name is from one of the hierarchical facets
   * @method
   * @param {string} facetName facet name to test
   * @return {boolean} true if facetName is a hierarchical facet
   */ isHierarchicalFacet: function isHierarchicalFacet(facetName) {
        return this.getHierarchicalFacetByName(facetName) !== undefined;
    },
    /**
   * Test if the facet name is from one of the conjunctive/normal facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a conjunctive facet
   */ isConjunctiveFacet: function isConjunctiveFacet(facet) {
        return this.facets.indexOf(facet) > -1;
    },
    /**
   * Returns true if the facet is refined, either for a specific value or in
   * general.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value, optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isFacetRefined: function isFacetRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $a04e05c4a0558547$exports.isRefined(this.facetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains exclusions or if a specific value is
   * excluded.
   *
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} [value] optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isExcludeRefined: function isExcludeRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $a04e05c4a0558547$exports.isRefined(this.facetsExcludes, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */ isDisjunctiveFacetRefined: function isDisjunctiveFacetRefined(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) return false;
        return $a04e05c4a0558547$exports.isRefined(this.disjunctiveFacetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */ isHierarchicalFacetRefined: function isHierarchicalFacetRefined(facet, value) {
        if (!this.isHierarchicalFacet(facet)) return false;
        var refinements = this.getHierarchicalRefinement(facet);
        if (!value) return refinements.length > 0;
        return refinements.indexOf(value) !== -1;
    },
    /**
   * Test if the triple (attribute, operator, value) is already refined.
   * If only the attribute and the operator are provided, it tests if the
   * contains any refinement value.
   * @method
   * @param {string} attribute attribute for which the refinement is applied
   * @param {string} [operator] operator of the refinement
   * @param {string} [value] value of the refinement
   * @return {boolean} true if it is refined
   */ isNumericRefined: function isNumericRefined(attribute, operator, value) {
        if (value === undefined && operator === undefined) return Boolean(this.numericRefinements[attribute]);
        var isOperatorDefined = this.numericRefinements[attribute] && this.numericRefinements[attribute][operator] !== undefined;
        if (value === undefined || !isOperatorDefined) return isOperatorDefined;
        var parsedValue = $1c31000d5d7cb0d9$exports(value);
        var isAttributeValueDefined = $42c6a8b833b5bd3a$var$findArray(this.numericRefinements[attribute][operator], parsedValue) !== undefined;
        return isOperatorDefined && isAttributeValueDefined;
    },
    /**
   * Returns true if the tag refined, false otherwise
   * @method
   * @param {string} tag the tag to check
   * @return {boolean} true if tag is refined
   */ isTagRefined: function isTagRefined(tag) {
        return this.tagRefinements.indexOf(tag) !== -1;
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */ getRefinedDisjunctiveFacets: function getRefinedDisjunctiveFacets() {
        // eslint-disable-next-line consistent-this
        var self = this;
        // attributes used for numeric filter can also be disjunctive
        var disjunctiveNumericRefinedFacets = $1e2f65f1489ad0ab$exports(Object.keys(this.numericRefinements).filter(function(facet) {
            return Object.keys(self.numericRefinements[facet]).length > 0;
        }), this.disjunctiveFacets);
        return Object.keys(this.disjunctiveFacetsRefinements).filter(function(facet) {
            return self.disjunctiveFacetsRefinements[facet].length > 0;
        }).concat(disjunctiveNumericRefinedFacets).concat(this.getRefinedHierarchicalFacets()).sort();
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */ getRefinedHierarchicalFacets: function getRefinedHierarchicalFacets() {
        // eslint-disable-next-line consistent-this
        var self = this;
        return $1e2f65f1489ad0ab$exports(// enforce the order between the two arrays,
        // so that refinement name index === hierarchical facet index
        this.hierarchicalFacets.map(function(facet) {
            return facet.name;
        }), Object.keys(this.hierarchicalFacetsRefinements).filter(function(facet) {
            return self.hierarchicalFacetsRefinements[facet].length > 0;
        })).sort();
    },
    /**
   * Returned the list of all disjunctive facets not refined
   * @method
   * @return {string[]} returns the list of facets that are not refined
   */ getUnrefinedDisjunctiveFacets: function getUnrefinedDisjunctiveFacets() {
        var refinedFacets = this.getRefinedDisjunctiveFacets();
        return this.disjunctiveFacets.filter(function(f) {
            return refinedFacets.indexOf(f) === -1;
        });
    },
    managedParameters: [
        "index",
        "facets",
        "disjunctiveFacets",
        "facetsRefinements",
        "hierarchicalFacets",
        "facetsExcludes",
        "disjunctiveFacetsRefinements",
        "numericRefinements",
        "tagRefinements",
        "hierarchicalFacetsRefinements"
    ],
    getQueryParams: function getQueryParams() {
        var managedParameters = this.managedParameters;
        var queryParams = {};
        // eslint-disable-next-line consistent-this
        var self = this;
        Object.keys(this).forEach(function(paramName) {
            var paramValue = self[paramName];
            if (managedParameters.indexOf(paramName) === -1 && paramValue !== undefined) queryParams[paramName] = paramValue;
        });
        return queryParams;
    },
    /**
   * Let the user set a specific value for a given parameter. Will return the
   * same instance if the parameter is invalid or if the value is the same as the
   * previous one.
   * @method
   * @param {string} parameter the parameter name
   * @param {any} value the value to be set, must be compliant with the definition
   * of the attribute on the object
   * @return {SearchParameters} the updated state
   */ setQueryParameter: function setParameter(parameter, value) {
        if (this[parameter] === value) return this;
        var modification = {};
        modification[parameter] = value;
        return this.setQueryParameters(modification);
    },
    /**
   * Let the user set any of the parameters with a plain object.
   * @method
   * @param {object} params all the keys and the values to be updated
   * @return {SearchParameters} a new updated instance
   */ setQueryParameters: function setQueryParameters(params) {
        if (!params) return this;
        var error = $42c6a8b833b5bd3a$var$SearchParameters.validate(this, params);
        if (error) throw error;
        // eslint-disable-next-line consistent-this
        var self = this;
        var nextWithNumbers = $42c6a8b833b5bd3a$var$SearchParameters._parseNumbers(params);
        var previousPlainObject = Object.keys(this).reduce(function(acc, key) {
            acc[key] = self[key];
            return acc;
        }, {});
        var nextPlainObject = Object.keys(nextWithNumbers).reduce(function(previous, key) {
            var isPreviousValueDefined = previous[key] !== undefined;
            var isNextValueDefined = nextWithNumbers[key] !== undefined;
            if (isPreviousValueDefined && !isNextValueDefined) return $f254195a30803f63$exports(previous, [
                key
            ]);
            if (isNextValueDefined) previous[key] = nextWithNumbers[key];
            return previous;
        }, previousPlainObject);
        return new this.constructor(nextPlainObject);
    },
    /**
   * Returns a new instance with the page reset. Two scenarios possible:
   * the page is omitted -> return the given instance
   * the page is set -> return a new instance with a page of 0
   * @return {SearchParameters} a new updated instance
   */ resetPage: function resetPage() {
        if (this.page === undefined) return this;
        return this.setPage(0);
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSortBy: function _getHierarchicalFacetSortBy(hierarchicalFacet) {
        return hierarchicalFacet.sortBy || [
            "isRefined:desc",
            "name:asc"
        ];
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSeparator: function _getHierarchicalFacetSeparator(hierarchicalFacet) {
        return hierarchicalFacet.separator || " > ";
    },
    /**
   * Helper function to get the hierarchicalFacet prefix path or null
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.rootPath or null as default
   */ _getHierarchicalRootPath: function _getHierarchicalRootPath(hierarchicalFacet) {
        return hierarchicalFacet.rootPath || null;
    },
    /**
   * Helper function to check if we show the parent level of the hierarchicalFacet
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.showParentLevel or true as default
   */ _getHierarchicalShowParentLevel: function _getHierarchicalShowParentLevel(hierarchicalFacet) {
        if (typeof hierarchicalFacet.showParentLevel === "boolean") return hierarchicalFacet.showParentLevel;
        return true;
    },
    /**
   * Helper function to get the hierarchicalFacet by it's name
   * @param  {string} hierarchicalFacetName the hierarchicalFacet name
   * @return {object} a hierarchicalFacet
   */ getHierarchicalFacetByName: function getHierarchicalFacetByName(hierarchicalFacetName) {
        return $d02ab4ee8a5630b4$exports(this.hierarchicalFacets, function(f) {
            return f.name === hierarchicalFacetName;
        });
    },
    /**
   * Get the current breadcrumb for a hierarchical facet, as an array
   * @param  {string} facetName Hierarchical facet name
   * @return {array.<string>} the path as an array of string
   */ getHierarchicalFacetBreadcrumb: function getHierarchicalFacetBreadcrumb(facetName) {
        if (!this.isHierarchicalFacet(facetName)) return [];
        var refinement = this.getHierarchicalRefinement(facetName)[0];
        if (!refinement) return [];
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facetName));
        var path = refinement.split(separator);
        return path.map(function(part) {
            return part.trim();
        });
    },
    toString: function toString() {
        return JSON.stringify(this, null, 2);
    }
};
/**
 * Callback used for clearRefinement method
 * @callback SearchParameters.clearCallback
 * @param {OperatorList|FacetList} value the value of the filter
 * @param {string} key the current attribute name
 * @param {string} type `numeric`, `disjunctiveFacet`, `conjunctiveFacet`, `hierarchicalFacet` or `exclude`
 * depending on the type of facet
 * @return {boolean} `true` if the element should be removed. `false` otherwise.
 */ $42c6a8b833b5bd3a$exports = $42c6a8b833b5bd3a$var$SearchParameters;


var $a9bed3272ad72cb7$exports = {};
"use strict";
var $d9dbf84c6b6a8a2d$exports = {};
"use strict";
$d9dbf84c6b6a8a2d$exports = function compact(array) {
    if (!Array.isArray(array)) return [];
    return array.filter(Boolean);
};





var $c4374e140840a233$exports = {};
"use strict";
// @MAJOR can be replaced by native Array#findIndex when we change support
$c4374e140840a233$exports = function find(array, comparator) {
    if (!Array.isArray(array)) return -1;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return i;
    }
    return -1;
};


var $0027bf120927ecb5$exports = {};
"use strict";

/**
 * Transform sort format from user friendly notation to lodash format
 * @param {string[]} sortBy array of predicate of the form "attribute:order"
 * @param {string[]} [defaults] array of predicate of the form "attribute:order"
 * @return {array.<string[]>} array containing 2 elements : attributes, orders
 */ $0027bf120927ecb5$exports = function formatSort(sortBy, defaults) {
    var defaultInstructions = (defaults || []).map(function(sort) {
        return sort.split(":");
    });
    return sortBy.reduce(function preparePredicate(out, sort) {
        var sortInstruction = sort.split(":");
        var matchingDefault = $d02ab4ee8a5630b4$exports(defaultInstructions, function(defaultInstruction) {
            return defaultInstruction[0] === sortInstruction[0];
        });
        if (sortInstruction.length > 1 || !matchingDefault) {
            out[0].push(sortInstruction[0]);
            out[1].push(sortInstruction[1]);
            return out;
        }
        out[0].push(matchingDefault[0]);
        out[1].push(matchingDefault[1]);
        return out;
    }, [
        [],
        []
    ]);
};



var $743fa82a11922a42$exports = {};
"use strict";
function $743fa82a11922a42$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined;
        var valIsNull = value === null;
        var othIsDefined = other !== undefined;
        var othIsNull = other === null;
        if (!othIsNull && value > other || valIsNull && othIsDefined || !valIsDefined) return 1;
        if (!valIsNull && value < other || othIsNull && valIsDefined || !othIsDefined) return -1;
    }
    return 0;
}
/**
 * @param {Array<object>} collection object with keys in attributes
 * @param {Array<string>} iteratees attributes
 * @param {Array<string>} orders asc | desc
 * @return {Array<object>} sorted collection
 */ function $743fa82a11922a42$var$orderBy(collection, iteratees, orders) {
    if (!Array.isArray(collection)) return [];
    if (!Array.isArray(orders)) orders = [];
    var result = collection.map(function(value, index) {
        return {
            criteria: iteratees.map(function(iteratee) {
                return value[iteratee];
            }),
            index: index,
            value: value
        };
    });
    result.sort(function comparer(object, other) {
        var index = -1;
        while(++index < object.criteria.length){
            var res = $743fa82a11922a42$var$compareAscending(object.criteria[index], other.criteria[index]);
            if (res) {
                if (index >= orders.length) return res;
                if (orders[index] === "desc") return -res;
                return res;
            }
        }
        // This ensures a stable sort in V8 and other engines.
        // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
        return object.index - other.index;
    });
    return result.map(function(res) {
        return res.value;
    });
}
$743fa82a11922a42$exports = $743fa82a11922a42$var$orderBy;


var $a9bed3272ad72cb7$var$escapeFacetValue = $49f03fd1dace76b5$exports.escapeFacetValue;
var $a9bed3272ad72cb7$var$unescapeFacetValue = $49f03fd1dace76b5$exports.unescapeFacetValue;
var $4c3c4e9ce2e2e204$exports = {};
"use strict";
$4c3c4e9ce2e2e204$exports = $4c3c4e9ce2e2e204$var$generateTrees;




var $4c3c4e9ce2e2e204$var$escapeFacetValue = $49f03fd1dace76b5$exports.escapeFacetValue;
var $4c3c4e9ce2e2e204$var$unescapeFacetValue = $49f03fd1dace76b5$exports.unescapeFacetValue;
function $4c3c4e9ce2e2e204$var$generateTrees(state) {
    return function generate(hierarchicalFacetResult, hierarchicalFacetIndex) {
        var hierarchicalFacet = state.hierarchicalFacets[hierarchicalFacetIndex];
        var hierarchicalFacetRefinement = state.hierarchicalFacetsRefinements[hierarchicalFacet.name] && state.hierarchicalFacetsRefinements[hierarchicalFacet.name][0] || "";
        var hierarchicalSeparator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var hierarchicalRootPath = state._getHierarchicalRootPath(hierarchicalFacet);
        var hierarchicalShowParentLevel = state._getHierarchicalShowParentLevel(hierarchicalFacet);
        var sortBy = $0027bf120927ecb5$exports(state._getHierarchicalFacetSortBy(hierarchicalFacet));
        var rootExhaustive = hierarchicalFacetResult.every(function(facetResult) {
            return facetResult.exhaustive;
        });
        var generateTreeFn = $4c3c4e9ce2e2e204$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, hierarchicalFacetRefinement);
        var results = hierarchicalFacetResult;
        if (hierarchicalRootPath) results = hierarchicalFacetResult.slice(hierarchicalRootPath.split(hierarchicalSeparator).length);
        return results.reduce(generateTreeFn, {
            name: state.hierarchicalFacets[hierarchicalFacetIndex].name,
            count: null,
            // root level, no count
            isRefined: true,
            // root level, always refined
            path: null,
            // root level, no path
            escapedValue: null,
            exhaustive: rootExhaustive,
            data: null
        });
    };
}
function $4c3c4e9ce2e2e204$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, currentRefinement) {
    return function generateTree(hierarchicalTree, hierarchicalFacetResult, currentHierarchicalLevel) {
        var parent = hierarchicalTree;
        if (currentHierarchicalLevel > 0) {
            var level = 0;
            parent = hierarchicalTree;
            while(level < currentHierarchicalLevel){
                /**
         * @type {object[]]} hierarchical data
         */ var data = parent && Array.isArray(parent.data) ? parent.data : [];
                parent = $d02ab4ee8a5630b4$exports(data, function(subtree) {
                    return subtree.isRefined;
                });
                level++;
            }
        }
        // we found a refined parent, let's add current level data under it
        if (parent) {
            // filter values in case an object has multiple categories:
            //   {
            //     categories: {
            //       level0: ['beers', 'bières'],
            //       level1: ['beers > IPA', 'bières > Belges']
            //     }
            //   }
            //
            // If parent refinement is `beers`, then we do not want to have `bières > Belges`
            // showing up
            var picked = Object.keys(hierarchicalFacetResult.data).map(function(facetValue) {
                return [
                    facetValue,
                    hierarchicalFacetResult.data[facetValue]
                ];
            }).filter(function(tuple) {
                var facetValue = tuple[0];
                return $4c3c4e9ce2e2e204$var$onlyMatchingTree(facetValue, parent.path || hierarchicalRootPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel);
            });
            parent.data = $743fa82a11922a42$exports(picked.map(function(tuple) {
                var facetValue = tuple[0];
                var facetCount = tuple[1];
                return $4c3c4e9ce2e2e204$var$format(facetCount, facetValue, hierarchicalSeparator, $4c3c4e9ce2e2e204$var$unescapeFacetValue(currentRefinement), hierarchicalFacetResult.exhaustive);
            }), sortBy[0], sortBy[1]);
        }
        return hierarchicalTree;
    };
}
// eslint-disable-next-line max-params
function $4c3c4e9ce2e2e204$var$onlyMatchingTree(facetValue, parentPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel) {
    // we want the facetValue is a child of hierarchicalRootPath
    if (hierarchicalRootPath && (facetValue.indexOf(hierarchicalRootPath) !== 0 || hierarchicalRootPath === facetValue)) return false;
    // we always want root levels (only when there is no prefix path)
    return !hierarchicalRootPath && facetValue.indexOf(hierarchicalSeparator) === -1 || // if there is a rootPath, being root level mean 1 level under rootPath
    hierarchicalRootPath && facetValue.split(hierarchicalSeparator).length - hierarchicalRootPath.split(hierarchicalSeparator).length === 1 || // if current refinement is a root level and current facetValue is a root level,
    // keep the facetValue
    facetValue.indexOf(hierarchicalSeparator) === -1 && currentRefinement.indexOf(hierarchicalSeparator) === -1 || // currentRefinement is a child of the facet value
    currentRefinement.indexOf(facetValue) === 0 || // facetValue is a child of the current parent, add it
    facetValue.indexOf(parentPath + hierarchicalSeparator) === 0 && (hierarchicalShowParentLevel || facetValue.indexOf(currentRefinement) === 0);
}
function $4c3c4e9ce2e2e204$var$format(facetCount, facetValue, hierarchicalSeparator, currentRefinement, exhaustive) {
    var parts = facetValue.split(hierarchicalSeparator);
    return {
        name: parts[parts.length - 1].trim(),
        path: facetValue,
        escapedValue: $4c3c4e9ce2e2e204$var$escapeFacetValue(facetValue),
        count: facetCount,
        isRefined: currentRefinement === facetValue || currentRefinement.indexOf(facetValue + hierarchicalSeparator) === 0,
        exhaustive: exhaustive,
        data: null
    };
}


/**
 * @typedef SearchResults.Facet
 * @type {object}
 * @property {string} name name of the attribute in the record
 * @property {object} data the faceting data: value, number of entries
 * @property {object} stats undefined unless facet_stats is retrieved from algolia
 */ /**
 * @typedef SearchResults.HierarchicalFacet
 * @type {object}
 * @property {string} name name of the current value given the hierarchical level, trimmed.
 * If root node, you get the facet name
 * @property {number} count number of objects matching this hierarchical value
 * @property {string} path the current hierarchical value full path
 * @property {boolean} isRefined `true` if the current value was refined, `false` otherwise
 * @property {HierarchicalFacet[]} data sub values for the current level
 */ /**
 * @typedef SearchResults.FacetValue
 * @type {object}
 * @property {string} name the facet value itself
 * @property {number} count times this facet appears in the results
 * @property {boolean} isRefined is the facet currently selected
 * @property {boolean} isExcluded is the facet currently excluded (only for conjunctive facets)
 */ /**
 * @typedef Refinement
 * @type {object}
 * @property {string} type the type of filter used:
 * `numeric`, `facet`, `exclude`, `disjunctive`, `hierarchical`
 * @property {string} attributeName name of the attribute used for filtering
 * @property {string} name the value of the filter
 * @property {number} numericValue the value as a number. Only for numeric filters.
 * @property {string} operator the operator used. Only for numeric filters.
 * @property {number} count the number of computed hits for this filter. Only on facets.
 * @property {boolean} exhaustive if the count is exhaustive
 */ /**
 * Turn an array of attributes in an object of attributes with their position in the array as value
 * @param {string[]} attributes the list of attributes in the record
 * @return {object} the list of attributes indexed by attribute name
 */ function $a9bed3272ad72cb7$var$getIndices(attributes) {
    var indices = {};
    attributes.forEach(function(val, idx) {
        indices[val] = idx;
    });
    return indices;
}
function $a9bed3272ad72cb7$var$assignFacetStats(dest, facetStats, key) {
    if (facetStats && facetStats[key]) dest.stats = facetStats[key];
}
/**
 * @typedef {Object} HierarchicalFacet
 * @property {string} name
 * @property {string[]} attributes
 */ /**
 * @param {HierarchicalFacet[]} hierarchicalFacets All hierarchical facets
 * @param {string} hierarchicalAttributeName The name of the hierarchical attribute
 * @return {HierarchicalFacet} The hierarchical facet matching the attribute name
 */ function $a9bed3272ad72cb7$var$findMatchingHierarchicalFacetFromAttributeName(hierarchicalFacets, hierarchicalAttributeName) {
    return $d02ab4ee8a5630b4$exports(hierarchicalFacets, function facetKeyMatchesAttribute(hierarchicalFacet) {
        var facetNames = hierarchicalFacet.attributes || [];
        return facetNames.indexOf(hierarchicalAttributeName) > -1;
    });
}
/**
 * Constructor for SearchResults
 * @class
 * @classdesc SearchResults contains the results of a query to Algolia using the
 * {@link AlgoliaSearchHelper}.
 * @param {SearchParameters} state state that led to the response
 * @param {array.<object>} results the results from algolia client
 * @param {object} options options to control results content
 * @example <caption>SearchResults of the first query in
 * <a href="http://demos.algolia.com/instant-search-demo">the instant search demo</a></caption>
{
   "hitsPerPage": 10,
   "processingTimeMS": 2,
   "facets": [
      {
         "name": "type",
         "data": {
            "HardGood": 6627,
            "BlackTie": 550,
            "Music": 665,
            "Software": 131,
            "Game": 456,
            "Movie": 1571
         },
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "Free shipping": 5507
         },
         "name": "shipping"
      }
  ],
   "hits": [
      {
         "thumbnailImage": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_54x108_s.gif",
         "_highlightResult": {
            "shortDescription": {
               "matchLevel": "none",
               "value": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
               "matchedWords": []
            },
            "category": {
               "matchLevel": "none",
               "value": "Computer Security Software",
               "matchedWords": []
            },
            "manufacturer": {
               "matchedWords": [],
               "value": "Webroot",
               "matchLevel": "none"
            },
            "name": {
               "value": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
               "matchedWords": [],
               "matchLevel": "none"
            }
         },
         "image": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_105x210_sc.jpg",
         "shipping": "Free shipping",
         "bestSellingRank": 4,
         "shortDescription": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
         "url": "http://www.bestbuy.com/site/webroot-secureanywhere-internet-security-3-devi…d=1219060687969&skuId=1688832&cmp=RMX&ky=2d3GfEmNIzjA0vkzveHdZEBgpPCyMnLTJ",
         "name": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
         "category": "Computer Security Software",
         "salePrice_range": "1 - 50",
         "objectID": "1688832",
         "type": "Software",
         "customerReviewCount": 5980,
         "salePrice": 49.99,
         "manufacturer": "Webroot"
      },
      ....
  ],
   "nbHits": 10000,
   "disjunctiveFacets": [
      {
         "exhaustive": false,
         "data": {
            "5": 183,
            "12": 112,
            "7": 149,
            ...
         },
         "name": "customerReviewCount",
         "stats": {
            "max": 7461,
            "avg": 157.939,
            "min": 1
         }
      },
      {
         "data": {
            "Printer Ink": 142,
            "Wireless Speakers": 60,
            "Point & Shoot Cameras": 48,
            ...
         },
         "name": "category",
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "> 5000": 2,
            "1 - 50": 6524,
            "501 - 2000": 566,
            "201 - 500": 1501,
            "101 - 200": 1360,
            "2001 - 5000": 47
         },
         "name": "salePrice_range"
      },
      {
         "data": {
            "Dynex™": 202,
            "Insignia™": 230,
            "PNY": 72,
            ...
         },
         "name": "manufacturer",
         "exhaustive": false
      }
  ],
   "query": "",
   "nbPages": 100,
   "page": 0,
   "index": "bestbuy"
}
 **/ function $a9bed3272ad72cb7$var$SearchResults(state, results, options) {
    var mainSubResponse = results[0];
    this._rawResults = results;
    // eslint-disable-next-line consistent-this
    var self = this;
    // https://www.algolia.com/doc/api-reference/api-methods/search/#response
    Object.keys(mainSubResponse).forEach(function(key) {
        self[key] = mainSubResponse[key];
    });
    // Make every key of the result options reachable from the instance
    var opts = $35783371e549f033$exports({
        persistHierarchicalRootCount: false
    }, options);
    Object.keys(opts).forEach(function(key) {
        self[key] = opts[key];
    });
    /**
   * query used to generate the results
   * @name query
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * The query as parsed by the engine given all the rules.
   * @name parsedQuery
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * all the records that match the search parameters. Each record is
   * augmented with a new attribute `_highlightResult`
   * which is an object keyed by attribute and with the following properties:
   * - `value` : the value of the facet highlighted (html)
   * - `matchLevel`: `full`, `partial` or `none`, depending on how the query terms match
   * @name hits
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * index where the results come from
   * @name index
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * number of hits per page requested
   * @name hitsPerPage
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of hits of this query on the index
   * @name nbHits
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of pages with respect to the number of hits per page and the total number of hits
   * @name nbPages
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * current page
   * @name page
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * The position if the position was guessed by IP.
   * @name aroundLatLng
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "48.8637,2.3615",
   */ /**
   * The radius computed by Algolia.
   * @name automaticRadius
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "126792922",
   */ /**
   * String identifying the server used to serve this request.
   *
   * getRankingInfo needs to be set to `true` for this to be returned
   *
   * @name serverUsed
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "c7-use-2.algolia.net",
   */ /**
   * Boolean that indicates if the computation of the counts did time out.
   * @deprecated
   * @name timeoutCounts
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Boolean that indicates if the computation of the hits did time out.
   * @deprecated
   * @name timeoutHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the counts of the facets is exhaustive
   * @name exhaustiveFacetsCount
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the number of hits is exhaustive
   * @name exhaustiveNbHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Contains the userData if they are set by a [query rule](https://www.algolia.com/doc/guides/query-rules/query-rules-overview/).
   * @name userData
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * queryID is the unique identifier of the query used to generate the current search results.
   * This value is only available if the `clickAnalytics` search parameter is set to `true`.
   * @name queryID
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * sum of the processing time of all the queries
   * @name processingTimeMS
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ this.processingTimeMS = results.reduce(function(sum, result) {
        return result.processingTimeMS === undefined ? sum : sum + result.processingTimeMS;
    }, 0);
    /**
   * disjunctive facets results
   * @member {SearchResults.Facet[]}
   */ this.disjunctiveFacets = [];
    /**
   * disjunctive facets results
   * @member {SearchResults.HierarchicalFacet[]}
   */ this.hierarchicalFacets = state.hierarchicalFacets.map(function initFutureTree() {
        return [];
    });
    /**
   * other facets results
   * @member {SearchResults.Facet[]}
   */ this.facets = [];
    var disjunctiveFacets = state.getRefinedDisjunctiveFacets();
    var facetsIndices = $a9bed3272ad72cb7$var$getIndices(state.facets);
    var disjunctiveFacetsIndices = $a9bed3272ad72cb7$var$getIndices(state.disjunctiveFacets);
    var nextDisjunctiveResult = 1;
    // Since we send request only for disjunctive facets that have been refined,
    // we get the facets information from the first, general, response.
    var mainFacets = mainSubResponse.facets || {};
    Object.keys(mainFacets).forEach(function(facetKey) {
        var facetValueObject = mainFacets[facetKey];
        var hierarchicalFacet = $a9bed3272ad72cb7$var$findMatchingHierarchicalFacetFromAttributeName(state.hierarchicalFacets, facetKey);
        if (hierarchicalFacet) {
            // Place the hierarchicalFacet data at the correct index depending on
            // the attributes order that was defined at the helper initialization
            var facetIndex = hierarchicalFacet.attributes.indexOf(facetKey);
            var idxAttributeName = $c4374e140840a233$exports(state.hierarchicalFacets, function(f) {
                return f.name === hierarchicalFacet.name;
            });
            self.hierarchicalFacets[idxAttributeName][facetIndex] = {
                attribute: facetKey,
                data: facetValueObject,
                exhaustive: mainSubResponse.exhaustiveFacetsCount
            };
        } else {
            var isFacetDisjunctive = state.disjunctiveFacets.indexOf(facetKey) !== -1;
            var isFacetConjunctive = state.facets.indexOf(facetKey) !== -1;
            var position;
            if (isFacetDisjunctive) {
                position = disjunctiveFacetsIndices[facetKey];
                self.disjunctiveFacets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $a9bed3272ad72cb7$var$assignFacetStats(self.disjunctiveFacets[position], mainSubResponse.facets_stats, facetKey);
            }
            if (isFacetConjunctive) {
                position = facetsIndices[facetKey];
                self.facets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $a9bed3272ad72cb7$var$assignFacetStats(self.facets[position], mainSubResponse.facets_stats, facetKey);
            }
        }
    });
    // Make sure we do not keep holes within the hierarchical facets
    this.hierarchicalFacets = $d9dbf84c6b6a8a2d$exports(this.hierarchicalFacets);
    // aggregate the refined disjunctive facets
    disjunctiveFacets.forEach(function(disjunctiveFacet) {
        var result = results[nextDisjunctiveResult];
        var facets = result && result.facets ? result.facets : {};
        var hierarchicalFacet = state.getHierarchicalFacetByName(disjunctiveFacet);
        // There should be only item in facets.
        Object.keys(facets).forEach(function(dfacet) {
            var facetResults = facets[dfacet];
            var position;
            if (hierarchicalFacet) {
                position = $c4374e140840a233$exports(state.hierarchicalFacets, function(f) {
                    return f.name === hierarchicalFacet.name;
                });
                var attributeIndex = $c4374e140840a233$exports(self.hierarchicalFacets[position], function(f) {
                    return f.attribute === dfacet;
                });
                // previous refinements and no results so not able to find it
                if (attributeIndex === -1) return;
                self.hierarchicalFacets[position][attributeIndex].data = $35783371e549f033$exports({}, self.hierarchicalFacets[position][attributeIndex].data, facetResults);
            } else {
                position = disjunctiveFacetsIndices[dfacet];
                var dataFromMainRequest = mainSubResponse.facets && mainSubResponse.facets[dfacet] || {};
                self.disjunctiveFacets[position] = {
                    name: dfacet,
                    data: $e8574be1cb58b6cf$exports({}, facetResults, dataFromMainRequest),
                    exhaustive: result.exhaustiveFacetsCount
                };
                $a9bed3272ad72cb7$var$assignFacetStats(self.disjunctiveFacets[position], result.facets_stats, dfacet);
                if (state.disjunctiveFacetsRefinements[dfacet]) state.disjunctiveFacetsRefinements[dfacet].forEach(function(refinementValue) {
                    // add the disjunctive refinements if it is no more retrieved
                    if (!self.disjunctiveFacets[position].data[refinementValue] && state.disjunctiveFacetsRefinements[dfacet].indexOf($a9bed3272ad72cb7$var$unescapeFacetValue(refinementValue)) > -1) self.disjunctiveFacets[position].data[refinementValue] = 0;
                });
            }
        });
        nextDisjunctiveResult++;
    });
    // if we have some parent level values for hierarchical facets, merge them
    state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
        var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
        // if we are already at a root refinement (or no refinement at all), there is no
        // root level values request
        if (currentRefinement.length === 0 || currentRefinement[0].split(separator).length < 2) return;
        results.slice(nextDisjunctiveResult).forEach(function(result) {
            var facets = result && result.facets ? result.facets : {};
            Object.keys(facets).forEach(function(dfacet) {
                var facetResults = facets[dfacet];
                var position = $c4374e140840a233$exports(state.hierarchicalFacets, function(f) {
                    return f.name === hierarchicalFacet.name;
                });
                var attributeIndex = $c4374e140840a233$exports(self.hierarchicalFacets[position], function(f) {
                    return f.attribute === dfacet;
                });
                // previous refinements and no results so not able to find it
                if (attributeIndex === -1) return;
                // when we always get root levels, if the hits refinement is `beers > IPA` (count: 5),
                // then the disjunctive values will be `beers` (count: 100),
                // but we do not want to display
                //   | beers (100)
                //     > IPA (5)
                // We want
                //   | beers (5)
                //     > IPA (5)
                // @MAJOR: remove this legacy behaviour in next major version
                var defaultData = {};
                if (currentRefinement.length > 0 && !self.persistHierarchicalRootCount) {
                    var root = currentRefinement[0].split(separator)[0];
                    defaultData[root] = self.hierarchicalFacets[position][attributeIndex].data[root];
                }
                self.hierarchicalFacets[position][attributeIndex].data = $e8574be1cb58b6cf$exports(defaultData, facetResults, self.hierarchicalFacets[position][attributeIndex].data);
            });
            nextDisjunctiveResult++;
        });
    });
    // add the excludes
    Object.keys(state.facetsExcludes).forEach(function(facetName) {
        var excludes = state.facetsExcludes[facetName];
        var position = facetsIndices[facetName];
        self.facets[position] = {
            name: facetName,
            data: mainFacets[facetName],
            exhaustive: mainSubResponse.exhaustiveFacetsCount
        };
        excludes.forEach(function(facetValue) {
            self.facets[position] = self.facets[position] || {
                name: facetName
            };
            self.facets[position].data = self.facets[position].data || {};
            self.facets[position].data[facetValue] = 0;
        });
    });
    /**
   * @type {Array}
   */ this.hierarchicalFacets = this.hierarchicalFacets.map($4c3c4e9ce2e2e204$exports(state));
    /**
   * @type {Array}
   */ this.facets = $d9dbf84c6b6a8a2d$exports(this.facets);
    /**
   * @type {Array}
   */ this.disjunctiveFacets = $d9dbf84c6b6a8a2d$exports(this.disjunctiveFacets);
    this._state = state;
}
/**
 * Get a facet object with its name
 * @deprecated
 * @param {string} name name of the faceted attribute
 * @return {SearchResults.Facet} the facet object
 */ $a9bed3272ad72cb7$var$SearchResults.prototype.getFacetByName = function(name) {
    function predicate(facet) {
        return facet.name === name;
    }
    return $d02ab4ee8a5630b4$exports(this.facets, predicate) || $d02ab4ee8a5630b4$exports(this.disjunctiveFacets, predicate) || $d02ab4ee8a5630b4$exports(this.hierarchicalFacets, predicate);
};
/**
 * Get the facet values of a specified attribute from a SearchResults object.
 * @private
 * @param {SearchResults} results the search results to search in
 * @param {string} attribute name of the faceted attribute to search for
 * @return {array|object} facet values. For the hierarchical facets it is an object.
 */ function $a9bed3272ad72cb7$var$extractNormalizedFacetValues(results, attribute) {
    function predicate(facet) {
        return facet.name === attribute;
    }
    if (results._state.isConjunctiveFacet(attribute)) {
        var facet = $d02ab4ee8a5630b4$exports(results.facets, predicate);
        if (!facet) return [];
        return Object.keys(facet.data).map(function(name) {
            var value = $a9bed3272ad72cb7$var$escapeFacetValue(name);
            return {
                name: name,
                escapedValue: value,
                count: facet.data[name],
                isRefined: results._state.isFacetRefined(attribute, value),
                isExcluded: results._state.isExcludeRefined(attribute, name)
            };
        });
    } else if (results._state.isDisjunctiveFacet(attribute)) {
        var disjunctiveFacet = $d02ab4ee8a5630b4$exports(results.disjunctiveFacets, predicate);
        if (!disjunctiveFacet) return [];
        return Object.keys(disjunctiveFacet.data).map(function(name) {
            var value = $a9bed3272ad72cb7$var$escapeFacetValue(name);
            return {
                name: name,
                escapedValue: value,
                count: disjunctiveFacet.data[name],
                isRefined: results._state.isDisjunctiveFacetRefined(attribute, value)
            };
        });
    } else if (results._state.isHierarchicalFacet(attribute)) {
        var hierarchicalFacetValues = $d02ab4ee8a5630b4$exports(results.hierarchicalFacets, predicate);
        if (!hierarchicalFacetValues) return hierarchicalFacetValues;
        var hierarchicalFacet = results._state.getHierarchicalFacetByName(attribute);
        var separator = results._state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var currentRefinement = $a9bed3272ad72cb7$var$unescapeFacetValue(results._state.getHierarchicalRefinement(attribute)[0] || "");
        if (currentRefinement.indexOf(hierarchicalFacet.rootPath) === 0) currentRefinement = currentRefinement.replace(hierarchicalFacet.rootPath + separator, "");
        var currentRefinementSplit = currentRefinement.split(separator);
        currentRefinementSplit.unshift(attribute);
        $a9bed3272ad72cb7$var$setIsRefined(hierarchicalFacetValues, currentRefinementSplit, 0);
        return hierarchicalFacetValues;
    }
    return undefined;
}
/**
 * Set the isRefined of a hierarchical facet result based on the current state.
 * @param {SearchResults.HierarchicalFacet} item Hierarchical facet to fix
 * @param {string[]} currentRefinement array of parts of the current hierarchical refinement
 * @param {number} depth recursion depth in the currentRefinement
 * @return {undefined} function mutates the item
 */ function $a9bed3272ad72cb7$var$setIsRefined(item, currentRefinement, depth) {
    item.isRefined = item.name === (currentRefinement[depth] && currentRefinement[depth].trim());
    if (item.data) item.data.forEach(function(child) {
        $a9bed3272ad72cb7$var$setIsRefined(child, currentRefinement, depth + 1);
    });
}
/**
 * Sort nodes of a hierarchical or disjunctive facet results
 * @private
 * @param {function} sortFn sort function to apply
 * @param {HierarchicalFacet|Array} node node upon which we want to apply the sort
 * @param {string[]} names attribute names
 * @param {number} [level=0] current index in the names array
 * @return {HierarchicalFacet|Array} sorted node
 */ function $a9bed3272ad72cb7$var$recSort(sortFn, node, names, level) {
    level = level || 0;
    if (Array.isArray(node)) return sortFn(node, names[level]);
    if (!node.data || node.data.length === 0) return node;
    var children = node.data.map(function(childNode) {
        return $a9bed3272ad72cb7$var$recSort(sortFn, childNode, names, level + 1);
    });
    var sortedChildren = sortFn(children, names[level]);
    var newNode = $e8574be1cb58b6cf$exports({
        data: sortedChildren
    }, node);
    return newNode;
}
$a9bed3272ad72cb7$var$SearchResults.DEFAULT_SORT = [
    "isRefined:desc",
    "count:desc",
    "name:asc"
];
function $a9bed3272ad72cb7$var$vanillaSortFn(order, data) {
    return data.sort(order);
}
/**
 * @typedef FacetOrdering
 * @type {Object}
 * @property {string[]} [order]
 * @property {'count' | 'alpha' | 'hidden'} [sortRemainingBy]
 */ /**
 * Sorts facet arrays via their facet ordering
 * @param {Array} facetValues the values
 * @param {FacetOrdering} facetOrdering the ordering
 * @returns {Array} the sorted facet values
 */ function $a9bed3272ad72cb7$var$sortViaFacetOrdering(facetValues, facetOrdering) {
    var orderedFacets = [];
    var remainingFacets = [];
    var order = facetOrdering.order || [];
    /**
   * an object with the keys being the values in order, the values their index:
   * ['one', 'two'] -> { one: 0, two: 1 }
   */ var reverseOrder = order.reduce(function(acc, name, i) {
        acc[name] = i;
        return acc;
    }, {});
    facetValues.forEach(function(item) {
        // hierarchical facets get sorted using their raw name
        var name = item.path || item.name;
        if (reverseOrder[name] !== undefined) orderedFacets[reverseOrder[name]] = item;
        else remainingFacets.push(item);
    });
    orderedFacets = orderedFacets.filter(function(facet) {
        return facet;
    });
    var sortRemainingBy = facetOrdering.sortRemainingBy;
    var ordering;
    if (sortRemainingBy === "hidden") return orderedFacets;
    else if (sortRemainingBy === "alpha") ordering = [
        [
            "path",
            "name"
        ],
        [
            "asc",
            "asc"
        ]
    ];
    else ordering = [
        [
            "count"
        ],
        [
            "desc"
        ]
    ];
    return orderedFacets.concat($743fa82a11922a42$exports(remainingFacets, ordering[0], ordering[1]));
}
/**
 * @param {SearchResults} results the search results class
 * @param {string} attribute the attribute to retrieve ordering of
 * @returns {FacetOrdering | undefined} the facet ordering
 */ function $a9bed3272ad72cb7$var$getFacetOrdering(results, attribute) {
    return results.renderingContent && results.renderingContent.facetOrdering && results.renderingContent.facetOrdering.values && results.renderingContent.facetOrdering.values[attribute];
}
/**
 * Get a the list of values for a given facet attribute. Those values are sorted
 * refinement first, descending count (bigger value on top), and name ascending
 * (alphabetical order). The sort formula can overridden using either string based
 * predicates or a function.
 *
 * This method will return all the values returned by the Algolia engine plus all
 * the values already refined. This means that it can happen that the
 * `maxValuesPerFacet` [configuration](https://www.algolia.com/doc/rest-api/search#param-maxValuesPerFacet)
 * might not be respected if you have facet values that are already refined.
 * @param {string} attribute attribute name
 * @param {object} opts configuration options.
 * @param {boolean} [opts.facetOrdering]
 * Force the use of facetOrdering from the result if a sortBy is present. If
 * sortBy isn't present, facetOrdering will be used automatically.
 * @param {Array.<string> | function} opts.sortBy
 * When using strings, it consists of
 * the name of the [FacetValue](#SearchResults.FacetValue) or the
 * [HierarchicalFacet](#SearchResults.HierarchicalFacet) attributes with the
 * order (`asc` or `desc`). For example to order the value by count, the
 * argument would be `['count:asc']`.
 *
 * If only the attribute name is specified, the ordering defaults to the one
 * specified in the default value for this attribute.
 *
 * When not specified, the order is
 * ascending.  This parameter can also be a function which takes two facet
 * values and should return a number, 0 if equal, 1 if the first argument is
 * bigger or -1 otherwise.
 *
 * The default value for this attribute `['isRefined:desc', 'count:desc', 'name:asc']`
 * @return {FacetValue[]|HierarchicalFacet|undefined} depending on the type of facet of
 * the attribute requested (hierarchical, disjunctive or conjunctive)
 * @example
 * helper.on('result', function(event){
 *   //get values ordered only by name ascending using the string predicate
 *   event.results.getFacetValues('city', {sortBy: ['name:asc']});
 *   //get values  ordered only by count ascending using a function
 *   event.results.getFacetValues('city', {
 *     // this is equivalent to ['count:asc']
 *     sortBy: function(a, b) {
 *       if (a.count === b.count) return 0;
 *       if (a.count > b.count)   return 1;
 *       if (b.count > a.count)   return -1;
 *     }
 *   });
 * });
 */ $a9bed3272ad72cb7$var$SearchResults.prototype.getFacetValues = function(attribute, opts) {
    var facetValues = $a9bed3272ad72cb7$var$extractNormalizedFacetValues(this, attribute);
    if (!facetValues) return undefined;
    var options = $e8574be1cb58b6cf$exports({}, opts, {
        sortBy: $a9bed3272ad72cb7$var$SearchResults.DEFAULT_SORT,
        // if no sortBy is given, attempt to sort based on facetOrdering
        // if it is given, we still allow to sort via facet ordering first
        facetOrdering: !(opts && opts.sortBy)
    });
    // eslint-disable-next-line consistent-this
    var results = this;
    var attributes;
    if (Array.isArray(facetValues)) attributes = [
        attribute
    ];
    else {
        var config = results._state.getHierarchicalFacetByName(facetValues.name);
        attributes = config.attributes;
    }
    return $a9bed3272ad72cb7$var$recSort(function(data, facetName) {
        if (options.facetOrdering) {
            var facetOrdering = $a9bed3272ad72cb7$var$getFacetOrdering(results, facetName);
            if (facetOrdering) return $a9bed3272ad72cb7$var$sortViaFacetOrdering(data, facetOrdering);
        }
        if (Array.isArray(options.sortBy)) {
            var order = $0027bf120927ecb5$exports(options.sortBy, $a9bed3272ad72cb7$var$SearchResults.DEFAULT_SORT);
            return $743fa82a11922a42$exports(data, order[0], order[1]);
        } else if (typeof options.sortBy === "function") return $a9bed3272ad72cb7$var$vanillaSortFn(options.sortBy, data);
        throw new Error("options.sortBy is optional but if defined it must be either an array of string (predicates) or a sorting function");
    }, facetValues, attributes);
};
/**
 * Returns the facet stats if attribute is defined and the facet contains some.
 * Otherwise returns undefined.
 * @param {string} attribute name of the faceted attribute
 * @return {object} The stats of the facet
 */ $a9bed3272ad72cb7$var$SearchResults.prototype.getFacetStats = function(attribute) {
    if (this._state.isConjunctiveFacet(attribute)) return $a9bed3272ad72cb7$var$getFacetStatsIfAvailable(this.facets, attribute);
    else if (this._state.isDisjunctiveFacet(attribute)) return $a9bed3272ad72cb7$var$getFacetStatsIfAvailable(this.disjunctiveFacets, attribute);
    return undefined;
};
/**
 * @typedef {Object} FacetListItem
 * @property {string} name
 */ /**
 * @param {FacetListItem[]} facetList (has more items, but enough for here)
 * @param {string} facetName The attribute to look for
 * @return {object|undefined} The stats of the facet
 */ function $a9bed3272ad72cb7$var$getFacetStatsIfAvailable(facetList, facetName) {
    var data = $d02ab4ee8a5630b4$exports(facetList, function(facet) {
        return facet.name === facetName;
    });
    return data && data.stats;
}
/**
 * Returns all refinements for all filters + tags. It also provides
 * additional information: count and exhaustiveness for each filter.
 *
 * See the [refinement type](#Refinement) for an exhaustive view of the available
 * data.
 *
 * Note that for a numeric refinement, results are grouped per operator, this
 * means that it will return responses for operators which are empty.
 *
 * @return {Array.<Refinement>} all the refinements
 */ $a9bed3272ad72cb7$var$SearchResults.prototype.getRefinements = function() {
    var state = this._state;
    // eslint-disable-next-line consistent-this
    var results = this;
    var res = [];
    Object.keys(state.facetsRefinements).forEach(function(attributeName) {
        state.facetsRefinements[attributeName].forEach(function(name) {
            res.push($a9bed3272ad72cb7$var$getRefinement(state, "facet", attributeName, name, results.facets));
        });
    });
    Object.keys(state.facetsExcludes).forEach(function(attributeName) {
        state.facetsExcludes[attributeName].forEach(function(name) {
            res.push($a9bed3272ad72cb7$var$getRefinement(state, "exclude", attributeName, name, results.facets));
        });
    });
    Object.keys(state.disjunctiveFacetsRefinements).forEach(function(attributeName) {
        state.disjunctiveFacetsRefinements[attributeName].forEach(function(name) {
            res.push($a9bed3272ad72cb7$var$getRefinement(state, "disjunctive", attributeName, name, results.disjunctiveFacets));
        });
    });
    Object.keys(state.hierarchicalFacetsRefinements).forEach(function(attributeName) {
        state.hierarchicalFacetsRefinements[attributeName].forEach(function(name) {
            res.push($a9bed3272ad72cb7$var$getHierarchicalRefinement(state, attributeName, name, results.hierarchicalFacets));
        });
    });
    Object.keys(state.numericRefinements).forEach(function(attributeName) {
        var operators = state.numericRefinements[attributeName];
        Object.keys(operators).forEach(function(operator) {
            operators[operator].forEach(function(value) {
                res.push({
                    type: "numeric",
                    attributeName: attributeName,
                    name: value,
                    numericValue: value,
                    operator: operator
                });
            });
        });
    });
    state.tagRefinements.forEach(function(name) {
        res.push({
            type: "tag",
            attributeName: "_tags",
            name: name
        });
    });
    return res;
};
/**
 * @typedef {Object} Facet
 * @property {string} name
 * @property {Object} data
 * @property {boolean} exhaustive
 */ /**
 * @param {SearchParameters} state the current state
 * @param {string} type the type of the refinement
 * @param {string} attributeName The attribute of the facet
 * @param {*} name The name of the facet
 * @param {Facet[]} resultsFacets facets from the results
 * @return {Refinement} the refinement
 */ function $a9bed3272ad72cb7$var$getRefinement(state, type, attributeName, name, resultsFacets) {
    var facet = $d02ab4ee8a5630b4$exports(resultsFacets, function(f) {
        return f.name === attributeName;
    });
    var count = facet && facet.data && facet.data[name] ? facet.data[name] : 0;
    var exhaustive = facet && facet.exhaustive || false;
    return {
        type: type,
        attributeName: attributeName,
        name: name,
        count: count,
        exhaustive: exhaustive
    };
}
/**
 * @param {SearchParameters} state the current state
 * @param {string} attributeName the attribute of the hierarchical facet
 * @param {string} name the name of the facet
 * @param {Facet[]} resultsFacets facets from the results
 * @return {HierarchicalFacet} the hierarchical facet
 */ function $a9bed3272ad72cb7$var$getHierarchicalRefinement(state, attributeName, name, resultsFacets) {
    var facetDeclaration = state.getHierarchicalFacetByName(attributeName);
    var separator = state._getHierarchicalFacetSeparator(facetDeclaration);
    var split = name.split(separator);
    var rootFacet = $d02ab4ee8a5630b4$exports(resultsFacets, function(facet) {
        return facet.name === attributeName;
    });
    var facet = split.reduce(function(intermediateFacet, part) {
        var newFacet = intermediateFacet && $d02ab4ee8a5630b4$exports(intermediateFacet.data, function(f) {
            return f.name === part;
        });
        return newFacet !== undefined ? newFacet : intermediateFacet;
    }, rootFacet);
    var count = facet && facet.count || 0;
    var exhaustive = facet && facet.exhaustive || false;
    var path = facet && facet.path || "";
    return {
        type: "hierarchical",
        attributeName: attributeName,
        name: path,
        count: count,
        exhaustive: exhaustive
    };
}
$a9bed3272ad72cb7$exports = $a9bed3272ad72cb7$var$SearchResults;



var $2nFq9 = parcelRequire("2nFq9");
/**
 * Event triggered when a parameter is set or updated
 * @event AlgoliaSearchHelper#event:change
 * @property {object} event
 * @property {SearchParameters} event.state the current parameters with the latest changes applied
 * @property {SearchResults} event.results the previous results received from Algolia. `null` before the first request
 * @example
 * helper.on('change', function(event) {
 *   console.log('The parameters have changed');
 * });
 */ /**
 * Event triggered when a main search is sent to Algolia
 * @event AlgoliaSearchHelper#event:search
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search
 * @property {SearchResults} event.results the results from the previous search. `null` if it is the first search.
 * @example
 * helper.on('search', function(event) {
 *   console.log('Search sent');
 * });
 */ /**
 * Event triggered when a search using `searchForFacetValues` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchForFacetValues
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @property {string} event.facet the facet searched into
 * @property {string} event.query the query used to search in the facets
 * @example
 * helper.on('searchForFacetValues', function(event) {
 *   console.log('searchForFacetValues sent');
 * });
 */ /**
 * Event triggered when a search using `searchOnce` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchOnce
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @example
 * helper.on('searchOnce', function(event) {
 *   console.log('searchOnce sent');
 * });
 */ /**
 * Event triggered when the results are retrieved from Algolia
 * @event AlgoliaSearchHelper#event:result
 * @property {object} event
 * @property {SearchResults} event.results the results received from Algolia
 * @property {SearchParameters} event.state the parameters used to query Algolia. Those might be different from the one in the helper instance (for example if the network is unreliable).
 * @example
 * helper.on('result', function(event) {
 *   console.log('Search results received');
 * });
 */ /**
 * Event triggered when Algolia sends back an error. For example, if an unknown parameter is
 * used, the error can be caught using this event.
 * @event AlgoliaSearchHelper#event:error
 * @property {object} event
 * @property {Error} event.error the error returned by the Algolia.
 * @example
 * helper.on('error', function(event) {
 *   console.log('Houston we got a problem.');
 * });
 */ /**
 * Event triggered when the queue of queries have been depleted (with any result or outdated queries)
 * @event AlgoliaSearchHelper#event:searchQueueEmpty
 * @example
 * helper.on('searchQueueEmpty', function() {
 *   console.log('No more search pending');
 *   // This is received before the result event if we're not expecting new results
 * });
 *
 * helper.search();
 */ /**
 * Initialize a new AlgoliaSearchHelper
 * @class
 * @classdesc The AlgoliaSearchHelper is a class that ease the management of the
 * search. It provides an event based interface for search callbacks:
 *  - change: when the internal search state is changed.
 *    This event contains a {@link SearchParameters} object and the
 *    {@link SearchResults} of the last result if any.
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 *  - error: when the response is an error. This event contains the error returned by the server.
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the index name to query
 * @param  {SearchParameters | object} options an object defining the initial
 * config of the search. It doesn't have to be a {SearchParameters},
 * just an object containing the properties you need from it.
 * @param {SearchResultsOptions|object} searchResultsOptions an object defining the options to use when creating the search results.
 */ function $ef22465501782220$var$AlgoliaSearchHelper(client, index, options, searchResultsOptions) {
    if (typeof client.addAlgoliaAgent === "function") client.addAlgoliaAgent("JS Helper (" + $2nFq9 + ")");
    this.setClient(client);
    var opts = options || {};
    opts.index = index;
    this.state = $42c6a8b833b5bd3a$exports.make(opts);
    this.recommendState = new $5f5e985ab36777f0$exports({
        params: opts.recommendState
    });
    this.lastResults = null;
    this.lastRecommendResults = null;
    this._queryId = 0;
    this._recommendQueryId = 0;
    this._lastQueryIdReceived = -1;
    this._lastRecommendQueryIdReceived = -1;
    this.derivedHelpers = [];
    this._currentNbQueries = 0;
    this._currentNbRecommendQueries = 0;
    this._searchResultsOptions = searchResultsOptions;
}
$0a179e04f2f2d4bb$exports($ef22465501782220$var$AlgoliaSearchHelper, $510c46699c725eb9$exports);
/**
 * Start the search with the parameters set in the state. When the
 * method is called, it triggers a `search` event. The results will
 * be available through the `result` event. If an error occurs, an
 * `error` will be fired instead.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires search
 * @fires result
 * @fires error
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.search = function() {
    this._search({
        onlyWithDerivedHelpers: false
    });
    return this;
};
$ef22465501782220$var$AlgoliaSearchHelper.prototype.searchOnlyWithDerivedHelpers = function() {
    this._search({
        onlyWithDerivedHelpers: true
    });
    return this;
};
/**
 * Sends the recommendation queries set in the state. When the method is
 * called, it triggers a `fetch` event. The results will be available through
 * the `result` event. If an error occurs, an `error` will be fired instead.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires fetch
 * @fires result
 * @fires error
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.recommend = function() {
    this._recommend();
    return this;
};
/**
 * Gets the search query parameters that would be sent to the Algolia Client
 * for the hits
 * @return {object} Query Parameters
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.getQuery = function() {
    var state = this.state;
    return $915525af975e011b$exports._getHitsSearchParams(state);
};
/**
 * Start a search using a modified version of the current state. This method does
 * not trigger the helper lifecycle and does not modify the state kept internally
 * by the helper. This second aspect means that the next search call will be the
 * same as a search call before calling searchOnce.
 * @param {object} options can contain all the parameters that can be set to SearchParameters
 * plus the index
 * @param {function} [cb] optional callback executed when the response from the
 * server is back.
 * @return {promise|undefined} if a callback is passed the method returns undefined
 * otherwise it returns a promise containing an object with two keys :
 *  - content with a SearchResults
 *  - state with the state used for the query as a SearchParameters
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the callback API
 * var state = helper.searchOnce({hitsPerPage: 1},
 *   function(error, content, state) {
 *     // if an error occurred it will be passed in error, otherwise its value is null
 *     // content contains the results formatted as a SearchResults
 *     // state is the instance of SearchParameters used for this search
 *   });
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the promise API
 * var state1 = helper.searchOnce({hitsPerPage: 1})
 *                 .then(promiseHandler);
 *
 * function promiseHandler(res) {
 *   // res contains
 *   // {
 *   //   content : SearchResults
 *   //   state   : SearchParameters (the one used for this specific search)
 *   // }
 * }
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.searchOnce = function(options, cb) {
    var tempState = !options ? this.state : this.state.setQueryParameters(options);
    var queries = $915525af975e011b$exports._getQueries(tempState.index, tempState);
    // eslint-disable-next-line consistent-this
    var self = this;
    this._currentNbQueries++;
    this.emit("searchOnce", {
        state: tempState
    });
    if (cb) {
        this.client.search(queries).then(function(content) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
            cb(null, new $a9bed3272ad72cb7$exports(tempState, content.results), tempState);
        }).catch(function(err) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
            cb(err, null, tempState);
        });
        return undefined;
    }
    return this.client.search(queries).then(function(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        return {
            content: new $a9bed3272ad72cb7$exports(tempState, content.results),
            state: tempState,
            _originalResponse: content
        };
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        throw e;
    });
};
/**
 * Start the search for answers with the parameters set in the state.
 * This method returns a promise.
 * @param {Object} options - the options for answers API call
 * @param {string[]} options.attributesForPrediction - Attributes to use for predictions. If empty, `searchableAttributes` is used instead.
 * @param {string[]} options.queryLanguages - The languages in the query. Currently only supports ['en'].
 * @param {number} options.nbHits - Maximum number of answers to retrieve from the Answers Engine. Cannot be greater than 1000.
 *
 * @return {promise} the answer results
 * @deprecated answers is deprecated and will be replaced with new initiatives
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.findAnswers = function(options) {
    // eslint-disable-next-line no-console
    console.warn("[algoliasearch-helper] answers is no longer supported");
    var state = this.state;
    var derivedHelper = this.derivedHelpers[0];
    if (!derivedHelper) return Promise.resolve([]);
    var derivedState = derivedHelper.getModifiedState(state);
    var data = $35783371e549f033$exports({
        attributesForPrediction: options.attributesForPrediction,
        nbHits: options.nbHits
    }, {
        params: $f254195a30803f63$exports($915525af975e011b$exports._getHitsSearchParams(derivedState), [
            "attributesToSnippet",
            "hitsPerPage",
            "restrictSearchableAttributes",
            "snippetEllipsisText"
        ])
    });
    var errorMessage = "search for answers was called, but this client does not have a function client.initIndex(index).findAnswers";
    if (typeof this.client.initIndex !== "function") throw new Error(errorMessage);
    var index = this.client.initIndex(derivedState.index);
    if (typeof index.findAnswers !== "function") throw new Error(errorMessage);
    return index.findAnswers(derivedState.query, options.queryLanguages, data);
};
/**
 * Structure of each result when using
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * @typedef FacetSearchHit
 * @type {object}
 * @property {string} value the facet value
 * @property {string} highlighted the facet value highlighted with the query string
 * @property {number} count number of occurrence of this facet value
 * @property {boolean} isRefined true if the value is already refined
 */ /**
 * Structure of the data resolved by the
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * promise.
 * @typedef FacetSearchResult
 * @type {object}
 * @property {FacetSearchHit} facetHits the results for this search for facet values
 * @property {number} processingTimeMS time taken by the query inside the engine
 */ /**
 * Search for facet values based on an query and the name of a faceted attribute. This
 * triggers a search and will return a promise. On top of using the query, it also sends
 * the parameters from the state so that the search is narrowed down to only the possible values.
 *
 * See the description of [FacetSearchResult](reference.html#FacetSearchResult)
 * @param {string} facet the name of the faceted attribute
 * @param {string} query the string query for the search
 * @param {number} [maxFacetHits] the maximum number values returned. Should be > 0 and <= 100
 * @param {object} [userState] the set of custom parameters to use on top of the current state. Setting a property to `undefined` removes
 * it in the generated query.
 * @return {promise.<FacetSearchResult>} the results of the search
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.searchForFacetValues = function(facet, query, maxFacetHits, userState) {
    var clientHasSFFV = typeof this.client.searchForFacetValues === "function";
    var clientHasInitIndex = typeof this.client.initIndex === "function";
    if (!clientHasSFFV && !clientHasInitIndex && typeof this.client.search !== "function") throw new Error("search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues");
    var state = this.state.setQueryParameters(userState || {});
    var isDisjunctive = state.isDisjunctiveFacet(facet);
    var algoliaQuery = $915525af975e011b$exports.getSearchForFacetQuery(facet, query, maxFacetHits, state);
    this._currentNbQueries++;
    // eslint-disable-next-line consistent-this
    var self = this;
    var searchForFacetValuesPromise;
    // newer algoliasearch ^3.27.1 - ~4.0.0
    if (clientHasSFFV) searchForFacetValuesPromise = this.client.searchForFacetValues([
        {
            indexName: state.index,
            params: algoliaQuery
        }
    ]);
    else if (clientHasInitIndex) searchForFacetValuesPromise = this.client.initIndex(state.index).searchForFacetValues(algoliaQuery);
    else {
        // @MAJOR only use client.search
        delete algoliaQuery.facetName;
        searchForFacetValuesPromise = this.client.search([
            {
                type: "facet",
                facet: facet,
                indexName: state.index,
                params: algoliaQuery
            }
        ]).then(function processResponse(response) {
            return response.results[0];
        });
    }
    this.emit("searchForFacetValues", {
        state: state,
        facet: facet,
        query: query
    });
    return searchForFacetValuesPromise.then(function addIsRefined(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        content = Array.isArray(content) ? content[0] : content;
        content.facetHits.forEach(function(f) {
            f.escapedValue = $ef22465501782220$require$escapeFacetValue(f.value);
            f.isRefined = isDisjunctive ? state.isDisjunctiveFacetRefined(facet, f.escapedValue) : state.isFacetRefined(facet, f.escapedValue);
        });
        return content;
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        throw e;
    });
};
/**
 * Sets the text query used for the search.
 *
 * This method resets the current page to 0.
 * @param  {string} q the user query
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.setQuery = function(q) {
    this._change({
        state: this.state.resetPage().setQuery(q),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the types of refinements except tags. A string can be provided to remove
 * only the refinements of a specific attribute. For more advanced use case, you can
 * provide a function instead. This function should follow the
 * [clearCallback definition](#SearchParameters.clearCallback).
 *
 * This method resets the current page to 0.
 * @param {string} [name] optional name of the facet / attribute on which we want to remove all refinements
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * // Removing all the refinements
 * helper.clearRefinements().search();
 * @example
 * // Removing all the filters on a the category attribute.
 * helper.clearRefinements('category').search();
 * @example
 * // Removing only the exclude filters on the category facet.
 * helper.clearRefinements(function(value, attribute, type) {
 *   return type === 'exclude' && attribute === 'category';
 * }).search();
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.clearRefinements = function(name) {
    this._change({
        state: this.state.resetPage().clearRefinements(name),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the tag filters.
 *
 * This method resets the current page to 0.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.clearTags = function() {
    this._change({
        state: this.state.resetPage().clearTags(),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.addDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addDisjunctiveFacetRefinement}
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.addDisjunctiveRefine = function() {
    return this.addDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Adds a refinement on a hierarchical facet. It will throw
 * an exception if the facet is not defined or if the facet
 * is already refined.
 *
 * This method resets the current page to 0.
 * @param {string} facet the facet name
 * @param {string} path the hierarchical facet path
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error if the facet is not defined or if the facet is refined
 * @chainable
 * @fires change
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.addHierarchicalFacetRefinement = function(facet, path) {
    this._change({
        state: this.state.resetPage().addHierarchicalFacetRefinement(facet, path),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} operator the operator of the filter
 * @param  {number} value the value of the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.addNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().addNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.addFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetRefinement}
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.addRefine = function() {
    return this.addFacetRefinement.apply(this, arguments);
};
/**
 * Adds a an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.addFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().addExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetExclusion}
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.addExclude = function() {
    return this.addFacetExclusion.apply(this, arguments);
};
/**
 * Adds a tag filter with the `tag` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag the tag to add to the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.addTag = function(tag) {
    this._change({
        state: this.state.resetPage().addTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a "frequently bought together" recommendation query.
 *
 * @param {FrequentlyBoughtTogetherQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.addFrequentlyBoughtTogether = function(params) {
    this._recommendChange({
        state: this.recommendState.addFrequentlyBoughtTogether(params)
    });
    return this;
};
/**
 * Adds a "related products" recommendation query.
 *
 * @param {RelatedProductsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.addRelatedProducts = function(params) {
    this._recommendChange({
        state: this.recommendState.addRelatedProducts(params)
    });
    return this;
};
/**
 * Adds a "trending items" recommendation query.
 *
 * @param {TrendingItemsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.addTrendingItems = function(params) {
    this._recommendChange({
        state: this.recommendState.addTrendingItems(params)
    });
    return this;
};
/**
 * Adds a "trending facets" recommendation query.
 *
 * @param {TrendingFacetsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.addTrendingFacets = function(params) {
    this._recommendChange({
        state: this.recommendState.addTrendingFacets(params)
    });
    return this;
};
/**
 * Adds a "looking similar" recommendation query.
 *
 * @param {LookingSimilarQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.addLookingSimilar = function(params) {
    this._recommendChange({
        state: this.recommendState.addLookingSimilar(params)
    });
    return this;
};
/**
 * Removes an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * Some parameters are optional, triggering different behavior:
 *  - if the value is not provided, then all the numeric value will be removed for the
 *  specified attribute/operator couple.
 *  - if the operator is not provided either, then all the numeric filter on this attribute
 *  will be removed.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} [operator] the operator of the filter
 * @param  {number} [value] the value of the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.removeNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().removeNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.removeDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeDisjunctiveFacetRefinement}
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.removeDisjunctiveRefine = function() {
    return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Removes the refinement set on a hierarchical facet.
 * @param {string} facet the facet name
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error if the facet is not defined or if the facet is not refined
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.removeHierarchicalFacetRefinement = function(facet) {
    this._change({
        state: this.state.resetPage().removeHierarchicalFacetRefinement(facet),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.removeFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetRefinement}
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.removeRefine = function() {
    return this.removeFacetRefinement.apply(this, arguments);
};
/**
 * Removes an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.removeFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetExclusion}
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.removeExclude = function() {
    return this.removeFacetExclusion.apply(this, arguments);
};
/**
 * Removes a tag filter with the `tag` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove from the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.removeTag = function(tag) {
    this._change({
        state: this.state.resetPage().removeTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a "frequently bought together" recommendation query.
 *
 * @param {string} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.removeFrequentlyBoughtTogether = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "related products" recommendation query.
 *
 * @param {string} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.removeRelatedProducts = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "trending items" recommendation query.
 *
 * @param {string} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.removeTrendingItems = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "trending facets" recommendation query.
 *
 * @param {string} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.removeTrendingFacets = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "looking similar" recommendation query.
 *
 * @param {string} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.removeLookingSimilar = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Adds or removes an exclusion filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.toggleFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleExcludeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetExclusion}
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.toggleExclude = function() {
    return this.toggleFacetExclusion.apply(this, arguments);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 * @deprecated since version 2.19.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.toggleRefinement = function(facet, value) {
    return this.toggleFacetRefinement(facet, value);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.toggleFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.toggleRefine = function() {
    return this.toggleFacetRefinement.apply(this, arguments);
};
/**
 * Adds or removes a tag filter with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove or add
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.toggleTag = function(tag) {
    this._change({
        state: this.state.resetPage().toggleTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Increments the page number by one.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * helper.setPage(0).nextPage().getPage();
 * // returns 1
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.nextPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page + 1);
};
/**
 * Decrements the page number by one.
 * @fires change
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @chainable
 * @example
 * helper.setPage(1).previousPage().getPage();
 * // returns 0
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.previousPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page - 1);
};
/**
 * @private
 * @param {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @chainable
 * @fires change
 */ function $ef22465501782220$var$setCurrentPage(page) {
    if (page < 0) throw new Error("Page requested below 0.");
    this._change({
        state: this.state.setPage(page),
        isPageReset: false
    });
    return this;
}
/**
 * Change the current page
 * @deprecated
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.setCurrentPage = $ef22465501782220$var$setCurrentPage;
/**
 * Updates the current page.
 * @function
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.setPage = $ef22465501782220$var$setCurrentPage;
/**
 * Updates the name of the index that will be targeted by the query.
 *
 * This method resets the current page to 0.
 * @param {string} name the index name
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.setIndex = function(name) {
    this._change({
        state: this.state.resetPage().setIndex(name),
        isPageReset: true
    });
    return this;
};
/**
 * Update a parameter of the search. This method reset the page
 *
 * The complete list of parameters is available on the
 * [Algolia website](https://www.algolia.com/doc/rest#query-an-index).
 * The most commonly used parameters have their own [shortcuts](#query-parameters-shortcuts)
 * or benefit from higher-level APIs (all the kind of filters and facets have their own API)
 *
 * This method resets the current page to 0.
 * @param {string} parameter name of the parameter to update
 * @param {any} value new value of the parameter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * helper.setQueryParameter('hitsPerPage', 20).search();
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.setQueryParameter = function(parameter, value) {
    this._change({
        state: this.state.resetPage().setQueryParameter(parameter, value),
        isPageReset: true
    });
    return this;
};
/**
 * Set the whole state (warning: will erase previous state)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.setState = function(newState) {
    this._change({
        state: $42c6a8b833b5bd3a$exports.make(newState),
        isPageReset: false
    });
    return this;
};
/**
 * Override the current state without triggering a change event.
 * Do not use this method unless you know what you are doing. (see the example
 * for a legit use case)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @example
 *  helper.on('change', function(state){
 *    // In this function you might want to find a way to store the state in the url/history
 *    updateYourURL(state)
 *  })
 *  window.onpopstate = function(event){
 *    // This is naive though as you should check if the state is really defined etc.
 *    helper.overrideStateWithoutTriggeringChangeEvent(event.state).search()
 *  }
 * @chainable
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.overrideStateWithoutTriggeringChangeEvent = function(newState) {
    this.state = new $42c6a8b833b5bd3a$exports(newState);
    return this;
};
/**
 * Check if an attribute has any numeric, conjunctive, disjunctive or hierarchical filters.
 * @param {string} attribute the name of the attribute
 * @return {boolean} true if the attribute is filtered by at least one value
 * @example
 * // hasRefinements works with numeric, conjunctive, disjunctive and hierarchical filters
 * helper.hasRefinements('price'); // false
 * helper.addNumericRefinement('price', '>', 100);
 * helper.hasRefinements('price'); // true
 *
 * helper.hasRefinements('color'); // false
 * helper.addFacetRefinement('color', 'blue');
 * helper.hasRefinements('color'); // true
 *
 * helper.hasRefinements('material'); // false
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * helper.hasRefinements('material'); // true
 *
 * helper.hasRefinements('categories'); // false
 * helper.toggleFacetRefinement('categories', 'kitchen > knife');
 * helper.hasRefinements('categories'); // true
 *
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.hasRefinements = function(attribute) {
    if ($47eb2399d0baf1bd$exports(this.state.getNumericRefinements(attribute))) return true;
    else if (this.state.isConjunctiveFacet(attribute)) return this.state.isFacetRefined(attribute);
    else if (this.state.isDisjunctiveFacet(attribute)) return this.state.isDisjunctiveFacetRefined(attribute);
    else if (this.state.isHierarchicalFacet(attribute)) return this.state.isHierarchicalFacetRefined(attribute);
    // there's currently no way to know that the user did call `addNumericRefinement` at some point
    // thus we cannot distinguish if there once was a numeric refinement that was cleared
    // so we will return false in every other situations to be consistent
    // while what we should do here is throw because we did not find the attribute in any type
    // of refinement
    return false;
};
/**
 * Check if a value is excluded for a specific faceted attribute. If the value
 * is omitted then the function checks if there is any excluding refinements.
 *
 * @param  {string}  facet name of the attribute for used for faceting
 * @param  {string}  [value] optional value. If passed will test that this value
 * is filtering the given facet.
 * @return {boolean} true if refined
 * @example
 * helper.isExcludeRefined('color'); // false
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // false
 *
 * helper.addFacetExclusion('color', 'red');
 *
 * helper.isExcludeRefined('color'); // true
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // true
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.isExcluded = function(facet, value) {
    return this.state.isExcludeRefined(facet, value);
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasRefinements}
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.isDisjunctiveRefined = function(facet, value) {
    return this.state.isDisjunctiveFacetRefined(facet, value);
};
/**
 * Check if the string is a currently filtering tag.
 * @param {string} tag tag to check
 * @return {boolean} true if the tag is currently refined
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.hasTag = function(tag) {
    return this.state.isTagRefined(tag);
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasTag}
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.isTagRefined = function() {
    return this.hasTagRefinements.apply(this, arguments);
};
/**
 * Get the name of the currently used index.
 * @return {string} name of the index
 * @example
 * helper.setIndex('highestPrice_products').getIndex();
 * // returns 'highestPrice_products'
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.getIndex = function() {
    return this.state.index;
};
function $ef22465501782220$var$getCurrentPage() {
    return this.state.page;
}
/**
 * Get the currently selected page
 * @deprecated
 * @return {number} the current page
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.getCurrentPage = $ef22465501782220$var$getCurrentPage;
/**
 * Get the currently selected page
 * @function
 * @return {number} the current page
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.getPage = $ef22465501782220$var$getCurrentPage;
/**
 * Get all the tags currently set to filters the results.
 *
 * @return {string[]} The list of tags currently set.
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.getTags = function() {
    return this.state.tagRefinements;
};
/**
 * Get the list of refinements for a given attribute. This method works with
 * conjunctive, disjunctive, excluding and numerical filters.
 *
 * See also SearchResults#getRefinements
 *
 * @param {string} facetName attribute name used for faceting
 * @return {Array.<FacetRefinement|NumericRefinement>} All Refinement are objects that contain a value, and
 * a type. Numeric also contains an operator.
 * @example
 * helper.addNumericRefinement('price', '>', 100);
 * helper.getRefinements('price');
 * // [
 * //   {
 * //     "value": [
 * //       100
 * //     ],
 * //     "operator": ">",
 * //     "type": "numeric"
 * //   }
 * // ]
 * @example
 * helper.addFacetRefinement('color', 'blue');
 * helper.addFacetExclusion('color', 'red');
 * helper.getRefinements('color');
 * // [
 * //   {
 * //     "value": "blue",
 * //     "type": "conjunctive"
 * //   },
 * //   {
 * //     "value": "red",
 * //     "type": "exclude"
 * //   }
 * // ]
 * @example
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * // [
 * //   {
 * //     "value": "plastic",
 * //     "type": "disjunctive"
 * //   }
 * // ]
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.getRefinements = function(facetName) {
    var refinements = [];
    if (this.state.isConjunctiveFacet(facetName)) {
        var conjRefinements = this.state.getConjunctiveRefinements(facetName);
        conjRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: "conjunctive"
            });
        });
        var excludeRefinements = this.state.getExcludeRefinements(facetName);
        excludeRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: "exclude"
            });
        });
    } else if (this.state.isDisjunctiveFacet(facetName)) {
        var disjunctiveRefinements = this.state.getDisjunctiveRefinements(facetName);
        disjunctiveRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: "disjunctive"
            });
        });
    }
    var numericRefinements = this.state.getNumericRefinements(facetName);
    Object.keys(numericRefinements).forEach(function(operator) {
        var value = numericRefinements[operator];
        refinements.push({
            value: value,
            operator: operator,
            type: "numeric"
        });
    });
    return refinements;
};
/**
 * Return the current refinement for the (attribute, operator)
 * @param {string} attribute attribute in the record
 * @param {string} operator operator applied on the refined values
 * @return {Array.<number|number[]>} refined values
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.getNumericRefinement = function(attribute, operator) {
    return this.state.getNumericRefinement(attribute, operator);
};
/**
 * Get the current breadcrumb for a hierarchical facet, as an array
 * @param  {string} facetName Hierarchical facet name
 * @return {array.<string>} the path as an array of string
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.getHierarchicalFacetBreadcrumb = function(facetName) {
    return this.state.getHierarchicalFacetBreadcrumb(facetName);
};
// /////////// PRIVATE
/**
 * Perform the underlying queries
 * @private
 * @param {object} options options for the query
 * @param {boolean} [options.onlyWithDerivedHelpers=false] if true, only the derived helpers will be queried
 * @return {undefined} does not return anything
 * @fires search
 * @fires result
 * @fires error
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype._search = function(options) {
    var state = this.state;
    var states = [];
    var mainQueries = [];
    if (!options.onlyWithDerivedHelpers) {
        mainQueries = $915525af975e011b$exports._getQueries(state.index, state);
        states.push({
            state: state,
            queriesCount: mainQueries.length,
            helper: this
        });
        this.emit("search", {
            state: state,
            results: this.lastResults
        });
    }
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedState = derivedHelper.getModifiedState(state);
        var derivedStateQueries = derivedState.index ? $915525af975e011b$exports._getQueries(derivedState.index, derivedState) : [];
        states.push({
            state: derivedState,
            queriesCount: derivedStateQueries.length,
            helper: derivedHelper
        });
        derivedHelper.emit("search", {
            state: derivedState,
            results: derivedHelper.lastResults
        });
        return derivedStateQueries;
    });
    var queries = Array.prototype.concat.apply(mainQueries, derivedQueries);
    var queryId = this._queryId++;
    this._currentNbQueries++;
    if (!queries.length) return Promise.resolve({
        results: []
    }).then(this._dispatchAlgoliaResponse.bind(this, states, queryId));
    try {
        this.client.search(queries).then(this._dispatchAlgoliaResponse.bind(this, states, queryId)).catch(this._dispatchAlgoliaError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit("error", {
            error: error
        });
    }
    return undefined;
};
$ef22465501782220$var$AlgoliaSearchHelper.prototype._recommend = function() {
    var searchState = this.state;
    var recommendState = this.recommendState;
    var index = this.getIndex();
    var states = [
        {
            state: recommendState,
            index: index,
            helper: this
        }
    ];
    this.emit("fetch", {
        recommend: {
            state: recommendState,
            results: this.lastRecommendResults
        }
    });
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedIndex = derivedHelper.getModifiedState(searchState).index;
        if (!derivedIndex) return [];
        // Contrary to what is done when deriving the search state, we don't want to
        // provide the current recommend state to the derived helper, as it would
        // inherit unwanted queries. We instead provide an empty recommend state.
        var derivedState = derivedHelper.getModifiedRecommendState(new $5f5e985ab36777f0$exports());
        states.push({
            state: derivedState,
            index: derivedIndex,
            helper: derivedHelper
        });
        derivedHelper.emit("fetch", {
            recommend: {
                state: derivedState,
                results: derivedHelper.lastRecommendResults
            }
        });
        return derivedState._buildQueries(derivedIndex);
    });
    var queries = Array.prototype.concat.apply(this.recommendState._buildQueries(index), derivedQueries);
    if (queries.length === 0) return;
    if (queries.length > 0 && typeof this.client.getRecommendations === "undefined") {
        // eslint-disable-next-line no-console
        console.warn("Please update algoliasearch/lite to the latest version in order to use recommendations widgets.");
        return;
    }
    var queryId = this._recommendQueryId++;
    this._currentNbRecommendQueries++;
    try {
        this.client.getRecommendations(queries).then(this._dispatchRecommendResponse.bind(this, queryId, states)).catch(this._dispatchRecommendError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit("error", {
            error: error
        });
    }
    return;
};
/**
 * Transform the responses as sent by the server and transform them into a user
 * usable object that merge the results of all the batch requests. It will dispatch
 * over the different helper + derived helpers (when there are some).
 * @private
 * @param {array.<{SearchParameters, AlgoliaQueries, AlgoliaSearchHelper}>} states state used to generate the request
 * @param {number} queryId id of the current request
 * @param {object} content content of the response
 * @return {undefined}
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaResponse = function(states, queryId, content) {
    // eslint-disable-next-line consistent-this
    var self = this;
    // @TODO remove the number of outdated queries discarded instead of just one
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    if (this._currentNbQueries === 0) this.emit("searchQueueEmpty");
    var results = content.results.slice();
    states.forEach(function(s) {
        var state = s.state;
        var queriesCount = s.queriesCount;
        var helper = s.helper;
        var specificResults = results.splice(0, queriesCount);
        if (!state.index) {
            helper.emit("result", {
                results: null,
                state: state
            });
            return;
        }
        helper.lastResults = new $a9bed3272ad72cb7$exports(state, specificResults, self._searchResultsOptions);
        helper.emit("result", {
            results: helper.lastResults,
            state: state
        });
    });
};
$ef22465501782220$var$AlgoliaSearchHelper.prototype._dispatchRecommendResponse = function(queryId, states, content) {
    // @TODO remove the number of outdated queries discarded instead of just one
    if (queryId < this._lastRecommendQueryIdReceived) // Outdated answer
    return;
    this._currentNbRecommendQueries -= queryId - this._lastRecommendQueryIdReceived;
    this._lastRecommendQueryIdReceived = queryId;
    if (this._currentNbRecommendQueries === 0) this.emit("recommendQueueEmpty");
    var results = content.results.slice();
    states.forEach(function(s) {
        var state = s.state;
        var helper = s.helper;
        if (!s.index) {
            // eslint-disable-next-line no-warning-comments
            // TODO: emit "result" event when events for Recommend are implemented
            helper.emit("recommend:result", {
                results: null,
                state: state
            });
            return;
        }
        helper.lastRecommendResults = results;
        // eslint-disable-next-line no-warning-comments
        // TODO: emit "result" event when events for Recommend are implemented
        helper.emit("recommend:result", {
            recommend: {
                results: helper.lastRecommendResults,
                state: state
            }
        });
    });
};
$ef22465501782220$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaError = function(queryId, error) {
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    this.emit("error", {
        error: error
    });
    if (this._currentNbQueries === 0) this.emit("searchQueueEmpty");
};
$ef22465501782220$var$AlgoliaSearchHelper.prototype._dispatchRecommendError = function(queryId, error) {
    if (queryId < this._lastRecommendQueryIdReceived) // Outdated answer
    return;
    this._currentNbRecommendQueries -= queryId - this._lastRecommendQueryIdReceived;
    this._lastRecommendQueryIdReceived = queryId;
    this.emit("error", {
        error: error
    });
    if (this._currentNbRecommendQueries === 0) this.emit("recommendQueueEmpty");
};
$ef22465501782220$var$AlgoliaSearchHelper.prototype.containsRefinement = function(query, facetFilters, numericFilters, tagFilters) {
    return query || facetFilters.length !== 0 || numericFilters.length !== 0 || tagFilters.length !== 0;
};
/**
 * Test if there are some disjunctive refinements on the facet
 * @private
 * @param {string} facet the attribute to test
 * @return {boolean} true if there are refinements on this attribute
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype._hasDisjunctiveRefinements = function(facet) {
    return this.state.disjunctiveRefinements[facet] && this.state.disjunctiveRefinements[facet].length > 0;
};
$ef22465501782220$var$AlgoliaSearchHelper.prototype._change = function(event) {
    var state = event.state;
    var isPageReset = event.isPageReset;
    if (state !== this.state) {
        this.state = state;
        this.emit("change", {
            state: this.state,
            results: this.lastResults,
            isPageReset: isPageReset
        });
    }
};
$ef22465501782220$var$AlgoliaSearchHelper.prototype._recommendChange = function(event) {
    var state = event.state;
    if (state !== this.recommendState) {
        this.recommendState = state;
        // eslint-disable-next-line no-warning-comments
        // TODO: emit "change" event when events for Recommend are implemented
        this.emit("recommend:change", {
            search: {
                results: this.lastResults,
                state: this.state
            },
            recommend: {
                results: this.lastRecommendResults,
                state: this.recommendState
            }
        });
    }
};
/**
 * Clears the cache of the underlying Algolia client.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.clearCache = function() {
    if (this.client.clearCache) this.client.clearCache();
    return this;
};
/**
 * Updates the internal client instance. If the reference of the clients
 * are equal then no update is actually done.
 * @param  {AlgoliaSearch} newClient an AlgoliaSearch client
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.setClient = function(newClient) {
    if (this.client === newClient) return this;
    if (typeof newClient.addAlgoliaAgent === "function") newClient.addAlgoliaAgent("JS Helper (" + $2nFq9 + ")");
    this.client = newClient;
    return this;
};
/**
 * Gets the instance of the currently used client.
 * @return {AlgoliaSearch} the currently used client
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.getClient = function() {
    return this.client;
};
/**
 * Creates an derived instance of the Helper. A derived helper
 * is a way to request other indices synchronised with the lifecycle
 * of the main Helper. This mechanism uses the multiqueries feature
 * of Algolia to aggregate all the requests in a single network call.
 *
 * This method takes a function that is used to create a new SearchParameter
 * that will be used to create requests to Algolia. Those new requests
 * are created just before the `search` event. The signature of the function
 * is `SearchParameters -> SearchParameters`.
 *
 * This method returns a new DerivedHelper which is an EventEmitter
 * that fires the same `search`, `result` and `error` events. Those
 * events, however, will receive data specific to this DerivedHelper
 * and the SearchParameters that is returned by the call of the
 * parameter function.
 * @param {function} fn SearchParameters -> SearchParameters
 * @param {function} recommendFn RecommendParameters -> RecommendParameters
 * @return {DerivedHelper} a new DerivedHelper
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.derive = function(fn, recommendFn) {
    var derivedHelper = new $e6e2bb60b64380ea$exports(this, fn, recommendFn);
    this.derivedHelpers.push(derivedHelper);
    return derivedHelper;
};
/**
 * This method detaches a derived Helper from the main one. Prefer using the one from the
 * derived helper itself, to remove the event listeners too.
 * @private
 * @param  {DerivedHelper} derivedHelper the derived helper to detach
 * @return {undefined} nothing is returned
 * @throws Error
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.detachDerivedHelper = function(derivedHelper) {
    var pos = this.derivedHelpers.indexOf(derivedHelper);
    if (pos === -1) throw new Error("Derived helper already detached");
    this.derivedHelpers.splice(pos, 1);
};
/**
 * This method returns true if there is currently at least one on-going search.
 * @return {boolean} true if there is a search pending
 */ $ef22465501782220$var$AlgoliaSearchHelper.prototype.hasPendingRequests = function() {
    return this._currentNbQueries > 0;
};
/**
 * @typedef AlgoliaSearchHelper.NumericRefinement
 * @type {object}
 * @property {number[]} value the numbers that are used for filtering this attribute with
 * the operator specified.
 * @property {string} operator the faceting data: value, number of entries
 * @property {string} type will be 'numeric'
 */ /**
 * @typedef AlgoliaSearchHelper.FacetRefinement
 * @type {object}
 * @property {string} value the string use to filter the attribute
 * @property {string} type the type of filter: 'conjunctive', 'disjunctive', 'exclude'
 */ $ef22465501782220$exports = $ef22465501782220$var$AlgoliaSearchHelper;





/**
 * The algoliasearchHelper module is the function that will let its
 * contains everything needed to use the Algoliasearch
 * Helper. It is a also a function that instanciate the helper.
 * To use the helper, you also need the Algolia JS client v3.
 * @example
 * //using the UMD build
 * var client = algoliasearch('latency', '6be0576ff61c053d5f9a3225e2a90f76');
 * var helper = algoliasearchHelper(client, 'bestbuy', {
 *   facets: ['shipping'],
 *   disjunctiveFacets: ['category']
 * });
 * helper.on('result', function(event) {
 *   console.log(event.results);
 * });
 * helper
 *   .toggleFacetRefinement('category', 'Movies & TV Shows')
 *   .toggleFacetRefinement('shipping', 'Free shipping')
 *   .search();
 * @example
 * // The helper is an event emitter using the node API
 * helper.on('result', updateTheResults);
 * helper.once('result', updateTheResults);
 * helper.removeListener('result', updateTheResults);
 * helper.removeAllListeners('result');
 * @module algoliasearchHelper
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the name of the index to query
 * @param  {SearchParameters|object} opts an object defining the initial config of the search. It doesn't have to be a {SearchParameters}, just an object containing the properties you need from it.
 * @param {SearchResultsOptions|object} searchResultsOptions an object defining the options to use when creating the search results.
 * @return {AlgoliaSearchHelper} The helper instance
 */ function $154f73342ab39590$var$algoliasearchHelper(client, index, opts, searchResultsOptions) {
    return new $ef22465501782220$exports(client, index, opts, searchResultsOptions);
}

/**
 * The version currently used
 * @member module:algoliasearchHelper.version
 * @type {number}
 */ $154f73342ab39590$var$algoliasearchHelper.version = (parcelRequire("2nFq9"));
/**
 * Constructor for the Helper.
 * @member module:algoliasearchHelper.AlgoliaSearchHelper
 * @type {AlgoliaSearchHelper}
 */ $154f73342ab39590$var$algoliasearchHelper.AlgoliaSearchHelper = $ef22465501782220$exports;
/**
 * Constructor for the object containing all the parameters of the search.
 * @member module:algoliasearchHelper.SearchParameters
 * @type {SearchParameters}
 */ $154f73342ab39590$var$algoliasearchHelper.SearchParameters = $42c6a8b833b5bd3a$exports;
/**
 * Constructor for the object containing all the parameters for Recommend.
 * @member module:algoliasearchHelper.RecommendParameters
 * @type {RecommendParameters}
 */ $154f73342ab39590$var$algoliasearchHelper.RecommendParameters = $5f5e985ab36777f0$exports;
/**
 * Constructor for the object containing the results of the search.
 * @member module:algoliasearchHelper.SearchResults
 * @type {SearchResults}
 */ $154f73342ab39590$var$algoliasearchHelper.SearchResults = $a9bed3272ad72cb7$exports;
$154f73342ab39590$exports = $154f73342ab39590$var$algoliasearchHelper;



function $45b570cdb109c464$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $45b570cdb109c464$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $45b570cdb109c464$var$_typeof(obj);
}
var $45b570cdb109c464$export$d900da7fa9a86f36 = "_ALGOLIA";
function $45b570cdb109c464$var$getCookie(name) {
    if ((typeof document === "undefined" ? "undefined" : $45b570cdb109c464$var$_typeof(document)) !== "object" || typeof document.cookie !== "string") return undefined;
    var prefix = "".concat(name, "=");
    var cookies = document.cookie.split(";");
    for(var i = 0; i < cookies.length; i++){
        var cookie = cookies[i];
        while(cookie.charAt(0) === " ")cookie = cookie.substring(1);
        if (cookie.indexOf(prefix) === 0) return cookie.substring(prefix.length, cookie.length);
    }
    return undefined;
}
function $45b570cdb109c464$export$61f1c6e9cd2ed687() {
    return $45b570cdb109c464$var$getCookie($45b570cdb109c464$export$d900da7fa9a86f36);
}
function $45b570cdb109c464$export$2e2bcd8739ae039() {
    return $45b570cdb109c464$export$61f1c6e9cd2ed687();
}


// eslint-disable-next-line no-restricted-globals
/**
 * Runs code on browser environments safely.
 */ function $f5ad79b5c8be60f0$export$39f19eed34acd2f1(callback) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        fallback: function fallback() {
            return undefined;
        }
    }, fallback = _ref.fallback;
    // eslint-disable-next-line no-restricted-globals
    if (typeof window === "undefined") return fallback();
    // eslint-disable-next-line no-restricted-globals
    return callback({
        window: window
    });
}

function $5d3ef3e388d952bb$export$8793edee2d425525() {}

// typed as any, since it accepts the _real_ js clients, not the interface we otherwise expect
function $e6076fe21a599f0b$export$58f35ab8a1251bc0(searchClient) {
    if (searchClient.transporter) {
        // searchClient v4
        var _searchClient$transpo = searchClient.transporter, headers = _searchClient$transpo.headers, queryParameters = _searchClient$transpo.queryParameters;
        var APP_ID = "x-algolia-application-id";
        var API_KEY = "x-algolia-api-key";
        var appId = headers[APP_ID] || queryParameters[APP_ID];
        var apiKey = headers[API_KEY] || queryParameters[API_KEY];
        return [
            appId,
            apiKey
        ];
    } else // searchClient v3
    return [
        searchClient.applicationID,
        searchClient.apiKey
    ];
}

// We aren't using the native `Array.prototype.find` because the refactor away from Lodash is not
// published as a major version.
// Relying on the `find` polyfill on user-land, which before was only required for niche use-cases,
// was decided as too risky.
// @MAJOR Replace with the native `Array.prototype.find` method
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
function $1578b04778e26176$export$71aa6c912b956294(items, predicate) {
    var value;
    for(var i = 0; i < items.length; i++){
        value = items[i];
        // inlined for performance: if (Call(predicate, thisArg, [value, i, list])) {
        if (predicate(value, i, items)) return value;
    }
    return undefined;
}


function $d77a7765e55fda26$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d77a7765e55fda26$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d77a7765e55fda26$var$_typeof(obj);
}
function $d77a7765e55fda26$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d77a7765e55fda26$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d77a7765e55fda26$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d77a7765e55fda26$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d77a7765e55fda26$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d77a7765e55fda26$var$_defineProperty(obj, key, value) {
    key = $d77a7765e55fda26$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d77a7765e55fda26$var$_toPropertyKey(arg) {
    var key = $d77a7765e55fda26$var$_toPrimitive(arg, "string");
    return $d77a7765e55fda26$var$_typeof(key) === "symbol" ? key : String(key);
}
function $d77a7765e55fda26$var$_toPrimitive(input, hint) {
    if ($d77a7765e55fda26$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($d77a7765e55fda26$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $d77a7765e55fda26$var$_slicedToArray(arr, i) {
    return $d77a7765e55fda26$var$_arrayWithHoles(arr) || $d77a7765e55fda26$var$_iterableToArrayLimit(arr, i) || $d77a7765e55fda26$var$_unsupportedIterableToArray(arr, i) || $d77a7765e55fda26$var$_nonIterableRest();
}
function $d77a7765e55fda26$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d77a7765e55fda26$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $d77a7765e55fda26$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $d77a7765e55fda26$var$_toConsumableArray(arr) {
    return $d77a7765e55fda26$var$_arrayWithoutHoles(arr) || $d77a7765e55fda26$var$_iterableToArray(arr) || $d77a7765e55fda26$var$_unsupportedIterableToArray(arr) || $d77a7765e55fda26$var$_nonIterableSpread();
}
function $d77a7765e55fda26$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d77a7765e55fda26$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d77a7765e55fda26$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d77a7765e55fda26$var$_arrayLikeToArray(o, minLen);
}
function $d77a7765e55fda26$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $d77a7765e55fda26$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $d77a7765e55fda26$var$_arrayLikeToArray(arr);
}
function $d77a7765e55fda26$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $d77a7765e55fda26$var$ALGOLIA_INSIGHTS_VERSION = "2.13.0";
var $d77a7765e55fda26$var$ALGOLIA_INSIGHTS_SRC = "https://cdn.jsdelivr.net/npm/search-insights@".concat($d77a7765e55fda26$var$ALGOLIA_INSIGHTS_VERSION, "/dist/search-insights.min.js");
function $d77a7765e55fda26$export$91e0bf09562e2c44() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _insightsClient = props.insightsClient, insightsInitParams = props.insightsInitParams, onEvent = props.onEvent, _props$$$internal = props.$$internal, $$internal = _props$$$internal === void 0 ? false : _props$$$internal, _props$$$automatic = props.$$automatic, $$automatic = _props$$$automatic === void 0 ? false : _props$$$automatic;
    var potentialInsightsClient = _insightsClient;
    if (!_insightsClient && _insightsClient !== null) (0, $f5ad79b5c8be60f0$export$39f19eed34acd2f1)(function(_ref) {
        var window = _ref.window;
        var pointer = window.AlgoliaAnalyticsObject || "aa";
        if (typeof pointer === "string") potentialInsightsClient = window[pointer];
        if (!potentialInsightsClient) {
            window.AlgoliaAnalyticsObject = pointer;
            if (!window[pointer]) {
                window[pointer] = function() {
                    if (!window[pointer].queue) window[pointer].queue = [];
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    window[pointer].queue.push(args);
                };
                window[pointer].version = $d77a7765e55fda26$var$ALGOLIA_INSIGHTS_VERSION;
                window[pointer].shouldAddScript = true;
            }
            potentialInsightsClient = window[pointer];
        }
    });
    // if still no insightsClient was found, we use a noop
    var insightsClient = potentialInsightsClient || (0, $5d3ef3e388d952bb$export$8793edee2d425525);
    return function(_ref2) {
        var instantSearchInstance = _ref2.instantSearchInstance;
        // remove existing default insights middleware
        // user-provided insights middleware takes precedence
        var existingInsightsMiddlewares = instantSearchInstance.middleware.filter(function(m) {
            return m.instance.$$type === "ais.insights" && m.instance.$$internal;
        }).map(function(m) {
            return m.creator;
        });
        instantSearchInstance.unuse.apply(instantSearchInstance, $d77a7765e55fda26$var$_toConsumableArray(existingInsightsMiddlewares));
        var _getAppIdAndApiKey = (0, $e6076fe21a599f0b$export$58f35ab8a1251bc0)(instantSearchInstance.client), _getAppIdAndApiKey2 = $d77a7765e55fda26$var$_slicedToArray(_getAppIdAndApiKey, 2), appId = _getAppIdAndApiKey2[0], apiKey = _getAppIdAndApiKey2[1];
        var queuedUserToken = undefined;
        var queuedAuthenticatedUserToken = undefined;
        var userTokenBeforeInit = undefined;
        var authenticatedUserTokenBeforeInit = undefined;
        var queue = insightsClient.queue;
        if (Array.isArray(queue)) {
            // Context: The umd build of search-insights is asynchronously loaded by the snippet.
            //
            // When user calls `aa('setUserToken', 'my-user-token')` before `search-insights` is loaded,
            // ['setUserToken', 'my-user-token'] gets stored in `aa.queue`.
            // Whenever `search-insights` is finally loaded, it will process the queue.
            //
            // But here's the reason why we handle it here:
            // At this point, even though `search-insights` is not loaded yet,
            // we still want to read the token from the queue.
            // Otherwise, the first search call will be fired without the token.
            var _map = [
                "setUserToken",
                "setAuthenticatedUserToken"
            ].map(function(key) {
                var _ref3 = (0, $1578b04778e26176$export$71aa6c912b956294)(queue.slice().reverse(), function(_ref5) {
                    var _ref6 = $d77a7765e55fda26$var$_slicedToArray(_ref5, 1), method = _ref6[0];
                    return method === key;
                }) || [], _ref4 = $d77a7765e55fda26$var$_slicedToArray(_ref3, 2), value = _ref4[1];
                return value;
            });
            var _map2 = $d77a7765e55fda26$var$_slicedToArray(_map, 2);
            queuedUserToken = _map2[0];
            queuedAuthenticatedUserToken = _map2[1];
        }
        // If user called `aa('setUserToken')` or `aa('setAuthenticatedUserToken')`
        // before creating the Insights middleware, we temporarily store the token
        // and set it later on.
        //
        // Otherwise, the `init` call might override them with anonymous user token.
        insightsClient("getUserToken", null, function(_error, userToken) {
            userTokenBeforeInit = $d77a7765e55fda26$var$normalizeUserToken(userToken);
        });
        insightsClient("getAuthenticatedUserToken", null, function(_error, userToken) {
            authenticatedUserTokenBeforeInit = $d77a7765e55fda26$var$normalizeUserToken(userToken);
        });
        // Only `init` if the `insightsInitParams` option is passed or
        // if the `insightsClient` version doesn't supports optional `init` calling.
        if (insightsInitParams || !$d77a7765e55fda26$var$isModernInsightsClient(insightsClient)) insightsClient("init", $d77a7765e55fda26$var$_objectSpread({
            appId: appId,
            apiKey: apiKey,
            partial: true
        }, insightsInitParams));
        var initialParameters;
        var helper;
        return {
            $$type: "ais.insights",
            $$internal: $$internal,
            $$automatic: $$automatic,
            onStateChange: function onStateChange() {},
            subscribe: function subscribe() {
                if (!insightsClient.shouldAddScript) return;
                var errorMessage = "[insights middleware]: could not load search-insights.js. Please load it manually following https://alg.li/insights-init";
                try {
                    var script = document.createElement("script");
                    script.async = true;
                    script.src = $d77a7765e55fda26$var$ALGOLIA_INSIGHTS_SRC;
                    script.onerror = function() {
                        instantSearchInstance.emit("error", new Error(errorMessage));
                    };
                    document.body.appendChild(script);
                    insightsClient.shouldAddScript = false;
                } catch (cause) {
                    insightsClient.shouldAddScript = false;
                    instantSearchInstance.emit("error", new Error(errorMessage));
                }
            },
            started: function started() {
                insightsClient("addAlgoliaAgent", "insights-middleware");
                helper = instantSearchInstance.mainHelper;
                initialParameters = {
                    userToken: helper.state.userToken,
                    clickAnalytics: helper.state.clickAnalytics
                };
                // We don't want to force clickAnalytics when the insights is enabled from the search response.
                // This means we don't enable insights for indices that don't opt in
                if (!$$automatic) helper.overrideStateWithoutTriggeringChangeEvent($d77a7765e55fda26$var$_objectSpread($d77a7765e55fda26$var$_objectSpread({}, helper.state), {}, {
                    clickAnalytics: true
                }));
                if (!$$internal) instantSearchInstance.scheduleSearch();
                var setUserTokenToSearch = function setUserTokenToSearch(userToken) {
                    var immediate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                    var normalizedUserToken = $d77a7765e55fda26$var$normalizeUserToken(userToken);
                    if (!normalizedUserToken) return;
                    var existingToken = helper.state.userToken;
                    function applyToken() {
                        helper.overrideStateWithoutTriggeringChangeEvent($d77a7765e55fda26$var$_objectSpread($d77a7765e55fda26$var$_objectSpread({}, helper.state), {}, {
                            userToken: normalizedUserToken
                        }));
                        if (existingToken && existingToken !== userToken) instantSearchInstance.scheduleSearch();
                    }
                    // Delay the token application to the next render cycle
                    if (!immediate) setTimeout(applyToken, 0);
                    else applyToken();
                };
                var anonymousUserToken = (0, $45b570cdb109c464$export$61f1c6e9cd2ed687)();
                if (anonymousUserToken) // When `aa('init', { ... })` is called, it creates an anonymous user token in cookie.
                // We can set it as userToken.
                setUserTokenToSearch(anonymousUserToken, true);
                function setUserToken(token, userToken, authenticatedUserToken) {
                    setUserTokenToSearch(token, true);
                    if (userToken) insightsClient("setUserToken", userToken);
                    if (authenticatedUserToken) insightsClient("setAuthenticatedUserToken", authenticatedUserToken);
                }
                // We consider the `userToken` or `authenticatedUserToken` before an
                // `init` call of higher importance than one from the queue.
                var tokenBeforeInit = authenticatedUserTokenBeforeInit || userTokenBeforeInit;
                var queuedToken = queuedAuthenticatedUserToken || queuedUserToken;
                if (tokenBeforeInit) setUserToken(tokenBeforeInit, userTokenBeforeInit, authenticatedUserTokenBeforeInit);
                else if (queuedToken) setUserToken(queuedToken, queuedUserToken, queuedAuthenticatedUserToken);
                // This updates userToken which is set explicitly by `aa('setUserToken', userToken)`
                insightsClient("onUserTokenChange", setUserTokenToSearch, {
                    immediate: true
                });
                // This updates userToken which is set explicitly by `aa('setAuthenticatedtUserToken', authenticatedUserToken)`
                insightsClient("onAuthenticatedUserTokenChange", function(authenticatedUserToken) {
                    // If we're unsetting the `authenticatedUserToken`, we revert to the `userToken`
                    if (!authenticatedUserToken) insightsClient("getUserToken", null, function(_, userToken) {
                        setUserTokenToSearch(userToken);
                    });
                    setUserTokenToSearch(authenticatedUserToken);
                }, {
                    immediate: true
                });
                var insightsClientWithLocalCredentials = insightsClient;
                if ($d77a7765e55fda26$var$isModernInsightsClient(insightsClient)) insightsClientWithLocalCredentials = function insightsClientWithLocalCredentials(method, payload) {
                    var extraParams = {
                        headers: {
                            "X-Algolia-Application-Id": appId,
                            "X-Algolia-API-Key": apiKey
                        }
                    };
                    // @ts-ignore we are calling this only when we know that the client actually is correct
                    return insightsClient(method, payload, extraParams);
                };
                instantSearchInstance.sendEventToInsights = function(event) {
                    if (onEvent) onEvent(event, insightsClientWithLocalCredentials);
                    else if (event.insightsMethod) {
                        // Source is used to differentiate events sent by instantsearch from those sent manually.
                        event.payload.algoliaSource = [
                            "instantsearch"
                        ];
                        if ($$automatic) event.payload.algoliaSource.push("instantsearch-automatic");
                        if (event.eventModifier === "internal") event.payload.algoliaSource.push("instantsearch-internal");
                        insightsClientWithLocalCredentials(event.insightsMethod, event.payload);
                    }
                };
            },
            unsubscribe: function unsubscribe() {
                insightsClient("onUserTokenChange", undefined);
                insightsClient("onAuthenticatedUserTokenChange", undefined);
                instantSearchInstance.sendEventToInsights = (0, $5d3ef3e388d952bb$export$8793edee2d425525);
                if (helper && initialParameters) {
                    helper.overrideStateWithoutTriggeringChangeEvent($d77a7765e55fda26$var$_objectSpread($d77a7765e55fda26$var$_objectSpread({}, helper.state), initialParameters));
                    instantSearchInstance.scheduleSearch();
                }
            }
        };
    };
}
/**
 * Determines if a given insights `client` supports the optional call to `init`
 * and the ability to set credentials via extra parameters when sending events.
 */ function $d77a7765e55fda26$var$isModernInsightsClient(client) {
    var _split$map = (client.version || "").split(".").map(Number), _split$map2 = $d77a7765e55fda26$var$_slicedToArray(_split$map, 2), major = _split$map2[0], minor = _split$map2[1];
    /* eslint-disable @typescript-eslint/naming-convention */ var v3 = major >= 3;
    var v2_6 = major === 2 && minor >= 6;
    var v1_10 = major === 1 && minor >= 10;
    /* eslint-enable @typescript-eslint/naming-convention */ return v3 || v2_6 || v1_10;
}
/**
 * While `search-insights` supports both string and number user tokens,
 * the Search API only accepts strings. This function normalizes the user token.
 */ function $d77a7765e55fda26$var$normalizeUserToken(userToken) {
    if (!userToken) return undefined;
    return typeof userToken === "number" ? userToken.toString() : userToken;
}


function $d41d5bee699468f4$export$dbf1227de6c1fbc6(instantSearchInstance, parent, uiState) {
    var helper = parent.getHelper();
    return {
        uiState: uiState,
        helper: helper,
        parent: parent,
        instantSearchInstance: instantSearchInstance,
        state: helper.state,
        renderState: instantSearchInstance.renderState,
        templatesConfig: instantSearchInstance.templatesConfig,
        createURL: parent.createURL,
        scopedResults: [],
        searchMetadata: {
            isSearchStalled: instantSearchInstance.status === "stalled"
        },
        status: instantSearchInstance.status,
        error: instantSearchInstance.error
    };
}
function $d41d5bee699468f4$export$c3ba97e79c76dd38(instantSearchInstance, parent) {
    var results = parent.getResults();
    var helper = parent.getHelper();
    return {
        helper: helper,
        parent: parent,
        instantSearchInstance: instantSearchInstance,
        results: results,
        scopedResults: parent.getScopedResults(),
        state: results ? results._state : helper.state,
        renderState: instantSearchInstance.renderState,
        templatesConfig: instantSearchInstance.templatesConfig,
        createURL: parent.createURL,
        searchMetadata: {
            isSearchStalled: instantSearchInstance.status === "stalled"
        },
        status: instantSearchInstance.status,
        error: instantSearchInstance.error
    };
}


function $2f4436411f662738$var$extractWidgetPayload(widgets, instantSearchInstance, payload) {
    var initOptions = (0, $d41d5bee699468f4$export$dbf1227de6c1fbc6)(instantSearchInstance, instantSearchInstance.mainIndex, instantSearchInstance._initialUiState);
    widgets.forEach(function(widget) {
        var widgetParams = {};
        if (widget.getWidgetRenderState) {
            var renderState = widget.getWidgetRenderState(initOptions);
            if (renderState && renderState.widgetParams) // casting, as we just earlier checked widgetParams exists, and thus an object
            widgetParams = renderState.widgetParams;
        }
        // since we destructure in all widgets, the parameters with defaults are set to "undefined"
        var params = Object.keys(widgetParams).filter(function(key) {
            return widgetParams[key] !== undefined;
        });
        payload.widgets.push({
            type: widget.$$type,
            widgetType: widget.$$widgetType,
            params: params
        });
        if (widget.$$type === "ais.index") $2f4436411f662738$var$extractWidgetPayload(widget.getWidgets(), instantSearchInstance, payload);
    });
}
function $2f4436411f662738$export$4b4254890acf93e7() {
    return (0, $f5ad79b5c8be60f0$export$39f19eed34acd2f1)(function(_ref) {
        var _window$navigator, _window$navigator$use;
        var window = _ref.window;
        return ((_window$navigator = window.navigator) === null || _window$navigator === void 0 ? void 0 : (_window$navigator$use = _window$navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.indexOf("Algolia Crawler")) > -1;
    }, {
        fallback: function fallback() {
            return false;
        }
    });
}
function $2f4436411f662738$export$8ee9d2447935ed96() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$$$internal = _ref2.$$internal, $$internal = _ref2$$$internal === void 0 ? false : _ref2$$$internal;
    return function(_ref3) {
        var instantSearchInstance = _ref3.instantSearchInstance;
        var payload = {
            widgets: []
        };
        var payloadContainer = document.createElement("meta");
        var refNode = document.querySelector("head");
        payloadContainer.name = "instantsearch:widgets";
        return {
            $$type: "ais.metadata",
            $$internal: $$internal,
            onStateChange: function onStateChange() {},
            subscribe: function subscribe() {
                // using setTimeout here to delay extraction until widgets have been added in a tick (e.g. Vue)
                setTimeout(function() {
                    var client = instantSearchInstance.client;
                    payload.ua = client.transporter && client.transporter.userAgent ? client.transporter.userAgent.value : client._ua;
                    $2f4436411f662738$var$extractWidgetPayload(instantSearchInstance.mainIndex.getWidgets(), instantSearchInstance, payload);
                    instantSearchInstance.middleware.forEach(function(middleware) {
                        return payload.widgets.push({
                            middleware: true,
                            type: middleware.instance.$$type,
                            internal: middleware.instance.$$internal
                        });
                    });
                    payloadContainer.content = JSON.stringify(payload);
                    refNode.appendChild(payloadContainer);
                }, 0);
            },
            started: function started() {},
            unsubscribe: function unsubscribe() {
                payloadContainer.remove();
            }
        };
    };
}


var $7bc6796954c5aef6$exports = {};
"use strict";
var $3e86f959b461293f$exports = {};

var $Ml1eZ = parcelRequire("Ml1eZ");
"use strict";
var $b4a00de25e4d402d$exports = {};

var $Ml1eZ = parcelRequire("Ml1eZ");
"use strict";
var $c0252427211a44d1$exports = {};
"use strict";
var $c0252427211a44d1$var$replace = String.prototype.replace;
var $c0252427211a44d1$var$percentTwenties = /%20/g;
var $c0252427211a44d1$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
$c0252427211a44d1$exports = {
    "default": $c0252427211a44d1$var$Format.RFC3986,
    formatters: {
        RFC1738: function RFC1738(value) {
            return $c0252427211a44d1$var$replace.call(value, $c0252427211a44d1$var$percentTwenties, "+");
        },
        RFC3986: function RFC3986(value) {
            return String(value);
        }
    },
    RFC1738: $c0252427211a44d1$var$Format.RFC1738,
    RFC3986: $c0252427211a44d1$var$Format.RFC3986
};


var $b4a00de25e4d402d$var$has = Object.prototype.hasOwnProperty;
var $b4a00de25e4d402d$var$isArray = Array.isArray;
var $b4a00de25e4d402d$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $b4a00de25e4d402d$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($b4a00de25e4d402d$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $b4a00de25e4d402d$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $b4a00de25e4d402d$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($b4a00de25e4d402d$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$b4a00de25e4d402d$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($b4a00de25e4d402d$var$isArray(target) && !$b4a00de25e4d402d$var$isArray(source)) mergeTarget = $b4a00de25e4d402d$var$arrayToObject(target, options);
    if ($b4a00de25e4d402d$var$isArray(target) && $b4a00de25e4d402d$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($b4a00de25e4d402d$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($b4a00de25e4d402d$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $b4a00de25e4d402d$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $b4a00de25e4d402d$var$decode = function decode(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $b4a00de25e4d402d$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if ((typeof str === "undefined" ? "undefined" : (0, $Ml1eZ._)(str)) === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
         || format === $c0252427211a44d1$exports.RFC1738 && (c === 0x28 || c === 0x29) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + $b4a00de25e4d402d$var$hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + ($b4a00de25e4d402d$var$hexTable[0xC0 | c >> 6] + $b4a00de25e4d402d$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + ($b4a00de25e4d402d$var$hexTable[0xE0 | c >> 12] + $b4a00de25e4d402d$var$hexTable[0x80 | c >> 6 & 0x3F] + $b4a00de25e4d402d$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        /* eslint operator-linebreak: [2, "before"] */ out += $b4a00de25e4d402d$var$hexTable[0xF0 | c >> 18] + $b4a00de25e4d402d$var$hexTable[0x80 | c >> 12 & 0x3F] + $b4a00de25e4d402d$var$hexTable[0x80 | c >> 6 & 0x3F] + $b4a00de25e4d402d$var$hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var $b4a00de25e4d402d$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $b4a00de25e4d402d$var$compactQueue(queue);
    return value;
};
var $b4a00de25e4d402d$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $b4a00de25e4d402d$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $b4a00de25e4d402d$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $b4a00de25e4d402d$var$maybeMap = function maybeMap(val, fn) {
    if ($b4a00de25e4d402d$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
$b4a00de25e4d402d$exports = {
    arrayToObject: $b4a00de25e4d402d$var$arrayToObject,
    assign: $b4a00de25e4d402d$var$assign,
    combine: $b4a00de25e4d402d$var$combine,
    compact: $b4a00de25e4d402d$var$compact,
    decode: $b4a00de25e4d402d$var$decode,
    encode: $b4a00de25e4d402d$var$encode,
    isBuffer: $b4a00de25e4d402d$var$isBuffer,
    isRegExp: $b4a00de25e4d402d$var$isRegExp,
    maybeMap: $b4a00de25e4d402d$var$maybeMap,
    merge: $b4a00de25e4d402d$var$merge
};



var $3e86f959b461293f$var$has = Object.prototype.hasOwnProperty;
var $3e86f959b461293f$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $3e86f959b461293f$var$isArray = Array.isArray;
var $3e86f959b461293f$var$split = String.prototype.split;
var $3e86f959b461293f$var$push = Array.prototype.push;
var $3e86f959b461293f$var$pushToArray = function pushToArray(arr, valueOrArray) {
    $3e86f959b461293f$var$push.apply(arr, $3e86f959b461293f$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $3e86f959b461293f$var$toISO = Date.prototype.toISOString;
var $3e86f959b461293f$var$defaultFormat = $c0252427211a44d1$exports.default;
var $3e86f959b461293f$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encoder: $b4a00de25e4d402d$exports.encode,
    encodeValuesOnly: false,
    format: $3e86f959b461293f$var$defaultFormat,
    formatter: $c0252427211a44d1$exports.formatters[$3e86f959b461293f$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $3e86f959b461293f$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $3e86f959b461293f$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || (typeof v === "undefined" ? "undefined" : (0, $Ml1eZ._)(v)) === "symbol" || (typeof v === "undefined" ? "undefined" : (0, $Ml1eZ._)(v)) === "bigint";
};
var $3e86f959b461293f$var$stringify = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset) {
    var obj = object;
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $3e86f959b461293f$var$isArray(obj)) obj = $b4a00de25e4d402d$exports.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $3e86f959b461293f$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($3e86f959b461293f$var$isNonNullishPrimitive(obj) || $b4a00de25e4d402d$exports.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $3e86f959b461293f$var$defaults.encoder, charset, "key", format);
            if (generateArrayPrefix === "comma" && encodeValuesOnly) {
                var valuesArray = $3e86f959b461293f$var$split.call(String(obj), ",");
                var valuesJoined = "";
                for(var i = 0; i < valuesArray.length; ++i)valuesJoined += (i === 0 ? "" : ",") + formatter(encoder(valuesArray[i], $3e86f959b461293f$var$defaults.encoder, charset, "value", format));
                return [
                    formatter(keyValue) + "=" + valuesJoined
                ];
            }
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $3e86f959b461293f$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $3e86f959b461293f$var$isArray(obj)) // we need to join elements in
    objKeys = [
        {
            value: obj.length > 0 ? obj.join(",") || null : void 0
        }
    ];
    else if ($3e86f959b461293f$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var keyPrefix = $3e86f959b461293f$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(prefix, key) : prefix : prefix + (allowDots ? "." + key : "[" + key + "]");
        $3e86f959b461293f$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset));
    }
    return values;
};
var $3e86f959b461293f$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $3e86f959b461293f$var$defaults;
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $3e86f959b461293f$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $c0252427211a44d1$exports.default;
    if (typeof opts.format !== "undefined") {
        if (!$3e86f959b461293f$var$has.call($c0252427211a44d1$exports.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $c0252427211a44d1$exports.formatters[format];
    var filter = $3e86f959b461293f$var$defaults.filter;
    if (typeof opts.filter === "function" || $3e86f959b461293f$var$isArray(opts.filter)) filter = opts.filter;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $3e86f959b461293f$var$defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === "undefined" ? $3e86f959b461293f$var$defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $3e86f959b461293f$var$defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === "undefined" ? $3e86f959b461293f$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $3e86f959b461293f$var$defaults.encode,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $3e86f959b461293f$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $3e86f959b461293f$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $3e86f959b461293f$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $3e86f959b461293f$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $3e86f959b461293f$var$defaults.strictNullHandling
    };
};
$3e86f959b461293f$exports = function(object, opts) {
    var obj = object;
    var options = $3e86f959b461293f$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($3e86f959b461293f$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var arrayFormat;
    if (opts && opts.arrayFormat in $3e86f959b461293f$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if (opts && "indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = "indices";
    var generateArrayPrefix = $3e86f959b461293f$var$arrayPrefixGenerators[arrayFormat];
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $3e86f959b461293f$var$pushToArray(keys, $3e86f959b461293f$var$stringify(obj[key], key, generateArrayPrefix, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};


var $e95dda4abd33cf1d$exports = {};
"use strict";

var $e95dda4abd33cf1d$var$has = Object.prototype.hasOwnProperty;
var $e95dda4abd33cf1d$var$isArray = Array.isArray;
var $e95dda4abd33cf1d$var$defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decoder: $b4a00de25e4d402d$exports.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $e95dda4abd33cf1d$var$interpretNumericEntities = function interpretNumericEntities(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $e95dda4abd33cf1d$var$parseArrayValue = function parseArrayValue(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $e95dda4abd33cf1d$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $e95dda4abd33cf1d$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $e95dda4abd33cf1d$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $e95dda4abd33cf1d$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $e95dda4abd33cf1d$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $e95dda4abd33cf1d$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $e95dda4abd33cf1d$var$defaults.decoder, charset, "key");
            val = $b4a00de25e4d402d$exports.maybeMap($e95dda4abd33cf1d$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $e95dda4abd33cf1d$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $e95dda4abd33cf1d$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $e95dda4abd33cf1d$var$isArray(val) ? [
            val
        ] : val;
        if ($e95dda4abd33cf1d$var$has.call(obj, key)) obj[key] = $b4a00de25e4d402d$exports.combine(obj[key], val);
        else obj[key] = val;
    }
    return obj;
};
var $e95dda4abd33cf1d$var$parseObject = function parseObject(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $e95dda4abd33cf1d$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== "__proto__") obj[cleanRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $e95dda4abd33cf1d$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $e95dda4abd33cf1d$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $e95dda4abd33cf1d$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return $e95dda4abd33cf1d$var$parseObject(keys, val, options, valuesParsed);
};
var $e95dda4abd33cf1d$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $e95dda4abd33cf1d$var$defaults;
    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $e95dda4abd33cf1d$var$defaults.charset : opts.charset;
    return {
        allowDots: typeof opts.allowDots === "undefined" ? $e95dda4abd33cf1d$var$defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $e95dda4abd33cf1d$var$defaults.allowPrototypes,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $e95dda4abd33cf1d$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $e95dda4abd33cf1d$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $e95dda4abd33cf1d$var$defaults.comma,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $e95dda4abd33cf1d$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $b4a00de25e4d402d$exports.isRegExp(opts.delimiter) ? opts.delimiter : $e95dda4abd33cf1d$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $e95dda4abd33cf1d$var$defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $e95dda4abd33cf1d$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $e95dda4abd33cf1d$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $e95dda4abd33cf1d$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $e95dda4abd33cf1d$var$defaults.strictNullHandling
    };
};
$e95dda4abd33cf1d$exports = function(str, opts) {
    var options = $e95dda4abd33cf1d$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $e95dda4abd33cf1d$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $e95dda4abd33cf1d$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $b4a00de25e4d402d$exports.merge(obj, newObj, options);
    }
    return $b4a00de25e4d402d$exports.compact(obj);
};



$7bc6796954c5aef6$exports = {
    formats: $c0252427211a44d1$exports,
    parse: $e95dda4abd33cf1d$exports,
    stringify: $3e86f959b461293f$exports
};



function $5d8d125229bfd881$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $5d8d125229bfd881$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $5d8d125229bfd881$var$_typeof(obj);
}
function $5d8d125229bfd881$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5d8d125229bfd881$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $5d8d125229bfd881$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $5d8d125229bfd881$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5d8d125229bfd881$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5d8d125229bfd881$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $5d8d125229bfd881$var$_defineProperty(obj, key, value) {
    key = $5d8d125229bfd881$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5d8d125229bfd881$var$_toPropertyKey(arg) {
    var key = $5d8d125229bfd881$var$_toPrimitive(arg, "string");
    return $5d8d125229bfd881$var$_typeof(key) === "symbol" ? key : String(key);
}
function $5d8d125229bfd881$var$_toPrimitive(input, hint) {
    if ($5d8d125229bfd881$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($5d8d125229bfd881$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $5d8d125229bfd881$var$setWindowTitle = function setWindowTitle(title) {
    if (title) // This function is only executed on browsers so we can disable this check.
    // eslint-disable-next-line no-restricted-globals
    window.document.title = title;
};
var $5d8d125229bfd881$var$BrowserHistory = /*#__PURE__*/ function() {
    /**
   * Initializes a new storage provider that syncs the search state to the URL
   * using web APIs (`window.location.pushState` and `onpopstate` event).
   */ function BrowserHistory(_ref) {
        var _this = this;
        var windowTitle = _ref.windowTitle, _ref$writeDelay = _ref.writeDelay, writeDelay = _ref$writeDelay === void 0 ? 400 : _ref$writeDelay, createURL = _ref.createURL, parseURL = _ref.parseURL, getLocation = _ref.getLocation, start = _ref.start, dispose = _ref.dispose, push = _ref.push, cleanUrlOnDispose = _ref.cleanUrlOnDispose;
        $5d8d125229bfd881$var$_classCallCheck(this, BrowserHistory);
        $5d8d125229bfd881$var$_defineProperty(this, "$$type", "ais.browser");
        /**
     * Transforms a UI state into a title for the page.
     */ $5d8d125229bfd881$var$_defineProperty(this, "windowTitle", void 0);
        /**
     * Time in milliseconds before performing a write in the history.
     * It prevents from adding too many entries in the history and
     * makes the back button more usable.
     *
     * @default 400
     */ $5d8d125229bfd881$var$_defineProperty(this, "writeDelay", void 0);
        /**
     * Creates a full URL based on the route state.
     * The storage adaptor maps all syncable keys to the query string of the URL.
     */ $5d8d125229bfd881$var$_defineProperty(this, "_createURL", void 0);
        /**
     * Parses the URL into a route state.
     * It should be symmetrical to `createURL`.
     */ $5d8d125229bfd881$var$_defineProperty(this, "parseURL", void 0);
        /**
     * Returns the location to store in the history.
     * @default () => window.location
     */ $5d8d125229bfd881$var$_defineProperty(this, "getLocation", void 0);
        $5d8d125229bfd881$var$_defineProperty(this, "writeTimer", void 0);
        $5d8d125229bfd881$var$_defineProperty(this, "_onPopState", void 0);
        /**
     * Indicates if last action was back/forward in the browser.
     */ $5d8d125229bfd881$var$_defineProperty(this, "inPopState", false);
        /**
     * Indicates whether the history router is disposed or not.
     */ $5d8d125229bfd881$var$_defineProperty(this, "isDisposed", false);
        /**
     * Indicates the window.history.length before the last call to
     * window.history.pushState (called in `write`).
     * It allows to determine if a `pushState` has been triggered elsewhere,
     * and thus to prevent the `write` method from calling `pushState`.
     */ $5d8d125229bfd881$var$_defineProperty(this, "latestAcknowledgedHistory", 0);
        $5d8d125229bfd881$var$_defineProperty(this, "_start", void 0);
        $5d8d125229bfd881$var$_defineProperty(this, "_dispose", void 0);
        $5d8d125229bfd881$var$_defineProperty(this, "_push", void 0);
        $5d8d125229bfd881$var$_defineProperty(this, "_cleanUrlOnDispose", void 0);
        this.windowTitle = windowTitle;
        this.writeTimer = undefined;
        this.writeDelay = writeDelay;
        this._createURL = createURL;
        this.parseURL = parseURL;
        this.getLocation = getLocation;
        this._start = start;
        this._dispose = dispose;
        this._push = push;
        this._cleanUrlOnDispose = typeof cleanUrlOnDispose === "undefined" ? true : cleanUrlOnDispose;
        (0, $f5ad79b5c8be60f0$export$39f19eed34acd2f1)(function(_ref2) {
            var window1 = _ref2.window;
            var title = _this.windowTitle && _this.windowTitle(_this.read());
            $5d8d125229bfd881$var$setWindowTitle(title);
            _this.latestAcknowledgedHistory = window1.history.length;
        });
    }
    /**
   * Reads the URL and returns a syncable UI search state.
   */ $5d8d125229bfd881$var$_createClass(BrowserHistory, [
        {
            key: "read",
            value: function read() {
                return this.parseURL({
                    qsModule: (0, (/*@__PURE__*/$parcel$interopDefault($7bc6796954c5aef6$exports))),
                    location: this.getLocation()
                });
            }
        },
        {
            key: "write",
            value: function write(routeState) {
                var _this2 = this;
                (0, $f5ad79b5c8be60f0$export$39f19eed34acd2f1)(function(_ref3) {
                    var window1 = _ref3.window;
                    var url = _this2.createURL(routeState);
                    var title = _this2.windowTitle && _this2.windowTitle(routeState);
                    if (_this2.writeTimer) clearTimeout(_this2.writeTimer);
                    _this2.writeTimer = setTimeout(function() {
                        $5d8d125229bfd881$var$setWindowTitle(title);
                        if (_this2.shouldWrite(url)) {
                            if (_this2._push) _this2._push(url);
                            else window1.history.pushState(routeState, title || "", url);
                            _this2.latestAcknowledgedHistory = window1.history.length;
                        }
                        _this2.inPopState = false;
                        _this2.writeTimer = undefined;
                    }, _this2.writeDelay);
                });
            }
        },
        {
            key: "onUpdate",
            value: function onUpdate(callback) {
                var _this3 = this;
                if (this._start) this._start(function() {
                    callback(_this3.read());
                });
                this._onPopState = function() {
                    if (_this3.writeTimer) {
                        clearTimeout(_this3.writeTimer);
                        _this3.writeTimer = undefined;
                    }
                    _this3.inPopState = true;
                    // We always read the state from the URL because the state of the history
                    // can be incorect in some cases (e.g. using React Router).
                    callback(_this3.read());
                };
                (0, $f5ad79b5c8be60f0$export$39f19eed34acd2f1)(function(_ref4) {
                    var window1 = _ref4.window;
                    window1.addEventListener("popstate", _this3._onPopState);
                });
            }
        },
        {
            key: "createURL",
            value: function createURL(routeState) {
                var url = this._createURL({
                    qsModule: (0, (/*@__PURE__*/$parcel$interopDefault($7bc6796954c5aef6$exports))),
                    routeState: routeState,
                    location: this.getLocation()
                });
                var e;
                return url;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                var _this4 = this;
                if (this._dispose) this._dispose();
                this.isDisposed = true;
                (0, $f5ad79b5c8be60f0$export$39f19eed34acd2f1)(function(_ref5) {
                    var window1 = _ref5.window;
                    if (_this4._onPopState) window1.removeEventListener("popstate", _this4._onPopState);
                });
                if (this.writeTimer) clearTimeout(this.writeTimer);
                if (this._cleanUrlOnDispose) this.write({});
            }
        },
        {
            key: "start",
            value: function start() {
                this.isDisposed = false;
            }
        },
        {
            key: "shouldWrite",
            value: function shouldWrite(url) {
                var _this5 = this;
                return (0, $f5ad79b5c8be60f0$export$39f19eed34acd2f1)(function(_ref6) {
                    var window1 = _ref6.window;
                    // We do want to `pushState` if:
                    // - the router is not disposed, IS.js needs to update the URL
                    // OR
                    // - the last write was from InstantSearch.js
                    // (unlike a SPA, where it would have last written)
                    var lastPushWasByISAfterDispose = !(_this5.isDisposed && _this5.latestAcknowledgedHistory !== window1.history.length);
                    return(// When the last state change was through popstate, the IS.js state changes,
                    // but that should not write the URL.
                    !_this5.inPopState && // When the previous pushState after dispose was by IS.js, we want to write the URL.
                    lastPushWasByISAfterDispose && // When the URL is the same as the current one, we do not want to write it.
                    url !== window1.location.href);
                });
            }
        }
    ]);
    return BrowserHistory;
}();
function $5d8d125229bfd881$export$2e2bcd8739ae039() {
    var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref7$createURL = _ref7.createURL, createURL = _ref7$createURL === void 0 ? function createURL(_ref8) {
        var qsModule = _ref8.qsModule, routeState = _ref8.routeState, location = _ref8.location;
        var protocol = location.protocol, hostname = location.hostname, _location$port = location.port, port = _location$port === void 0 ? "" : _location$port, pathname = location.pathname, hash = location.hash;
        var queryString = qsModule.stringify(routeState);
        var portWithPrefix = port === "" ? "" : ":".concat(port);
        // IE <= 11 has no proper `location.origin` so we cannot rely on it.
        if (!queryString) return "".concat(protocol, "//").concat(hostname).concat(portWithPrefix).concat(pathname).concat(hash);
        return "".concat(protocol, "//").concat(hostname).concat(portWithPrefix).concat(pathname, "?").concat(queryString).concat(hash);
    } : _ref7$createURL, _ref7$parseURL = _ref7.parseURL, parseURL = _ref7$parseURL === void 0 ? function parseURL(_ref9) {
        var qsModule = _ref9.qsModule, location = _ref9.location;
        // `qs` by default converts arrays with more than 20 items to an object.
        // We want to avoid this because the data structure manipulated can therefore vary.
        // Setting the limit to `100` seems a good number because the engine's default is 100
        // (it can go up to 1000 but it is very unlikely to select more than 100 items in the UI).
        //
        // Using an `arrayLimit` of `n` allows `n + 1` items.
        //
        // See:
        //   - https://github.com/ljharb/qs#parsing-arrays
        //   - https://www.algolia.com/doc/api-reference/api-parameters/maxValuesPerFacet/
        return qsModule.parse(location.search.slice(1), {
            arrayLimit: 99
        });
    } : _ref7$parseURL, _ref7$writeDelay = _ref7.writeDelay, writeDelay = _ref7$writeDelay === void 0 ? 400 : _ref7$writeDelay, windowTitle = _ref7.windowTitle, _ref7$getLocation = _ref7.getLocation, getLocation = _ref7$getLocation === void 0 ? function getLocation() {
        return (0, $f5ad79b5c8be60f0$export$39f19eed34acd2f1)(function(_ref10) {
            var window1 = _ref10.window;
            return window1.location;
        }, {
            fallback: function fallback() {
                throw new Error("You need to provide `getLocation` to the `history` router in environments where `window` does not exist.");
            }
        });
    } : _ref7$getLocation, start = _ref7.start, dispose = _ref7.dispose, push = _ref7.push, cleanUrlOnDispose = _ref7.cleanUrlOnDispose;
    return new $5d8d125229bfd881$var$BrowserHistory({
        createURL: createURL,
        parseURL: parseURL,
        writeDelay: writeDelay,
        windowTitle: windowTitle,
        getLocation: getLocation,
        start: start,
        dispose: dispose,
        push: push,
        cleanUrlOnDispose: cleanUrlOnDispose
    });
}


function $1e832b89437cfe1e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1e832b89437cfe1e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1e832b89437cfe1e$var$_typeof(obj);
}
var $1e832b89437cfe1e$var$_excluded = [
    "configure"
];
function $1e832b89437cfe1e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1e832b89437cfe1e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1e832b89437cfe1e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1e832b89437cfe1e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1e832b89437cfe1e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1e832b89437cfe1e$var$_defineProperty(obj, key, value) {
    key = $1e832b89437cfe1e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1e832b89437cfe1e$var$_toPropertyKey(arg) {
    var key = $1e832b89437cfe1e$var$_toPrimitive(arg, "string");
    return $1e832b89437cfe1e$var$_typeof(key) === "symbol" ? key : String(key);
}
function $1e832b89437cfe1e$var$_toPrimitive(input, hint) {
    if ($1e832b89437cfe1e$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($1e832b89437cfe1e$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $1e832b89437cfe1e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1e832b89437cfe1e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1e832b89437cfe1e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $1e832b89437cfe1e$var$getIndexStateWithoutConfigure(uiState) {
    var configure = uiState.configure, trackedUiState = $1e832b89437cfe1e$var$_objectWithoutProperties(uiState, $1e832b89437cfe1e$var$_excluded);
    return trackedUiState;
}
function $1e832b89437cfe1e$export$2e2bcd8739ae039() {
    return {
        $$type: "ais.simple",
        stateToRoute: function stateToRoute(uiState) {
            return Object.keys(uiState).reduce(function(state, indexId) {
                return $1e832b89437cfe1e$var$_objectSpread($1e832b89437cfe1e$var$_objectSpread({}, state), {}, $1e832b89437cfe1e$var$_defineProperty({}, indexId, $1e832b89437cfe1e$var$getIndexStateWithoutConfigure(uiState[indexId])));
            }, {});
        },
        routeToState: function routeToState() {
            var routeState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return Object.keys(routeState).reduce(function(state, indexId) {
                return $1e832b89437cfe1e$var$_objectSpread($1e832b89437cfe1e$var$_objectSpread({}, state), {}, $1e832b89437cfe1e$var$_defineProperty({}, indexId, $1e832b89437cfe1e$var$getIndexStateWithoutConfigure(routeState[indexId])));
            }, {});
        }
    };
}


function $7082429cdf0df441$var$isPrimitive(obj) {
    return obj !== Object(obj);
}
function $7082429cdf0df441$export$248d38f6296296c5(first, second) {
    if (first === second) return true;
    if ($7082429cdf0df441$var$isPrimitive(first) || $7082429cdf0df441$var$isPrimitive(second) || typeof first === "function" || typeof second === "function") return first === second;
    if (Object.keys(first).length !== Object.keys(second).length) return false;
    // @TODO avoid for..of because of the large polyfill
    // eslint-disable-next-line no-restricted-syntax
    for(var _i = 0, _Object$keys = Object.keys(first); _i < _Object$keys.length; _i++){
        var key = _Object$keys[_i];
        if (!(key in second)) return false;
        if (!$7082429cdf0df441$export$248d38f6296296c5(first[key], second[key])) return false;
    }
    return true;
}


function $1adad19165a0c397$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1adad19165a0c397$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1adad19165a0c397$var$_typeof(obj);
}
function $1adad19165a0c397$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1adad19165a0c397$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1adad19165a0c397$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1adad19165a0c397$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1adad19165a0c397$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1adad19165a0c397$var$_defineProperty(obj, key, value) {
    key = $1adad19165a0c397$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1adad19165a0c397$var$_toPropertyKey(arg) {
    var key = $1adad19165a0c397$var$_toPrimitive(arg, "string");
    return $1adad19165a0c397$var$_typeof(key) === "symbol" ? key : String(key);
}
function $1adad19165a0c397$var$_toPrimitive(input, hint) {
    if ($1adad19165a0c397$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($1adad19165a0c397$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $1adad19165a0c397$export$1fe5128387816284 = function createRouterMiddleware() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _props$router = props.router, router = _props$router === void 0 ? (0, $5d8d125229bfd881$export$2e2bcd8739ae039)() : _props$router, _props$stateMapping = props.stateMapping, stateMapping = _props$stateMapping === void 0 ? (0, $1e832b89437cfe1e$export$2e2bcd8739ae039)() : _props$stateMapping, _props$$$internal = props.$$internal, $$internal = _props$$$internal === void 0 ? false : _props$$$internal;
    return function(_ref) {
        var instantSearchInstance = _ref.instantSearchInstance;
        function topLevelCreateURL(nextState) {
            var previousUiState = // If only the mainIndex is initialized, we don't yet know what other
            // index widgets are used. Therefore we fall back to the initialUiState.
            // We can't indiscriminately use the initialUiState because then we
            // reintroduce state that was changed by the user.
            // When there are no widgets, we are sure the user can't yet have made
            // any changes.
            instantSearchInstance.mainIndex.getWidgets().length === 0 ? instantSearchInstance._initialUiState : instantSearchInstance.mainIndex.getWidgetUiState({});
            var uiState = Object.keys(nextState).reduce(function(acc, indexId) {
                return $1adad19165a0c397$var$_objectSpread($1adad19165a0c397$var$_objectSpread({}, acc), {}, $1adad19165a0c397$var$_defineProperty({}, indexId, nextState[indexId]));
            }, previousUiState);
            var route = stateMapping.stateToRoute(uiState);
            return router.createURL(route);
        }
        // casting to UiState here to keep createURL unaware of custom UiState
        // (as long as it's an object, it's ok)
        instantSearchInstance._createURL = topLevelCreateURL;
        var lastRouteState = undefined;
        var initialUiState = instantSearchInstance._initialUiState;
        return {
            $$type: "ais.router({router:".concat(router.$$type || "__unknown__", ", stateMapping:").concat(stateMapping.$$type || "__unknown__", "})"),
            $$internal: $$internal,
            onStateChange: function onStateChange(_ref2) {
                var uiState = _ref2.uiState;
                var routeState = stateMapping.stateToRoute(uiState);
                if (lastRouteState === undefined || !(0, $7082429cdf0df441$export$248d38f6296296c5)(lastRouteState, routeState)) {
                    router.write(routeState);
                    lastRouteState = routeState;
                }
            },
            subscribe: function subscribe() {
                instantSearchInstance._initialUiState = $1adad19165a0c397$var$_objectSpread($1adad19165a0c397$var$_objectSpread({}, initialUiState), stateMapping.routeToState(router.read()));
                router.onUpdate(function(route) {
                    if (instantSearchInstance.mainIndex.getWidgets().length > 0) instantSearchInstance.setUiState(stateMapping.routeToState(route));
                });
            },
            started: function started() {
                var _router$start;
                (_router$start = router.start) === null || _router$start === void 0 || _router$start.call(router);
            },
            unsubscribe: function unsubscribe() {
                router.dispose();
            }
        };
    };
};



function $44084963839a4436$export$110679b26359d23d(_ref) {
    var name = _ref.name, _ref$connector = _ref.connector, connector = _ref$connector === void 0 ? false : _ref$connector;
    return [
        "https://www.algolia.com/doc/api-reference/widgets/",
        name,
        "/js/",
        connector ? "#connector" : ""
    ].join("");
}
function $44084963839a4436$export$2fde5bffc340821e() {
    for(var _len = arguments.length, widgets = new Array(_len), _key = 0; _key < _len; _key++)widgets[_key] = arguments[_key];
    var links = widgets.map(function(widget) {
        return $44084963839a4436$export$110679b26359d23d(widget);
    }).join(", ");
    return function(message) {
        return [
            message,
            "See documentation: ".concat(links)
        ].filter(Boolean).join("\n\n");
    };
}

function $ff005e3275c54053$export$a9c9a0d43506297d(widget) {
    return widget.$$type === "ais.index";
}

// We aren't using the native `Array.prototype.findIndex` because the refactor away from Lodash is not
// published as a major version.
// Relying on the `findIndex` polyfill on user-land, which before was only required for niche use-cases,
// was decided as too risky.
// @MAJOR Replace with the native `Array.prototype.findIndex` method
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
function $8df1059d47fbc2e7$export$de3a4d4a0d731119(array, comparator) {
    if (!Array.isArray(array)) return -1;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return i;
    }
    return -1;
}


function $e40064689b5991c9$export$f70730c3d1fc524e(array) {
    return array.filter(function(value, index, self) {
        return self.indexOf(value) === index;
    });
}


function $d7c0d1a238d975a9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d7c0d1a238d975a9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d7c0d1a238d975a9$var$_typeof(obj);
}
var $d7c0d1a238d975a9$var$_excluded = [
    "facets",
    "disjunctiveFacets",
    "facetsRefinements",
    "facetsExcludes",
    "disjunctiveFacetsRefinements",
    "numericRefinements",
    "tagRefinements",
    "hierarchicalFacets",
    "hierarchicalFacetsRefinements",
    "ruleContexts"
];
function $d7c0d1a238d975a9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d7c0d1a238d975a9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d7c0d1a238d975a9$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d7c0d1a238d975a9$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d7c0d1a238d975a9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d7c0d1a238d975a9$var$_defineProperty(obj, key, value) {
    key = $d7c0d1a238d975a9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d7c0d1a238d975a9$var$_toPropertyKey(arg) {
    var key = $d7c0d1a238d975a9$var$_toPrimitive(arg, "string");
    return $d7c0d1a238d975a9$var$_typeof(key) === "symbol" ? key : String(key);
}
function $d7c0d1a238d975a9$var$_toPrimitive(input, hint) {
    if ($d7c0d1a238d975a9$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($d7c0d1a238d975a9$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $d7c0d1a238d975a9$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d7c0d1a238d975a9$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d7c0d1a238d975a9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $d7c0d1a238d975a9$var$mergeWithRest = function mergeWithRest(left, right) {
    var facets = right.facets, disjunctiveFacets = right.disjunctiveFacets, facetsRefinements = right.facetsRefinements, facetsExcludes = right.facetsExcludes, disjunctiveFacetsRefinements = right.disjunctiveFacetsRefinements, numericRefinements = right.numericRefinements, tagRefinements = right.tagRefinements, hierarchicalFacets = right.hierarchicalFacets, hierarchicalFacetsRefinements = right.hierarchicalFacetsRefinements, ruleContexts = right.ruleContexts, rest = $d7c0d1a238d975a9$var$_objectWithoutProperties(right, $d7c0d1a238d975a9$var$_excluded);
    return left.setQueryParameters(rest);
};
// Merge facets
var $d7c0d1a238d975a9$var$mergeFacets = function mergeFacets(left, right) {
    return right.facets.reduce(function(_, name) {
        return _.addFacet(name);
    }, left);
};
var $d7c0d1a238d975a9$var$mergeDisjunctiveFacets = function mergeDisjunctiveFacets(left, right) {
    return right.disjunctiveFacets.reduce(function(_, name) {
        return _.addDisjunctiveFacet(name);
    }, left);
};
var $d7c0d1a238d975a9$var$mergeHierarchicalFacets = function mergeHierarchicalFacets(left, right) {
    return left.setQueryParameters({
        hierarchicalFacets: right.hierarchicalFacets.reduce(function(facets, facet) {
            var index = (0, $8df1059d47fbc2e7$export$de3a4d4a0d731119)(facets, function(_) {
                return _.name === facet.name;
            });
            if (index === -1) return facets.concat(facet);
            var nextFacets = facets.slice();
            nextFacets.splice(index, 1, facet);
            return nextFacets;
        }, left.hierarchicalFacets)
    });
};
// Merge facet refinements
var $d7c0d1a238d975a9$var$mergeTagRefinements = function mergeTagRefinements(left, right) {
    return right.tagRefinements.reduce(function(_, value) {
        return _.addTagRefinement(value);
    }, left);
};
var $d7c0d1a238d975a9$var$mergeFacetRefinements = function mergeFacetRefinements(left, right) {
    return left.setQueryParameters({
        facetsRefinements: $d7c0d1a238d975a9$var$_objectSpread($d7c0d1a238d975a9$var$_objectSpread({}, left.facetsRefinements), right.facetsRefinements)
    });
};
var $d7c0d1a238d975a9$var$mergeFacetsExcludes = function mergeFacetsExcludes(left, right) {
    return left.setQueryParameters({
        facetsExcludes: $d7c0d1a238d975a9$var$_objectSpread($d7c0d1a238d975a9$var$_objectSpread({}, left.facetsExcludes), right.facetsExcludes)
    });
};
var $d7c0d1a238d975a9$var$mergeDisjunctiveFacetsRefinements = function mergeDisjunctiveFacetsRefinements(left, right) {
    return left.setQueryParameters({
        disjunctiveFacetsRefinements: $d7c0d1a238d975a9$var$_objectSpread($d7c0d1a238d975a9$var$_objectSpread({}, left.disjunctiveFacetsRefinements), right.disjunctiveFacetsRefinements)
    });
};
var $d7c0d1a238d975a9$var$mergeNumericRefinements = function mergeNumericRefinements(left, right) {
    return left.setQueryParameters({
        numericRefinements: $d7c0d1a238d975a9$var$_objectSpread($d7c0d1a238d975a9$var$_objectSpread({}, left.numericRefinements), right.numericRefinements)
    });
};
var $d7c0d1a238d975a9$var$mergeHierarchicalFacetsRefinements = function mergeHierarchicalFacetsRefinements(left, right) {
    return left.setQueryParameters({
        hierarchicalFacetsRefinements: $d7c0d1a238d975a9$var$_objectSpread($d7c0d1a238d975a9$var$_objectSpread({}, left.hierarchicalFacetsRefinements), right.hierarchicalFacetsRefinements)
    });
};
var $d7c0d1a238d975a9$var$mergeRuleContexts = function mergeRuleContexts(left, right) {
    var ruleContexts = (0, $e40064689b5991c9$export$f70730c3d1fc524e)([].concat(left.ruleContexts).concat(right.ruleContexts).filter(Boolean));
    if (ruleContexts.length > 0) return left.setQueryParameters({
        ruleContexts: ruleContexts
    });
    return left;
};
var $d7c0d1a238d975a9$export$8049d91f25899769 = function mergeSearchParameters() {
    for(var _len = arguments.length, parameters = new Array(_len), _key = 0; _key < _len; _key++)parameters[_key] = arguments[_key];
    return parameters.reduce(function(left, right) {
        var hierarchicalFacetsRefinementsMerged = $d7c0d1a238d975a9$var$mergeHierarchicalFacetsRefinements(left, right);
        var hierarchicalFacetsMerged = $d7c0d1a238d975a9$var$mergeHierarchicalFacets(hierarchicalFacetsRefinementsMerged, right);
        var tagRefinementsMerged = $d7c0d1a238d975a9$var$mergeTagRefinements(hierarchicalFacetsMerged, right);
        var numericRefinementsMerged = $d7c0d1a238d975a9$var$mergeNumericRefinements(tagRefinementsMerged, right);
        var disjunctiveFacetsRefinementsMerged = $d7c0d1a238d975a9$var$mergeDisjunctiveFacetsRefinements(numericRefinementsMerged, right);
        var facetsExcludesMerged = $d7c0d1a238d975a9$var$mergeFacetsExcludes(disjunctiveFacetsRefinementsMerged, right);
        var facetRefinementsMerged = $d7c0d1a238d975a9$var$mergeFacetRefinements(facetsExcludesMerged, right);
        var disjunctiveFacetsMerged = $d7c0d1a238d975a9$var$mergeDisjunctiveFacets(facetRefinementsMerged, right);
        var ruleContextsMerged = $d7c0d1a238d975a9$var$mergeRuleContexts(disjunctiveFacetsMerged, right);
        var facetsMerged = $d7c0d1a238d975a9$var$mergeFacets(ruleContextsMerged, right);
        return $d7c0d1a238d975a9$var$mergeWithRest(facetsMerged, right);
    });
};

function $797213e2a0f490d6$export$1c33c9881dac6797(current) {
    var parent = current.getParent();
    var states = [
        current.getHelper().state
    ];
    while(parent !== null){
        states = [
            parent.getHelper().state
        ].concat(states);
        parent = parent.getParent();
    }
    return states;
}


function $d58d3e7e2b39b859$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d58d3e7e2b39b859$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d58d3e7e2b39b859$var$_typeof(obj);
}
var $d58d3e7e2b39b859$var$_excluded = [
    "initialSearchParameters"
], $d58d3e7e2b39b859$var$_excluded2 = [
    "initialRecommendParameters"
];
function $d58d3e7e2b39b859$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d58d3e7e2b39b859$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d58d3e7e2b39b859$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d58d3e7e2b39b859$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d58d3e7e2b39b859$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d58d3e7e2b39b859$var$_defineProperty(obj, key, value) {
    key = $d58d3e7e2b39b859$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d58d3e7e2b39b859$var$_toPropertyKey(arg) {
    var key = $d58d3e7e2b39b859$var$_toPrimitive(arg, "string");
    return $d58d3e7e2b39b859$var$_typeof(key) === "symbol" ? key : String(key);
}
function $d58d3e7e2b39b859$var$_toPrimitive(input, hint) {
    if ($d58d3e7e2b39b859$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($d58d3e7e2b39b859$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $d58d3e7e2b39b859$var$_toConsumableArray(arr) {
    return $d58d3e7e2b39b859$var$_arrayWithoutHoles(arr) || $d58d3e7e2b39b859$var$_iterableToArray(arr) || $d58d3e7e2b39b859$var$_unsupportedIterableToArray(arr) || $d58d3e7e2b39b859$var$_nonIterableSpread();
}
function $d58d3e7e2b39b859$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d58d3e7e2b39b859$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d58d3e7e2b39b859$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d58d3e7e2b39b859$var$_arrayLikeToArray(o, minLen);
}
function $d58d3e7e2b39b859$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $d58d3e7e2b39b859$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $d58d3e7e2b39b859$var$_arrayLikeToArray(arr);
}
function $d58d3e7e2b39b859$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d58d3e7e2b39b859$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d58d3e7e2b39b859$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d58d3e7e2b39b859$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $d58d3e7e2b39b859$var$withUsage = (0, $44084963839a4436$export$2fde5bffc340821e)({
    name: "index-widget"
});
/**
 * This is the same content as helper._change / setState, but allowing for extra
 * UiState to be synchronized.
 * see: https://github.com/algolia/algoliasearch-helper-js/blob/6b835ffd07742f2d6b314022cce6848f5cfecd4a/src/algoliasearch.helper.js#L1311-L1324
 */ function $d58d3e7e2b39b859$var$privateHelperSetState(helper, _ref) {
    var state = _ref.state, recommendState = _ref.recommendState, isPageReset = _ref.isPageReset, _uiState = _ref._uiState;
    if (state !== helper.state) {
        helper.state = state;
        helper.emit("change", {
            state: helper.state,
            results: helper.lastResults,
            isPageReset: isPageReset,
            _uiState: _uiState
        });
    }
    if (recommendState !== helper.recommendState) helper.recommendState = recommendState;
}
function $d58d3e7e2b39b859$var$getLocalWidgetsUiState(widgets, widgetStateOptions) {
    var initialUiState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return widgets.reduce(function(uiState, widget) {
        if ((0, $ff005e3275c54053$export$a9c9a0d43506297d)(widget)) return uiState;
        if (!widget.getWidgetUiState && !widget.getWidgetState) return uiState;
        if (widget.getWidgetUiState) return widget.getWidgetUiState(uiState, widgetStateOptions);
        return widget.getWidgetState(uiState, widgetStateOptions);
    }, initialUiState);
}
function $d58d3e7e2b39b859$var$getLocalWidgetsSearchParameters(widgets, widgetSearchParametersOptions) {
    var initialSearchParameters = widgetSearchParametersOptions.initialSearchParameters, rest = $d58d3e7e2b39b859$var$_objectWithoutProperties(widgetSearchParametersOptions, $d58d3e7e2b39b859$var$_excluded);
    return widgets.reduce(function(state, widget) {
        if (!widget.getWidgetSearchParameters || (0, $ff005e3275c54053$export$a9c9a0d43506297d)(widget)) return state;
        if (widget.dependsOn === "search" && widget.getWidgetParameters) return widget.getWidgetParameters(state, rest);
        return widget.getWidgetSearchParameters(state, rest);
    }, initialSearchParameters);
}
function $d58d3e7e2b39b859$var$getLocalWidgetsRecommendParameters(widgets, widgetRecommendParametersOptions) {
    var initialRecommendParameters = widgetRecommendParametersOptions.initialRecommendParameters, rest = $d58d3e7e2b39b859$var$_objectWithoutProperties(widgetRecommendParametersOptions, $d58d3e7e2b39b859$var$_excluded2);
    return widgets.reduce(function(state, widget) {
        if (!(0, $ff005e3275c54053$export$a9c9a0d43506297d)(widget) && widget.dependsOn === "recommend" && widget.getWidgetParameters) return widget.getWidgetParameters(state, rest);
        return state;
    }, initialRecommendParameters);
}
function $d58d3e7e2b39b859$var$resetPageFromWidgets(widgets) {
    var indexWidgets = widgets.filter((0, $ff005e3275c54053$export$a9c9a0d43506297d));
    if (indexWidgets.length === 0) return;
    indexWidgets.forEach(function(widget) {
        var widgetHelper = widget.getHelper();
        $d58d3e7e2b39b859$var$privateHelperSetState(widgetHelper, {
            state: widgetHelper.state.resetPage(),
            recommendState: widgetHelper.recommendState,
            isPageReset: true
        });
        $d58d3e7e2b39b859$var$resetPageFromWidgets(widget.getWidgets());
    });
}
function $d58d3e7e2b39b859$var$resolveScopedResultsFromWidgets(widgets) {
    var indexWidgets = widgets.filter((0, $ff005e3275c54053$export$a9c9a0d43506297d));
    return indexWidgets.reduce(function(scopedResults, current) {
        return scopedResults.concat.apply(scopedResults, [
            {
                indexId: current.getIndexId(),
                results: current.getResults(),
                helper: current.getHelper()
            }
        ].concat($d58d3e7e2b39b859$var$_toConsumableArray($d58d3e7e2b39b859$var$resolveScopedResultsFromWidgets(current.getWidgets()))));
    }, []);
}
var $d58d3e7e2b39b859$var$index = function index(widgetParams) {
    if (widgetParams === undefined || widgetParams.indexName === undefined) throw new Error($d58d3e7e2b39b859$var$withUsage("The `indexName` option is required."));
    var indexName = widgetParams.indexName, _widgetParams$indexId = widgetParams.indexId, indexId = _widgetParams$indexId === void 0 ? indexName : _widgetParams$indexId;
    var localWidgets = [];
    var localUiState = {};
    var localInstantSearchInstance = null;
    var localParent = null;
    var helper = null;
    var derivedHelper = null;
    var lastValidSearchParameters = null;
    return {
        $$type: "ais.index",
        $$widgetType: "ais.index",
        getIndexName: function getIndexName() {
            return indexName;
        },
        getIndexId: function getIndexId() {
            return indexId;
        },
        getHelper: function getHelper() {
            return helper;
        },
        getResults: function getResults() {
            var _derivedHelper;
            if (!((_derivedHelper = derivedHelper) !== null && _derivedHelper !== void 0 && _derivedHelper.lastResults)) return null;
            // To make the UI optimistic, we patch the state to display to the current
            // one instead of the one associated with the latest results.
            // This means user-driven UI changes (e.g., checked checkbox) are reflected
            // immediately instead of waiting for Algolia to respond, regardless of
            // the status of the network request.
            derivedHelper.lastResults._state = helper.state;
            return derivedHelper.lastResults;
        },
        getPreviousState: function getPreviousState() {
            return lastValidSearchParameters;
        },
        getScopedResults: function getScopedResults() {
            var widgetParent = this.getParent();
            // If the widget is the root, we consider itself as the only sibling.
            var widgetSiblings = widgetParent ? widgetParent.getWidgets() : [
                this
            ];
            return $d58d3e7e2b39b859$var$resolveScopedResultsFromWidgets(widgetSiblings);
        },
        getParent: function getParent() {
            return localParent;
        },
        createURL: function createURL(nextState) {
            if (typeof nextState === "function") return localInstantSearchInstance._createURL($d58d3e7e2b39b859$var$_defineProperty({}, indexId, nextState(localUiState)));
            return localInstantSearchInstance._createURL($d58d3e7e2b39b859$var$_defineProperty({}, indexId, $d58d3e7e2b39b859$var$getLocalWidgetsUiState(localWidgets, {
                searchParameters: nextState,
                helper: helper
            })));
        },
        getWidgets: function getWidgets() {
            return localWidgets;
        },
        addWidgets: function addWidgets(widgets) {
            var _this = this;
            if (!Array.isArray(widgets)) throw new Error($d58d3e7e2b39b859$var$withUsage("The `addWidgets` method expects an array of widgets."));
            if (widgets.some(function(widget) {
                return typeof widget.init !== "function" && typeof widget.render !== "function";
            })) throw new Error($d58d3e7e2b39b859$var$withUsage("The widget definition expects a `render` and/or an `init` method."));
            localWidgets = localWidgets.concat(widgets);
            if (localInstantSearchInstance && Boolean(widgets.length)) {
                $d58d3e7e2b39b859$var$privateHelperSetState(helper, {
                    state: $d58d3e7e2b39b859$var$getLocalWidgetsSearchParameters(localWidgets, {
                        uiState: localUiState,
                        initialSearchParameters: helper.state
                    }),
                    recommendState: $d58d3e7e2b39b859$var$getLocalWidgetsRecommendParameters(localWidgets, {
                        uiState: localUiState,
                        initialRecommendParameters: helper.recommendState
                    }),
                    _uiState: localUiState
                });
                // We compute the render state before calling `init` in a separate loop
                // to construct the whole render state object that is then passed to
                // `init`.
                widgets.forEach(function(widget) {
                    if (widget.getRenderState) {
                        var renderState = widget.getRenderState(localInstantSearchInstance.renderState[_this.getIndexId()] || {}, (0, $d41d5bee699468f4$export$dbf1227de6c1fbc6)(localInstantSearchInstance, _this, localInstantSearchInstance._initialUiState));
                        $d58d3e7e2b39b859$var$storeRenderState({
                            renderState: renderState,
                            instantSearchInstance: localInstantSearchInstance,
                            parent: _this
                        });
                    }
                });
                widgets.forEach(function(widget) {
                    if (widget.init) widget.init((0, $d41d5bee699468f4$export$dbf1227de6c1fbc6)(localInstantSearchInstance, _this, localInstantSearchInstance._initialUiState));
                });
                localInstantSearchInstance.scheduleSearch();
            }
            return this;
        },
        removeWidgets: function removeWidgets(widgets) {
            var _this2 = this;
            if (!Array.isArray(widgets)) throw new Error($d58d3e7e2b39b859$var$withUsage("The `removeWidgets` method expects an array of widgets."));
            if (widgets.some(function(widget) {
                return typeof widget.dispose !== "function";
            })) throw new Error($d58d3e7e2b39b859$var$withUsage("The widget definition expects a `dispose` method."));
            localWidgets = localWidgets.filter(function(widget) {
                return widgets.indexOf(widget) === -1;
            });
            if (localInstantSearchInstance && Boolean(widgets.length)) {
                var cleanedState = widgets.reduce(function(state, widget) {
                    // the `dispose` method exists at this point we already assert it
                    var next = widget.dispose({
                        helper: helper,
                        state: state,
                        parent: _this2
                    });
                    return next || state;
                }, helper.state);
                var newState = localInstantSearchInstance.future.preserveSharedStateOnUnmount ? $d58d3e7e2b39b859$var$getLocalWidgetsSearchParameters(localWidgets, {
                    uiState: localUiState,
                    initialSearchParameters: new (0, (/*@__PURE__*/$parcel$interopDefault($154f73342ab39590$exports))).SearchParameters({
                        index: this.getIndexName()
                    })
                }) : $d58d3e7e2b39b859$var$getLocalWidgetsSearchParameters(localWidgets, {
                    uiState: $d58d3e7e2b39b859$var$getLocalWidgetsUiState(localWidgets, {
                        searchParameters: cleanedState,
                        helper: helper
                    }),
                    initialSearchParameters: cleanedState
                });
                localUiState = $d58d3e7e2b39b859$var$getLocalWidgetsUiState(localWidgets, {
                    searchParameters: newState,
                    helper: helper
                });
                helper.setState(newState);
                if (localWidgets.length) localInstantSearchInstance.scheduleSearch();
            }
            return this;
        },
        init: function init(_ref2) {
            var _this3 = this, _instantSearchInstanc;
            var instantSearchInstance = _ref2.instantSearchInstance, parent = _ref2.parent, uiState = _ref2.uiState;
            if (helper !== null) // helper is already initialized, therefore we do not need to set up
            // any listeners
            return;
            localInstantSearchInstance = instantSearchInstance;
            localParent = parent;
            localUiState = uiState[indexId] || {};
            // The `mainHelper` is already defined at this point. The instance is created
            // inside InstantSearch at the `start` method, which occurs before the `init`
            // step.
            var mainHelper = instantSearchInstance.mainHelper;
            var parameters = $d58d3e7e2b39b859$var$getLocalWidgetsSearchParameters(localWidgets, {
                uiState: localUiState,
                initialSearchParameters: new (0, (/*@__PURE__*/$parcel$interopDefault($154f73342ab39590$exports))).SearchParameters({
                    index: indexName
                })
            });
            var recommendParameters = $d58d3e7e2b39b859$var$getLocalWidgetsRecommendParameters(localWidgets, {
                uiState: localUiState,
                initialRecommendParameters: new (0, (/*@__PURE__*/$parcel$interopDefault($154f73342ab39590$exports))).RecommendParameters()
            });
            // This Helper is only used for state management we do not care about the
            // `searchClient`. Only the "main" Helper created at the `InstantSearch`
            // level is aware of the client.
            helper = (0, (/*@__PURE__*/$parcel$interopDefault($154f73342ab39590$exports)))({}, parameters.index, parameters);
            helper.recommendState = recommendParameters;
            // We forward the call to `search` to the "main" instance of the Helper
            // which is responsible for managing the queries (it's the only one that is
            // aware of the `searchClient`).
            helper.search = function() {
                if (instantSearchInstance.onStateChange) {
                    instantSearchInstance.onStateChange({
                        uiState: instantSearchInstance.mainIndex.getWidgetUiState({}),
                        setUiState: function setUiState(nextState) {
                            return instantSearchInstance.setUiState(nextState, false);
                        }
                    });
                    // We don't trigger a search when controlled because it becomes the
                    // responsibility of `setUiState`.
                    return mainHelper;
                }
                return mainHelper.search();
            };
            helper.searchWithoutTriggeringOnStateChange = function() {
                return mainHelper.search();
            };
            // We use the same pattern for the `searchForFacetValues`.
            helper.searchForFacetValues = function(facetName, facetValue, maxFacetHits, userState) {
                var state = helper.state.setQueryParameters(userState);
                return mainHelper.searchForFacetValues(facetName, facetValue, maxFacetHits, state);
            };
            derivedHelper = mainHelper.derive(function() {
                return (0, $d7c0d1a238d975a9$export$8049d91f25899769).apply(void 0, [
                    mainHelper.state
                ].concat($d58d3e7e2b39b859$var$_toConsumableArray((0, $797213e2a0f490d6$export$1c33c9881dac6797)(_this3))));
            });
            var indexInitialResults = (_instantSearchInstanc = instantSearchInstance._initialResults) === null || _instantSearchInstanc === void 0 ? void 0 : _instantSearchInstanc[this.getIndexId()];
            if (indexInitialResults) {
                // We restore the shape of the results provided to the instance to respect
                // the helper's structure.
                var results = new (0, (/*@__PURE__*/$parcel$interopDefault($154f73342ab39590$exports))).SearchResults(new (0, (/*@__PURE__*/$parcel$interopDefault($154f73342ab39590$exports))).SearchParameters(indexInitialResults.state), indexInitialResults.results);
                derivedHelper.lastResults = results;
                helper.lastResults = results;
            }
            // Subscribe to the Helper state changes for the page before widgets
            // are initialized. This behavior mimics the original one of the Helper.
            // It makes sense to replicate it at the `init` step. We have another
            // listener on `change` below, once `init` is done.
            helper.on("change", function(_ref3) {
                var isPageReset = _ref3.isPageReset;
                if (isPageReset) $d58d3e7e2b39b859$var$resetPageFromWidgets(localWidgets);
            });
            derivedHelper.on("search", function() {
                // The index does not manage the "staleness" of the search. This is the
                // responsibility of the main instance. It does not make sense to manage
                // it at the index level because it's either: all of them or none of them
                // that are stalled. The queries are performed into a single network request.
                instantSearchInstance.scheduleStalledRender();
            });
            derivedHelper.on("result", function(_ref4) {
                var results = _ref4.results;
                // The index does not render the results it schedules a new render
                // to let all the other indices emit their own results. It allows us to
                // run the render process in one pass.
                instantSearchInstance.scheduleRender();
                // the derived helper is the one which actually searches, but the helper
                // which is exposed e.g. via instance.helper, doesn't search, and thus
                // does not have access to lastResults, which it used to in pre-federated
                // search behavior.
                helper.lastResults = results;
                lastValidSearchParameters = results === null || results === void 0 ? void 0 : results._state;
            });
            // We compute the render state before calling `init` in a separate loop
            // to construct the whole render state object that is then passed to
            // `init`.
            localWidgets.forEach(function(widget) {
                if (widget.getRenderState) {
                    var renderState = widget.getRenderState(instantSearchInstance.renderState[_this3.getIndexId()] || {}, (0, $d41d5bee699468f4$export$dbf1227de6c1fbc6)(instantSearchInstance, _this3, uiState));
                    $d58d3e7e2b39b859$var$storeRenderState({
                        renderState: renderState,
                        instantSearchInstance: instantSearchInstance,
                        parent: _this3
                    });
                }
            });
            localWidgets.forEach(function(widget) {
                if (widget.init) widget.init((0, $d41d5bee699468f4$export$dbf1227de6c1fbc6)(instantSearchInstance, _this3, uiState));
            });
            // Subscribe to the Helper state changes for the `uiState` once widgets
            // are initialized. Until the first render, state changes are part of the
            // configuration step. This is mainly for backward compatibility with custom
            // widgets. When the subscription happens before the `init` step, the (static)
            // configuration of the widget is pushed in the URL. That's what we want to avoid.
            // https://github.com/algolia/instantsearch/pull/994/commits/4a672ae3fd78809e213de0368549ef12e9dc9454
            helper.on("change", function(event) {
                var state = event.state;
                var _uiState = event._uiState;
                localUiState = $d58d3e7e2b39b859$var$getLocalWidgetsUiState(localWidgets, {
                    searchParameters: state,
                    helper: helper
                }, _uiState || {});
                // We don't trigger an internal change when controlled because it
                // becomes the responsibility of `setUiState`.
                if (!instantSearchInstance.onStateChange) instantSearchInstance.onInternalStateChange();
            });
            if (indexInitialResults) // If there are initial results, we're not notified of the next results
            // because we don't trigger an initial search. We therefore need to directly
            // schedule a render that will render the results injected on the helper.
            instantSearchInstance.scheduleRender();
        },
        render: function render(_ref5) {
            var _this4 = this;
            var instantSearchInstance = _ref5.instantSearchInstance;
            // we can't attach a listener to the error event of search, as the error
            // then would no longer be thrown for global handlers.
            if (instantSearchInstance.status === "error" && !instantSearchInstance.mainHelper.hasPendingRequests() && lastValidSearchParameters) helper.setState(lastValidSearchParameters);
            // We only render index widgets if there are no results.
            // This makes sure `render` is never called with `results` being `null`.
            var widgetsToRender = this.getResults() ? localWidgets : localWidgets.filter((0, $ff005e3275c54053$export$a9c9a0d43506297d));
            widgetsToRender = widgetsToRender.filter(function(widget) {
                if (!widget.shouldRender) return true;
                return widget.shouldRender({
                    instantSearchInstance: instantSearchInstance
                });
            });
            widgetsToRender.forEach(function(widget) {
                if (widget.getRenderState) {
                    var renderState = widget.getRenderState(instantSearchInstance.renderState[_this4.getIndexId()] || {}, (0, $d41d5bee699468f4$export$c3ba97e79c76dd38)(instantSearchInstance, _this4));
                    $d58d3e7e2b39b859$var$storeRenderState({
                        renderState: renderState,
                        instantSearchInstance: instantSearchInstance,
                        parent: _this4
                    });
                }
            });
            widgetsToRender.forEach(function(widget) {
                // At this point, all the variables used below are set. Both `helper`
                // and `derivedHelper` have been created at the `init` step. The attribute
                // `lastResults` might be `null` though. It's possible that a stalled render
                // happens before the result e.g with a dynamically added index the request might
                // be delayed. The render is triggered for the complete tree but some parts do
                // not have results yet.
                if (widget.render) widget.render((0, $d41d5bee699468f4$export$c3ba97e79c76dd38)(instantSearchInstance, _this4));
            });
        },
        dispose: function dispose() {
            var _this5 = this, _helper, _derivedHelper2;
            localWidgets.forEach(function(widget) {
                if (widget.dispose) // The dispose function is always called once the instance is started
                // (it's an effect of `removeWidgets`). The index is initialized and
                // the Helper is available. We don't care about the return value of
                // `dispose` because the index is removed. We can't call `removeWidgets`
                // because we want to keep the widgets on the instance, to allow idempotent
                // operations on `add` & `remove`.
                widget.dispose({
                    helper: helper,
                    state: helper.state,
                    parent: _this5
                });
            });
            localInstantSearchInstance = null;
            localParent = null;
            (_helper = helper) === null || _helper === void 0 || _helper.removeAllListeners();
            helper = null;
            (_derivedHelper2 = derivedHelper) === null || _derivedHelper2 === void 0 || _derivedHelper2.detach();
            derivedHelper = null;
        },
        getWidgetUiState: function getWidgetUiState(uiState) {
            return localWidgets.filter((0, $ff005e3275c54053$export$a9c9a0d43506297d)).reduce(function(previousUiState, innerIndex) {
                return innerIndex.getWidgetUiState(previousUiState);
            }, $d58d3e7e2b39b859$var$_objectSpread($d58d3e7e2b39b859$var$_objectSpread({}, uiState), {}, $d58d3e7e2b39b859$var$_defineProperty({}, indexId, $d58d3e7e2b39b859$var$_objectSpread($d58d3e7e2b39b859$var$_objectSpread({}, uiState[indexId]), localUiState))));
        },
        getWidgetState: function getWidgetState(uiState) {
            return this.getWidgetUiState(uiState);
        },
        getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref6) {
            var uiState = _ref6.uiState;
            return $d58d3e7e2b39b859$var$getLocalWidgetsSearchParameters(localWidgets, {
                uiState: uiState,
                initialSearchParameters: searchParameters
            });
        },
        refreshUiState: function refreshUiState() {
            localUiState = $d58d3e7e2b39b859$var$getLocalWidgetsUiState(localWidgets, {
                searchParameters: this.getHelper().state,
                helper: this.getHelper()
            }, localUiState);
        },
        setIndexUiState: function setIndexUiState(indexUiState) {
            var nextIndexUiState = typeof indexUiState === "function" ? indexUiState(localUiState) : indexUiState;
            localInstantSearchInstance.setUiState(function(state) {
                return $d58d3e7e2b39b859$var$_objectSpread($d58d3e7e2b39b859$var$_objectSpread({}, state), {}, $d58d3e7e2b39b859$var$_defineProperty({}, indexId, nextIndexUiState));
            });
        }
    };
};
var $d58d3e7e2b39b859$export$2e2bcd8739ae039 = $d58d3e7e2b39b859$var$index;
function $d58d3e7e2b39b859$var$storeRenderState(_ref7) {
    var renderState = _ref7.renderState, instantSearchInstance = _ref7.instantSearchInstance, parent = _ref7.parent;
    var parentIndexName = parent ? parent.getIndexId() : instantSearchInstance.mainIndex.getIndexId();
    instantSearchInstance.renderState = $d58d3e7e2b39b859$var$_objectSpread($d58d3e7e2b39b859$var$_objectSpread({}, instantSearchInstance.renderState), {}, $d58d3e7e2b39b859$var$_defineProperty({}, parentIndexName, $d58d3e7e2b39b859$var$_objectSpread($d58d3e7e2b39b859$var$_objectSpread({}, instantSearchInstance.renderState[parentIndexName]), renderState)));
}


var $d60c657ebeadddc2$var$NAMESPACE = "ais";
var $d60c657ebeadddc2$export$d8556a2a8f973135 = function component(componentName) {
    return function() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, descendantName = _ref.descendantName, modifierName = _ref.modifierName;
        var descendent = descendantName ? "-".concat(descendantName) : "";
        var modifier = modifierName ? "--".concat(modifierName) : "";
        return "".concat($d60c657ebeadddc2$var$NAMESPACE, "-").concat(componentName).concat(descendent).concat(modifier);
    };
};


function $ad82201011f73d65$export$d14846335956eefa(object, path) {
    var parts = Array.isArray(path) ? path : path.split(".");
    return parts.reduce(function(current, key) {
        return current && current[key];
    }, object);
}

/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/4.17.11-npm/escape.js
 */ // Used to map characters to HTML entities.
var $638238b1c80b9474$var$htmlEntities = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
};
// Used to match HTML entities and HTML characters.
var $638238b1c80b9474$var$regexUnescapedHtml = /[&<>"']/g;
var $638238b1c80b9474$var$regexHasUnescapedHtml = RegExp($638238b1c80b9474$var$regexUnescapedHtml.source);
function $638238b1c80b9474$export$4e7f196112fea3c5(value) {
    return value && $638238b1c80b9474$var$regexHasUnescapedHtml.test(value) ? value.replace($638238b1c80b9474$var$regexUnescapedHtml, function(character) {
        return $638238b1c80b9474$var$htmlEntities[character];
    }) : value;
}
/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/4.17.11-npm/unescape.js
 */ // Used to map HTML entities to characters.
var $638238b1c80b9474$var$htmlCharacters = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&#39;": "'"
};
// Used to match HTML entities and HTML characters.
var $638238b1c80b9474$var$regexEscapedHtml = /&(amp|quot|lt|gt|#39);/g;
var $638238b1c80b9474$var$regexHasEscapedHtml = RegExp($638238b1c80b9474$var$regexEscapedHtml.source);
function $638238b1c80b9474$export$e8bacd2802a88316(value) {
    return value && $638238b1c80b9474$var$regexHasEscapedHtml.test(value) ? value.replace($638238b1c80b9474$var$regexEscapedHtml, function(character) {
        return $638238b1c80b9474$var$htmlCharacters[character];
    }) : value;
}


function $55631d4f00075070$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $55631d4f00075070$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $55631d4f00075070$var$_typeof(obj);
}
/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/master/isPlainObject.js
 */ function $55631d4f00075070$var$getTag(value) {
    if (value === null) return value === undefined ? "[object Undefined]" : "[object Null]";
    return Object.prototype.toString.call(value);
}
function $55631d4f00075070$var$isObjectLike(value) {
    return $55631d4f00075070$var$_typeof(value) === "object" && value !== null;
}
function $55631d4f00075070$export$53b83ca8eaab0383(value) {
    if (!$55631d4f00075070$var$isObjectLike(value) || $55631d4f00075070$var$getTag(value) !== "[object Object]") return false;
    if (Object.getPrototypeOf(value) === null) return true;
    var proto = value;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(value) === proto;
}


function $a81e7c21001dea67$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $a81e7c21001dea67$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $a81e7c21001dea67$var$_typeof(obj);
}
function $a81e7c21001dea67$var$_objectDestructuringEmpty(obj) {
    if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function $a81e7c21001dea67$var$_extends() {
    $a81e7c21001dea67$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a81e7c21001dea67$var$_extends.apply(this, arguments);
}
function $a81e7c21001dea67$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a81e7c21001dea67$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a81e7c21001dea67$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a81e7c21001dea67$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a81e7c21001dea67$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a81e7c21001dea67$var$_defineProperty(obj, key, value) {
    key = $a81e7c21001dea67$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a81e7c21001dea67$var$_toPropertyKey(arg) {
    var key = $a81e7c21001dea67$var$_toPrimitive(arg, "string");
    return $a81e7c21001dea67$var$_typeof(key) === "symbol" ? key : String(key);
}
function $a81e7c21001dea67$var$_toPrimitive(input, hint) {
    if ($a81e7c21001dea67$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($a81e7c21001dea67$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $a81e7c21001dea67$export$1e7338a8952eaf35 = {
    highlightPreTag: "__ais-highlight__",
    highlightPostTag: "__/ais-highlight__"
};
var $a81e7c21001dea67$export$62e796b7905e8e6b = {
    highlightPreTag: "<mark>",
    highlightPostTag: "</mark>"
};
// @MAJOR: in the future, this should only escape, not replace
function $a81e7c21001dea67$var$replaceTagsAndEscape(value) {
    return (0, $638238b1c80b9474$export$4e7f196112fea3c5)(value).replace(new RegExp($a81e7c21001dea67$export$1e7338a8952eaf35.highlightPreTag, "g"), $a81e7c21001dea67$export$62e796b7905e8e6b.highlightPreTag).replace(new RegExp($a81e7c21001dea67$export$1e7338a8952eaf35.highlightPostTag, "g"), $a81e7c21001dea67$export$62e796b7905e8e6b.highlightPostTag);
}
function $a81e7c21001dea67$var$recursiveEscape(input) {
    if ((0, $55631d4f00075070$export$53b83ca8eaab0383)(input) && typeof input.value !== "string") return Object.keys(input).reduce(function(acc, key) {
        return $a81e7c21001dea67$var$_objectSpread($a81e7c21001dea67$var$_objectSpread({}, acc), {}, $a81e7c21001dea67$var$_defineProperty({}, key, $a81e7c21001dea67$var$recursiveEscape(input[key])));
    }, {});
    if (Array.isArray(input)) return input.map($a81e7c21001dea67$var$recursiveEscape);
    return $a81e7c21001dea67$var$_objectSpread($a81e7c21001dea67$var$_objectSpread({}, input), {}, {
        value: $a81e7c21001dea67$var$replaceTagsAndEscape(input.value)
    });
}
function $a81e7c21001dea67$export$9adb036445aab889(hits) {
    if (hits.__escaped === undefined) {
        // We don't override the value on hit because it will mutate the raw results
        // instead we make a shallow copy and we assign the escaped values on it.
        hits = hits.map(function(_ref) {
            var hit = $a81e7c21001dea67$var$_extends({}, ($a81e7c21001dea67$var$_objectDestructuringEmpty(_ref), _ref));
            if (hit._highlightResult) hit._highlightResult = $a81e7c21001dea67$var$recursiveEscape(hit._highlightResult);
            if (hit._snippetResult) hit._snippetResult = $a81e7c21001dea67$var$recursiveEscape(hit._snippetResult);
            return hit;
        });
        hits.__escaped = true;
    }
    return hits;
}
function $a81e7c21001dea67$export$9ae2e822836b2e1a(facetHits) {
    return facetHits.map(function(h) {
        return $a81e7c21001dea67$var$_objectSpread($a81e7c21001dea67$var$_objectSpread({}, h), {}, {
            highlighted: $a81e7c21001dea67$var$replaceTagsAndEscape(h.highlighted)
        });
    });
}


var $674309a480e15742$var$suit = (0, $d60c657ebeadddc2$export$d8556a2a8f973135)("Highlight");
function $674309a480e15742$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? "mark" : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var highlightAttributeResult = (0, $ad82201011f73d65$export$d14846335956eefa)(hit._highlightResult, attribute);
    var _ref2 = highlightAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? "" : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue & Angular
    var className = $674309a480e15742$var$suit({
        descendantName: "highlighted"
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : "");
    return attributeValue.replace(new RegExp((0, $a81e7c21001dea67$export$62e796b7905e8e6b).highlightPreTag, "g"), "<".concat(highlightedTagName, ' class="').concat(className, '">')).replace(new RegExp((0, $a81e7c21001dea67$export$62e796b7905e8e6b).highlightPostTag, "g"), "</".concat(highlightedTagName, ">"));
}



function $d7a00abc021a2a59$export$a34fe2fceda1929e(parts) {
    var highlightPreTag = (0, $a81e7c21001dea67$export$62e796b7905e8e6b).highlightPreTag, highlightPostTag = (0, $a81e7c21001dea67$export$62e796b7905e8e6b).highlightPostTag;
    return parts.map(function(part) {
        return part.isHighlighted ? highlightPreTag + part.value + highlightPostTag : part.value;
    }).join("");
}


var $cc15584f78286dce$var$hasAlphanumeric = new RegExp(/\w/i);
function $cc15584f78286dce$export$60c97785b669d08a(parts, i) {
    var _parts, _parts2;
    var current = parts[i];
    var isNextHighlighted = ((_parts = parts[i + 1]) === null || _parts === void 0 ? void 0 : _parts.isHighlighted) || true;
    var isPreviousHighlighted = ((_parts2 = parts[i - 1]) === null || _parts2 === void 0 ? void 0 : _parts2.isHighlighted) || true;
    if (!$cc15584f78286dce$var$hasAlphanumeric.test((0, $638238b1c80b9474$export$e8bacd2802a88316)(current.value)) && isPreviousHighlighted === isNextHighlighted) return isPreviousHighlighted;
    return current.isHighlighted;
}


function $b32be9885056ed94$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $b32be9885056ed94$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b32be9885056ed94$var$_typeof(obj);
}
function $b32be9885056ed94$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b32be9885056ed94$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b32be9885056ed94$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b32be9885056ed94$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b32be9885056ed94$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b32be9885056ed94$var$_defineProperty(obj, key, value) {
    key = $b32be9885056ed94$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b32be9885056ed94$var$_toPropertyKey(arg) {
    var key = $b32be9885056ed94$var$_toPrimitive(arg, "string");
    return $b32be9885056ed94$var$_typeof(key) === "symbol" ? key : String(key);
}
function $b32be9885056ed94$var$_toPrimitive(input, hint) {
    if ($b32be9885056ed94$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b32be9885056ed94$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $b32be9885056ed94$export$8d1202a2cf66e93(parts) {
    if (!parts.some(function(part) {
        return part.isHighlighted;
    })) return parts.map(function(part) {
        return $b32be9885056ed94$var$_objectSpread($b32be9885056ed94$var$_objectSpread({}, part), {}, {
            isHighlighted: false
        });
    });
    return parts.map(function(part, i) {
        return $b32be9885056ed94$var$_objectSpread($b32be9885056ed94$var$_objectSpread({}, part), {}, {
            isHighlighted: !(0, $cc15584f78286dce$export$60c97785b669d08a)(parts, i)
        });
    });
}


function $b44df87e9fbd5757$export$e04d28e65b830ebf(highlightedValue) {
    // @MAJOR: this should use TAG_PLACEHOLDER
    var highlightPostTag = (0, $a81e7c21001dea67$export$62e796b7905e8e6b).highlightPostTag, highlightPreTag = (0, $a81e7c21001dea67$export$62e796b7905e8e6b).highlightPreTag;
    var splitByPreTag = highlightedValue.split(highlightPreTag);
    var firstValue = splitByPreTag.shift();
    var elements = !firstValue ? [] : [
        {
            value: firstValue,
            isHighlighted: false
        }
    ];
    splitByPreTag.forEach(function(split) {
        var splitByPostTag = split.split(highlightPostTag);
        elements.push({
            value: splitByPostTag[0],
            isHighlighted: true
        });
        if (splitByPostTag[1] !== "") elements.push({
            value: splitByPostTag[1],
            isHighlighted: false
        });
    });
    return elements;
}


var $2887fcce333dc33c$var$suit = (0, $d60c657ebeadddc2$export$d8556a2a8f973135)("ReverseHighlight");
function $2887fcce333dc33c$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? "mark" : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var highlightAttributeResult = (0, $ad82201011f73d65$export$d14846335956eefa)(hit._highlightResult, attribute);
    var _ref2 = highlightAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? "" : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue & Angular
    var className = $2887fcce333dc33c$var$suit({
        descendantName: "highlighted"
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : "");
    var reverseHighlightedValue = (0, $d7a00abc021a2a59$export$a34fe2fceda1929e)((0, $b32be9885056ed94$export$8d1202a2cf66e93)((0, $b44df87e9fbd5757$export$e04d28e65b830ebf)(attributeValue)));
    return reverseHighlightedValue.replace(new RegExp((0, $a81e7c21001dea67$export$62e796b7905e8e6b).highlightPreTag, "g"), "<".concat(highlightedTagName, ' class="').concat(className, '">')).replace(new RegExp((0, $a81e7c21001dea67$export$62e796b7905e8e6b).highlightPostTag, "g"), "</".concat(highlightedTagName, ">"));
}



var $06aa9be74175d3cd$var$suit = (0, $d60c657ebeadddc2$export$d8556a2a8f973135)("Snippet");
function $06aa9be74175d3cd$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? "mark" : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var snippetAttributeResult = (0, $ad82201011f73d65$export$d14846335956eefa)(hit._snippetResult, attribute);
    var _ref2 = snippetAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? "" : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue & Angular
    var className = $06aa9be74175d3cd$var$suit({
        descendantName: "highlighted"
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : "");
    return attributeValue.replace(new RegExp((0, $a81e7c21001dea67$export$62e796b7905e8e6b).highlightPreTag, "g"), "<".concat(highlightedTagName, ' class="').concat(className, '">')).replace(new RegExp((0, $a81e7c21001dea67$export$62e796b7905e8e6b).highlightPostTag, "g"), "</".concat(highlightedTagName, ">"));
}



var $e9cd3c2d0f694b5b$var$suit = (0, $d60c657ebeadddc2$export$d8556a2a8f973135)("ReverseSnippet");
function $e9cd3c2d0f694b5b$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? "mark" : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var snippetAttributeResult = (0, $ad82201011f73d65$export$d14846335956eefa)(hit._snippetResult, attribute);
    var _ref2 = snippetAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? "" : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue & Angular
    var className = $e9cd3c2d0f694b5b$var$suit({
        descendantName: "highlighted"
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : "");
    var reverseHighlightedValue = (0, $d7a00abc021a2a59$export$a34fe2fceda1929e)((0, $b32be9885056ed94$export$8d1202a2cf66e93)((0, $b44df87e9fbd5757$export$e04d28e65b830ebf)(attributeValue)));
    return reverseHighlightedValue.replace(new RegExp((0, $a81e7c21001dea67$export$62e796b7905e8e6b).highlightPreTag, "g"), "<".concat(highlightedTagName, ' class="').concat(className, '">')).replace(new RegExp((0, $a81e7c21001dea67$export$62e796b7905e8e6b).highlightPostTag, "g"), "</".concat(highlightedTagName, ">"));
}

function $c1bd8090b7245f7b$export$44b4521aa38272f2(payload) {
    return btoa(encodeURIComponent(JSON.stringify(payload)));
}
function $c1bd8090b7245f7b$export$706ea24b0964bee9(serialized) {
    return JSON.parse(decodeURIComponent(atob(serialized)));
}


function $f1042ca31b903852$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f1042ca31b903852$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f1042ca31b903852$var$_typeof(obj);
}
function $f1042ca31b903852$export$cbcfede36ce7ab2e(domElement) {
    var method = domElement.getAttribute("data-insights-method");
    var serializedPayload = domElement.getAttribute("data-insights-payload");
    if (typeof serializedPayload !== "string") throw new Error("The insights helper expects `data-insights-payload` to be a base64-encoded JSON string.");
    try {
        var payload = (0, $c1bd8090b7245f7b$export$706ea24b0964bee9)(serializedPayload);
        return {
            method: method,
            payload: payload
        };
    } catch (error) {
        throw new Error("The insights helper was unable to parse `data-insights-payload`.");
    }
}
function $f1042ca31b903852$export$a3453cc0ced8b97c(_ref) {
    var method = _ref.method, payload = _ref.payload;
    if ($f1042ca31b903852$var$_typeof(payload) !== "object") throw new Error("The insights helper expects the payload to be an object.");
    var serializedPayload;
    try {
        serializedPayload = (0, $c1bd8090b7245f7b$export$44b4521aa38272f2)(payload);
    } catch (error) {
        throw new Error("Could not JSON serialize the payload object.");
    }
    return 'data-insights-method="'.concat(method, '" data-insights-payload="').concat(serializedPayload, '"');
}
function $f1042ca31b903852$export$2e2bcd8739ae039(method, payload) {
    return $f1042ca31b903852$export$a3453cc0ced8b97c({
        method: method,
        payload: payload
    });
}


function $7234c78063a6de6b$export$f5dd818bff069720(value, numberLocale) {
    return value.toLocaleString(numberLocale);
}


function $3adb68681ed97d86$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $3adb68681ed97d86$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $3adb68681ed97d86$var$_typeof(obj);
}
function $3adb68681ed97d86$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3adb68681ed97d86$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3adb68681ed97d86$var$ownKeys(Object(source), !0).forEach(function(key) {
            $3adb68681ed97d86$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3adb68681ed97d86$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3adb68681ed97d86$var$_defineProperty(obj, key, value) {
    key = $3adb68681ed97d86$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3adb68681ed97d86$var$_toPropertyKey(arg) {
    var key = $3adb68681ed97d86$var$_toPrimitive(arg, "string");
    return $3adb68681ed97d86$var$_typeof(key) === "symbol" ? key : String(key);
}
function $3adb68681ed97d86$var$_toPrimitive(input, hint) {
    if ($3adb68681ed97d86$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($3adb68681ed97d86$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $3adb68681ed97d86$export$2e2bcd8739ae039(_ref) {
    var numberLocale = _ref.numberLocale;
    return {
        formatNumber: function formatNumber(value, render) {
            return (0, $7234c78063a6de6b$export$f5dd818bff069720)(Number(render(value)), numberLocale);
        },
        highlight: function highlight(options, render) {
            try {
                var highlightOptions = JSON.parse(options);
                return render((0, $674309a480e15742$export$2e2bcd8739ae039)($3adb68681ed97d86$var$_objectSpread($3adb68681ed97d86$var$_objectSpread({}, highlightOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error('\nThe highlight helper expects a JSON object of the format:\n{ "attribute": "name", "highlightedTagName": "mark" }');
            }
        },
        reverseHighlight: function reverseHighlight(options, render) {
            try {
                var reverseHighlightOptions = JSON.parse(options);
                return render((0, $2887fcce333dc33c$export$2e2bcd8739ae039)($3adb68681ed97d86$var$_objectSpread($3adb68681ed97d86$var$_objectSpread({}, reverseHighlightOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error('\n  The reverseHighlight helper expects a JSON object of the format:\n  { "attribute": "name", "highlightedTagName": "mark" }');
            }
        },
        snippet: function snippet(options, render) {
            try {
                var snippetOptions = JSON.parse(options);
                return render((0, $06aa9be74175d3cd$export$2e2bcd8739ae039)($3adb68681ed97d86$var$_objectSpread($3adb68681ed97d86$var$_objectSpread({}, snippetOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error('\nThe snippet helper expects a JSON object of the format:\n{ "attribute": "name", "highlightedTagName": "mark" }');
            }
        },
        reverseSnippet: function reverseSnippet(options, render) {
            try {
                var reverseSnippetOptions = JSON.parse(options);
                return render((0, $e9cd3c2d0f694b5b$export$2e2bcd8739ae039)($3adb68681ed97d86$var$_objectSpread($3adb68681ed97d86$var$_objectSpread({}, reverseSnippetOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error('\n  The reverseSnippet helper expects a JSON object of the format:\n  { "attribute": "name", "highlightedTagName": "mark" }');
            }
        },
        insights: function insights(options, render) {
            try {
                var _JSON$parse = JSON.parse(options), method = _JSON$parse.method, payload = _JSON$parse.payload;
                return render((0, $f1042ca31b903852$export$2e2bcd8739ae039)(method, $3adb68681ed97d86$var$_objectSpread({
                    objectIDs: [
                        this.objectID
                    ]
                }, payload)));
            } catch (error) {
                throw new Error('\nThe insights helper expects a JSON object of the format:\n{ "method": "method-name", "payload": { "eventName": "name of the event" } }');
            }
        }
    };
}


var $7b1d2bcfdde95277$var$nextMicroTask = Promise.resolve();
function $7b1d2bcfdde95277$export$260e5c0943f31606(callback) {
    var progress = null;
    var cancelled = false;
    var fn = function fn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (progress !== null) return;
        progress = $7b1d2bcfdde95277$var$nextMicroTask.then(function() {
            progress = null;
            if (cancelled) {
                cancelled = false;
                return;
            }
            callback.apply(void 0, args);
        });
    };
    fn.wait = function() {
        if (progress === null) throw new Error("The deferred function should be called before calling `wait()`");
        return progress;
    };
    fn.cancel = function() {
        if (progress === null) return;
        cancelled = true;
    };
    return fn;
}

function $0ef5562b511d11a9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $0ef5562b511d11a9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $0ef5562b511d11a9$var$_typeof(obj);
}
function $0ef5562b511d11a9$var$_slicedToArray(arr, i) {
    return $0ef5562b511d11a9$var$_arrayWithHoles(arr) || $0ef5562b511d11a9$var$_iterableToArrayLimit(arr, i) || $0ef5562b511d11a9$var$_unsupportedIterableToArray(arr, i) || $0ef5562b511d11a9$var$_nonIterableRest();
}
function $0ef5562b511d11a9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0ef5562b511d11a9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0ef5562b511d11a9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0ef5562b511d11a9$var$_arrayLikeToArray(o, minLen);
}
function $0ef5562b511d11a9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0ef5562b511d11a9$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $0ef5562b511d11a9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $0ef5562b511d11a9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0ef5562b511d11a9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0ef5562b511d11a9$var$ownKeys(Object(source), !0).forEach(function(key) {
            $0ef5562b511d11a9$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0ef5562b511d11a9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0ef5562b511d11a9$var$_defineProperty(obj, key, value) {
    key = $0ef5562b511d11a9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0ef5562b511d11a9$var$_toPropertyKey(arg) {
    var key = $0ef5562b511d11a9$var$_toPrimitive(arg, "string");
    return $0ef5562b511d11a9$var$_typeof(key) === "symbol" ? key : String(key);
}
function $0ef5562b511d11a9$var$_toPrimitive(input, hint) {
    if ($0ef5562b511d11a9$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($0ef5562b511d11a9$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $0ef5562b511d11a9$export$7edf4eca27ca3a19(client, results) {
    if (!results) return;
    // Disable cache hydration on:
    // - Algoliasearch API Client < v4 with cache disabled
    // - Third party clients (detected by the `addAlgoliaAgent` function missing)
    if ((!("transporter" in client) || client._cacheHydrated) && (!client._useCache || typeof client.addAlgoliaAgent !== "function")) return;
    var cachedRequest = Object.keys(results).map(function(key) {
        var _results$key = results[key], state = _results$key.state, requestParams = _results$key.requestParams, serverResults = _results$key.results;
        return serverResults.map(function(result) {
            return $0ef5562b511d11a9$var$_objectSpread({
                indexName: state.index || result.index
            }, requestParams || result.params ? {
                params: $0ef5562b511d11a9$var$serializeQueryParameters(requestParams || $0ef5562b511d11a9$var$deserializeQueryParameters(result.params))
            } : {});
        });
    });
    var cachedResults = Object.keys(results).reduce(function(acc, key) {
        return acc.concat(results[key].results);
    }, []);
    // Algoliasearch API Client >= v4
    // To hydrate the client we need to populate the cache with the data from
    // the server (done in `hydrateSearchClientWithMultiIndexRequest` or
    // `hydrateSearchClientWithSingleIndexRequest`). But since there is no way
    // for us to compute the key the same way as `algoliasearch-client` we need
    // to populate it on a custom key and override the `search` method to
    // search on it first.
    if ("transporter" in client && !client._cacheHydrated) {
        client._cacheHydrated = true;
        var baseMethod = client.search;
        // @ts-ignore wanting type checks for v3 on this would make this too complex
        client.search = function(requests) {
            for(var _len = arguments.length, methodArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)methodArgs[_key - 1] = arguments[_key];
            var requestsWithSerializedParams = requests.map(function(request) {
                return $0ef5562b511d11a9$var$_objectSpread($0ef5562b511d11a9$var$_objectSpread({}, request), {}, {
                    params: $0ef5562b511d11a9$var$serializeQueryParameters(request.params)
                });
            });
            return client.transporter.responsesCache.get({
                method: "search",
                args: [
                    requestsWithSerializedParams
                ].concat(methodArgs)
            }, function() {
                return baseMethod.apply(void 0, [
                    requests
                ].concat(methodArgs));
            });
        };
        client.transporter.responsesCache.set({
            method: "search",
            args: cachedRequest
        }, {
            results: cachedResults
        });
    }
    // Algoliasearch API Client < v4
    // Prior to client v4 we didn't have a proper API to hydrate the client
    // cache from the outside. The following code populates the cache with
    // a single-index result. You can find more information about the
    // computation of the key inside the client (see link below).
    // https://github.com/algolia/algoliasearch-client-javascript/blob/c27e89ff92b2a854ae6f40dc524bffe0f0cbc169/src/AlgoliaSearchCore.js#L232-L240
    if (!("transporter" in client)) {
        var cacheKey = "/1/indexes/*/queries_body_".concat(JSON.stringify({
            requests: cachedRequest
        }));
        client.cache = $0ef5562b511d11a9$var$_objectSpread($0ef5562b511d11a9$var$_objectSpread({}, client.cache), {}, $0ef5562b511d11a9$var$_defineProperty({}, cacheKey, JSON.stringify({
            results: Object.keys(results).map(function(key) {
                return results[key].results;
            })
        })));
    }
}
function $0ef5562b511d11a9$var$deserializeQueryParameters(parameters) {
    return parameters.split("&").reduce(function(acc, parameter) {
        var _parameter$split = parameter.split("="), _parameter$split2 = $0ef5562b511d11a9$var$_slicedToArray(_parameter$split, 2), key = _parameter$split2[0], value = _parameter$split2[1];
        acc[key] = value ? decodeURIComponent(value) : "";
        return acc;
    }, {});
}
// This function is copied from the algoliasearch v4 API Client. If modified,
// consider updating it also in `serializeQueryParameters` from `@algolia/transporter`.
function $0ef5562b511d11a9$var$serializeQueryParameters(parameters) {
    var isObjectOrArray = function isObjectOrArray(value) {
        return Object.prototype.toString.call(value) === "[object Object]" || Object.prototype.toString.call(value) === "[object Array]";
    };
    var encode = function encode(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        var i = 0;
        return format.replace(/%s/g, function() {
            return encodeURIComponent(args[i++]);
        });
    };
    return Object.keys(parameters).map(function(key) {
        return encode("%s=%s", key, isObjectOrArray(parameters[key]) ? JSON.stringify(parameters[key]) : parameters[key]);
    }).join("&");
}



function $5f4ddd72ddc8501a$export$fd5e8f1329b3d5e0(finalUiState, indexWidget) {
    var nextIndexUiState = finalUiState[indexWidget.getIndexId()] || {};
    indexWidget.getHelper().setState(indexWidget.getWidgetSearchParameters(indexWidget.getHelper().state, {
        uiState: nextIndexUiState
    }));
    indexWidget.getWidgets().filter((0, $ff005e3275c54053$export$a9c9a0d43506297d)).forEach(function(widget) {
        return $5f4ddd72ddc8501a$export$fd5e8f1329b3d5e0(finalUiState, widget);
    });
}


var $994b38cd6cf9cac3$export$2e2bcd8739ae039 = "4.66.1";


function $bbd8b6e0d0869c08$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $bbd8b6e0d0869c08$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $bbd8b6e0d0869c08$var$_typeof(obj);
}
function $bbd8b6e0d0869c08$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bbd8b6e0d0869c08$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $bbd8b6e0d0869c08$var$ownKeys(Object(source), !0).forEach(function(key) {
            $bbd8b6e0d0869c08$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $bbd8b6e0d0869c08$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bbd8b6e0d0869c08$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bbd8b6e0d0869c08$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $bbd8b6e0d0869c08$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $bbd8b6e0d0869c08$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bbd8b6e0d0869c08$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bbd8b6e0d0869c08$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $bbd8b6e0d0869c08$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $bbd8b6e0d0869c08$var$_setPrototypeOf(subClass, superClass);
}
function $bbd8b6e0d0869c08$var$_setPrototypeOf(o, p) {
    $bbd8b6e0d0869c08$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bbd8b6e0d0869c08$var$_setPrototypeOf(o, p);
}
function $bbd8b6e0d0869c08$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $bbd8b6e0d0869c08$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $bbd8b6e0d0869c08$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bbd8b6e0d0869c08$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bbd8b6e0d0869c08$var$_possibleConstructorReturn(this, result);
    };
}
function $bbd8b6e0d0869c08$var$_possibleConstructorReturn(self, call) {
    if (call && ($bbd8b6e0d0869c08$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $bbd8b6e0d0869c08$var$_assertThisInitialized(self);
}
function $bbd8b6e0d0869c08$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $bbd8b6e0d0869c08$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $bbd8b6e0d0869c08$var$_getPrototypeOf(o) {
    $bbd8b6e0d0869c08$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $bbd8b6e0d0869c08$var$_getPrototypeOf(o);
}
function $bbd8b6e0d0869c08$var$_defineProperty(obj, key, value) {
    key = $bbd8b6e0d0869c08$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bbd8b6e0d0869c08$var$_toPropertyKey(arg) {
    var key = $bbd8b6e0d0869c08$var$_toPrimitive(arg, "string");
    return $bbd8b6e0d0869c08$var$_typeof(key) === "symbol" ? key : String(key);
}
function $bbd8b6e0d0869c08$var$_toPrimitive(input, hint) {
    if ($bbd8b6e0d0869c08$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($bbd8b6e0d0869c08$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $bbd8b6e0d0869c08$var$withUsage = (0, $44084963839a4436$export$2fde5bffc340821e)({
    name: "instantsearch"
});
function $bbd8b6e0d0869c08$var$defaultCreateURL() {
    return "#";
}
var $bbd8b6e0d0869c08$export$8bd42a83af1ca676 = {
    preserveSharedStateOnUnmount: false,
    persistHierarchicalRootCount: false
};
/**
 * The actual implementation of the InstantSearch. This is
 * created using the `instantsearch` factory function.
 * It emits the 'render' event every time a search is done
 */ var $bbd8b6e0d0869c08$var$InstantSearch = /*#__PURE__*/ function(_EventEmitter) {
    $bbd8b6e0d0869c08$var$_inherits(InstantSearch, _EventEmitter);
    var _super = $bbd8b6e0d0869c08$var$_createSuper(InstantSearch);
    function InstantSearch(options) {
        var _options$future2;
        var _this;
        $bbd8b6e0d0869c08$var$_classCallCheck(this, InstantSearch);
        _this = _super.call(this);
        // prevent `render` event listening from causing a warning
        $bbd8b6e0d0869c08$var$_defineProperty($bbd8b6e0d0869c08$var$_assertThisInitialized(_this), "client", void 0);
        $bbd8b6e0d0869c08$var$_defineProperty($bbd8b6e0d0869c08$var$_assertThisInitialized(_this), "indexName", void 0);
        $bbd8b6e0d0869c08$var$_defineProperty($bbd8b6e0d0869c08$var$_assertThisInitialized(_this), "insightsClient", void 0);
        $bbd8b6e0d0869c08$var$_defineProperty($bbd8b6e0d0869c08$var$_assertThisInitialized(_this), "onStateChange", null);
        $bbd8b6e0d0869c08$var$_defineProperty($bbd8b6e0d0869c08$var$_assertThisInitialized(_this), "future", void 0);
        $bbd8b6e0d0869c08$var$_defineProperty($bbd8b6e0d0869c08$var$_assertThisInitialized(_this), "helper", void 0);
        $bbd8b6e0d0869c08$var$_defineProperty($bbd8b6e0d0869c08$var$_assertThisInitialized(_this), "mainHelper", void 0);
        $bbd8b6e0d0869c08$var$_defineProperty($bbd8b6e0d0869c08$var$_assertThisInitialized(_this), "mainIndex", void 0);
        $bbd8b6e0d0869c08$var$_defineProperty($bbd8b6e0d0869c08$var$_assertThisInitialized(_this), "started", void 0);
        $bbd8b6e0d0869c08$var$_defineProperty($bbd8b6e0d0869c08$var$_assertThisInitialized(_this), "templatesConfig", void 0);
        $bbd8b6e0d0869c08$var$_defineProperty($bbd8b6e0d0869c08$var$_assertThisInitialized(_this), "renderState", {});
        $bbd8b6e0d0869c08$var$_defineProperty($bbd8b6e0d0869c08$var$_assertThisInitialized(_this), "_stalledSearchDelay", void 0);
        $bbd8b6e0d0869c08$var$_defineProperty($bbd8b6e0d0869c08$var$_assertThisInitialized(_this), "_searchStalledTimer", void 0);
        $bbd8b6e0d0869c08$var$_defineProperty($bbd8b6e0d0869c08$var$_assertThisInitialized(_this), "_initialUiState", void 0);
        $bbd8b6e0d0869c08$var$_defineProperty($bbd8b6e0d0869c08$var$_assertThisInitialized(_this), "_initialResults", void 0);
        $bbd8b6e0d0869c08$var$_defineProperty($bbd8b6e0d0869c08$var$_assertThisInitialized(_this), "_createURL", void 0);
        $bbd8b6e0d0869c08$var$_defineProperty($bbd8b6e0d0869c08$var$_assertThisInitialized(_this), "_searchFunction", void 0);
        $bbd8b6e0d0869c08$var$_defineProperty($bbd8b6e0d0869c08$var$_assertThisInitialized(_this), "_mainHelperSearch", void 0);
        $bbd8b6e0d0869c08$var$_defineProperty($bbd8b6e0d0869c08$var$_assertThisInitialized(_this), "_insights", void 0);
        $bbd8b6e0d0869c08$var$_defineProperty($bbd8b6e0d0869c08$var$_assertThisInitialized(_this), "middleware", []);
        $bbd8b6e0d0869c08$var$_defineProperty($bbd8b6e0d0869c08$var$_assertThisInitialized(_this), "sendEventToInsights", void 0);
        /**
     * The status of the search. Can be "idle", "loading", "stalled", or "error".
     */ $bbd8b6e0d0869c08$var$_defineProperty($bbd8b6e0d0869c08$var$_assertThisInitialized(_this), "status", "idle");
        /**
     * The last returned error from the Search API.
     * The error gets cleared when the next valid search response is rendered.
     */ $bbd8b6e0d0869c08$var$_defineProperty($bbd8b6e0d0869c08$var$_assertThisInitialized(_this), "error", undefined);
        $bbd8b6e0d0869c08$var$_defineProperty($bbd8b6e0d0869c08$var$_assertThisInitialized(_this), "scheduleSearch", (0, $7b1d2bcfdde95277$export$260e5c0943f31606)(function() {
            if (_this.started) _this.mainHelper.search();
        }));
        $bbd8b6e0d0869c08$var$_defineProperty($bbd8b6e0d0869c08$var$_assertThisInitialized(_this), "scheduleRender", (0, $7b1d2bcfdde95277$export$260e5c0943f31606)(function() {
            var _this$mainHelper;
            var shouldResetStatus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            if (!((_this$mainHelper = _this.mainHelper) !== null && _this$mainHelper !== void 0 && _this$mainHelper.hasPendingRequests())) {
                clearTimeout(_this._searchStalledTimer);
                _this._searchStalledTimer = null;
                if (shouldResetStatus) {
                    _this.status = "idle";
                    _this.error = undefined;
                }
            }
            _this.mainIndex.render({
                instantSearchInstance: $bbd8b6e0d0869c08$var$_assertThisInitialized(_this)
            });
            _this.emit("render");
        }));
        $bbd8b6e0d0869c08$var$_defineProperty($bbd8b6e0d0869c08$var$_assertThisInitialized(_this), "onInternalStateChange", (0, $7b1d2bcfdde95277$export$260e5c0943f31606)(function() {
            var nextUiState = _this.mainIndex.getWidgetUiState({});
            _this.middleware.forEach(function(_ref) {
                var instance = _ref.instance;
                instance.onStateChange({
                    uiState: nextUiState
                });
            });
        }));
        _this.setMaxListeners(100);
        var _options$indexName = options.indexName, indexName = _options$indexName === void 0 ? "" : _options$indexName, numberLocale = options.numberLocale, _options$initialUiSta = options.initialUiState, initialUiState = _options$initialUiSta === void 0 ? {} : _options$initialUiSta, _options$routing = options.routing, routing = _options$routing === void 0 ? null : _options$routing, _options$insights = options.insights, insights = _options$insights === void 0 ? undefined : _options$insights, searchFunction = options.searchFunction, _options$stalledSearc = options.stalledSearchDelay, stalledSearchDelay = _options$stalledSearc === void 0 ? 200 : _options$stalledSearc, _options$searchClient = options.searchClient, searchClient = _options$searchClient === void 0 ? null : _options$searchClient, _options$insightsClie = options.insightsClient, insightsClient = _options$insightsClie === void 0 ? null : _options$insightsClie, _options$onStateChang = options.onStateChange, onStateChange = _options$onStateChang === void 0 ? null : _options$onStateChang, _options$future = options.future, future = _options$future === void 0 ? $bbd8b6e0d0869c08$var$_objectSpread($bbd8b6e0d0869c08$var$_objectSpread({}, $bbd8b6e0d0869c08$export$8bd42a83af1ca676), options.future || {}) : _options$future;
        if (searchClient === null) throw new Error($bbd8b6e0d0869c08$var$withUsage("The `searchClient` option is required."));
        if (typeof searchClient.search !== "function") throw new Error("The `searchClient` must implement a `search` method.\n\nSee: https://www.algolia.com/doc/guides/building-search-ui/going-further/backend-search/in-depth/backend-instantsearch/js/");
        if (typeof searchClient.addAlgoliaAgent === "function") searchClient.addAlgoliaAgent("instantsearch.js (".concat((0, $994b38cd6cf9cac3$export$2e2bcd8739ae039), ")"));
        if (insightsClient && typeof insightsClient !== "function") throw new Error($bbd8b6e0d0869c08$var$withUsage("The `insightsClient` option should be a function."));
        _this.client = searchClient;
        _this.future = future;
        _this.insightsClient = insightsClient;
        _this.indexName = indexName;
        _this.helper = null;
        _this.mainHelper = null;
        _this.mainIndex = (0, $d58d3e7e2b39b859$export$2e2bcd8739ae039)({
            indexName: indexName
        });
        _this.onStateChange = onStateChange;
        _this.started = false;
        _this.templatesConfig = {
            helpers: (0, $3adb68681ed97d86$export$2e2bcd8739ae039)({
                numberLocale: numberLocale
            }),
            compileOptions: {}
        };
        _this._stalledSearchDelay = stalledSearchDelay;
        _this._searchStalledTimer = null;
        _this._createURL = $bbd8b6e0d0869c08$var$defaultCreateURL;
        _this._initialUiState = initialUiState;
        _this._initialResults = null;
        _this._insights = insights;
        if (searchFunction) _this._searchFunction = searchFunction;
        _this.sendEventToInsights = (0, $5d3ef3e388d952bb$export$8793edee2d425525);
        if (routing) {
            var routerOptions = typeof routing === "boolean" ? {} : routing;
            routerOptions.$$internal = true;
            _this.use((0, $1adad19165a0c397$export$1fe5128387816284)(routerOptions));
        }
        // This is the default Insights middleware,
        // added when `insights` is set to true by the user.
        // Any user-provided middleware will be added later and override this one.
        if (insights) {
            var insightsOptions = typeof insights === "boolean" ? {} : insights;
            insightsOptions.$$internal = true;
            _this.use((0, $d77a7765e55fda26$export$91e0bf09562e2c44)(insightsOptions));
        }
        if ((0, $2f4436411f662738$export$4b4254890acf93e7)()) _this.use((0, $2f4436411f662738$export$8ee9d2447935ed96)({
            $$internal: true
        }));
        return _this;
    }
    /**
   * Hooks a middleware into the InstantSearch lifecycle.
   */ $bbd8b6e0d0869c08$var$_createClass(InstantSearch, [
        {
            key: "_isSearchStalled",
            get: /**
     * @deprecated use `status === 'stalled'` instead
     */ function get() {
                return this.status === "stalled";
            }
        },
        {
            key: "use",
            value: function use() {
                var _this2 = this;
                for(var _len = arguments.length, middleware = new Array(_len), _key = 0; _key < _len; _key++)middleware[_key] = arguments[_key];
                var newMiddlewareList = middleware.map(function(fn) {
                    var newMiddleware = $bbd8b6e0d0869c08$var$_objectSpread({
                        $$type: "__unknown__",
                        $$internal: false,
                        subscribe: (0, $5d3ef3e388d952bb$export$8793edee2d425525),
                        started: (0, $5d3ef3e388d952bb$export$8793edee2d425525),
                        unsubscribe: (0, $5d3ef3e388d952bb$export$8793edee2d425525),
                        onStateChange: (0, $5d3ef3e388d952bb$export$8793edee2d425525)
                    }, fn({
                        instantSearchInstance: _this2
                    }));
                    _this2.middleware.push({
                        creator: fn,
                        instance: newMiddleware
                    });
                    return newMiddleware;
                });
                // If the instance has already started, we directly subscribe the
                // middleware so they're notified of changes.
                if (this.started) newMiddlewareList.forEach(function(m) {
                    m.subscribe();
                    m.started();
                });
                return this;
            }
        },
        {
            key: "unuse",
            value: function unuse() {
                for(var _len2 = arguments.length, middlewareToUnuse = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)middlewareToUnuse[_key2] = arguments[_key2];
                this.middleware.filter(function(m) {
                    return middlewareToUnuse.includes(m.creator);
                }).forEach(function(m) {
                    return m.instance.unsubscribe();
                });
                this.middleware = this.middleware.filter(function(m) {
                    return !middlewareToUnuse.includes(m.creator);
                });
                return this;
            }
        },
        {
            key: "EXPERIMENTAL_use",
            value: function EXPERIMENTAL_use() {
                return this.use.apply(this, arguments);
            }
        },
        {
            key: "addWidget",
            value: function addWidget(widget) {
                return this.addWidgets([
                    widget
                ]);
            }
        },
        {
            key: "addWidgets",
            value: function addWidgets(widgets) {
                if (!Array.isArray(widgets)) throw new Error($bbd8b6e0d0869c08$var$withUsage("The `addWidgets` method expects an array of widgets. Please use `addWidget`."));
                if (widgets.some(function(widget) {
                    return typeof widget.init !== "function" && typeof widget.render !== "function";
                })) throw new Error($bbd8b6e0d0869c08$var$withUsage("The widget definition expects a `render` and/or an `init` method."));
                this.mainIndex.addWidgets(widgets);
                return this;
            }
        },
        {
            key: "removeWidget",
            value: function removeWidget(widget) {
                return this.removeWidgets([
                    widget
                ]);
            }
        },
        {
            key: "removeWidgets",
            value: function removeWidgets(widgets) {
                if (!Array.isArray(widgets)) throw new Error($bbd8b6e0d0869c08$var$withUsage("The `removeWidgets` method expects an array of widgets. Please use `removeWidget`."));
                if (widgets.some(function(widget) {
                    return typeof widget.dispose !== "function";
                })) throw new Error($bbd8b6e0d0869c08$var$withUsage("The widget definition expects a `dispose` method."));
                this.mainIndex.removeWidgets(widgets);
                return this;
            }
        },
        {
            key: "start",
            value: function start() {
                var _this3 = this;
                if (this.started) throw new Error($bbd8b6e0d0869c08$var$withUsage("The `start` method has already been called once."));
                // This Helper is used for the queries, we don't care about its state. The
                // states are managed at the `index` level. We use this Helper to create
                // DerivedHelper scoped into the `index` widgets.
                // In Vue InstantSearch' hydrate, a main helper gets set before start, so
                // we need to respect this helper as a way to keep all listeners correct.
                var mainHelper = this.mainHelper || (0, (/*@__PURE__*/$parcel$interopDefault($154f73342ab39590$exports)))(this.client, this.indexName, undefined, {
                    persistHierarchicalRootCount: this.future.persistHierarchicalRootCount
                });
                mainHelper.search = function() {
                    _this3.status = "loading";
                    _this3.scheduleRender(false);
                    // This solution allows us to keep the exact same API for the users but
                    // under the hood, we have a different implementation. It should be
                    // completely transparent for the rest of the codebase. Only this module
                    // is impacted.
                    return mainHelper.searchOnlyWithDerivedHelpers();
                };
                if (this._searchFunction) {
                    // this client isn't used to actually search, but required for the helper
                    // to not throw errors
                    var fakeClient = {
                        search: function search() {
                            return new Promise((0, $5d3ef3e388d952bb$export$8793edee2d425525));
                        }
                    };
                    this._mainHelperSearch = mainHelper.search.bind(mainHelper);
                    mainHelper.search = function() {
                        var mainIndexHelper = _this3.mainIndex.getHelper();
                        var searchFunctionHelper = (0, (/*@__PURE__*/$parcel$interopDefault($154f73342ab39590$exports)))(fakeClient, mainIndexHelper.state.index, mainIndexHelper.state);
                        searchFunctionHelper.once("search", function(_ref2) {
                            var state = _ref2.state;
                            mainIndexHelper.overrideStateWithoutTriggeringChangeEvent(state);
                            _this3._mainHelperSearch();
                        });
                        // Forward state changes from `searchFunctionHelper` to `mainIndexHelper`
                        searchFunctionHelper.on("change", function(_ref3) {
                            var state = _ref3.state;
                            mainIndexHelper.setState(state);
                        });
                        _this3._searchFunction(searchFunctionHelper);
                        return mainHelper;
                    };
                }
                // Only the "main" Helper emits the `error` event vs the one for `search`
                // and `results` that are also emitted on the derived one.
                mainHelper.on("error", function(_ref4) {
                    var error = _ref4.error;
                    if (!(error instanceof Error)) {
                        // typescript lies here, error is in some cases { name: string, message: string }
                        var err = error;
                        error = Object.keys(err).reduce(function(acc, key) {
                            acc[key] = err[key];
                            return acc;
                        }, new Error(err.message));
                    }
                    // If an error is emitted, it is re-thrown by events. In previous versions
                    // we emitted {error}, which is thrown as:
                    // "Uncaught, unspecified \"error\" event. ([object Object])"
                    // To avoid breaking changes, we make the error available in both
                    // `error` and `error.error`
                    // @MAJOR emit only error
                    error.error = error;
                    _this3.error = error;
                    _this3.status = "error";
                    _this3.scheduleRender(false);
                    // This needs to execute last because it throws the error.
                    _this3.emit("error", error);
                });
                this.mainHelper = mainHelper;
                this.middleware.forEach(function(_ref5) {
                    var instance = _ref5.instance;
                    instance.subscribe();
                });
                this.mainIndex.init({
                    instantSearchInstance: this,
                    parent: null,
                    uiState: this._initialUiState
                });
                if (this._initialResults) {
                    (0, $0ef5562b511d11a9$export$7edf4eca27ca3a19)(this.client, this._initialResults);
                    var originalScheduleSearch = this.scheduleSearch;
                    // We don't schedule a first search when initial results are provided
                    // because we already have the results to render. This skips the initial
                    // network request on the browser on `start`.
                    this.scheduleSearch = (0, $7b1d2bcfdde95277$export$260e5c0943f31606)((0, $5d3ef3e388d952bb$export$8793edee2d425525));
                    // We also skip the initial network request when widgets are dynamically
                    // added in the first tick (that's the case in all the framework-based flavors).
                    // When we add a widget to `index`, it calls `scheduleSearch`. We can rely
                    // on our `defer` util to restore the original `scheduleSearch` value once
                    // widgets are added to hook back to the regular lifecycle.
                    (0, $7b1d2bcfdde95277$export$260e5c0943f31606)(function() {
                        _this3.scheduleSearch = originalScheduleSearch;
                    })();
                } else if (this.mainIndex.getWidgets().length > 0) this.scheduleSearch();
                // Keep the previous reference for legacy purpose, some pattern use
                // the direct Helper access `search.helper` (e.g multi-index).
                this.helper = this.mainIndex.getHelper();
                // track we started the search if we add more widgets,
                // to init them directly after add
                this.started = true;
                this.middleware.forEach(function(_ref6) {
                    var instance = _ref6.instance;
                    instance.started();
                });
                // This is the automatic Insights middleware,
                // added when `insights` is unset and the initial results possess `queryID`.
                // Any user-provided middleware will be added later and override this one.
                if (typeof this._insights === "undefined") mainHelper.derivedHelpers[0].once("result", function() {
                    var hasAutomaticInsights = _this3.mainIndex.getScopedResults().some(function(_ref7) {
                        var results = _ref7.results;
                        return results === null || results === void 0 ? void 0 : results._automaticInsights;
                    });
                    if (hasAutomaticInsights) _this3.use((0, $d77a7765e55fda26$export$91e0bf09562e2c44)({
                        $$internal: true,
                        $$automatic: true
                    }));
                });
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                var _this$mainHelper2;
                this.scheduleSearch.cancel();
                this.scheduleRender.cancel();
                clearTimeout(this._searchStalledTimer);
                this.removeWidgets(this.mainIndex.getWidgets());
                this.mainIndex.dispose();
                // You can not start an instance two times, therefore a disposed instance
                // needs to set started as false otherwise this can not be restarted at a
                // later point.
                this.started = false;
                // The helper needs to be reset to perform the next search from a fresh state.
                // If not reset, it would use the state stored before calling `dispose()`.
                this.removeAllListeners();
                (_this$mainHelper2 = this.mainHelper) === null || _this$mainHelper2 === void 0 || _this$mainHelper2.removeAllListeners();
                this.mainHelper = null;
                this.helper = null;
                this.middleware.forEach(function(_ref8) {
                    var instance = _ref8.instance;
                    instance.unsubscribe();
                });
            }
        },
        {
            key: "scheduleStalledRender",
            value: function scheduleStalledRender() {
                var _this4 = this;
                if (!this._searchStalledTimer) this._searchStalledTimer = setTimeout(function() {
                    _this4.status = "stalled";
                    _this4.scheduleRender();
                }, this._stalledSearchDelay);
            }
        },
        {
            key: "setUiState",
            value: function setUiState(uiState) {
                var _this5 = this;
                var callOnStateChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                if (!this.mainHelper) throw new Error($bbd8b6e0d0869c08$var$withUsage("The `start` method needs to be called before `setUiState`."));
                // We refresh the index UI state to update the local UI state that the
                // main index passes to the function form of `setUiState`.
                this.mainIndex.refreshUiState();
                var nextUiState = typeof uiState === "function" ? uiState(this.mainIndex.getWidgetUiState({})) : uiState;
                if (this.onStateChange && callOnStateChange) this.onStateChange({
                    uiState: nextUiState,
                    setUiState: function setUiState(finalUiState) {
                        (0, $5f4ddd72ddc8501a$export$fd5e8f1329b3d5e0)(typeof finalUiState === "function" ? finalUiState(nextUiState) : finalUiState, _this5.mainIndex);
                        _this5.scheduleSearch();
                        _this5.onInternalStateChange();
                    }
                });
                else {
                    (0, $5f4ddd72ddc8501a$export$fd5e8f1329b3d5e0)(nextUiState, this.mainIndex);
                    this.scheduleSearch();
                    this.onInternalStateChange();
                }
            }
        },
        {
            key: "getUiState",
            value: function getUiState() {
                if (this.started) // We refresh the index UI state to make sure changes from `refine` are taken in account
                this.mainIndex.refreshUiState();
                return this.mainIndex.getWidgetUiState({});
            }
        },
        {
            key: "createURL",
            value: function createURL() {
                var nextState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!this.started) throw new Error($bbd8b6e0d0869c08$var$withUsage("The `start` method needs to be called before `createURL`."));
                return this._createURL(nextState);
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                if (!this.mainHelper) throw new Error($bbd8b6e0d0869c08$var$withUsage("The `start` method needs to be called before `refresh`."));
                this.mainHelper.clearCache().search();
            }
        }
    ]);
    return InstantSearch;
}((0, (/*@__PURE__*/$parcel$interopDefault($510c46699c725eb9$exports))));
var $bbd8b6e0d0869c08$export$2e2bcd8739ae039 = $bbd8b6e0d0869c08$var$InstantSearch;



var $4rNTR = parcelRequire("4rNTR");
var $a8c82b7320c97ac5$exports = {};
"use strict";

$a8c82b7320c97ac5$exports = (parcelRequire("1C9Uy"));


var $9a733937aba41e31$export$2e2bcd8739ae039 = "7.7.1";


function $e9a60775bb250308$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $e9a60775bb250308$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $e9a60775bb250308$var$_typeof(obj);
}
/* eslint-disable complexity */ /*
 * Code taken from dequal/lite v2.0.0
 * https://github.com/lukeed/dequal/blob/9aa73181ac7e081cd330cac67d313632ac04bb02/src/lite.js
 *
 * It adds a 3rd argument `compare(a, b)` that lets execute custom logic to
 * compare values.
 * We use it to skip comparing function references.
 */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $e9a60775bb250308$var$has = Object.prototype.hasOwnProperty;
function $e9a60775bb250308$export$de8294bb3be0322f(foo, bar, compare) {
    // start of custom implementation
    if (compare !== null && compare !== void 0 && compare(foo, bar)) return true;
    // end of custom implementation
    var ctor;
    var len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $e9a60775bb250308$export$de8294bb3be0322f(foo[len], bar[len], compare));
            }
            return len === -1;
        }
        if (!ctor || $e9a60775bb250308$var$_typeof(foo) === "object") {
            len = 0;
            // eslint-disable-next-line guard-for-in, no-restricted-syntax
            for(ctor in foo){
                if ($e9a60775bb250308$var$has.call(foo, ctor) && ++len && !$e9a60775bb250308$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$e9a60775bb250308$export$de8294bb3be0322f(foo[ctor], bar[ctor], compare)) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    // eslint-disable-next-line no-self-compare
    return foo !== foo && bar !== bar;
}



var $4rNTR = parcelRequire("4rNTR");
function $99f86b198d5fa8ef$var$_slicedToArray(arr, i) {
    return $99f86b198d5fa8ef$var$_arrayWithHoles(arr) || $99f86b198d5fa8ef$var$_iterableToArrayLimit(arr, i) || $99f86b198d5fa8ef$var$_unsupportedIterableToArray(arr, i) || $99f86b198d5fa8ef$var$_nonIterableRest();
}
function $99f86b198d5fa8ef$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $99f86b198d5fa8ef$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $99f86b198d5fa8ef$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $99f86b198d5fa8ef$var$_arrayLikeToArray(o, minLen);
}
function $99f86b198d5fa8ef$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $99f86b198d5fa8ef$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $99f86b198d5fa8ef$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $99f86b198d5fa8ef$export$91db9bc4f8ac944a() {
    var _useReducer = (0, $4rNTR.useReducer)(function(x) {
        return x + 1;
    }, 0), _useReducer2 = $99f86b198d5fa8ef$var$_slicedToArray(_useReducer, 2), forceUpdate = _useReducer2[1];
    return forceUpdate;
}



var $4rNTR = parcelRequire("4rNTR");

var $4rNTR = parcelRequire("4rNTR");
var $b0f0a1180493a637$export$87f9401208449446 = /*#__PURE__*/ (0, $4rNTR.createContext)(null);


function $069dd2e8db801d4a$export$692e83606e644bf6() {
    return (0, $4rNTR.useContext)((0, $b0f0a1180493a637$export$87f9401208449446));
}



var $4rNTR = parcelRequire("4rNTR");

var $4rNTR = parcelRequire("4rNTR");
var $7fe84e8d59dfeb40$export$92edcc5c9a39af56 = /*#__PURE__*/ (0, $4rNTR.createContext)(null);


function $0737848057cf6b19$export$b7b167d1ffee3ddc() {
    return (0, $4rNTR.useContext)((0, $7fe84e8d59dfeb40$export$92edcc5c9a39af56));
}



var $4rNTR = parcelRequire("4rNTR");

var $4rNTR = parcelRequire("4rNTR");
var $f8a89e8895f00e9e$export$f690384094665d60 = /*#__PURE__*/ (0, $4rNTR.createContext)(null);


function $98a4bafefa0373fc$export$b0820d56d4bdeee6() {
    return (0, $4rNTR.useContext)((0, $f8a89e8895f00e9e$export$f690384094665d60));
}



var $dab5a9e24bd89074$exports = {};
// shim for using process in browser
var $dab5a9e24bd89074$var$process = $dab5a9e24bd89074$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $dab5a9e24bd89074$var$cachedSetTimeout;
var $dab5a9e24bd89074$var$cachedClearTimeout;
function $dab5a9e24bd89074$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $dab5a9e24bd89074$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $dab5a9e24bd89074$var$cachedSetTimeout = setTimeout;
        else $dab5a9e24bd89074$var$cachedSetTimeout = $dab5a9e24bd89074$var$defaultSetTimout;
    } catch (e) {
        $dab5a9e24bd89074$var$cachedSetTimeout = $dab5a9e24bd89074$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $dab5a9e24bd89074$var$cachedClearTimeout = clearTimeout;
        else $dab5a9e24bd89074$var$cachedClearTimeout = $dab5a9e24bd89074$var$defaultClearTimeout;
    } catch (e) {
        $dab5a9e24bd89074$var$cachedClearTimeout = $dab5a9e24bd89074$var$defaultClearTimeout;
    }
})();
function $dab5a9e24bd89074$var$runTimeout(fun) {
    if ($dab5a9e24bd89074$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($dab5a9e24bd89074$var$cachedSetTimeout === $dab5a9e24bd89074$var$defaultSetTimout || !$dab5a9e24bd89074$var$cachedSetTimeout) && setTimeout) {
        $dab5a9e24bd89074$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $dab5a9e24bd89074$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $dab5a9e24bd89074$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $dab5a9e24bd89074$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $dab5a9e24bd89074$var$runClearTimeout(marker) {
    if ($dab5a9e24bd89074$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($dab5a9e24bd89074$var$cachedClearTimeout === $dab5a9e24bd89074$var$defaultClearTimeout || !$dab5a9e24bd89074$var$cachedClearTimeout) && clearTimeout) {
        $dab5a9e24bd89074$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $dab5a9e24bd89074$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $dab5a9e24bd89074$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $dab5a9e24bd89074$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $dab5a9e24bd89074$var$queue = [];
var $dab5a9e24bd89074$var$draining = false;
var $dab5a9e24bd89074$var$currentQueue;
var $dab5a9e24bd89074$var$queueIndex = -1;
function $dab5a9e24bd89074$var$cleanUpNextTick() {
    if (!$dab5a9e24bd89074$var$draining || !$dab5a9e24bd89074$var$currentQueue) return;
    $dab5a9e24bd89074$var$draining = false;
    if ($dab5a9e24bd89074$var$currentQueue.length) $dab5a9e24bd89074$var$queue = $dab5a9e24bd89074$var$currentQueue.concat($dab5a9e24bd89074$var$queue);
    else $dab5a9e24bd89074$var$queueIndex = -1;
    if ($dab5a9e24bd89074$var$queue.length) $dab5a9e24bd89074$var$drainQueue();
}
function $dab5a9e24bd89074$var$drainQueue() {
    if ($dab5a9e24bd89074$var$draining) return;
    var timeout = $dab5a9e24bd89074$var$runTimeout($dab5a9e24bd89074$var$cleanUpNextTick);
    $dab5a9e24bd89074$var$draining = true;
    var len = $dab5a9e24bd89074$var$queue.length;
    while(len){
        $dab5a9e24bd89074$var$currentQueue = $dab5a9e24bd89074$var$queue;
        $dab5a9e24bd89074$var$queue = [];
        while(++$dab5a9e24bd89074$var$queueIndex < len)if ($dab5a9e24bd89074$var$currentQueue) $dab5a9e24bd89074$var$currentQueue[$dab5a9e24bd89074$var$queueIndex].run();
        $dab5a9e24bd89074$var$queueIndex = -1;
        len = $dab5a9e24bd89074$var$queue.length;
    }
    $dab5a9e24bd89074$var$currentQueue = null;
    $dab5a9e24bd89074$var$draining = false;
    $dab5a9e24bd89074$var$runClearTimeout(timeout);
}
$dab5a9e24bd89074$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $dab5a9e24bd89074$var$queue.push(new $dab5a9e24bd89074$var$Item(fun, args));
    if ($dab5a9e24bd89074$var$queue.length === 1 && !$dab5a9e24bd89074$var$draining) $dab5a9e24bd89074$var$runTimeout($dab5a9e24bd89074$var$drainQueue);
};
// v8 likes predictible objects
function $dab5a9e24bd89074$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$dab5a9e24bd89074$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$dab5a9e24bd89074$var$process.title = "browser";
$dab5a9e24bd89074$var$process.browser = true;
$dab5a9e24bd89074$var$process.env = {};
$dab5a9e24bd89074$var$process.argv = [];
$dab5a9e24bd89074$var$process.version = ""; // empty string to avoid regexp issues
$dab5a9e24bd89074$var$process.versions = {};
function $dab5a9e24bd89074$var$noop() {}
$dab5a9e24bd89074$var$process.on = $dab5a9e24bd89074$var$noop;
$dab5a9e24bd89074$var$process.addListener = $dab5a9e24bd89074$var$noop;
$dab5a9e24bd89074$var$process.once = $dab5a9e24bd89074$var$noop;
$dab5a9e24bd89074$var$process.off = $dab5a9e24bd89074$var$noop;
$dab5a9e24bd89074$var$process.removeListener = $dab5a9e24bd89074$var$noop;
$dab5a9e24bd89074$var$process.removeAllListeners = $dab5a9e24bd89074$var$noop;
$dab5a9e24bd89074$var$process.emit = $dab5a9e24bd89074$var$noop;
$dab5a9e24bd89074$var$process.prependListener = $dab5a9e24bd89074$var$noop;
$dab5a9e24bd89074$var$process.prependOnceListener = $dab5a9e24bd89074$var$noop;
$dab5a9e24bd89074$var$process.listeners = function(name) {
    return [];
};
$dab5a9e24bd89074$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$dab5a9e24bd89074$var$process.cwd = function() {
    return "/";
};
$dab5a9e24bd89074$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$dab5a9e24bd89074$var$process.umask = function() {
    return 0;
};


function $eecdf173df47b6d4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $eecdf173df47b6d4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $eecdf173df47b6d4$var$_typeof(obj);
}
function $eecdf173df47b6d4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $eecdf173df47b6d4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $eecdf173df47b6d4$var$ownKeys(Object(source), !0).forEach(function(key) {
            $eecdf173df47b6d4$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $eecdf173df47b6d4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $eecdf173df47b6d4$var$_defineProperty(obj, key, value) {
    key = $eecdf173df47b6d4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $eecdf173df47b6d4$var$_toPropertyKey(arg) {
    var key = $eecdf173df47b6d4$var$_toPrimitive(arg, "string");
    return $eecdf173df47b6d4$var$_typeof(key) === "symbol" ? key : String(key);
}
function $eecdf173df47b6d4$var$_toPrimitive(input, hint) {
    if ($eecdf173df47b6d4$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($eecdf173df47b6d4$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $eecdf173df47b6d4$var$defaultUserAgents = [
    "react (".concat((0, $4rNTR.version), ")"),
    "react-instantsearch (".concat((0, $9a733937aba41e31$export$2e2bcd8739ae039), ")"),
    "react-instantsearch-core (".concat((0, $9a733937aba41e31$export$2e2bcd8739ae039), ")")
];
var $eecdf173df47b6d4$var$serverUserAgent = "react-instantsearch-server (".concat((0, $9a733937aba41e31$export$2e2bcd8739ae039), ")");
var $eecdf173df47b6d4$var$nextUserAgent = function nextUserAgent(nextVersion) {
    return nextVersion ? "next.js (".concat(nextVersion, ")") : null;
};
function $eecdf173df47b6d4$export$c42eabfabffc4866(props) {
    var forceUpdate = (0, $99f86b198d5fa8ef$export$91db9bc4f8ac944a)();
    var serverContext = (0, $069dd2e8db801d4a$export$692e83606e644bf6)();
    var serverState = (0, $0737848057cf6b19$export$b7b167d1ffee3ddc)();
    var waitingForResultsRef = (0, $98a4bafefa0373fc$export$b0820d56d4bdeee6)();
    var initialResults = serverState === null || serverState === void 0 ? void 0 : serverState.initialResults;
    var prevPropsRef = (0, $4rNTR.useRef)(props);
    var shouldRenderAtOnce = serverContext || initialResults || waitingForResultsRef;
    var searchRef = (0, $4rNTR.useRef)(null);
    // As we need to render on mount with SSR, using the local ref above in `StrictMode` will
    // create and start two instances of InstantSearch. To avoid this, we instead discard it and use
    // an upward ref from `InstantSearchSSRContext` as it has already been mounted a second time at this point.
    if (serverState) searchRef = serverState.ssrSearchRef;
    if (searchRef.current === null) {
        // We don't use the `instantsearch()` function because it comes with other
        // top-level APIs that we don't need.
        // See https://github.com/algolia/instantsearch/blob/5b529f43d8acc680f85837eaaa41f7fd03a3f833/src/index.es.ts#L63-L86
        var search = new (0, $bbd8b6e0d0869c08$export$2e2bcd8739ae039)(props);
        search._schedule = function _schedule(cb) {
            search._schedule.queue.push(cb);
            clearTimeout(search._schedule.timer);
            search._schedule.timer = setTimeout(function() {
                search._schedule.queue.forEach(function(callback) {
                    callback();
                });
                search._schedule.queue = [];
            }, 0);
        };
        search._schedule.queue = [];
        if (shouldRenderAtOnce) // InstantSearch.js has a private Initial Results API that lets us inject
        // results on the search instance.
        // On the server, we default the initial results to an empty object so that
        // InstantSearch.js doesn't schedule a search that isn't used, leading to
        // an additional network request. (This is equivalent to monkey-patching
        // `scheduleSearch` to a noop.)
        search._initialResults = initialResults || {};
        $eecdf173df47b6d4$var$addAlgoliaAgents(props.searchClient, [].concat($eecdf173df47b6d4$var$defaultUserAgents, [
            serverContext && $eecdf173df47b6d4$var$serverUserAgent,
            $eecdf173df47b6d4$var$nextUserAgent($eecdf173df47b6d4$var$getNextVersion())
        ]));
        // On the server, we start the search early to compute the search parameters.
        // On SSR, we start the search early to directly catch up with the lifecycle
        // and render.
        if (shouldRenderAtOnce) search.start();
        if (serverContext) // We notify `getServerState()` of the InstantSearch internals to retrieve
        // the server state and pass it to the render on SSR.
        serverContext.notifyServer({
            search: search
        });
        $eecdf173df47b6d4$var$warnNextRouter(props.routing);
        $eecdf173df47b6d4$var$warnNextAppDir(Boolean(waitingForResultsRef));
        searchRef.current = search;
    }
    var _search = searchRef.current;
    var prevProps = prevPropsRef.current;
    if (prevProps.indexName !== props.indexName) {
        _search.helper.setIndex(props.indexName || "").search();
        prevPropsRef.current = props;
    }
    if (prevProps.searchClient !== props.searchClient) {
        $eecdf173df47b6d4$var$addAlgoliaAgents(props.searchClient, [].concat($eecdf173df47b6d4$var$defaultUserAgents, [
            serverContext && $eecdf173df47b6d4$var$serverUserAgent
        ]));
        _search.mainHelper.setClient(props.searchClient).search();
        prevPropsRef.current = props;
    }
    if (prevProps.onStateChange !== props.onStateChange) {
        _search.onStateChange = props.onStateChange;
        prevPropsRef.current = props;
    }
    if (prevProps.searchFunction !== props.searchFunction) {
        // Updating the `searchFunction` to `undefined` is not supported by
        // InstantSearch.js, so it will throw an error.
        // This is a fair behavior until we add an update API in InstantSearch.js.
        _search._searchFunction = props.searchFunction;
        prevPropsRef.current = props;
    }
    if (prevProps.stalledSearchDelay !== props.stalledSearchDelay) {
        var _props$stalledSearchD;
        // The default `stalledSearchDelay` in InstantSearch.js is 200ms.
        // We need to reset it when it's undefined to get back to the original value.
        _search._stalledSearchDelay = (_props$stalledSearchD = props.stalledSearchDelay) !== null && _props$stalledSearchD !== void 0 ? _props$stalledSearchD : 200;
        prevPropsRef.current = props;
    }
    if (!(0, $e9a60775bb250308$export$de8294bb3be0322f)(prevProps.future, props.future)) {
        _search.future = $eecdf173df47b6d4$var$_objectSpread($eecdf173df47b6d4$var$_objectSpread({}, (0, $bbd8b6e0d0869c08$export$8bd42a83af1ca676)), props.future);
        prevPropsRef.current = props;
    }
    var cleanupTimerRef = (0, $4rNTR.useRef)(null);
    var store = (0, $a8c82b7320c97ac5$exports.useSyncExternalStore)((0, $4rNTR.useCallback)(function() {
        var search = searchRef.current;
        // Scenario 1: the component mounts.
        if (cleanupTimerRef.current === null) // On SSR, the instance is already started so we don't start it again.
        {
            if (!search.started) {
                search.start();
                forceUpdate();
            }
        } else {
            // We cancel the previous cleanup function because we don't want to
            // dispose the search during an update.
            clearTimeout(cleanupTimerRef.current);
            search._preventWidgetCleanup = false;
        }
        return function() {
            function cleanup() {
                search.dispose();
            }
            clearTimeout(search._schedule.timer);
            // We clean up only when the component that uses this subscription unmounts,
            // but not when it updates, because it would dispose the instance, which
            // would remove all the widgets and break routing.
            // Executing the cleanup function in a `setTimeout()` lets us cancel it
            // in the next effect.
            // (There might be better ways to do this.)
            cleanupTimerRef.current = setTimeout(cleanup);
            // We need to prevent the `useWidget` cleanup function so that widgets
            // are not removed before the instance is disposed, triggering
            // an unwanted search request.
            search._preventWidgetCleanup = true;
        };
    }, [
        forceUpdate
    ]), function() {
        return searchRef.current;
    }, function() {
        return searchRef.current;
    });
    return store;
}
function $eecdf173df47b6d4$var$addAlgoliaAgents(searchClient, userAgents) {
    if (typeof searchClient.addAlgoliaAgent !== "function") return;
    userAgents.filter(Boolean).forEach(function(userAgent) {
        searchClient.addAlgoliaAgent(userAgent);
    });
}
function $eecdf173df47b6d4$var$warnNextRouter(routing) {
    var _routing$router, isUsingNextRouter;
}
function $eecdf173df47b6d4$var$warnNextAppDir(isRscContextDefined) {
    var _next;
    return;
}
/**
 * Gets the version of Next.js if it is available in the `window` object,
 * otherwise it returns the NEXT_RUNTIME environment variable (in SSR),
 * which is either `nodejs` or `edge`.
 */ function $eecdf173df47b6d4$var$getNextVersion() {
    var _next2, _process$env;
    return typeof window !== "undefined" && ((_next2 = window.next) === null || _next2 === void 0 ? void 0 : _next2.version) || (typeof $dab5a9e24bd89074$exports !== "undefined" ? (_process$env = {}, _process$env === void 0) ? void 0 : _process$env.NEXT_RUNTIME : undefined);
}


var $e029f0879523ffed$var$_excluded = [
    "children"
];
function $e029f0879523ffed$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e029f0879523ffed$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e029f0879523ffed$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e029f0879523ffed$export$ad8f235d2c2c71c0(_ref) {
    var children = _ref.children, props = $e029f0879523ffed$var$_objectWithoutProperties(_ref, $e029f0879523ffed$var$_excluded);
    var search = (0, $eecdf173df47b6d4$export$c42eabfabffc4866)(props);
    if (!search.started) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement((0, $93aff80651844e0e$export$4b9ddb9c6903c13).Provider, {
        value: search
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement((0, $f765a77f41ff4abf$export$899c7584ba03b94a).Provider, {
        value: search.mainIndex
    }, children));
}


var $4rNTR = parcelRequire("4rNTR");
function $d1f13103b9562995$export$11cc42aebef2ef3a(object) {
    return Object.prototype.toString.call(object).slice(8, -1);
}


function $c9c42a7fa64cf8eb$export$adc2a8e09aa583ee(rendering, usage) {
    if (rendering === undefined || typeof rendering !== "function") throw new Error("The render function is not valid (received type ".concat((0, $d1f13103b9562995$export$11cc42aebef2ef3a)(rendering), ").\n\n").concat(usage));
}


function $a6f5b5d7abd3f3eb$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $a6f5b5d7abd3f3eb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $a6f5b5d7abd3f3eb$var$_typeof(obj);
}
function $a6f5b5d7abd3f3eb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a6f5b5d7abd3f3eb$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a6f5b5d7abd3f3eb$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a6f5b5d7abd3f3eb$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a6f5b5d7abd3f3eb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a6f5b5d7abd3f3eb$var$_defineProperty(obj, key, value) {
    key = $a6f5b5d7abd3f3eb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a6f5b5d7abd3f3eb$var$_toPropertyKey(arg) {
    var key = $a6f5b5d7abd3f3eb$var$_toPrimitive(arg, "string");
    return $a6f5b5d7abd3f3eb$var$_typeof(key) === "symbol" ? key : String(key);
}
function $a6f5b5d7abd3f3eb$var$_toPrimitive(input, hint) {
    if ($a6f5b5d7abd3f3eb$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($a6f5b5d7abd3f3eb$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $a6f5b5d7abd3f3eb$var$withUsage = (0, $44084963839a4436$export$2fde5bffc340821e)({
    name: "search-box",
    connector: true
});
/**
 * @typedef {Object} CustomSearchBoxWidgetParams
 * @property {function(string, function(string))} [queryHook = undefined] A function that will be called every time
 * a new value for the query is set. The first parameter is the query and the second is a
 * function to actually trigger the search. The function takes the query as the parameter.
 *
 * This queryHook can be used to debounce the number of searches done from the searchBox.
 */ var $a6f5b5d7abd3f3eb$var$defaultQueryHook = function defaultQueryHook(query, hook) {
    return hook(query);
};
/**
 * **SearchBox** connector provides the logic to build a widget that will let the user search for a query.
 *
 * The connector provides to the rendering: `refine()` to set the query. The behaviour of this function
 * may be impacted by the `queryHook` widget parameter.
 */ var $a6f5b5d7abd3f3eb$var$connectSearchBox = function connectSearchBox(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $5d3ef3e388d952bb$export$8793edee2d425525);
    (0, $c9c42a7fa64cf8eb$export$adc2a8e09aa583ee)(renderFn, $a6f5b5d7abd3f3eb$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, _ref$queryHook = _ref.queryHook, queryHook = _ref$queryHook === void 0 ? $a6f5b5d7abd3f3eb$var$defaultQueryHook : _ref$queryHook;
        var _refine;
        var _clear;
        return {
            $$type: "ais.searchBox",
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($a6f5b5d7abd3f3eb$var$_objectSpread($a6f5b5d7abd3f3eb$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($a6f5b5d7abd3f3eb$var$_objectSpread($a6f5b5d7abd3f3eb$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref2) {
                var state = _ref2.state;
                unmountFn();
                return state.setQueryParameter("query", undefined);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $a6f5b5d7abd3f3eb$var$_objectSpread($a6f5b5d7abd3f3eb$var$_objectSpread({}, renderState), {}, {
                    searchBox: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref3) {
                var helper = _ref3.helper, instantSearchInstance = _ref3.instantSearchInstance, state = _ref3.state;
                if (!_refine) {
                    _refine = function _refine(query) {
                        queryHook(query, function(q) {
                            return helper.setQuery(q).search();
                        });
                    };
                    _clear = function _clear() {
                        helper.setQuery("").search();
                    };
                }
                return {
                    query: state.query || "",
                    refine: _refine,
                    clear: _clear,
                    widgetParams: widgetParams,
                    isSearchStalled: instantSearchInstance.status === "stalled"
                };
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref4) {
                var searchParameters = _ref4.searchParameters;
                var query = searchParameters.query || "";
                if (query === "" || uiState && uiState.query === query) return uiState;
                return $a6f5b5d7abd3f3eb$var$_objectSpread($a6f5b5d7abd3f3eb$var$_objectSpread({}, uiState), {}, {
                    query: query
                });
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref5) {
                var uiState = _ref5.uiState;
                return searchParameters.setQueryParameter("query", uiState.query || "");
            }
        };
    };
};
var $a6f5b5d7abd3f3eb$export$2e2bcd8739ae039 = $a6f5b5d7abd3f3eb$var$connectSearchBox;



var $4rNTR = parcelRequire("4rNTR");


function $f2bd7c4305d571fc$export$be9bb8d98a5619e9(state) {
    var _state$query, _state$page, _state$hitsPerPage;
    return new (0, (/*@__PURE__*/$parcel$interopDefault($154f73342ab39590$exports))).SearchResults(state, [
        {
            query: (_state$query = state.query) !== null && _state$query !== void 0 ? _state$query : "",
            page: (_state$page = state.page) !== null && _state$page !== void 0 ? _state$page : 0,
            hitsPerPage: (_state$hitsPerPage = state.hitsPerPage) !== null && _state$hitsPerPage !== void 0 ? _state$hitsPerPage : 20,
            hits: [],
            nbHits: 0,
            nbPages: 0,
            params: "",
            exhaustiveNbHits: true,
            exhaustiveFacetsCount: true,
            processingTimeMS: 0,
            index: state.index
        }
    ], {
        /** used by connectors to prevent persisting these results */ __isArtificial: true
    });
}


function $a9ad9293f1baef7c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $a9ad9293f1baef7c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $a9ad9293f1baef7c$var$_typeof(obj);
}
function $a9ad9293f1baef7c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a9ad9293f1baef7c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a9ad9293f1baef7c$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a9ad9293f1baef7c$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a9ad9293f1baef7c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a9ad9293f1baef7c$var$_defineProperty(obj, key, value) {
    key = $a9ad9293f1baef7c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a9ad9293f1baef7c$var$_toPropertyKey(arg) {
    var key = $a9ad9293f1baef7c$var$_toPrimitive(arg, "string");
    return $a9ad9293f1baef7c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $a9ad9293f1baef7c$var$_toPrimitive(input, hint) {
    if ($a9ad9293f1baef7c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($a9ad9293f1baef7c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $a9ad9293f1baef7c$export$cb51f617c98f90d3(indexWidget) {
    var helper = indexWidget.getHelper();
    var results = // On SSR, we get the results injected on the Index.
    indexWidget.getResults() || // On the browser, we create fallback results based on the helper state.
    (0, $f2bd7c4305d571fc$export$be9bb8d98a5619e9)(helper.state);
    var scopedResults = indexWidget.getScopedResults().map(function(scopedResult) {
        var fallbackResults = scopedResult.indexId === indexWidget.getIndexId() ? results : (0, $f2bd7c4305d571fc$export$be9bb8d98a5619e9)(scopedResult.helper.state);
        return $a9ad9293f1baef7c$var$_objectSpread($a9ad9293f1baef7c$var$_objectSpread({}, scopedResult), {}, {
            // We keep `results` from being `null`.
            results: scopedResult.results || fallbackResults
        });
    });
    return {
        results: results,
        scopedResults: scopedResults
    };
}



var $4rNTR = parcelRequire("4rNTR");
/**
 * Throws an error if the condition is not met.
 *
 * The error is exhaustive in development, and becomes generic in production.
 *
 * This is used to make development a better experience to provide guidance as
 * to where the error comes from.
 */ function $3fc57e8fdaeb5f31$export$f5708dca728d7177(condition, message) {
    if (condition) return;
    throw new Error("Invariant failed");
}



function $e8c9c95883f15326$export$78be30f1ffebe6ed() {
    var context = (0, $4rNTR.useContext)((0, $f765a77f41ff4abf$export$899c7584ba03b94a));
    (0, $3fc57e8fdaeb5f31$export$f5708dca728d7177)(context !== null, "The <Index> component must be used within <InstantSearch>.");
    return context;
}



var $4rNTR = parcelRequire("4rNTR");


function $16f0a1f9504e36e2$export$607655cdd66d2a68() {
    var search = (0, $4rNTR.useContext)((0, $93aff80651844e0e$export$4b9ddb9c6903c13));
    (0, $3fc57e8fdaeb5f31$export$f5708dca728d7177)(search !== null, "Hooks must be used inside the <InstantSearch> component.\n\nThey are not compatible with the `react-instantsearch-core@6.x` and `react-instantsearch-dom` packages, so make sure to use the <InstantSearch> component from `react-instantsearch-core@7.x`.");
    return search;
}




var $4rNTR = parcelRequire("4rNTR");

function $6661d56a04a778dc$var$_slicedToArray(arr, i) {
    return $6661d56a04a778dc$var$_arrayWithHoles(arr) || $6661d56a04a778dc$var$_iterableToArrayLimit(arr, i) || $6661d56a04a778dc$var$_unsupportedIterableToArray(arr, i) || $6661d56a04a778dc$var$_nonIterableRest();
}
function $6661d56a04a778dc$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6661d56a04a778dc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6661d56a04a778dc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6661d56a04a778dc$var$_arrayLikeToArray(o, minLen);
}
function $6661d56a04a778dc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6661d56a04a778dc$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $6661d56a04a778dc$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $6661d56a04a778dc$export$e15835fface14b28(value) {
    var _useState = (0, $4rNTR.useState)(function() {
        return value;
    }), _useState2 = $6661d56a04a778dc$var$_slicedToArray(_useState, 2), stableValue = _useState2[0], setStableValue = _useState2[1];
    if (!(0, $e9a60775bb250308$export$de8294bb3be0322f)(stableValue, value)) setStableValue(value);
    return stableValue;
}



var $4rNTR = parcelRequire("4rNTR");


var $4rNTR = parcelRequire("4rNTR");
var $d12608b228d41f6d$var$useKey = "use";
var $d12608b228d41f6d$export$1f96ae73734a86cc = $4rNTR[$d12608b228d41f6d$var$useKey];




var $4rNTR = parcelRequire("4rNTR");
var $2a7c74f272413fda$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $4rNTR.useLayoutEffect) : (0, $4rNTR.useEffect);



function $0f84479040493ae8$export$bed784987806c3d2(_ref) {
    var _waitingForResultsRef;
    var widget = _ref.widget, parentIndex = _ref.parentIndex, props = _ref.props, shouldSsr = _ref.shouldSsr;
    var waitingForResultsRef = (0, $98a4bafefa0373fc$export$b0820d56d4bdeee6)();
    var prevPropsRef = (0, $4rNTR.useRef)(props);
    (0, $4rNTR.useEffect)(function() {
        prevPropsRef.current = props;
    }, [
        props
    ]);
    var prevWidgetRef = (0, $4rNTR.useRef)(widget);
    (0, $4rNTR.useEffect)(function() {
        prevWidgetRef.current = widget;
    }, [
        widget
    ]);
    var cleanupTimerRef = (0, $4rNTR.useRef)(null);
    var shouldAddWidgetEarly = shouldSsr && !parentIndex.getWidgets().includes(widget);
    var search = (0, $16f0a1f9504e36e2$export$607655cdd66d2a68)();
    // This effect is responsible for adding, removing, and updating the widget.
    // We need to support scenarios where the widget is remounted quickly, like in
    // Strict Mode, so that we don't lose its state, and therefore that we don't
    // break routing.
    (0, $2a7c74f272413fda$export$700979bc83e7db82)(function() {
        var previousWidget = prevWidgetRef.current;
        // Scenario 1: the widget is added for the first time.
        if (!cleanupTimerRef.current) {
            if (!shouldSsr) parentIndex.addWidgets([
                widget
            ]);
        } else {
            // We cancel the original effect cleanup because it may not be necessary if
            // props haven't changed. (We manually call it if it is below.)
            clearTimeout(cleanupTimerRef.current);
            // Warning: if an unstable function prop is provided, `dequal` is not able
            // to keep its reference and therefore will consider that props did change.
            // This could unsollicitely remove/add the widget, therefore forget its state,
            // and could be a source of confusion.
            // If users face this issue, we should advise them to provide stable function
            // references.
            var arePropsEqual = (0, $e9a60775bb250308$export$de8294bb3be0322f)(props, prevPropsRef.current);
            // If props did change, then we execute the cleanup function instantly
            // and then add the widget back. This lets us add the widget without
            // waiting for the scheduled cleanup function to finish (that we canceled
            // above).
            if (!arePropsEqual) {
                parentIndex.removeWidgets([
                    previousWidget
                ]);
                parentIndex.addWidgets([
                    widget
                ]);
            }
        }
        return function() {
            // We don't remove the widget right away, but rather schedule it so that
            // we're able to cancel it in the next effect.
            cleanupTimerRef.current = setTimeout(function() {
                search._schedule(function() {
                    if (search._preventWidgetCleanup) return;
                    parentIndex.removeWidgets([
                        previousWidget
                    ]);
                });
            });
        };
    }, [
        parentIndex,
        widget,
        shouldSsr,
        search,
        props
    ]);
    if (shouldAddWidgetEarly || (waitingForResultsRef === null || waitingForResultsRef === void 0 ? void 0 : (_waitingForResultsRef = waitingForResultsRef.current) === null || _waitingForResultsRef === void 0 ? void 0 : _waitingForResultsRef.status) === "pending") parentIndex.addWidgets([
        widget
    ]);
    if (typeof window === "undefined" && waitingForResultsRef !== null && waitingForResultsRef !== void 0 && waitingForResultsRef.current && // We need the widgets contained in the index to be added before we trigger the search request.
    widget.$$type !== "ais.index") {
        var _search$helper;
        (0, $d12608b228d41f6d$export$1f96ae73734a86cc)(waitingForResultsRef.current);
        // If we made a second request because of DynamicWidgets, we need to wait for the second result,
        // except for DynamicWidgets itself which needs to render its children after the first result.
        if (widget.$$type !== "ais.dynamicWidgets" && (_search$helper = search.helper) !== null && _search$helper !== void 0 && _search$helper.lastResults) (0, $d12608b228d41f6d$export$1f96ae73734a86cc)(waitingForResultsRef.current);
    }
}


function $dc402206ef11e68a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $dc402206ef11e68a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $dc402206ef11e68a$var$_typeof(obj);
}
var $dc402206ef11e68a$var$_excluded = [
    "instantSearchInstance",
    "widgetParams"
], $dc402206ef11e68a$var$_excluded2 = [
    "widgetParams"
];
function $dc402206ef11e68a$var$_slicedToArray(arr, i) {
    return $dc402206ef11e68a$var$_arrayWithHoles(arr) || $dc402206ef11e68a$var$_iterableToArrayLimit(arr, i) || $dc402206ef11e68a$var$_unsupportedIterableToArray(arr, i) || $dc402206ef11e68a$var$_nonIterableRest();
}
function $dc402206ef11e68a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $dc402206ef11e68a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $dc402206ef11e68a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $dc402206ef11e68a$var$_arrayLikeToArray(o, minLen);
}
function $dc402206ef11e68a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $dc402206ef11e68a$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $dc402206ef11e68a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $dc402206ef11e68a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $dc402206ef11e68a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $dc402206ef11e68a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $dc402206ef11e68a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $dc402206ef11e68a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $dc402206ef11e68a$var$_defineProperty(obj, key, value) {
    key = $dc402206ef11e68a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dc402206ef11e68a$var$_toPropertyKey(arg) {
    var key = $dc402206ef11e68a$var$_toPrimitive(arg, "string");
    return $dc402206ef11e68a$var$_typeof(key) === "symbol" ? key : String(key);
}
function $dc402206ef11e68a$var$_toPrimitive(input, hint) {
    if ($dc402206ef11e68a$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($dc402206ef11e68a$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $dc402206ef11e68a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $dc402206ef11e68a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $dc402206ef11e68a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $dc402206ef11e68a$export$7b345619fa263f7e(connector) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var additionalWidgetProperties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var serverContext = (0, $069dd2e8db801d4a$export$692e83606e644bf6)();
    var search = (0, $16f0a1f9504e36e2$export$607655cdd66d2a68)();
    var parentIndex = (0, $e8c9c95883f15326$export$78be30f1ffebe6ed)();
    var stableProps = (0, $6661d56a04a778dc$export$e15835fface14b28)(props);
    var stableAdditionalWidgetProperties = (0, $6661d56a04a778dc$export$e15835fface14b28)(additionalWidgetProperties);
    var shouldSetStateRef = (0, $4rNTR.useRef)(true);
    var previousRenderStateRef = (0, $4rNTR.useRef)(null);
    var previousStatusRef = (0, $4rNTR.useRef)(search.status);
    var widget = (0, $4rNTR.useMemo)(function() {
        var createWidget = connector(function(connectorState, isFirstRender) {
            // We skip the `init` widget render because:
            // - We rely on `getWidgetRenderState` to compute the initial state before
            //   the InstantSearch.js lifecycle starts.
            // - It prevents UI flashes when updating the widget props.
            if (isFirstRender) {
                shouldSetStateRef.current = true;
                return;
            }
            // There are situations where InstantSearch.js may render widgets slightly
            // after they're removed by React, and thus try to update the React state
            // on unmounted components. React 16 and 17 consider them as memory leaks
            // and display a warning.
            // This happens in <DynamicWidgets> when `attributesToRender` contains a
            // value without an attribute previously mounted. React will unmount the
            // component controlled by that attribute, but InstantSearch.js will stay
            // unaware of this change until the render pass finishes, and therefore
            // notifies of a state change.
            // This ref lets us track this situation and ignore these state updates.
            if (shouldSetStateRef.current) {
                var instantSearchInstance = connectorState.instantSearchInstance, widgetParams = connectorState.widgetParams, renderState = $dc402206ef11e68a$var$_objectWithoutProperties(connectorState, $dc402206ef11e68a$var$_excluded);
                // We only update the state when a widget render state param changes,
                // except for functions. We ignore function reference changes to avoid
                // infinite loops. It's safe to omit them because they get updated
                // every time another render param changes.
                if (!(0, $e9a60775bb250308$export$de8294bb3be0322f)(renderState, previousRenderStateRef.current, function(a, b) {
                    return (a === null || a === void 0 ? void 0 : a.constructor) === Function && (b === null || b === void 0 ? void 0 : b.constructor) === Function;
                }) || instantSearchInstance.status !== previousStatusRef.current) {
                    // eslint-disable-next-line @typescript-eslint/no-use-before-define
                    setState(renderState);
                    previousRenderStateRef.current = renderState;
                    previousStatusRef.current = instantSearchInstance.status;
                }
            }
        }, function() {
            // We'll ignore the next state update until we know for sure that
            // InstantSearch.js re-inits the component.
            shouldSetStateRef.current = false;
        });
        return $dc402206ef11e68a$var$_objectSpread($dc402206ef11e68a$var$_objectSpread({}, createWidget(stableProps)), stableAdditionalWidgetProperties);
    }, [
        connector,
        stableProps,
        stableAdditionalWidgetProperties
    ]);
    var _useState = (0, $4rNTR.useState)(function() {
        if (widget.getWidgetRenderState) {
            var _widget$getWidgetSear;
            // The helper exists because we've started InstantSearch.
            var helper = parentIndex.getHelper();
            var uiState = parentIndex.getWidgetUiState({})[parentIndex.getIndexId()];
            helper.state = ((_widget$getWidgetSear = widget.getWidgetSearchParameters) === null || _widget$getWidgetSear === void 0 ? void 0 : _widget$getWidgetSear.call(widget, helper.state, {
                uiState: uiState
            })) || helper.state;
            var _getIndexSearchResult = (0, $a9ad9293f1baef7c$export$cb51f617c98f90d3)(parentIndex), results = _getIndexSearchResult.results, scopedResults = _getIndexSearchResult.scopedResults;
            // We get the widget render state by providing the same parameters as
            // InstantSearch provides to the widget's `render` method.
            // See https://github.com/algolia/instantsearch/blob/019cd18d0de6dd320284aa4890541b7fe2198c65/src/widgets/index/index.ts#L604-L617
            var _widget$getWidgetRend = widget.getWidgetRenderState({
                helper: helper,
                parent: parentIndex,
                instantSearchInstance: search,
                results: results,
                scopedResults: scopedResults,
                state: helper.state,
                renderState: search.renderState,
                templatesConfig: search.templatesConfig,
                createURL: parentIndex.createURL,
                searchMetadata: {
                    isSearchStalled: search.status === "stalled"
                },
                status: search.status,
                error: search.error
            }), widgetParams = _widget$getWidgetRend.widgetParams, renderState = $dc402206ef11e68a$var$_objectWithoutProperties(_widget$getWidgetRend, $dc402206ef11e68a$var$_excluded2);
            return renderState;
        }
        return {};
    }), _useState2 = $dc402206ef11e68a$var$_slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    (0, $0f84479040493ae8$export$bed784987806c3d2)({
        widget: widget,
        parentIndex: parentIndex,
        props: stableProps,
        shouldSsr: Boolean(serverContext)
    });
    return state;
}


function $2208d89299218ca5$export$34d981d965dcc5b5(props, additionalWidgetProperties) {
    return (0, $dc402206ef11e68a$export$7b345619fa263f7e)((0, $a6f5b5d7abd3f3eb$export$2e2bcd8739ae039), props, additionalWidgetProperties);
}


function $b252d2dae9b61923$export$a274e22fb40f762e() {
    for(var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++)classNames[_key] = arguments[_key];
    return classNames.reduce(function(acc, className) {
        if (Array.isArray(className)) return acc.concat(className);
        return acc.concat([
            className
        ]);
    }, []).filter(Boolean).join(" ");
}



var $4rNTR = parcelRequire("4rNTR");
var $47a71d88e79f1269$var$_excluded = [
    "formRef",
    "inputRef",
    "isSearchStalled",
    "onChange",
    "onReset",
    "onSubmit",
    "placeholder",
    "value",
    "autoFocus",
    "resetIconComponent",
    "submitIconComponent",
    "loadingIconComponent",
    "classNames",
    "translations"
];
function $47a71d88e79f1269$var$_extends() {
    $47a71d88e79f1269$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $47a71d88e79f1269$var$_extends.apply(this, arguments);
}
function $47a71d88e79f1269$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $47a71d88e79f1269$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $47a71d88e79f1269$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $47a71d88e79f1269$var$_ref2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("path", {
    d: "M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z"
});
function $47a71d88e79f1269$var$DefaultSubmitIcon(_ref) {
    var classNames = _ref.classNames;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("svg", {
        className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-SearchBox-submitIcon", classNames.submitIcon),
        width: "10",
        height: "10",
        viewBox: "0 0 40 40",
        "aria-hidden": "true"
    }, $47a71d88e79f1269$var$_ref2);
}
var $47a71d88e79f1269$var$_ref4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("path", {
    d: "M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z"
});
function $47a71d88e79f1269$var$DefaultResetIcon(_ref3) {
    var classNames = _ref3.classNames;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("svg", {
        className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-SearchBox-resetIcon", classNames.resetIcon),
        viewBox: "0 0 20 20",
        width: "10",
        height: "10",
        "aria-hidden": "true"
    }, $47a71d88e79f1269$var$_ref4);
}
var $47a71d88e79f1269$var$_ref6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("g", {
    fill: "none",
    fillRule: "evenodd"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("g", {
    transform: "translate(1 1)",
    strokeWidth: "2"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("circle", {
    strokeOpacity: ".5",
    cx: "18",
    cy: "18",
    r: "18"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("path", {
    d: "M36 18c0-9.94-8.06-18-18-18"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 18 18",
    to: "360 18 18",
    dur: "1s",
    repeatCount: "indefinite"
}))));
function $47a71d88e79f1269$var$DefaultLoadingIcon(_ref5) {
    var classNames = _ref5.classNames;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("svg", {
        "aria-label": "Results are loading",
        width: "16",
        height: "16",
        viewBox: "0 0 38 38",
        stroke: "#444",
        className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-SearchBox-loadingIcon", classNames.loadingIcon),
        "aria-hidden": "true"
    }, $47a71d88e79f1269$var$_ref6);
}
function $47a71d88e79f1269$export$5a58787633b0b5d8(_ref7) {
    var formRef = _ref7.formRef, inputRef = _ref7.inputRef, isSearchStalled = _ref7.isSearchStalled, onChange = _ref7.onChange, onReset = _ref7.onReset, onSubmit = _ref7.onSubmit, _ref7$placeholder = _ref7.placeholder, placeholder = _ref7$placeholder === void 0 ? "" : _ref7$placeholder, value = _ref7.value, autoFocus = _ref7.autoFocus, _ref7$resetIconCompon = _ref7.resetIconComponent, ResetIcon = _ref7$resetIconCompon === void 0 ? $47a71d88e79f1269$var$DefaultResetIcon : _ref7$resetIconCompon, _ref7$submitIconCompo = _ref7.submitIconComponent, SubmitIcon = _ref7$submitIconCompo === void 0 ? $47a71d88e79f1269$var$DefaultSubmitIcon : _ref7$submitIconCompo, _ref7$loadingIconComp = _ref7.loadingIconComponent, LoadingIcon = _ref7$loadingIconComp === void 0 ? $47a71d88e79f1269$var$DefaultLoadingIcon : _ref7$loadingIconComp, _ref7$classNames = _ref7.classNames, classNames = _ref7$classNames === void 0 ? {} : _ref7$classNames, translations = _ref7.translations, props = $47a71d88e79f1269$var$_objectWithoutProperties(_ref7, $47a71d88e79f1269$var$_excluded);
    function handleSubmit(event) {
        event.preventDefault();
        event.stopPropagation();
        if (onSubmit) onSubmit(event);
        if (inputRef.current) inputRef.current.blur();
    }
    function handleReset(event) {
        event.preventDefault();
        event.stopPropagation();
        onReset(event);
        if (inputRef.current) inputRef.current.focus();
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("div", $47a71d88e79f1269$var$_extends({}, props, {
        className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-SearchBox", classNames.root, props.className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("form", {
        ref: formRef,
        action: "",
        className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-SearchBox-form", classNames.form),
        noValidate: true,
        onSubmit: handleSubmit,
        onReset: handleReset,
        role: "search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("input", {
        ref: inputRef,
        className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-SearchBox-input", classNames.input),
        "aria-label": "Search",
        autoComplete: "off",
        autoCorrect: "off",
        autoCapitalize: "off",
        placeholder: placeholder,
        spellCheck: false,
        maxLength: 512,
        type: "search",
        value: value,
        onChange: onChange,
        onCompositionEnd: onChange,
        autoFocus: autoFocus
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("button", {
        className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-SearchBox-submit", classNames.submit),
        type: "submit",
        title: translations.submitButtonTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement(SubmitIcon, {
        classNames: classNames
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("button", {
        className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-SearchBox-reset", classNames.reset),
        type: "reset",
        title: translations.resetButtonTitle,
        hidden: value.length === 0 || isSearchStalled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement(ResetIcon, {
        classNames: classNames
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("span", {
        className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-SearchBox-loadingIndicator", classNames.loadingIndicator),
        hidden: !isSearchStalled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement(LoadingIcon, {
        classNames: classNames
    }))));
}


function $af9fe37648bf2f63$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $af9fe37648bf2f63$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $af9fe37648bf2f63$var$_typeof(obj);
}
var $af9fe37648bf2f63$var$_excluded = [
    "queryHook",
    "searchAsYouType",
    "ignoreCompositionEvents",
    "translations"
];
function $af9fe37648bf2f63$var$_extends() {
    $af9fe37648bf2f63$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $af9fe37648bf2f63$var$_extends.apply(this, arguments);
}
function $af9fe37648bf2f63$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $af9fe37648bf2f63$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $af9fe37648bf2f63$var$ownKeys(Object(source), !0).forEach(function(key) {
            $af9fe37648bf2f63$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $af9fe37648bf2f63$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $af9fe37648bf2f63$var$_defineProperty(obj, key, value) {
    key = $af9fe37648bf2f63$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $af9fe37648bf2f63$var$_toPropertyKey(arg) {
    var key = $af9fe37648bf2f63$var$_toPrimitive(arg, "string");
    return $af9fe37648bf2f63$var$_typeof(key) === "symbol" ? key : String(key);
}
function $af9fe37648bf2f63$var$_toPrimitive(input, hint) {
    if ($af9fe37648bf2f63$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($af9fe37648bf2f63$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $af9fe37648bf2f63$var$_slicedToArray(arr, i) {
    return $af9fe37648bf2f63$var$_arrayWithHoles(arr) || $af9fe37648bf2f63$var$_iterableToArrayLimit(arr, i) || $af9fe37648bf2f63$var$_unsupportedIterableToArray(arr, i) || $af9fe37648bf2f63$var$_nonIterableRest();
}
function $af9fe37648bf2f63$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $af9fe37648bf2f63$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $af9fe37648bf2f63$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $af9fe37648bf2f63$var$_arrayLikeToArray(o, minLen);
}
function $af9fe37648bf2f63$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $af9fe37648bf2f63$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $af9fe37648bf2f63$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $af9fe37648bf2f63$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $af9fe37648bf2f63$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $af9fe37648bf2f63$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $af9fe37648bf2f63$export$5a58787633b0b5d8(_ref) {
    var queryHook = _ref.queryHook, _ref$searchAsYouType = _ref.searchAsYouType, searchAsYouType = _ref$searchAsYouType === void 0 ? true : _ref$searchAsYouType, _ref$ignoreCompositio = _ref.ignoreCompositionEvents, ignoreCompositionEvents = _ref$ignoreCompositio === void 0 ? false : _ref$ignoreCompositio, translations = _ref.translations, props = $af9fe37648bf2f63$var$_objectWithoutProperties(_ref, $af9fe37648bf2f63$var$_excluded);
    var _useSearchBox = (0, $2208d89299218ca5$export$34d981d965dcc5b5)({
        queryHook: queryHook
    }, {
        $$widgetType: "ais.searchBox"
    }), query = _useSearchBox.query, refine = _useSearchBox.refine, isSearchStalled = _useSearchBox.isSearchStalled;
    var _useState = (0, $4rNTR.useState)(query), _useState2 = $af9fe37648bf2f63$var$_slicedToArray(_useState, 2), inputValue = _useState2[0], setInputValue = _useState2[1];
    var inputRef = (0, $4rNTR.useRef)(null);
    function setQuery(newQuery) {
        var isComposing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        setInputValue(newQuery);
        if (searchAsYouType && !(ignoreCompositionEvents && isComposing)) refine(newQuery);
    }
    function onReset() {
        setQuery("");
        if (!searchAsYouType) refine("");
    }
    function onChange(event) {
        setQuery(event.currentTarget.value, event.nativeEvent.isComposing);
    }
    function onSubmit(event) {
        if (!searchAsYouType) refine(inputValue);
        if (props.onSubmit) props.onSubmit(event);
    }
    // Track when the InstantSearch query changes to synchronize it with
    // the React state.
    // We bypass the state update if the input is focused to avoid concurrent
    // updates when typing.
    if (query !== inputValue && document.activeElement !== inputRef.current) setInputValue(query);
    var uiProps = {
        inputRef: inputRef,
        isSearchStalled: isSearchStalled,
        onChange: onChange,
        onReset: onReset,
        onSubmit: onSubmit,
        value: inputValue,
        translations: $af9fe37648bf2f63$var$_objectSpread({
            submitButtonTitle: "Submit the search query",
            resetButtonTitle: "Clear the search query"
        }, translations)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement((0, $47a71d88e79f1269$export$5a58787633b0b5d8), $af9fe37648bf2f63$var$_extends({}, props, uiProps));
}



function $8d065bb96d52ed31$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $8d065bb96d52ed31$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $8d065bb96d52ed31$var$_typeof(obj);
}
function $8d065bb96d52ed31$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8d065bb96d52ed31$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8d065bb96d52ed31$var$ownKeys(Object(source), !0).forEach(function(key) {
            $8d065bb96d52ed31$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8d065bb96d52ed31$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8d065bb96d52ed31$var$_defineProperty(obj, key, value) {
    key = $8d065bb96d52ed31$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8d065bb96d52ed31$var$_toPropertyKey(arg) {
    var key = $8d065bb96d52ed31$var$_toPrimitive(arg, "string");
    return $8d065bb96d52ed31$var$_typeof(key) === "symbol" ? key : String(key);
}
function $8d065bb96d52ed31$var$_toPrimitive(input, hint) {
    if ($8d065bb96d52ed31$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($8d065bb96d52ed31$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/**
 * Refine the given search parameters.
 */ var $8d065bb96d52ed31$var$withUsage = (0, $44084963839a4436$export$2fde5bffc340821e)({
    name: "configure",
    connector: true
});
function $8d065bb96d52ed31$var$getInitialSearchParameters(state, widgetParams) {
    // We leverage the helper internals to remove the `widgetParams` from
    // the state. The function `setQueryParameters` omits the values that
    // are `undefined` on the next state.
    return state.setQueryParameters(Object.keys(widgetParams.searchParameters).reduce(function(acc, key) {
        return $8d065bb96d52ed31$var$_objectSpread($8d065bb96d52ed31$var$_objectSpread({}, acc), {}, $8d065bb96d52ed31$var$_defineProperty({}, key, undefined));
    }, {}));
}
var $8d065bb96d52ed31$var$connectConfigure = function connectConfigure() {
    var renderFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $5d3ef3e388d952bb$export$8793edee2d425525);
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $5d3ef3e388d952bb$export$8793edee2d425525);
    return function(widgetParams) {
        if (!widgetParams || !(0, $55631d4f00075070$export$53b83ca8eaab0383)(widgetParams.searchParameters)) throw new Error($8d065bb96d52ed31$var$withUsage("The `searchParameters` option expects an object."));
        var connectorState = {};
        function refine(helper) {
            return function(searchParameters) {
                // Merge new `searchParameters` with the ones set from other widgets
                var actualState = $8d065bb96d52ed31$var$getInitialSearchParameters(helper.state, widgetParams);
                var nextSearchParameters = (0, $d7c0d1a238d975a9$export$8049d91f25899769)(actualState, new (0, (/*@__PURE__*/$parcel$interopDefault($154f73342ab39590$exports))).SearchParameters(searchParameters));
                // Update original `widgetParams.searchParameters` to the new refined one
                widgetParams.searchParameters = searchParameters;
                // Trigger a search with the resolved search parameters
                helper.setState(nextSearchParameters).search();
            };
        }
        return {
            $$type: "ais.configure",
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($8d065bb96d52ed31$var$_objectSpread($8d065bb96d52ed31$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($8d065bb96d52ed31$var$_objectSpread($8d065bb96d52ed31$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref) {
                var state = _ref.state;
                unmountFn();
                return $8d065bb96d52ed31$var$getInitialSearchParameters(state, widgetParams);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                var _renderState$configur;
                var widgetRenderState = this.getWidgetRenderState(renderOptions);
                return $8d065bb96d52ed31$var$_objectSpread($8d065bb96d52ed31$var$_objectSpread({}, renderState), {}, {
                    configure: $8d065bb96d52ed31$var$_objectSpread($8d065bb96d52ed31$var$_objectSpread({}, widgetRenderState), {}, {
                        widgetParams: $8d065bb96d52ed31$var$_objectSpread($8d065bb96d52ed31$var$_objectSpread({}, widgetRenderState.widgetParams), {}, {
                            searchParameters: (0, $d7c0d1a238d975a9$export$8049d91f25899769)(new (0, (/*@__PURE__*/$parcel$interopDefault($154f73342ab39590$exports))).SearchParameters((_renderState$configur = renderState.configure) === null || _renderState$configur === void 0 ? void 0 : _renderState$configur.widgetParams.searchParameters), new (0, (/*@__PURE__*/$parcel$interopDefault($154f73342ab39590$exports))).SearchParameters(widgetRenderState.widgetParams.searchParameters)).getQueryParams()
                        })
                    })
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref2) {
                var helper = _ref2.helper;
                if (!connectorState.refine) connectorState.refine = refine(helper);
                return {
                    refine: connectorState.refine,
                    widgetParams: widgetParams
                };
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(state, _ref3) {
                var uiState = _ref3.uiState;
                return (0, $d7c0d1a238d975a9$export$8049d91f25899769)(state, new (0, (/*@__PURE__*/$parcel$interopDefault($154f73342ab39590$exports))).SearchParameters($8d065bb96d52ed31$var$_objectSpread($8d065bb96d52ed31$var$_objectSpread({}, uiState.configure), widgetParams.searchParameters)));
            },
            getWidgetUiState: function getWidgetUiState(uiState) {
                return $8d065bb96d52ed31$var$_objectSpread($8d065bb96d52ed31$var$_objectSpread({}, uiState), {}, {
                    configure: $8d065bb96d52ed31$var$_objectSpread($8d065bb96d52ed31$var$_objectSpread({}, uiState.configure), widgetParams.searchParameters)
                });
            }
        };
    };
};
var $8d065bb96d52ed31$export$2e2bcd8739ae039 = $8d065bb96d52ed31$var$connectConfigure;



function $cc6015ff59e9616b$export$9bc811ec545fbcb6(props, additionalWidgetProperties) {
    return (0, $dc402206ef11e68a$export$7b345619fa263f7e)((0, $8d065bb96d52ed31$export$2e2bcd8739ae039), {
        searchParameters: props
    }, additionalWidgetProperties);
}


function $641ab7cdaedadbf8$export$de5f40ff1ff419d2(props) {
    (0, $cc6015ff59e9616b$export$9bc811ec545fbcb6)(props, {
        $$widgetType: "ais.configure"
    });
    return null;
}


var $4rNTR = parcelRequire("4rNTR");
function $f129011ec49682ff$export$12368a7050a31bdd(helper, facet, value) {
    if (helper.state.isHierarchicalFacet(facet)) return helper.state.isHierarchicalFacetRefined(facet, value);
    else if (helper.state.isConjunctiveFacet(facet)) return helper.state.isFacetRefined(facet, value);
    else return helper.state.isDisjunctiveFacetRefined(facet, value);
}


function $4ccf760566976ca3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4ccf760566976ca3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4ccf760566976ca3$var$ownKeys(Object(source), !0).forEach(function(key) {
            $4ccf760566976ca3$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4ccf760566976ca3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4ccf760566976ca3$var$_defineProperty(obj, key, value) {
    key = $4ccf760566976ca3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4ccf760566976ca3$var$_toPropertyKey(arg) {
    var key = $4ccf760566976ca3$var$_toPrimitive(arg, "string");
    return $4ccf760566976ca3$var$_typeof(key) === "symbol" ? key : String(key);
}
function $4ccf760566976ca3$var$_toPrimitive(input, hint) {
    if ($4ccf760566976ca3$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($4ccf760566976ca3$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $4ccf760566976ca3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $4ccf760566976ca3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $4ccf760566976ca3$var$_typeof(obj);
}
function $4ccf760566976ca3$var$_slicedToArray(arr, i) {
    return $4ccf760566976ca3$var$_arrayWithHoles(arr) || $4ccf760566976ca3$var$_iterableToArrayLimit(arr, i) || $4ccf760566976ca3$var$_unsupportedIterableToArray(arr, i) || $4ccf760566976ca3$var$_nonIterableRest();
}
function $4ccf760566976ca3$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4ccf760566976ca3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4ccf760566976ca3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4ccf760566976ca3$var$_arrayLikeToArray(o, minLen);
}
function $4ccf760566976ca3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4ccf760566976ca3$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $4ccf760566976ca3$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $4ccf760566976ca3$export$75bfa3473d01f29f(_ref) {
    var instantSearchInstance = _ref.instantSearchInstance, helper = _ref.helper, attr = _ref.attribute, widgetType = _ref.widgetType;
    var sendEventForFacet = function sendEventForFacet() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var facetValue = args[1], _args$ = args[2], eventName = _args$ === void 0 ? "Filter Applied" : _args$, _args$2 = args[3], additionalData = _args$2 === void 0 ? {} : _args$2;
        var _args$0$split = args[0].split(":"), _args$0$split2 = $4ccf760566976ca3$var$_slicedToArray(_args$0$split, 2), eventType = _args$0$split2[0], eventModifier = _args$0$split2[1];
        var attribute = typeof attr === "string" ? attr : attr(facetValue);
        if (args.length === 1 && $4ccf760566976ca3$var$_typeof(args[0]) === "object") instantSearchInstance.sendEventToInsights(args[0]);
        else if (eventType === "click" && args.length >= 2 && args.length <= 4) {
            if (!(0, $f129011ec49682ff$export$12368a7050a31bdd)(helper, attribute, facetValue)) // send event only when the facet is being checked "ON"
            instantSearchInstance.sendEventToInsights({
                insightsMethod: "clickedFilters",
                widgetType: widgetType,
                eventType: eventType,
                eventModifier: eventModifier,
                payload: $4ccf760566976ca3$var$_objectSpread({
                    eventName: eventName,
                    index: helper.getIndex(),
                    filters: [
                        "".concat(attribute, ":").concat(facetValue)
                    ]
                }, additionalData),
                attribute: attribute
            });
        }
    };
    return sendEventForFacet;
}


function $ed1f7bf390969195$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ed1f7bf390969195$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ed1f7bf390969195$var$_typeof(obj);
}
var $ed1f7bf390969195$var$_excluded = [
    "name",
    "escapedValue"
], $ed1f7bf390969195$var$_excluded2 = [
    "escapedValue",
    "value"
];
function $ed1f7bf390969195$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ed1f7bf390969195$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ed1f7bf390969195$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ed1f7bf390969195$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ed1f7bf390969195$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ed1f7bf390969195$var$_defineProperty(obj, key, value) {
    key = $ed1f7bf390969195$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ed1f7bf390969195$var$_toPropertyKey(arg) {
    var key = $ed1f7bf390969195$var$_toPrimitive(arg, "string");
    return $ed1f7bf390969195$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ed1f7bf390969195$var$_toPrimitive(input, hint) {
    if ($ed1f7bf390969195$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ed1f7bf390969195$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $ed1f7bf390969195$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ed1f7bf390969195$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ed1f7bf390969195$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $ed1f7bf390969195$var$withUsage = (0, $44084963839a4436$export$2fde5bffc340821e)({
    name: "refinement-list",
    connector: true
});
var $ed1f7bf390969195$var$DEFAULT_SORT = [
    "isRefined",
    "count:desc",
    "name:asc"
];
/**
 * **RefinementList** connector provides the logic to build a custom widget that
 * will let the user filter the results based on the values of a specific facet.
 *
 * **Requirement:** the attribute passed as `attribute` must be present in
 * attributesForFaceting of the searched index.
 *
 * This connector provides:
 * - a `refine()` function to select an item.
 * - a `toggleShowMore()` function to display more or less items
 * - a `searchForItems()` function to search within the items.
 */ var $ed1f7bf390969195$var$connectRefinementList = function connectRefinementList(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $5d3ef3e388d952bb$export$8793edee2d425525);
    (0, $c9c42a7fa64cf8eb$export$adc2a8e09aa583ee)(renderFn, $ed1f7bf390969195$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, attribute = _ref.attribute, _ref$operator = _ref.operator, operator = _ref$operator === void 0 ? "or" : _ref$operator, _ref$limit = _ref.limit, limit = _ref$limit === void 0 ? 10 : _ref$limit, _ref$showMore = _ref.showMore, showMore = _ref$showMore === void 0 ? false : _ref$showMore, _ref$showMoreLimit = _ref.showMoreLimit, showMoreLimit = _ref$showMoreLimit === void 0 ? 20 : _ref$showMoreLimit, _ref$sortBy = _ref.sortBy, sortBy = _ref$sortBy === void 0 ? $ed1f7bf390969195$var$DEFAULT_SORT : _ref$sortBy, _ref$escapeFacetValue = _ref.escapeFacetValues, escapeFacetValues = _ref$escapeFacetValue === void 0 ? true : _ref$escapeFacetValue, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function transformItems(items) {
            return items;
        } : _ref$transformItems;
        if (!attribute) throw new Error($ed1f7bf390969195$var$withUsage("The `attribute` option is required."));
        if (!/^(and|or)$/.test(operator)) throw new Error($ed1f7bf390969195$var$withUsage('The `operator` must one of: `"and"`, `"or"` (got "'.concat(operator, '").')));
        if (showMore === true && showMoreLimit <= limit) throw new Error($ed1f7bf390969195$var$withUsage("`showMoreLimit` should be greater than `limit`."));
        var formatItems = function formatItems(_ref2) {
            var label = _ref2.name, value = _ref2.escapedValue, item = $ed1f7bf390969195$var$_objectWithoutProperties(_ref2, $ed1f7bf390969195$var$_excluded);
            return $ed1f7bf390969195$var$_objectSpread($ed1f7bf390969195$var$_objectSpread({}, item), {}, {
                value: value,
                label: label,
                highlighted: label
            });
        };
        var lastResultsFromMainSearch;
        var lastItemsFromMainSearch = [];
        var hasExhaustiveItems = true;
        var triggerRefine;
        var sendEvent;
        var isShowingMore = false;
        // Provide the same function to the `renderFn` so that way the user
        // has to only bind it once when `isFirstRendering` for instance
        var toggleShowMore = function toggleShowMore() {};
        function cachedToggleShowMore() {
            toggleShowMore();
        }
        function createToggleShowMore(renderOptions, widget) {
            return function() {
                isShowingMore = !isShowingMore;
                widget.render(renderOptions);
            };
        }
        function getLimit() {
            return isShowingMore ? showMoreLimit : limit;
        }
        var searchForFacetValues = function searchForFacetValues() {
            return function() {};
        };
        var createSearchForFacetValues = function createSearchForFacetValues(helper, widget) {
            return function(renderOptions) {
                return function(query) {
                    var instantSearchInstance = renderOptions.instantSearchInstance, searchResults = renderOptions.results;
                    if (query === "" && lastItemsFromMainSearch) // render with previous data from the helper.
                    renderFn($ed1f7bf390969195$var$_objectSpread($ed1f7bf390969195$var$_objectSpread({}, widget.getWidgetRenderState($ed1f7bf390969195$var$_objectSpread($ed1f7bf390969195$var$_objectSpread({}, renderOptions), {}, {
                        results: lastResultsFromMainSearch
                    }))), {}, {
                        instantSearchInstance: instantSearchInstance
                    }), false);
                    else {
                        var tags = {
                            highlightPreTag: escapeFacetValues ? (0, $a81e7c21001dea67$export$1e7338a8952eaf35).highlightPreTag : (0, $a81e7c21001dea67$export$62e796b7905e8e6b).highlightPreTag,
                            highlightPostTag: escapeFacetValues ? (0, $a81e7c21001dea67$export$1e7338a8952eaf35).highlightPostTag : (0, $a81e7c21001dea67$export$62e796b7905e8e6b).highlightPostTag
                        };
                        helper.searchForFacetValues(attribute, query, // We cap the `maxFacetHits` value to 100 because the Algolia API
                        // doesn't support a greater number.
                        // See https://www.algolia.com/doc/api-reference/api-parameters/maxFacetHits/
                        Math.min(getLimit(), 100), tags).then(function(results) {
                            var facetValues = escapeFacetValues ? (0, $a81e7c21001dea67$export$9ae2e822836b2e1a)(results.facetHits) : results.facetHits;
                            var normalizedFacetValues = transformItems(facetValues.map(function(_ref3) {
                                var escapedValue = _ref3.escapedValue, value = _ref3.value, item = $ed1f7bf390969195$var$_objectWithoutProperties(_ref3, $ed1f7bf390969195$var$_excluded2);
                                return $ed1f7bf390969195$var$_objectSpread($ed1f7bf390969195$var$_objectSpread({}, item), {}, {
                                    value: escapedValue,
                                    label: value
                                });
                            }), {
                                results: searchResults
                            });
                            renderFn($ed1f7bf390969195$var$_objectSpread($ed1f7bf390969195$var$_objectSpread({}, widget.getWidgetRenderState($ed1f7bf390969195$var$_objectSpread($ed1f7bf390969195$var$_objectSpread({}, renderOptions), {}, {
                                results: lastResultsFromMainSearch
                            }))), {}, {
                                items: normalizedFacetValues,
                                canToggleShowMore: false,
                                canRefine: true,
                                isFromSearch: true,
                                instantSearchInstance: instantSearchInstance
                            }), false);
                        });
                    }
                };
            };
        };
        return {
            $$type: "ais.refinementList",
            init: function init(initOptions) {
                renderFn($ed1f7bf390969195$var$_objectSpread($ed1f7bf390969195$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: initOptions.instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                renderFn($ed1f7bf390969195$var$_objectSpread($ed1f7bf390969195$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: renderOptions.instantSearchInstance
                }), false);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $ed1f7bf390969195$var$_objectSpread($ed1f7bf390969195$var$_objectSpread({}, renderState), {}, {
                    refinementList: $ed1f7bf390969195$var$_objectSpread($ed1f7bf390969195$var$_objectSpread({}, renderState.refinementList), {}, $ed1f7bf390969195$var$_defineProperty({}, attribute, this.getWidgetRenderState(renderOptions)))
                });
            },
            getWidgetRenderState: function getWidgetRenderState(renderOptions) {
                var _this = this;
                var results = renderOptions.results, state = renderOptions.state, _createURL = renderOptions.createURL, instantSearchInstance = renderOptions.instantSearchInstance, helper = renderOptions.helper;
                var items = [];
                var facetValues = [];
                if (!sendEvent || !triggerRefine || !searchForFacetValues) {
                    sendEvent = (0, $4ccf760566976ca3$export$75bfa3473d01f29f)({
                        instantSearchInstance: instantSearchInstance,
                        helper: helper,
                        attribute: attribute,
                        widgetType: this.$$type
                    });
                    triggerRefine = function triggerRefine(facetValue) {
                        sendEvent("click:internal", facetValue);
                        helper.toggleFacetRefinement(attribute, facetValue).search();
                    };
                    searchForFacetValues = createSearchForFacetValues(helper, this);
                }
                if (results) {
                    var values = results.getFacetValues(attribute, {
                        sortBy: sortBy,
                        facetOrdering: sortBy === $ed1f7bf390969195$var$DEFAULT_SORT
                    });
                    facetValues = values && Array.isArray(values) ? values : [];
                    items = transformItems(facetValues.slice(0, getLimit()).map(formatItems), {
                        results: results
                    });
                    var maxValuesPerFacetConfig = state.maxValuesPerFacet;
                    var currentLimit = getLimit();
                    // If the limit is the max number of facet retrieved it is impossible to know
                    // if the facets are exhaustive. The only moment we are sure it is exhaustive
                    // is when it is strictly under the number requested unless we know that another
                    // widget has requested more values (maxValuesPerFacet > getLimit()).
                    // Because this is used for making the search of facets unable or not, it is important
                    // to be conservative here.
                    hasExhaustiveItems = maxValuesPerFacetConfig > currentLimit ? facetValues.length <= currentLimit : facetValues.length < currentLimit;
                    lastResultsFromMainSearch = results;
                    lastItemsFromMainSearch = items;
                    if (renderOptions.results) toggleShowMore = createToggleShowMore(renderOptions, this);
                }
                // Do not mistake searchForFacetValues and searchFacetValues which is the actual search
                // function
                var searchFacetValues = searchForFacetValues && searchForFacetValues(renderOptions);
                var canShowLess = isShowingMore && lastItemsFromMainSearch.length > limit;
                var canShowMore = showMore && !hasExhaustiveItems;
                var canToggleShowMore = canShowLess || canShowMore;
                return {
                    createURL: function createURL(facetValue) {
                        return _createURL(function(uiState) {
                            return _this.getWidgetUiState(uiState, {
                                searchParameters: state.resetPage().toggleFacetRefinement(attribute, facetValue),
                                helper: helper
                            });
                        });
                    },
                    items: items,
                    refine: triggerRefine,
                    searchForItems: searchFacetValues,
                    isFromSearch: false,
                    canRefine: items.length > 0,
                    widgetParams: widgetParams,
                    isShowingMore: isShowingMore,
                    canToggleShowMore: canToggleShowMore,
                    toggleShowMore: cachedToggleShowMore,
                    sendEvent: sendEvent,
                    hasExhaustiveItems: hasExhaustiveItems
                };
            },
            dispose: function dispose(_ref4) {
                var state = _ref4.state;
                unmountFn();
                var withoutMaxValuesPerFacet = state.setQueryParameter("maxValuesPerFacet", undefined);
                if (operator === "and") return withoutMaxValuesPerFacet.removeFacet(attribute);
                return withoutMaxValuesPerFacet.removeDisjunctiveFacet(attribute);
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref5) {
                var searchParameters = _ref5.searchParameters;
                var values = operator === "or" ? searchParameters.getDisjunctiveRefinements(attribute) : searchParameters.getConjunctiveRefinements(attribute);
                return $ed1f7bf390969195$var$removeEmptyRefinementsFromUiState($ed1f7bf390969195$var$_objectSpread($ed1f7bf390969195$var$_objectSpread({}, uiState), {}, {
                    refinementList: $ed1f7bf390969195$var$_objectSpread($ed1f7bf390969195$var$_objectSpread({}, uiState.refinementList), {}, $ed1f7bf390969195$var$_defineProperty({}, attribute, values))
                }), attribute);
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref6) {
                var uiState = _ref6.uiState;
                var isDisjunctive = operator === "or";
                if (searchParameters.isHierarchicalFacet(attribute)) return searchParameters;
                if (isDisjunctive && searchParameters.isConjunctiveFacet(attribute) || !isDisjunctive && searchParameters.isDisjunctiveFacet(attribute)) return searchParameters;
                var values = uiState.refinementList && uiState.refinementList[attribute];
                var withFacetConfiguration = isDisjunctive ? searchParameters.addDisjunctiveFacet(attribute).removeDisjunctiveFacetRefinement(attribute) : searchParameters.addFacet(attribute).removeFacetRefinement(attribute);
                var currentMaxValuesPerFacet = withFacetConfiguration.maxValuesPerFacet || 0;
                var nextMaxValuesPerFacet = Math.max(currentMaxValuesPerFacet, showMore ? showMoreLimit : limit);
                var withMaxValuesPerFacet = withFacetConfiguration.setQueryParameter("maxValuesPerFacet", nextMaxValuesPerFacet);
                if (!values) {
                    var key = isDisjunctive ? "disjunctiveFacetsRefinements" : "facetsRefinements";
                    return withMaxValuesPerFacet.setQueryParameters($ed1f7bf390969195$var$_defineProperty({}, key, $ed1f7bf390969195$var$_objectSpread($ed1f7bf390969195$var$_objectSpread({}, withMaxValuesPerFacet[key]), {}, $ed1f7bf390969195$var$_defineProperty({}, attribute, []))));
                }
                return values.reduce(function(parameters, value) {
                    return isDisjunctive ? parameters.addDisjunctiveFacetRefinement(attribute, value) : parameters.addFacetRefinement(attribute, value);
                }, withMaxValuesPerFacet);
            }
        };
    };
};
function $ed1f7bf390969195$var$removeEmptyRefinementsFromUiState(indexUiState, attribute) {
    if (!indexUiState.refinementList) return indexUiState;
    if (!indexUiState.refinementList[attribute] || indexUiState.refinementList[attribute].length === 0) delete indexUiState.refinementList[attribute];
    if (Object.keys(indexUiState.refinementList).length === 0) delete indexUiState.refinementList;
    return indexUiState;
}
var $ed1f7bf390969195$export$2e2bcd8739ae039 = $ed1f7bf390969195$var$connectRefinementList;



function $51481702b21a6a03$export$5da5a5848a7e380(props, additionalWidgetProperties) {
    return (0, $dc402206ef11e68a$export$7b345619fa263f7e)((0, $ed1f7bf390969195$export$2e2bcd8739ae039), props, additionalWidgetProperties);
}





var $4rNTR = parcelRequire("4rNTR");


var $4rNTR = parcelRequire("4rNTR");
var $c4d3ac6bd09a40cc$exports = {};
function $c4d3ac6bd09a40cc$var$_extends() {
    $c4d3ac6bd09a40cc$exports = $c4d3ac6bd09a40cc$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, $c4d3ac6bd09a40cc$exports.__esModule = true, $c4d3ac6bd09a40cc$exports["default"] = $c4d3ac6bd09a40cc$exports;
    return $c4d3ac6bd09a40cc$var$_extends.apply(this, arguments);
}
$c4d3ac6bd09a40cc$exports = $c4d3ac6bd09a40cc$var$_extends, $c4d3ac6bd09a40cc$exports.__esModule = true, $c4d3ac6bd09a40cc$exports["default"] = $c4d3ac6bd09a40cc$exports;


var $43084169ac51459d$exports = {};
var $c9a7a5e6fafdee57$exports = {};
function $c9a7a5e6fafdee57$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
$c9a7a5e6fafdee57$exports = $c9a7a5e6fafdee57$var$_objectWithoutPropertiesLoose, $c9a7a5e6fafdee57$exports.__esModule = true, $c9a7a5e6fafdee57$exports["default"] = $c9a7a5e6fafdee57$exports;


function $43084169ac51459d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c9a7a5e6fafdee57$exports(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
$43084169ac51459d$exports = $43084169ac51459d$var$_objectWithoutProperties, $43084169ac51459d$exports.__esModule = true, $43084169ac51459d$exports["default"] = $43084169ac51459d$exports;



var $7c8240b123a4cf2b$var$_excluded = [
    "parts",
    "highlightedTagName",
    "nonHighlightedTagName",
    "separator",
    "className",
    "classNames"
];
function $7c8240b123a4cf2b$var$createHighlightPartComponent(_ref) {
    var createElement = _ref.createElement;
    return function HighlightPart(_ref2) {
        var classNames = _ref2.classNames, children = _ref2.children, highlightedTagName = _ref2.highlightedTagName, isHighlighted = _ref2.isHighlighted, nonHighlightedTagName = _ref2.nonHighlightedTagName;
        var TagName = isHighlighted ? highlightedTagName : nonHighlightedTagName;
        return createElement(TagName, {
            className: isHighlighted ? classNames.highlighted : classNames.nonHighlighted
        }, children);
    };
}
function $7c8240b123a4cf2b$export$c8682df1c852a966(_ref3) {
    var createElement = _ref3.createElement, Fragment = _ref3.Fragment;
    var HighlightPart = $7c8240b123a4cf2b$var$createHighlightPartComponent({
        createElement: createElement,
        Fragment: Fragment
    });
    return function Highlight(userProps) {
        var parts = userProps.parts, _userProps$highlighte = userProps.highlightedTagName, highlightedTagName = _userProps$highlighte === void 0 ? "mark" : _userProps$highlighte, _userProps$nonHighlig = userProps.nonHighlightedTagName, nonHighlightedTagName = _userProps$nonHighlig === void 0 ? "span" : _userProps$nonHighlig, _userProps$separator = userProps.separator, separator = _userProps$separator === void 0 ? ", " : _userProps$separator, className = userProps.className, _userProps$classNames = userProps.classNames, classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames, props = (0, (/*@__PURE__*/$parcel$interopDefault($43084169ac51459d$exports)))(userProps, $7c8240b123a4cf2b$var$_excluded);
        return createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($c4d3ac6bd09a40cc$exports)))({}, props, {
            className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)(classNames.root, className)
        }), parts.map(function(part, partIndex) {
            var isLastPart = partIndex === parts.length - 1;
            return createElement(Fragment, {
                key: partIndex
            }, part.map(function(subPart, subPartIndex) {
                return createElement(HighlightPart, {
                    key: subPartIndex,
                    classNames: classNames,
                    highlightedTagName: highlightedTagName,
                    nonHighlightedTagName: nonHighlightedTagName,
                    isHighlighted: subPart.isHighlighted
                }, subPart.value);
            }), !isLastPart && createElement("span", {
                className: classNames.separator
            }, separator));
        }));
    };
}



var $4rNTR = parcelRequire("4rNTR");
var $899a27daa8df1b71$export$57a0c6fc80bec05c = (0, $7c8240b123a4cf2b$export$c8682df1c852a966)({
    createElement: (0, $4rNTR.createElement),
    Fragment: (0, $4rNTR.Fragment)
});


var $1bc65673d14beafa$var$_excluded = [
    "classNames"
];
function $1bc65673d14beafa$var$_extends() {
    $1bc65673d14beafa$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1bc65673d14beafa$var$_extends.apply(this, arguments);
}
function $1bc65673d14beafa$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1bc65673d14beafa$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1bc65673d14beafa$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $1bc65673d14beafa$export$39dbc3f558091353(_ref) {
    var _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = $1bc65673d14beafa$var$_objectWithoutProperties(_ref, $1bc65673d14beafa$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement((0, $899a27daa8df1b71$export$57a0c6fc80bec05c), $1bc65673d14beafa$var$_extends({
        classNames: {
            root: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-Highlight", classNames.root),
            highlighted: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-Highlight-highlighted", classNames.highlighted),
            nonHighlighted: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-Highlight-nonHighlighted", classNames.nonHighlighted),
            separator: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-Highlight-separator", classNames.separator)
        }
    }, props));
}



var $4rNTR = parcelRequire("4rNTR");
var $0bca03328b6b7809$var$_excluded = [
    "isShowingMore",
    "translations"
];
function $0bca03328b6b7809$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0bca03328b6b7809$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0bca03328b6b7809$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $0bca03328b6b7809$export$e41c325c8b11c297(_ref) {
    var isShowingMore = _ref.isShowingMore, translations = _ref.translations, props = $0bca03328b6b7809$var$_objectWithoutProperties(_ref, $0bca03328b6b7809$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("button", props, translations.showMoreButtonText({
        isShowingMore: isShowingMore
    }));
}


var $ed2f5b6064aed6b4$var$_excluded = [
    "canRefine",
    "items",
    "onRefine",
    "query",
    "searchBox",
    "noResults",
    "showMore",
    "canToggleShowMore",
    "onToggleShowMore",
    "isShowingMore",
    "className",
    "classNames",
    "translations"
];
function $ed2f5b6064aed6b4$var$_extends() {
    $ed2f5b6064aed6b4$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ed2f5b6064aed6b4$var$_extends.apply(this, arguments);
}
function $ed2f5b6064aed6b4$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ed2f5b6064aed6b4$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ed2f5b6064aed6b4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ed2f5b6064aed6b4$export$40832886fec19653(_ref) {
    var canRefine = _ref.canRefine, items = _ref.items, onRefine = _ref.onRefine, query = _ref.query, searchBox = _ref.searchBox, noResults = _ref.noResults, showMore = _ref.showMore, canToggleShowMore = _ref.canToggleShowMore, onToggleShowMore = _ref.onToggleShowMore, isShowingMore = _ref.isShowingMore, className = _ref.className, _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, translations = _ref.translations, props = $ed2f5b6064aed6b4$var$_objectWithoutProperties(_ref, $ed2f5b6064aed6b4$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("div", $ed2f5b6064aed6b4$var$_extends({}, props, {
        className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-RefinementList", classNames.root, items.length === 0 && (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-RefinementList--noRefinement", classNames.noRefinementRoot), className)
    }), searchBox && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("div", {
        className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-RefinementList-searchBox", classNames.searchBox)
    }, searchBox), noResults ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("div", {
        className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-RefinementList-noResults", classNames.noResults)
    }, noResults) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("ul", {
        className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-RefinementList-list", classNames.list)
    }, items.map(function(item) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("li", {
            key: item.value,
            className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-RefinementList-item", classNames.item, item.isRefined && (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-RefinementList-item--selected", classNames.selectedItem))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("label", {
            className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-RefinementList-label", classNames.label)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("input", {
            checked: item.isRefined,
            className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-RefinementList-checkbox", classNames.checkbox),
            type: "checkbox",
            value: item.value,
            onChange: function onChange() {
                onRefine(item);
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("span", {
            className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-RefinementList-labelText", classNames.labelText)
        }, query.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement((0, $1bc65673d14beafa$export$39dbc3f558091353), {
            parts: [
                (0, $b44df87e9fbd5757$export$e04d28e65b830ebf)((0, $638238b1c80b9474$export$e8bacd2802a88316)(item.highlighted || ""))
            ]
        }) : item.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("span", {
            className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-RefinementList-count", classNames.count)
        }, item.count)));
    })), showMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement((0, $0bca03328b6b7809$export$e41c325c8b11c297), {
        className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-RefinementList-showMore", classNames.showMore, !canToggleShowMore && (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-RefinementList-showMore--disabled", classNames.disabledShowMore)),
        disabled: !canToggleShowMore,
        onClick: onToggleShowMore,
        isShowingMore: isShowingMore,
        translations: translations
    }));
}



function $c72f67aaa3609706$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $c72f67aaa3609706$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $c72f67aaa3609706$var$_typeof(obj);
}
var $c72f67aaa3609706$var$_excluded = [
    "searchable",
    "searchablePlaceholder",
    "attribute",
    "operator",
    "limit",
    "showMore",
    "showMoreLimit",
    "sortBy",
    "escapeFacetValues",
    "transformItems",
    "translations"
];
function $c72f67aaa3609706$var$_extends() {
    $c72f67aaa3609706$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c72f67aaa3609706$var$_extends.apply(this, arguments);
}
function $c72f67aaa3609706$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c72f67aaa3609706$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c72f67aaa3609706$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c72f67aaa3609706$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c72f67aaa3609706$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c72f67aaa3609706$var$_defineProperty(obj, key, value) {
    key = $c72f67aaa3609706$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c72f67aaa3609706$var$_toPropertyKey(arg) {
    var key = $c72f67aaa3609706$var$_toPrimitive(arg, "string");
    return $c72f67aaa3609706$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c72f67aaa3609706$var$_toPrimitive(input, hint) {
    if ($c72f67aaa3609706$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c72f67aaa3609706$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $c72f67aaa3609706$var$_slicedToArray(arr, i) {
    return $c72f67aaa3609706$var$_arrayWithHoles(arr) || $c72f67aaa3609706$var$_iterableToArrayLimit(arr, i) || $c72f67aaa3609706$var$_unsupportedIterableToArray(arr, i) || $c72f67aaa3609706$var$_nonIterableRest();
}
function $c72f67aaa3609706$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c72f67aaa3609706$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c72f67aaa3609706$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c72f67aaa3609706$var$_arrayLikeToArray(o, minLen);
}
function $c72f67aaa3609706$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c72f67aaa3609706$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $c72f67aaa3609706$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c72f67aaa3609706$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c72f67aaa3609706$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c72f67aaa3609706$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $c72f67aaa3609706$export$40832886fec19653(_ref) {
    var searchable = _ref.searchable, searchablePlaceholder = _ref.searchablePlaceholder, attribute = _ref.attribute, operator = _ref.operator, limit = _ref.limit, showMore = _ref.showMore, showMoreLimit = _ref.showMoreLimit, sortBy = _ref.sortBy, escapeFacetValues = _ref.escapeFacetValues, transformItems = _ref.transformItems, translations = _ref.translations, props = $c72f67aaa3609706$var$_objectWithoutProperties(_ref, $c72f67aaa3609706$var$_excluded);
    var _useRefinementList = (0, $51481702b21a6a03$export$5da5a5848a7e380)({
        attribute: attribute,
        operator: operator,
        limit: limit,
        showMore: showMore,
        showMoreLimit: showMoreLimit,
        sortBy: sortBy,
        escapeFacetValues: escapeFacetValues,
        transformItems: transformItems
    }, {
        $$widgetType: "ais.refinementList"
    }), canRefine = _useRefinementList.canRefine, canToggleShowMore = _useRefinementList.canToggleShowMore, isFromSearch = _useRefinementList.isFromSearch, isShowingMore = _useRefinementList.isShowingMore, items = _useRefinementList.items, refine = _useRefinementList.refine, searchForItems = _useRefinementList.searchForItems, toggleShowMore = _useRefinementList.toggleShowMore;
    var _useState = (0, $4rNTR.useState)(""), _useState2 = $c72f67aaa3609706$var$_slicedToArray(_useState, 2), inputValue = _useState2[0], setInputValue = _useState2[1];
    var inputRef = (0, $4rNTR.useRef)(null);
    function setQuery(newQuery) {
        var compositionComplete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        setInputValue(newQuery);
        if (compositionComplete) searchForItems(newQuery);
    }
    function onRefine(item) {
        refine(item.value);
        setQuery("");
    }
    function onChange(event) {
        var compositionComplete = event.type === "compositionend" || !event.nativeEvent.isComposing;
        setQuery(event.currentTarget.value, compositionComplete);
    }
    function onReset() {
        setQuery("");
    }
    function onSubmit() {
        if (items.length > 0) {
            refine(items[0].value);
            setQuery("");
        }
    }
    var mergedTranslations = $c72f67aaa3609706$var$_objectSpread({
        resetButtonTitle: "Clear the search query",
        submitButtonTitle: "Submit the search query",
        noResultsText: "No results.",
        showMoreButtonText: function showMoreButtonText(options) {
            return options.isShowingMore ? "Show less" : "Show more";
        }
    }, translations);
    var uiProps = {
        items: items,
        canRefine: canRefine,
        onRefine: onRefine,
        query: inputValue,
        searchBox: searchable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement((0, $47a71d88e79f1269$export$5a58787633b0b5d8), {
            inputRef: inputRef,
            placeholder: searchablePlaceholder,
            isSearchStalled: false,
            value: inputValue,
            onChange: onChange,
            onReset: onReset,
            onSubmit: onSubmit,
            translations: {
                submitButtonTitle: mergedTranslations.submitButtonTitle,
                resetButtonTitle: mergedTranslations.resetButtonTitle
            }
        }),
        noResults: searchable && isFromSearch && items.length === 0 && mergedTranslations.noResultsText,
        canToggleShowMore: canToggleShowMore,
        onToggleShowMore: toggleShowMore,
        isShowingMore: isShowingMore,
        translations: {
            showMoreButtonText: mergedTranslations.showMoreButtonText
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement((0, $ed2f5b6064aed6b4$export$40832886fec19653), $c72f67aaa3609706$var$_extends({}, props, uiProps, {
        showMore: showMore
    }));
}


var $4rNTR = parcelRequire("4rNTR");

function $8a297d3d52ff178a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $8a297d3d52ff178a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $8a297d3d52ff178a$var$_typeof(obj);
}
function $8a297d3d52ff178a$var$_toConsumableArray(arr) {
    return $8a297d3d52ff178a$var$_arrayWithoutHoles(arr) || $8a297d3d52ff178a$var$_iterableToArray(arr) || $8a297d3d52ff178a$var$_unsupportedIterableToArray(arr) || $8a297d3d52ff178a$var$_nonIterableSpread();
}
function $8a297d3d52ff178a$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8a297d3d52ff178a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8a297d3d52ff178a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8a297d3d52ff178a$var$_arrayLikeToArray(o, minLen);
}
function $8a297d3d52ff178a$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $8a297d3d52ff178a$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $8a297d3d52ff178a$var$_arrayLikeToArray(arr);
}
function $8a297d3d52ff178a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8a297d3d52ff178a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8a297d3d52ff178a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8a297d3d52ff178a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $8a297d3d52ff178a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8a297d3d52ff178a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8a297d3d52ff178a$var$_defineProperty(obj, key, value) {
    key = $8a297d3d52ff178a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8a297d3d52ff178a$var$_toPropertyKey(arg) {
    var key = $8a297d3d52ff178a$var$_toPrimitive(arg, "string");
    return $8a297d3d52ff178a$var$_typeof(key) === "symbol" ? key : String(key);
}
function $8a297d3d52ff178a$var$_toPrimitive(input, hint) {
    if ($8a297d3d52ff178a$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($8a297d3d52ff178a$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $8a297d3d52ff178a$var$withUsage = (0, $44084963839a4436$export$2fde5bffc340821e)({
    name: "hits-per-page",
    connector: true
});
var $8a297d3d52ff178a$var$connectHitsPerPage = function connectHitsPerPage(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $5d3ef3e388d952bb$export$8793edee2d425525);
    (0, $c9c42a7fa64cf8eb$export$adc2a8e09aa583ee)(renderFn, $8a297d3d52ff178a$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, userItems = _ref.items, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function transformItems(items) {
            return items;
        } : _ref$transformItems;
        if (!Array.isArray(userItems)) throw new Error($8a297d3d52ff178a$var$withUsage("The `items` option expects an array of objects."));
        var items = userItems;
        var defaultItems = items.filter(function(item) {
            return item.default === true;
        });
        if (defaultItems.length === 0) throw new Error($8a297d3d52ff178a$var$withUsage("A default value must be specified in `items`."));
        if (defaultItems.length > 1) throw new Error($8a297d3d52ff178a$var$withUsage("More than one default value is specified in `items`."));
        var defaultItem = defaultItems[0];
        var normalizeItems = function normalizeItems(_ref2) {
            var hitsPerPage = _ref2.hitsPerPage;
            return items.map(function(item) {
                return $8a297d3d52ff178a$var$_objectSpread($8a297d3d52ff178a$var$_objectSpread({}, item), {}, {
                    isRefined: Number(item.value) === Number(hitsPerPage)
                });
            });
        };
        var connectorState = {
            getRefine: function getRefine(helper) {
                return function(value) {
                    return !value && value !== 0 ? helper.setQueryParameter("hitsPerPage", undefined).search() : helper.setQueryParameter("hitsPerPage", value).search();
                };
            },
            createURLFactory: function createURLFactory(_ref3) {
                var state = _ref3.state, createURL = _ref3.createURL, getWidgetUiState = _ref3.getWidgetUiState, helper = _ref3.helper;
                return function(value) {
                    return createURL(function(uiState) {
                        return getWidgetUiState(uiState, {
                            searchParameters: state.resetPage().setQueryParameter("hitsPerPage", !value && value !== 0 ? undefined : value),
                            helper: helper
                        });
                    });
                };
            }
        };
        return {
            $$type: "ais.hitsPerPage",
            init: function init(initOptions) {
                var state = initOptions.state, instantSearchInstance = initOptions.instantSearchInstance;
                var isCurrentInOptions = items.some(function(item) {
                    return Number(state.hitsPerPage) === Number(item.value);
                });
                if (!isCurrentInOptions) items = [
                    // The helper will convert the empty string to `undefined`.
                    {
                        value: "",
                        label: ""
                    }
                ].concat($8a297d3d52ff178a$var$_toConsumableArray(items));
                renderFn($8a297d3d52ff178a$var$_objectSpread($8a297d3d52ff178a$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($8a297d3d52ff178a$var$_objectSpread($8a297d3d52ff178a$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref4) {
                var state = _ref4.state;
                unmountFn();
                return state.setQueryParameter("hitsPerPage", undefined);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $8a297d3d52ff178a$var$_objectSpread($8a297d3d52ff178a$var$_objectSpread({}, renderState), {}, {
                    hitsPerPage: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref5) {
                var state = _ref5.state, results = _ref5.results, createURL = _ref5.createURL, helper = _ref5.helper;
                var canRefine = results ? results.nbHits > 0 : false;
                return {
                    items: transformItems(normalizeItems(state), {
                        results: results
                    }),
                    refine: connectorState.getRefine(helper),
                    createURL: connectorState.createURLFactory({
                        state: state,
                        createURL: createURL,
                        getWidgetUiState: this.getWidgetUiState,
                        helper: helper
                    }),
                    hasNoResults: !canRefine,
                    canRefine: canRefine,
                    widgetParams: widgetParams
                };
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref6) {
                var searchParameters = _ref6.searchParameters;
                var hitsPerPage = searchParameters.hitsPerPage;
                if (hitsPerPage === undefined || hitsPerPage === defaultItem.value) return uiState;
                return $8a297d3d52ff178a$var$_objectSpread($8a297d3d52ff178a$var$_objectSpread({}, uiState), {}, {
                    hitsPerPage: hitsPerPage
                });
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref7) {
                var uiState = _ref7.uiState;
                return searchParameters.setQueryParameters({
                    hitsPerPage: uiState.hitsPerPage || defaultItem.value
                });
            }
        };
    };
};
var $8a297d3d52ff178a$export$2e2bcd8739ae039 = $8a297d3d52ff178a$var$connectHitsPerPage;



function $0c72aea3400dbc14$export$98505b536e552530(props, additionalWidgetProperties) {
    return (0, $dc402206ef11e68a$export$7b345619fa263f7e)((0, $8a297d3d52ff178a$export$2e2bcd8739ae039), props, additionalWidgetProperties);
}




var $4rNTR = parcelRequire("4rNTR");
var $9c39a644fc8e87e2$var$_excluded = [
    "items",
    "onChange",
    "currentValue",
    "classNames"
];
function $9c39a644fc8e87e2$var$_extends() {
    $9c39a644fc8e87e2$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9c39a644fc8e87e2$var$_extends.apply(this, arguments);
}
function $9c39a644fc8e87e2$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9c39a644fc8e87e2$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9c39a644fc8e87e2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $9c39a644fc8e87e2$export$1c363d4fc6896e21(_ref) {
    var items = _ref.items, _onChange = _ref.onChange, currentValue = _ref.currentValue, _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = $9c39a644fc8e87e2$var$_objectWithoutProperties(_ref, $9c39a644fc8e87e2$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("div", $9c39a644fc8e87e2$var$_extends({}, props, {
        className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-HitsPerPage", classNames.root, props.className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("select", {
        className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-HitsPerPage-select", classNames.select),
        onChange: function onChange(event) {
            _onChange(Number(event.target.value));
        },
        value: String(currentValue)
    }, items.map(function(item) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("option", {
            key: item.value,
            className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-HitsPerPage-option", classNames.option),
            value: item.value
        }, item.label);
    })));
}


var $681ad9c5be6e319a$var$_excluded = [
    "items",
    "transformItems"
];
function $681ad9c5be6e319a$var$_extends() {
    $681ad9c5be6e319a$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $681ad9c5be6e319a$var$_extends.apply(this, arguments);
}
function $681ad9c5be6e319a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $681ad9c5be6e319a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $681ad9c5be6e319a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $681ad9c5be6e319a$export$1c363d4fc6896e21(_ref) {
    var userItems = _ref.items, transformItems = _ref.transformItems, props = $681ad9c5be6e319a$var$_objectWithoutProperties(_ref, $681ad9c5be6e319a$var$_excluded);
    var _useHitsPerPage = (0, $0c72aea3400dbc14$export$98505b536e552530)({
        items: userItems,
        transformItems: transformItems
    }, {
        $$widgetType: "ais.hitsPerPage"
    }), items = _useHitsPerPage.items, refine = _useHitsPerPage.refine;
    var _ref2 = items.find(function(_ref3) {
        var isRefined = _ref3.isRefined;
        return isRefined;
    }) || {}, currentValue = _ref2.value;
    var uiProps = {
        items: items,
        currentValue: currentValue,
        onChange: function onChange(value) {
            return refine(value);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement((0, $9c39a644fc8e87e2$export$1c363d4fc6896e21), $681ad9c5be6e319a$var$_extends({}, props, uiProps));
}




var $62def845f6145da8$var$_excluded = [
    "classNames",
    "hits",
    "itemComponent",
    "sendEvent",
    "emptyComponent"
];
function $62def845f6145da8$export$abc871145e3e685(_ref) {
    var createElement = _ref.createElement;
    return function Hits(userProps) {
        var _userProps$classNames = userProps.classNames, classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames, hits = userProps.hits, ItemComponent = userProps.itemComponent, sendEvent = userProps.sendEvent, EmptyComponent = userProps.emptyComponent, props = (0, (/*@__PURE__*/$parcel$interopDefault($43084169ac51459d$exports)))(userProps, $62def845f6145da8$var$_excluded);
        if (hits.length === 0 && EmptyComponent) return createElement(EmptyComponent, {
            className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-Hits", classNames.root, (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-Hits--empty", classNames.emptyRoot), props.className)
        });
        return createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($c4d3ac6bd09a40cc$exports)))({}, props, {
            className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-Hits", classNames.root, hits.length === 0 && (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-Hits--empty", classNames.emptyRoot), props.className)
        }), createElement("ol", {
            className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-Hits-list", classNames.list)
        }, hits.map(function(hit, index) {
            return createElement(ItemComponent, {
                key: hit.objectID,
                hit: hit,
                index: index,
                className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-Hits-item", classNames.item),
                onClick: function onClick() {
                    sendEvent("click:internal", hit, "Hit Clicked");
                },
                onAuxClick: function onAuxClick() {
                    sendEvent("click:internal", hit, "Hit Clicked");
                }
            });
        })));
    };
}



var $4rNTR = parcelRequire("4rNTR");

function $32c0236291282a5b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $32c0236291282a5b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $32c0236291282a5b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $32c0236291282a5b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $32c0236291282a5b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $32c0236291282a5b$var$_defineProperty(obj, key, value) {
    key = $32c0236291282a5b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $32c0236291282a5b$var$_toPropertyKey(arg) {
    var key = $32c0236291282a5b$var$_toPrimitive(arg, "string");
    return $32c0236291282a5b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $32c0236291282a5b$var$_toPrimitive(input, hint) {
    if ($32c0236291282a5b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($32c0236291282a5b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $32c0236291282a5b$var$_slicedToArray(arr, i) {
    return $32c0236291282a5b$var$_arrayWithHoles(arr) || $32c0236291282a5b$var$_iterableToArrayLimit(arr, i) || $32c0236291282a5b$var$_unsupportedIterableToArray(arr, i) || $32c0236291282a5b$var$_nonIterableRest();
}
function $32c0236291282a5b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $32c0236291282a5b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $32c0236291282a5b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $32c0236291282a5b$var$_arrayLikeToArray(o, minLen);
}
function $32c0236291282a5b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $32c0236291282a5b$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $32c0236291282a5b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $32c0236291282a5b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $32c0236291282a5b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $32c0236291282a5b$var$_typeof(obj);
}
function $32c0236291282a5b$var$chunk(arr) {
    var chunkSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
    var chunks = [];
    for(var i = 0; i < Math.ceil(arr.length / chunkSize); i++)chunks.push(arr.slice(i * chunkSize, (i + 1) * chunkSize));
    return chunks;
}
function $32c0236291282a5b$export$2f82a8f6391c6db9(_ref) {
    var getIndex = _ref.getIndex, widgetType = _ref.widgetType, methodName = _ref.methodName, args = _ref.args, instantSearchInstance = _ref.instantSearchInstance;
    // when there's only one argument, that means it's custom
    if (args.length === 1 && $32c0236291282a5b$var$_typeof(args[0]) === "object") return [
        args[0]
    ];
    var _args$0$split = args[0].split(":"), _args$0$split2 = $32c0236291282a5b$var$_slicedToArray(_args$0$split, 2), eventType = _args$0$split2[0], eventModifier = _args$0$split2[1];
    var hits = args[1];
    var eventName = args[2];
    var additionalData = args[3] || {};
    if (!hits) return [];
    if ((eventType === "click" || eventType === "conversion") && !eventName) return [];
    var hitsArray = Array.isArray(hits) ? hits : [
        hits
    ];
    if (hitsArray.length === 0) return [];
    var queryID = hitsArray[0].__queryID;
    var hitsChunks = $32c0236291282a5b$var$chunk(hitsArray);
    var objectIDsByChunk = hitsChunks.map(function(batch) {
        return batch.map(function(hit) {
            return hit.objectID;
        });
    });
    var positionsByChunk = hitsChunks.map(function(batch) {
        return batch.map(function(hit) {
            return hit.__position;
        });
    });
    if (eventType === "view") {
        if (instantSearchInstance.status !== "idle") return [];
        return hitsChunks.map(function(batch, i) {
            return {
                insightsMethod: "viewedObjectIDs",
                widgetType: widgetType,
                eventType: eventType,
                payload: $32c0236291282a5b$var$_objectSpread({
                    eventName: eventName || "Hits Viewed",
                    index: getIndex(),
                    objectIDs: objectIDsByChunk[i]
                }, additionalData),
                hits: batch,
                eventModifier: eventModifier
            };
        });
    } else if (eventType === "click") return hitsChunks.map(function(batch, i) {
        return {
            insightsMethod: "clickedObjectIDsAfterSearch",
            widgetType: widgetType,
            eventType: eventType,
            payload: $32c0236291282a5b$var$_objectSpread({
                eventName: eventName || "Hit Clicked",
                index: getIndex(),
                queryID: queryID,
                objectIDs: objectIDsByChunk[i],
                positions: positionsByChunk[i]
            }, additionalData),
            hits: batch,
            eventModifier: eventModifier
        };
    });
    else if (eventType === "conversion") return hitsChunks.map(function(batch, i) {
        return {
            insightsMethod: "convertedObjectIDsAfterSearch",
            widgetType: widgetType,
            eventType: eventType,
            payload: $32c0236291282a5b$var$_objectSpread({
                eventName: eventName || "Hit Converted",
                index: getIndex(),
                queryID: queryID,
                objectIDs: objectIDsByChunk[i]
            }, additionalData),
            hits: batch,
            eventModifier: eventModifier
        };
    });
    else return [];
}
function $32c0236291282a5b$export$4139f3a7130239e3(_ref2) {
    var instantSearchInstance = _ref2.instantSearchInstance, getIndex = _ref2.getIndex, widgetType = _ref2.widgetType;
    var sentEvents = {};
    var timer = undefined;
    var sendEventForHits = function sendEventForHits() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var payloads = $32c0236291282a5b$export$2f82a8f6391c6db9({
            widgetType: widgetType,
            getIndex: getIndex,
            methodName: "sendEvent",
            args: args,
            instantSearchInstance: instantSearchInstance
        });
        payloads.forEach(function(payload) {
            if (payload.eventType === "click" && payload.eventModifier === "internal" && sentEvents[payload.eventType]) return;
            sentEvents[payload.eventType] = true;
            instantSearchInstance.sendEventToInsights(payload);
        });
        clearTimeout(timer);
        timer = setTimeout(function() {
            sentEvents = {};
        }, 0);
    };
    return sendEventForHits;
}
function $32c0236291282a5b$export$5a3d9973824d9b76(_ref3) {
    var getIndex = _ref3.getIndex, widgetType = _ref3.widgetType, instantSearchInstance = _ref3.instantSearchInstance;
    var bindEventForHits = function bindEventForHits() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var payloads = $32c0236291282a5b$export$2f82a8f6391c6db9({
            widgetType: widgetType,
            getIndex: getIndex,
            methodName: "bindEvent",
            args: args,
            instantSearchInstance: instantSearchInstance
        });
        return payloads.length ? "data-insights-event=".concat((0, $c1bd8090b7245f7b$export$44b4521aa38272f2)(payloads)) : "";
    };
    return bindEventForHits;
}

function $ca39c5c6391402fa$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ca39c5c6391402fa$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ca39c5c6391402fa$var$_typeof(obj);
}
function $ca39c5c6391402fa$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ca39c5c6391402fa$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ca39c5c6391402fa$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ca39c5c6391402fa$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ca39c5c6391402fa$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ca39c5c6391402fa$var$_defineProperty(obj, key, value) {
    key = $ca39c5c6391402fa$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ca39c5c6391402fa$var$_toPropertyKey(arg) {
    var key = $ca39c5c6391402fa$var$_toPrimitive(arg, "string");
    return $ca39c5c6391402fa$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ca39c5c6391402fa$var$_toPrimitive(input, hint) {
    if ($ca39c5c6391402fa$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ca39c5c6391402fa$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $ca39c5c6391402fa$export$33d742d8ee5a4609(hits, page, hitsPerPage) {
    return hits.map(function(hit, idx) {
        return $ca39c5c6391402fa$var$_objectSpread($ca39c5c6391402fa$var$_objectSpread({}, hit), {}, {
            __position: hitsPerPage * page + idx + 1
        });
    });
}

function $00ab561a6feaa3d9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $00ab561a6feaa3d9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $00ab561a6feaa3d9$var$_typeof(obj);
}
function $00ab561a6feaa3d9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $00ab561a6feaa3d9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $00ab561a6feaa3d9$var$ownKeys(Object(source), !0).forEach(function(key) {
            $00ab561a6feaa3d9$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $00ab561a6feaa3d9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $00ab561a6feaa3d9$var$_defineProperty(obj, key, value) {
    key = $00ab561a6feaa3d9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $00ab561a6feaa3d9$var$_toPropertyKey(arg) {
    var key = $00ab561a6feaa3d9$var$_toPrimitive(arg, "string");
    return $00ab561a6feaa3d9$var$_typeof(key) === "symbol" ? key : String(key);
}
function $00ab561a6feaa3d9$var$_toPrimitive(input, hint) {
    if ($00ab561a6feaa3d9$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($00ab561a6feaa3d9$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $00ab561a6feaa3d9$export$b8f834386ea30952(hits, queryID) {
    if (!queryID) return hits;
    return hits.map(function(hit) {
        return $00ab561a6feaa3d9$var$_objectSpread($00ab561a6feaa3d9$var$_objectSpread({}, hit), {}, {
            __queryID: queryID
        });
    });
}


function $373bc2343db97f54$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $373bc2343db97f54$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $373bc2343db97f54$var$_typeof(obj);
}
function $373bc2343db97f54$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $373bc2343db97f54$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $373bc2343db97f54$var$ownKeys(Object(source), !0).forEach(function(key) {
            $373bc2343db97f54$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $373bc2343db97f54$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $373bc2343db97f54$var$_defineProperty(obj, key, value) {
    key = $373bc2343db97f54$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $373bc2343db97f54$var$_toPropertyKey(arg) {
    var key = $373bc2343db97f54$var$_toPrimitive(arg, "string");
    return $373bc2343db97f54$var$_typeof(key) === "symbol" ? key : String(key);
}
function $373bc2343db97f54$var$_toPrimitive(input, hint) {
    if ($373bc2343db97f54$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($373bc2343db97f54$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $373bc2343db97f54$var$withUsage = (0, $44084963839a4436$export$2fde5bffc340821e)({
    name: "hits",
    connector: true
});
var $373bc2343db97f54$var$connectHits = function connectHits(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $5d3ef3e388d952bb$export$8793edee2d425525);
    (0, $c9c42a7fa64cf8eb$export$adc2a8e09aa583ee)(renderFn, $373bc2343db97f54$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, _ref$escapeHTML = _ref.escapeHTML, escapeHTML = _ref$escapeHTML === void 0 ? true : _ref$escapeHTML, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function transformItems(items) {
            return items;
        } : _ref$transformItems;
        var sendEvent;
        var bindEvent;
        return {
            $$type: "ais.hits",
            init: function init(initOptions) {
                renderFn($373bc2343db97f54$var$_objectSpread($373bc2343db97f54$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: initOptions.instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var renderState = this.getWidgetRenderState(renderOptions);
                renderFn($373bc2343db97f54$var$_objectSpread($373bc2343db97f54$var$_objectSpread({}, renderState), {}, {
                    instantSearchInstance: renderOptions.instantSearchInstance
                }), false);
                renderState.sendEvent("view:internal", renderState.hits);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $373bc2343db97f54$var$_objectSpread($373bc2343db97f54$var$_objectSpread({}, renderState), {}, {
                    hits: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref2) {
                var results = _ref2.results, helper = _ref2.helper, instantSearchInstance = _ref2.instantSearchInstance;
                if (!sendEvent) sendEvent = (0, $32c0236291282a5b$export$4139f3a7130239e3)({
                    instantSearchInstance: instantSearchInstance,
                    getIndex: function getIndex() {
                        return helper.getIndex();
                    },
                    widgetType: this.$$type
                });
                if (!bindEvent) bindEvent = (0, $32c0236291282a5b$export$5a3d9973824d9b76)({
                    getIndex: function getIndex() {
                        return helper.getIndex();
                    },
                    widgetType: this.$$type,
                    instantSearchInstance: instantSearchInstance
                });
                if (!results) return {
                    hits: [],
                    results: undefined,
                    sendEvent: sendEvent,
                    bindEvent: bindEvent,
                    widgetParams: widgetParams
                };
                if (escapeHTML && results.hits.length > 0) results.hits = (0, $a81e7c21001dea67$export$9adb036445aab889)(results.hits);
                var hitsWithAbsolutePosition = (0, $ca39c5c6391402fa$export$33d742d8ee5a4609)(results.hits, results.page, results.hitsPerPage);
                var hitsWithAbsolutePositionAndQueryID = (0, $00ab561a6feaa3d9$export$b8f834386ea30952)(hitsWithAbsolutePosition, results.queryID);
                var transformedHits = transformItems(hitsWithAbsolutePositionAndQueryID, {
                    results: results
                });
                return {
                    hits: transformedHits,
                    results: results,
                    sendEvent: sendEvent,
                    bindEvent: bindEvent,
                    widgetParams: widgetParams
                };
            },
            dispose: function dispose(_ref3) {
                var state = _ref3.state;
                unmountFn();
                if (!escapeHTML) return state;
                return state.setQueryParameters(Object.keys((0, $a81e7c21001dea67$export$1e7338a8952eaf35)).reduce(function(acc, key) {
                    return $373bc2343db97f54$var$_objectSpread($373bc2343db97f54$var$_objectSpread({}, acc), {}, $373bc2343db97f54$var$_defineProperty({}, key, undefined));
                }, {}));
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(state) {
                if (!escapeHTML) return state;
                // @MAJOR: set this globally, not in the Hits widget to allow Hits to be conditionally used
                return state.setQueryParameters((0, $a81e7c21001dea67$export$1e7338a8952eaf35));
            }
        };
    };
};
var $373bc2343db97f54$export$2e2bcd8739ae039 = $373bc2343db97f54$var$connectHits;



function $6433247356d85328$export$1dc18a9d9332e2a7(props, additionalWidgetProperties) {
    return (0, $dc402206ef11e68a$export$7b345619fa263f7e)((0, $373bc2343db97f54$export$2e2bcd8739ae039), props, additionalWidgetProperties);
}


var $c677a420a7e56b00$var$_excluded = [
    "escapeHTML",
    "transformItems",
    "hitComponent"
], $c677a420a7e56b00$var$_excluded2 = [
    "hit",
    "index"
];
function $c677a420a7e56b00$var$_extends() {
    $c677a420a7e56b00$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c677a420a7e56b00$var$_extends.apply(this, arguments);
}
function $c677a420a7e56b00$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c677a420a7e56b00$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c677a420a7e56b00$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// @MAJOR: Move default hit component back to the UI library
// once flavour specificities are erased
function $c677a420a7e56b00$var$DefaultHitComponent(_ref) {
    var hit = _ref.hit;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("div", {
        style: {
            wordBreak: "break-all"
        }
    }, JSON.stringify(hit).slice(0, 100), "\u2026");
}
var $c677a420a7e56b00$var$HitsUiComponent = (0, $62def845f6145da8$export$abc871145e3e685)({
    createElement: (0, $4rNTR.createElement),
    Fragment: (0, $4rNTR.Fragment)
});
function $c677a420a7e56b00$export$9abb8533010f1d93(_ref2) {
    var escapeHTML = _ref2.escapeHTML, transformItems = _ref2.transformItems, _ref2$hitComponent = _ref2.hitComponent, HitComponent = _ref2$hitComponent === void 0 ? $c677a420a7e56b00$var$DefaultHitComponent : _ref2$hitComponent, props = $c677a420a7e56b00$var$_objectWithoutProperties(_ref2, $c677a420a7e56b00$var$_excluded);
    var _useHits = (0, $6433247356d85328$export$1dc18a9d9332e2a7)({
        escapeHTML: escapeHTML,
        transformItems: transformItems
    }, {
        $$widgetType: "ais.hits"
    }), hits = _useHits.hits, sendEvent = _useHits.sendEvent;
    var itemComponent = function itemComponent(_ref3) {
        var hit = _ref3.hit, index = _ref3.index, itemProps = $c677a420a7e56b00$var$_objectWithoutProperties(_ref3, $c677a420a7e56b00$var$_excluded2);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("li", $c677a420a7e56b00$var$_extends({
            key: hit.objectID
        }, itemProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement(HitComponent, {
            hit: hit,
            sendEvent: sendEvent
        }));
    };
    var uiProps = {
        hits: hits,
        sendEvent: sendEvent,
        itemComponent: itemComponent
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement($c677a420a7e56b00$var$HitsUiComponent, $c677a420a7e56b00$var$_extends({}, props, uiProps));
}


var $4rNTR = parcelRequire("4rNTR");

function $748293abdec4b17f$var$_toConsumableArray(arr) {
    return $748293abdec4b17f$var$_arrayWithoutHoles(arr) || $748293abdec4b17f$var$_iterableToArray(arr) || $748293abdec4b17f$var$_unsupportedIterableToArray(arr) || $748293abdec4b17f$var$_nonIterableSpread();
}
function $748293abdec4b17f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $748293abdec4b17f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $748293abdec4b17f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $748293abdec4b17f$var$_arrayLikeToArray(o, minLen);
}
function $748293abdec4b17f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $748293abdec4b17f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $748293abdec4b17f$var$_arrayLikeToArray(arr);
}
function $748293abdec4b17f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $748293abdec4b17f$export$d02631cccf789723(_ref) {
    var _ref$start = _ref.start, start = _ref$start === void 0 ? 0 : _ref$start, end = _ref.end, _ref$step = _ref.step, step = _ref$step === void 0 ? 1 : _ref$step;
    // We can't divide by 0 so we re-assign the step to 1 if it happens.
    var limitStep = step === 0 ? 1 : step;
    // In some cases the array to create has a decimal length.
    // We therefore need to round the value.
    // Example:
    //   { start: 1, end: 5000, step: 500 }
    //   => Array length = (5000 - 1) / 500 = 9.998
    var arrayLength = Math.round((end - start) / limitStep);
    return $748293abdec4b17f$var$_toConsumableArray(Array(arrayLength)).map(function(_, current) {
        return start + current * limitStep;
    });
}


function $7ba083ce348c51c4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $7ba083ce348c51c4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $7ba083ce348c51c4$var$_typeof(obj);
}
function $7ba083ce348c51c4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7ba083ce348c51c4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7ba083ce348c51c4$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7ba083ce348c51c4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7ba083ce348c51c4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7ba083ce348c51c4$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7ba083ce348c51c4$var$_defineProperty(obj, key, value) {
    key = $7ba083ce348c51c4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7ba083ce348c51c4$var$_toPropertyKey(arg) {
    var key = $7ba083ce348c51c4$var$_toPrimitive(arg, "string");
    return $7ba083ce348c51c4$var$_typeof(key) === "symbol" ? key : String(key);
}
function $7ba083ce348c51c4$var$_toPrimitive(input, hint) {
    if ($7ba083ce348c51c4$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($7ba083ce348c51c4$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $7ba083ce348c51c4$var$Paginator = /*#__PURE__*/ function() {
    function Paginator(params) {
        $7ba083ce348c51c4$var$_classCallCheck(this, Paginator);
        $7ba083ce348c51c4$var$_defineProperty(this, "currentPage", void 0);
        $7ba083ce348c51c4$var$_defineProperty(this, "total", void 0);
        $7ba083ce348c51c4$var$_defineProperty(this, "padding", void 0);
        this.currentPage = params.currentPage;
        this.total = params.total;
        this.padding = params.padding;
    }
    $7ba083ce348c51c4$var$_createClass(Paginator, [
        {
            key: "pages",
            value: function pages() {
                var total = this.total, currentPage = this.currentPage, padding = this.padding;
                if (total === 0) return [
                    0
                ];
                var totalDisplayedPages = this.nbPagesDisplayed(padding, total);
                if (totalDisplayedPages === total) return (0, $748293abdec4b17f$export$d02631cccf789723)({
                    end: total
                });
                var paddingLeft = this.calculatePaddingLeft(currentPage, padding, total, totalDisplayedPages);
                var paddingRight = totalDisplayedPages - paddingLeft;
                var first = currentPage - paddingLeft;
                var last = currentPage + paddingRight;
                return (0, $748293abdec4b17f$export$d02631cccf789723)({
                    start: first,
                    end: last
                });
            }
        },
        {
            key: "nbPagesDisplayed",
            value: function nbPagesDisplayed(padding, total) {
                return Math.min(2 * padding + 1, total);
            }
        },
        {
            key: "calculatePaddingLeft",
            value: function calculatePaddingLeft(current, padding, total, totalDisplayedPages) {
                if (current <= padding) return current;
                if (current >= total - padding) return totalDisplayedPages - (total - current);
                return padding;
            }
        },
        {
            key: "isLastPage",
            value: function isLastPage() {
                return this.currentPage === this.total - 1 || this.total === 0;
            }
        },
        {
            key: "isFirstPage",
            value: function isFirstPage() {
                return this.currentPage === 0;
            }
        }
    ]);
    return Paginator;
}();
var $7ba083ce348c51c4$export$2e2bcd8739ae039 = $7ba083ce348c51c4$var$Paginator;


function $dfd799a44ae791ab$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $dfd799a44ae791ab$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $dfd799a44ae791ab$var$_typeof(obj);
}
function $dfd799a44ae791ab$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $dfd799a44ae791ab$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $dfd799a44ae791ab$var$ownKeys(Object(source), !0).forEach(function(key) {
            $dfd799a44ae791ab$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $dfd799a44ae791ab$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $dfd799a44ae791ab$var$_defineProperty(obj, key, value) {
    key = $dfd799a44ae791ab$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dfd799a44ae791ab$var$_toPropertyKey(arg) {
    var key = $dfd799a44ae791ab$var$_toPrimitive(arg, "string");
    return $dfd799a44ae791ab$var$_typeof(key) === "symbol" ? key : String(key);
}
function $dfd799a44ae791ab$var$_toPrimitive(input, hint) {
    if ($dfd799a44ae791ab$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($dfd799a44ae791ab$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $dfd799a44ae791ab$var$withUsage = (0, $44084963839a4436$export$2fde5bffc340821e)({
    name: "pagination",
    connector: true
});
/**
 * **Pagination** connector provides the logic to build a widget that will let the user
 * choose the current page of the results.
 *
 * When using the pagination with Algolia, you should be aware that the engine won't provide you pages
 * beyond the 1000th hits by default. You can find more information on the [Algolia documentation](https://www.algolia.com/doc/guides/searching/pagination/#pagination-limitations).
 */ var $dfd799a44ae791ab$var$connectPagination = function connectPagination(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $5d3ef3e388d952bb$export$8793edee2d425525);
    (0, $c9c42a7fa64cf8eb$export$adc2a8e09aa583ee)(renderFn, $dfd799a44ae791ab$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, totalPages = _ref.totalPages, _ref$padding = _ref.padding, padding = _ref$padding === void 0 ? 3 : _ref$padding;
        var pager = new (0, $7ba083ce348c51c4$export$2e2bcd8739ae039)({
            currentPage: 0,
            total: 0,
            padding: padding
        });
        var connectorState = {};
        function getMaxPage(_ref2) {
            var nbPages = _ref2.nbPages;
            return totalPages !== undefined ? Math.min(totalPages, nbPages) : nbPages;
        }
        return {
            $$type: "ais.pagination",
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($dfd799a44ae791ab$var$_objectSpread($dfd799a44ae791ab$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($dfd799a44ae791ab$var$_objectSpread($dfd799a44ae791ab$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref3) {
                var state = _ref3.state;
                unmountFn();
                return state.setQueryParameter("page", undefined);
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref4) {
                var searchParameters = _ref4.searchParameters;
                var page = searchParameters.page || 0;
                if (!page) return uiState;
                return $dfd799a44ae791ab$var$_objectSpread($dfd799a44ae791ab$var$_objectSpread({}, uiState), {}, {
                    page: page + 1
                });
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref5) {
                var uiState = _ref5.uiState;
                var page = uiState.page ? uiState.page - 1 : 0;
                return searchParameters.setQueryParameter("page", page);
            },
            getWidgetRenderState: function getWidgetRenderState(_ref6) {
                var results = _ref6.results, helper = _ref6.helper, state = _ref6.state, createURL = _ref6.createURL;
                if (!connectorState.refine) connectorState.refine = function(page) {
                    helper.setPage(page);
                    helper.search();
                };
                if (!connectorState.createURL) connectorState.createURL = function(page) {
                    return createURL(function(uiState) {
                        return $dfd799a44ae791ab$var$_objectSpread($dfd799a44ae791ab$var$_objectSpread({}, uiState), {}, {
                            page: page + 1
                        });
                    });
                };
                var page = state.page || 0;
                var nbPages = getMaxPage(results || {
                    nbPages: 0
                });
                pager.currentPage = page;
                pager.total = nbPages;
                return {
                    createURL: connectorState.createURL,
                    refine: connectorState.refine,
                    canRefine: nbPages > 1,
                    currentRefinement: page,
                    nbHits: (results === null || results === void 0 ? void 0 : results.nbHits) || 0,
                    nbPages: nbPages,
                    pages: results ? pager.pages() : [],
                    isFirstPage: pager.isFirstPage(),
                    isLastPage: pager.isLastPage(),
                    widgetParams: widgetParams
                };
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $dfd799a44ae791ab$var$_objectSpread($dfd799a44ae791ab$var$_objectSpread({}, renderState), {}, {
                    pagination: this.getWidgetRenderState(renderOptions)
                });
            }
        };
    };
};
var $dfd799a44ae791ab$export$2e2bcd8739ae039 = $dfd799a44ae791ab$var$connectPagination;



function $7b3981399aa38d88$export$f80c710216eae131(props, additionalWidgetProperties) {
    return (0, $dc402206ef11e68a$export$7b345619fa263f7e)((0, $dfd799a44ae791ab$export$2e2bcd8739ae039), props, additionalWidgetProperties);
}




var $4rNTR = parcelRequire("4rNTR");
function $e0871b1634b95609$export$1131d30bb631f2ba(event) {
    var isMiddleClick = event.button === 1;
    return Boolean(isMiddleClick || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey);
}


var $bc67e0d34f4e3c1d$var$_excluded = [
    "pages",
    "currentPage",
    "nbPages",
    "isFirstPage",
    "isLastPage",
    "showFirst",
    "showPrevious",
    "showNext",
    "showLast",
    "createURL",
    "onNavigate",
    "translations",
    "classNames"
], $bc67e0d34f4e3c1d$var$_excluded2 = [
    "isDisabled",
    "className",
    "classNames",
    "href",
    "onClick"
];
function $bc67e0d34f4e3c1d$var$_extends() {
    $bc67e0d34f4e3c1d$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bc67e0d34f4e3c1d$var$_extends.apply(this, arguments);
}
function $bc67e0d34f4e3c1d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $bc67e0d34f4e3c1d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $bc67e0d34f4e3c1d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $bc67e0d34f4e3c1d$export$68f5e1453c188a82(_ref) {
    var pages = _ref.pages, currentPage = _ref.currentPage, nbPages = _ref.nbPages, isFirstPage = _ref.isFirstPage, isLastPage = _ref.isLastPage, _ref$showFirst = _ref.showFirst, showFirst = _ref$showFirst === void 0 ? true : _ref$showFirst, _ref$showPrevious = _ref.showPrevious, showPrevious = _ref$showPrevious === void 0 ? true : _ref$showPrevious, _ref$showNext = _ref.showNext, showNext = _ref$showNext === void 0 ? true : _ref$showNext, _ref$showLast = _ref.showLast, showLast = _ref$showLast === void 0 ? true : _ref$showLast, createURL = _ref.createURL, onNavigate = _ref.onNavigate, translations = _ref.translations, _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = $bc67e0d34f4e3c1d$var$_objectWithoutProperties(_ref, $bc67e0d34f4e3c1d$var$_excluded);
    var firstPageIndex = 0;
    var previousPageIndex = currentPage - 1;
    var nextPageIndex = currentPage + 1;
    var lastPageIndex = nbPages - 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("div", $bc67e0d34f4e3c1d$var$_extends({}, props, {
        className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-Pagination", classNames.root, nbPages <= 1 && (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-Pagination--noRefinement", classNames.noRefinementRoot), props.className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("ul", {
        className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-Pagination-list", classNames.list)
    }, showFirst && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement($bc67e0d34f4e3c1d$var$PaginationItem, {
        isDisabled: isFirstPage,
        className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-Pagination-item--firstPage", classNames.firstPageItem),
        classNames: classNames,
        "aria-label": translations.firstPageItemAriaLabel,
        href: createURL(firstPageIndex),
        onClick: function onClick() {
            return onNavigate(firstPageIndex);
        }
    }, translations.firstPageItemText), showPrevious && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement($bc67e0d34f4e3c1d$var$PaginationItem, {
        isDisabled: isFirstPage,
        className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-Pagination-item--previousPage", classNames.previousPageItem),
        classNames: classNames,
        "aria-label": translations.previousPageItemAriaLabel,
        href: createURL(previousPageIndex),
        onClick: function onClick() {
            return onNavigate(previousPageIndex);
        }
    }, translations.previousPageItemText), pages.map(function(page) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement($bc67e0d34f4e3c1d$var$PaginationItem, {
            key: page,
            isDisabled: false,
            className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-Pagination-item--page", classNames.pageItem, page === currentPage && (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-Pagination-item--selected", classNames.selectedItem)),
            classNames: classNames,
            "aria-label": translations.pageItemAriaLabel({
                currentPage: page + 1,
                nbPages: nbPages
            }),
            href: createURL(page),
            onClick: function onClick() {
                return onNavigate(page);
            }
        }, translations.pageItemText({
            currentPage: page + 1,
            nbPages: nbPages
        }));
    }), showNext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement($bc67e0d34f4e3c1d$var$PaginationItem, {
        isDisabled: isLastPage,
        className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-Pagination-item--nextPage", classNames.nextPageItem),
        classNames: classNames,
        "aria-label": translations.nextPageItemAriaLabel,
        href: createURL(nextPageIndex),
        onClick: function onClick() {
            return onNavigate(nextPageIndex);
        }
    }, translations.nextPageItemText), showLast && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement($bc67e0d34f4e3c1d$var$PaginationItem, {
        isDisabled: isLastPage,
        className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-Pagination-item--lastPage", classNames.lastPageItem),
        classNames: classNames,
        "aria-label": translations.lastPageItemAriaLabel,
        href: createURL(lastPageIndex),
        onClick: function onClick() {
            return onNavigate(lastPageIndex);
        }
    }, translations.lastPageItemText)));
}
function $bc67e0d34f4e3c1d$var$PaginationItem(_ref2) {
    var isDisabled = _ref2.isDisabled, className = _ref2.className, classNames = _ref2.classNames, href = _ref2.href, _onClick = _ref2.onClick, props = $bc67e0d34f4e3c1d$var$_objectWithoutProperties(_ref2, $bc67e0d34f4e3c1d$var$_excluded2);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("li", {
        className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-Pagination-item", classNames.item, "ais-Pagination-item--disabled", classNames.disabledItem, className)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("span", $bc67e0d34f4e3c1d$var$_extends({
        className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-Pagination-link", classNames.link)
    }, props)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("li", {
        className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-Pagination-item", classNames.item, className)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement("a", $bc67e0d34f4e3c1d$var$_extends({
        className: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-Pagination-link", classNames.link),
        href: href,
        onClick: function onClick(event) {
            if ((0, $e0871b1634b95609$export$1131d30bb631f2ba)(event)) return;
            event.preventDefault();
            _onClick(event);
        }
    }, props)));
}


function $93090f15413781f6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $93090f15413781f6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $93090f15413781f6$var$_typeof(obj);
}
var $93090f15413781f6$var$_excluded = [
    "showFirst",
    "showPrevious",
    "showNext",
    "showLast",
    "padding",
    "totalPages",
    "translations"
];
function $93090f15413781f6$var$_extends() {
    $93090f15413781f6$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $93090f15413781f6$var$_extends.apply(this, arguments);
}
function $93090f15413781f6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $93090f15413781f6$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $93090f15413781f6$var$ownKeys(Object(source), !0).forEach(function(key) {
            $93090f15413781f6$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $93090f15413781f6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $93090f15413781f6$var$_defineProperty(obj, key, value) {
    key = $93090f15413781f6$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $93090f15413781f6$var$_toPropertyKey(arg) {
    var key = $93090f15413781f6$var$_toPrimitive(arg, "string");
    return $93090f15413781f6$var$_typeof(key) === "symbol" ? key : String(key);
}
function $93090f15413781f6$var$_toPrimitive(input, hint) {
    if ($93090f15413781f6$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($93090f15413781f6$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $93090f15413781f6$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $93090f15413781f6$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $93090f15413781f6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $93090f15413781f6$export$68f5e1453c188a82(_ref) {
    var showFirst = _ref.showFirst, showPrevious = _ref.showPrevious, showNext = _ref.showNext, showLast = _ref.showLast, padding = _ref.padding, totalPages = _ref.totalPages, translations = _ref.translations, props = $93090f15413781f6$var$_objectWithoutProperties(_ref, $93090f15413781f6$var$_excluded);
    var _usePagination = (0, $7b3981399aa38d88$export$f80c710216eae131)({
        padding: padding,
        totalPages: totalPages
    }, {
        $$widgetType: "ais.pagination"
    }), pages = _usePagination.pages, currentRefinement = _usePagination.currentRefinement, isFirstPage = _usePagination.isFirstPage, isLastPage = _usePagination.isLastPage, nbPages = _usePagination.nbPages, createURL = _usePagination.createURL, refine = _usePagination.refine;
    var uiProps = {
        pages: pages,
        currentPage: currentRefinement,
        isFirstPage: isFirstPage,
        isLastPage: isLastPage,
        nbPages: nbPages,
        createURL: createURL,
        onNavigate: refine,
        translations: $93090f15413781f6$var$_objectSpread({
            firstPageItemText: "\u2039\u2039",
            previousPageItemText: "\u2039",
            nextPageItemText: "\u203A",
            lastPageItemText: "\u203A\u203A",
            pageItemText: function pageItemText(_ref2) {
                var currentPage = _ref2.currentPage;
                return String(currentPage);
            },
            firstPageItemAriaLabel: "First Page",
            previousPageItemAriaLabel: "Previous Page",
            nextPageItemAriaLabel: "Next Page",
            lastPageItemAriaLabel: "Last Page, Page ".concat(nbPages),
            pageItemAriaLabel: function pageItemAriaLabel(_ref3) {
                var currentPage = _ref3.currentPage;
                return "Page ".concat(currentPage);
            }
        }, translations)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement((0, $bc67e0d34f4e3c1d$export$68f5e1453c188a82), $93090f15413781f6$var$_extends({}, props, uiProps, {
        showFirst: showFirst,
        showPrevious: showPrevious,
        showNext: showNext,
        showLast: showLast
    }));
}



var $4rNTR = parcelRequire("4rNTR");

var $163a166b485c55d7$var$_excluded = [
    "hit",
    "attribute",
    "highlightedTagName",
    "nonHighlightedTagName",
    "separator"
];
function $163a166b485c55d7$var$_extends() {
    $163a166b485c55d7$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $163a166b485c55d7$var$_extends.apply(this, arguments);
}
function $163a166b485c55d7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $163a166b485c55d7$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $163a166b485c55d7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $163a166b485c55d7$export$39dbc3f558091353(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute, highlightedTagName = _ref.highlightedTagName, nonHighlightedTagName = _ref.nonHighlightedTagName, separator = _ref.separator, props = $163a166b485c55d7$var$_objectWithoutProperties(_ref, $163a166b485c55d7$var$_excluded);
    var property = (0, $ad82201011f73d65$export$d14846335956eefa)(hit._highlightResult, attribute) || [];
    var properties = Array.isArray(property) ? property : [
        property
    ];
    var parts = properties.map(function(singleValue) {
        return (0, $b44df87e9fbd5757$export$e04d28e65b830ebf)((0, $638238b1c80b9474$export$e8bacd2802a88316)(singleValue.value || ""));
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement((0, $1bc65673d14beafa$export$39dbc3f558091353), $163a166b485c55d7$var$_extends({}, props, {
        parts: parts,
        highlightedTagName: highlightedTagName,
        nonHighlightedTagName: nonHighlightedTagName,
        separator: separator
    }));
}



var $4rNTR = parcelRequire("4rNTR");


var $4rNTR = parcelRequire("4rNTR");

var $31ab14f1f03ff54e$var$_excluded = [
    "classNames"
];
function $31ab14f1f03ff54e$var$_extends() {
    $31ab14f1f03ff54e$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $31ab14f1f03ff54e$var$_extends.apply(this, arguments);
}
function $31ab14f1f03ff54e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $31ab14f1f03ff54e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $31ab14f1f03ff54e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $31ab14f1f03ff54e$export$10c56fa12fda26f9(_ref) {
    var _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = $31ab14f1f03ff54e$var$_objectWithoutProperties(_ref, $31ab14f1f03ff54e$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement((0, $899a27daa8df1b71$export$57a0c6fc80bec05c), $31ab14f1f03ff54e$var$_extends({
        classNames: {
            root: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-Snippet", classNames.root),
            highlighted: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-Snippet-highlighted", classNames.highlighted),
            nonHighlighted: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-Snippet-nonHighlighted", classNames.nonHighlighted),
            separator: (0, $b252d2dae9b61923$export$a274e22fb40f762e)("ais-Snippet-separator", classNames.separator)
        }
    }, props));
}


var $649b7b0791a1bb9a$var$_excluded = [
    "hit",
    "attribute",
    "highlightedTagName",
    "nonHighlightedTagName",
    "separator"
];
function $649b7b0791a1bb9a$var$_extends() {
    $649b7b0791a1bb9a$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $649b7b0791a1bb9a$var$_extends.apply(this, arguments);
}
function $649b7b0791a1bb9a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $649b7b0791a1bb9a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $649b7b0791a1bb9a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $649b7b0791a1bb9a$export$10c56fa12fda26f9(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute, highlightedTagName = _ref.highlightedTagName, nonHighlightedTagName = _ref.nonHighlightedTagName, separator = _ref.separator, props = $649b7b0791a1bb9a$var$_objectWithoutProperties(_ref, $649b7b0791a1bb9a$var$_excluded);
    var property = (0, $ad82201011f73d65$export$d14846335956eefa)(hit._snippetResult, attribute) || [];
    var properties = Array.isArray(property) ? property : [
        property
    ];
    var parts = properties.map(function(singleValue) {
        return (0, $b44df87e9fbd5757$export$e04d28e65b830ebf)((0, $638238b1c80b9474$export$e8bacd2802a88316)(singleValue.value || ""));
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement((0, $31ab14f1f03ff54e$export$10c56fa12fda26f9), $649b7b0791a1bb9a$var$_extends({}, props, {
        parts: parts,
        highlightedTagName: highlightedTagName,
        nonHighlightedTagName: nonHighlightedTagName,
        separator: separator
    }));
}



parcelRequire("4rNTR");
function $8af36babf1918803$export$195b9afc167669b() {
    return /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("a", {
        href: "https://algolia.com",
        "aria-label": "Go to the Algolia website",
        children: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 117",
            children: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("path", {
                fill: "#FFF",
                d: "M249.5 64.2V1.4c0-.9-.7-1.5-1.6-1.4L236.2 2a1.4 1.4 0 0 0-1.2 1.3V67c0 3 0 21.6 22.4 22.3a1.4 1.4 0 0 0 1.5-1.4v-9.5c0-.7-.6-1.3-1.2-1.4-8.2-.9-8.2-11-8.2-12.7ZM443.5 24.4h-11.8c-.8 0-1.4.6-1.4 1.4v62c0 .8.6 1.4 1.4 1.4h11.8c.8 0 1.4-.6 1.4-1.4v-62c0-.8-.6-1.4-1.4-1.4ZM431.7 16.6h11.8c.8 0 1.4-.6 1.4-1.3v-14c0-.8-.7-1.4-1.6-1.3L431.5 2a1.4 1.4 0 0 0-1.2 1.3v12c0 .8.6 1.4 1.4 1.4Zm-20.5 47.6V1.4c0-.9-.7-1.5-1.5-1.4L397.9 2a1.4 1.4 0 0 0-1.2 1.3V67c0 3 0 21.6 22.4 22.3a1.4 1.4 0 0 0 1.5-1.4v-9.5c0-.7-.5-1.3-1.2-1.4-8.2-.9-8.2-11-8.2-12.7Zm-30.7-31c-2.6-2.8-5.8-5-9.6-6.5a31.7 31.7 0 0 0-12-2.3c-4.5 0-8.5.7-12.2 2.3A27.9 27.9 0 0 0 331 43.5a39.6 39.6 0 0 0 0 26.3c1.5 4 3.6 7.5 6.2 10.3 2.6 2.9 5.8 5 9.5 6.7a38 38 0 0 0 12.2 2.4c2.8 0 8.6-.9 12.3-2.4a27 27 0 0 0 9.5-6.7 35.1 35.1 0 0 0 8.3-23c0-4.9-.8-9.6-2.4-13.6-1.5-4-3.5-7.4-6.1-10.2ZM370 71.5a13.1 13.1 0 0 1-11.2 5.6 13 13 0 0 1-11.2-5.6c-2.7-3.6-4-7.9-4-14.2 0-6.3 1.3-11.5 4-15.1a13 13 0 0 1 11.1-5.5 13 13 0 0 1 11.3 5.5c2.6 3.6 4 8.8 4 15 0 6.4-1.3 10.6-4 14.3Zm-161.6-47H197a32 32 0 0 0-27 15 33.8 33.8 0 0 0 8.9 45.9 18.8 18.8 0 0 0 11.2 3.1H191.2l.6-.2h.2a21 21 0 0 0 16.5-14.6V87c0 .8.6 1.4 1.4 1.4h11.7c.8 0 1.4-.6 1.4-1.4V25.8c0-.8-.6-1.4-1.4-1.4h-13Zm0 48.3a17.8 17.8 0 0 1-10.4 3.5h-.2a12.5 12.5 0 0 1-.7 0A18.4 18.4 0 0 1 180.4 51c2.7-6.8 9-11.6 16.6-11.6h11.5v33.3Zm289-48.3H486a32 32 0 0 0-27 15 33.8 33.8 0 0 0 8.8 45.9 18.8 18.8 0 0 0 11.3 3.1h1.1l.6-.2h.2a21 21 0 0 0 16.5-14.6V87c0 .8.6 1.4 1.4 1.4h11.7c.8 0 1.4-.6 1.4-1.4V25.8c0-.8-.6-1.4-1.4-1.4h-13.1Zm0 48.3a17.8 17.8 0 0 1-10.5 3.5h-.9A18.4 18.4 0 0 1 469.4 51c2.6-6.8 9-11.6 16.6-11.6h11.5v33.3ZM306.3 24.4h-11.5a32 32 0 0 0-27 15 33.7 33.7 0 0 0-5.1 14.6 34.6 34.6 0 0 0 0 7.6c1 8.9 5.4 16.7 11.8 22a19.5 19.5 0 0 0 2.2 1.7 18.8 18.8 0 0 0 21.6-.6c3.8-2.7 6.7-6.7 8-11.1V87.9c0 5-1.3 8.9-4 11.5-2.7 2.6-7.3 3.9-13.6 3.9-2.6 0-6.7-.2-10.9-.6a1.4 1.4 0 0 0-1.4 1l-3 10a1.4 1.4 0 0 0 1.1 1.8c5 .7 10 1 12.8 1 11.4 0 19.8-2.4 25.3-7.4 5-4.6 7.8-11.4 8.2-20.7V25.8c0-.8-.6-1.4-1.3-1.4h-13.2Zm0 15s.2 32.4 0 33.4a17.5 17.5 0 0 1-10 3.4h-.2a13.6 13.6 0 0 1-1.7 0A18.7 18.7 0 0 1 278.3 51c2.6-6.8 9-11.6 16.5-11.6h11.5ZM58.2 0A58.3 58.3 0 1 0 86 109.5c.9-.5 1-1.6.3-2.2l-5.5-4.9a3.8 3.8 0 0 0-4-.6A47 47 0 0 1 11 57.5 47.3 47.3 0 0 1 58.2 11h47.3v84L78.7 71.2a2 2 0 0 0-3 .3 22 22 0 1 1 4.4-15.2 4 4 0 0 0 1.3 2.6l7 6.2c.8.7 2 .3 2.3-.8a33 33 0 0 0-30.4-39 33 33 0 0 0-35 32 33.3 33.3 0 0 0 32.2 33.9 32.8 32.8 0 0 0 20-6.3l35.1 31c1.5 1.4 3.9.3 3.9-1.7V2.2a2.2 2.2 0 0 0-2.2-2.2h-56Z"
            })
        })
    });
}



parcelRequire("4rNTR");
/**
 * Clears the refinements of a SearchParameters object based on rules provided.
 * The included attributes list is applied before the excluded attributes list. If the list
 * is not provided, this list of all the currently refined attributes is used as included attributes.
 * @returns search parameters with refinements cleared
 */ function $7653f50090c906ef$export$c8b9db57471d846b(_ref) {
    var helper = _ref.helper, _ref$attributesToClea = _ref.attributesToClear, attributesToClear = _ref$attributesToClea === void 0 ? [] : _ref$attributesToClea;
    var finalState = helper.state.setPage(0);
    finalState = attributesToClear.reduce(function(state, attribute) {
        if (finalState.isNumericRefined(attribute)) return state.removeNumericRefinement(attribute);
        if (finalState.isHierarchicalFacet(attribute)) return state.removeHierarchicalFacetRefinement(attribute);
        if (finalState.isDisjunctiveFacet(attribute)) return state.removeDisjunctiveFacetRefinement(attribute);
        if (finalState.isConjunctiveFacet(attribute)) return state.removeFacetRefinement(attribute);
        return state;
    }, finalState);
    if (attributesToClear.indexOf("query") !== -1) finalState = finalState.setQuery("");
    return finalState;
}

function $fb452fd4492d2b5e$export$ad628980c7383a99(value) {
    if (typeof value === "string") return value.replace(/^\\-/, "-");
    return value;
}
function $fb452fd4492d2b5e$export$40415fcf01f0c9e8(value) {
    if (typeof value === "number" && value < 0 || typeof value === "string") return String(value).replace(/^-/, "\\-");
    return value;
}



function $4e0f8b2d91454446$var$getRefinement(state, type, attribute, name) {
    var resultsFacets = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var res = {
        type: type,
        attribute: attribute,
        name: name,
        escapedValue: (0, $fb452fd4492d2b5e$export$40415fcf01f0c9e8)(name)
    };
    var facet = (0, $1578b04778e26176$export$71aa6c912b956294)(resultsFacets, function(resultsFacet) {
        return resultsFacet.name === attribute;
    });
    var count;
    if (type === "hierarchical") {
        var facetDeclaration = state.getHierarchicalFacetByName(attribute);
        var nameParts = name.split(facetDeclaration.separator);
        var getFacetRefinement = function getFacetRefinement(facetData) {
            return function(refinementKey) {
                return facetData[refinementKey];
            };
        };
        var _loop = function _loop(i) {
            facet = facet && facet.data && (0, $1578b04778e26176$export$71aa6c912b956294)(Object.keys(facet.data).map(getFacetRefinement(facet.data)), function(refinement) {
                return refinement.name === nameParts[i];
            });
        };
        for(var i = 0; facet !== undefined && i < nameParts.length; ++i)_loop(i);
        count = facet && facet.count;
    } else count = facet && facet.data && facet.data[res.name];
    if (count !== undefined) res.count = count;
    if (facet && facet.exhaustive !== undefined) res.exhaustive = facet.exhaustive;
    return res;
}
function $4e0f8b2d91454446$export$d9f33760e70a0a(results, state) {
    var includesQuery = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var refinements = [];
    var _state$facetsRefineme = state.facetsRefinements, facetsRefinements = _state$facetsRefineme === void 0 ? {} : _state$facetsRefineme, _state$facetsExcludes = state.facetsExcludes, facetsExcludes = _state$facetsExcludes === void 0 ? {} : _state$facetsExcludes, _state$disjunctiveFac = state.disjunctiveFacetsRefinements, disjunctiveFacetsRefinements = _state$disjunctiveFac === void 0 ? {} : _state$disjunctiveFac, _state$hierarchicalFa = state.hierarchicalFacetsRefinements, hierarchicalFacetsRefinements = _state$hierarchicalFa === void 0 ? {} : _state$hierarchicalFa, _state$numericRefinem = state.numericRefinements, numericRefinements = _state$numericRefinem === void 0 ? {} : _state$numericRefinem, _state$tagRefinements = state.tagRefinements, tagRefinements = _state$tagRefinements === void 0 ? [] : _state$tagRefinements;
    Object.keys(facetsRefinements).forEach(function(attribute) {
        var refinementNames = facetsRefinements[attribute];
        refinementNames.forEach(function(refinementName) {
            refinements.push($4e0f8b2d91454446$var$getRefinement(state, "facet", attribute, refinementName, results.facets));
        });
    });
    Object.keys(facetsExcludes).forEach(function(attribute) {
        var refinementNames = facetsExcludes[attribute];
        refinementNames.forEach(function(refinementName) {
            refinements.push({
                type: "exclude",
                attribute: attribute,
                name: refinementName,
                exclude: true
            });
        });
    });
    Object.keys(disjunctiveFacetsRefinements).forEach(function(attribute) {
        var refinementNames = disjunctiveFacetsRefinements[attribute];
        refinementNames.forEach(function(refinementName) {
            refinements.push($4e0f8b2d91454446$var$getRefinement(state, "disjunctive", attribute, // We unescape any disjunctive refined values with `unescapeFacetValue` because
            // they can be escaped on negative numeric values with `escapeFacetValue`.
            (0, $fb452fd4492d2b5e$export$ad628980c7383a99)(refinementName), results.disjunctiveFacets));
        });
    });
    Object.keys(hierarchicalFacetsRefinements).forEach(function(attribute) {
        var refinementNames = hierarchicalFacetsRefinements[attribute];
        refinementNames.forEach(function(refinement) {
            refinements.push($4e0f8b2d91454446$var$getRefinement(state, "hierarchical", attribute, refinement, results.hierarchicalFacets));
        });
    });
    Object.keys(numericRefinements).forEach(function(attribute) {
        var operators = numericRefinements[attribute];
        Object.keys(operators).forEach(function(operatorOriginal) {
            var operator = operatorOriginal;
            var valueOrValues = operators[operator];
            var refinementNames = Array.isArray(valueOrValues) ? valueOrValues : [
                valueOrValues
            ];
            refinementNames.forEach(function(refinementName) {
                refinements.push({
                    type: "numeric",
                    attribute: attribute,
                    name: "".concat(refinementName),
                    numericValue: refinementName,
                    operator: operator
                });
            });
        });
    });
    tagRefinements.forEach(function(refinementName) {
        refinements.push({
            type: "tag",
            attribute: "_tags",
            name: refinementName
        });
    });
    if (includesQuery && state.query && state.query.trim()) refinements.push({
        attribute: "query",
        type: "query",
        name: state.query,
        query: state.query
    });
    return refinements;
}


function $bf5879793427c673$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $bf5879793427c673$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $bf5879793427c673$var$_typeof(obj);
}
function $bf5879793427c673$var$_toConsumableArray(arr) {
    return $bf5879793427c673$var$_arrayWithoutHoles(arr) || $bf5879793427c673$var$_iterableToArray(arr) || $bf5879793427c673$var$_unsupportedIterableToArray(arr) || $bf5879793427c673$var$_nonIterableSpread();
}
function $bf5879793427c673$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bf5879793427c673$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bf5879793427c673$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bf5879793427c673$var$_arrayLikeToArray(o, minLen);
}
function $bf5879793427c673$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $bf5879793427c673$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $bf5879793427c673$var$_arrayLikeToArray(arr);
}
function $bf5879793427c673$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $bf5879793427c673$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bf5879793427c673$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $bf5879793427c673$var$ownKeys(Object(source), !0).forEach(function(key) {
            $bf5879793427c673$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $bf5879793427c673$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bf5879793427c673$var$_defineProperty(obj, key, value) {
    key = $bf5879793427c673$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bf5879793427c673$var$_toPropertyKey(arg) {
    var key = $bf5879793427c673$var$_toPrimitive(arg, "string");
    return $bf5879793427c673$var$_typeof(key) === "symbol" ? key : String(key);
}
function $bf5879793427c673$var$_toPrimitive(input, hint) {
    if ($bf5879793427c673$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($bf5879793427c673$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $bf5879793427c673$var$withUsage = (0, $44084963839a4436$export$2fde5bffc340821e)({
    name: "clear-refinements",
    connector: true
});
var $bf5879793427c673$var$connectClearRefinements = function connectClearRefinements(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $5d3ef3e388d952bb$export$8793edee2d425525);
    (0, $c9c42a7fa64cf8eb$export$adc2a8e09aa583ee)(renderFn, $bf5879793427c673$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, _ref$includedAttribut = _ref.includedAttributes, includedAttributes = _ref$includedAttribut === void 0 ? [] : _ref$includedAttribut, _ref$excludedAttribut = _ref.excludedAttributes, excludedAttributes = _ref$excludedAttribut === void 0 ? [
            "query"
        ] : _ref$excludedAttribut, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function transformItems(items) {
            return items;
        } : _ref$transformItems;
        if (widgetParams && widgetParams.includedAttributes && widgetParams.excludedAttributes) throw new Error($bf5879793427c673$var$withUsage("The options `includedAttributes` and `excludedAttributes` cannot be used together."));
        var connectorState = {
            refine: (0, $5d3ef3e388d952bb$export$8793edee2d425525),
            createURL: function createURL() {
                return "";
            },
            attributesToClear: []
        };
        var cachedRefine = function cachedRefine() {
            return connectorState.refine();
        };
        var cachedCreateURL = function cachedCreateURL() {
            return connectorState.createURL();
        };
        return {
            $$type: "ais.clearRefinements",
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($bf5879793427c673$var$_objectSpread($bf5879793427c673$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($bf5879793427c673$var$_objectSpread($bf5879793427c673$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose() {
                unmountFn();
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $bf5879793427c673$var$_objectSpread($bf5879793427c673$var$_objectSpread({}, renderState), {}, {
                    clearRefinements: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref2) {
                var createURL = _ref2.createURL, scopedResults = _ref2.scopedResults, results = _ref2.results;
                connectorState.attributesToClear = scopedResults.reduce(function(attributesToClear, scopedResult) {
                    return attributesToClear.concat($bf5879793427c673$var$getAttributesToClear({
                        scopedResult: scopedResult,
                        includedAttributes: includedAttributes,
                        excludedAttributes: excludedAttributes,
                        transformItems: transformItems,
                        results: results
                    }));
                }, []);
                connectorState.refine = function() {
                    connectorState.attributesToClear.forEach(function(_ref3) {
                        var indexHelper = _ref3.helper, items = _ref3.items;
                        indexHelper.setState((0, $7653f50090c906ef$export$c8b9db57471d846b)({
                            helper: indexHelper,
                            attributesToClear: items
                        })).search();
                    });
                };
                connectorState.createURL = function() {
                    return createURL((0, $d7c0d1a238d975a9$export$8049d91f25899769).apply(void 0, $bf5879793427c673$var$_toConsumableArray(connectorState.attributesToClear.map(function(_ref4) {
                        var indexHelper = _ref4.helper, items = _ref4.items;
                        return (0, $7653f50090c906ef$export$c8b9db57471d846b)({
                            helper: indexHelper,
                            attributesToClear: items
                        });
                    }))));
                };
                var canRefine = connectorState.attributesToClear.some(function(attributeToClear) {
                    return attributeToClear.items.length > 0;
                });
                return {
                    canRefine: canRefine,
                    hasRefinements: canRefine,
                    refine: cachedRefine,
                    createURL: cachedCreateURL,
                    widgetParams: widgetParams
                };
            }
        };
    };
};
function $bf5879793427c673$var$getAttributesToClear(_ref5) {
    var scopedResult = _ref5.scopedResult, includedAttributes = _ref5.includedAttributes, excludedAttributes = _ref5.excludedAttributes, transformItems = _ref5.transformItems, results = _ref5.results;
    var includesQuery = includedAttributes.indexOf("query") !== -1 || excludedAttributes.indexOf("query") === -1;
    return {
        helper: scopedResult.helper,
        items: transformItems((0, $e40064689b5991c9$export$f70730c3d1fc524e)((0, $4e0f8b2d91454446$export$d9f33760e70a0a)(scopedResult.results, scopedResult.helper.state, includesQuery).map(function(refinement) {
            return refinement.attribute;
        }).filter(function(attribute) {
            return(// If the array is empty (default case), we keep all the attributes
            includedAttributes.length === 0 || // Otherwise, only add the specified attributes
            includedAttributes.indexOf(attribute) !== -1);
        }).filter(function(attribute) {
            return(// If the query is included, we ignore the default `excludedAttributes = ['query']`
            attribute === "query" && includesQuery || // Otherwise, ignore the excluded attributes
            excludedAttributes.indexOf(attribute) === -1);
        })), {
            results: results
        })
    };
}
var $bf5879793427c673$export$2e2bcd8739ae039 = $bf5879793427c673$var$connectClearRefinements;



function $e1ae1324f83d3503$export$60a47f8af66e226a(props, additionalWidgetProperties) {
    return (0, $dc402206ef11e68a$export$7b345619fa263f7e)((0, $bf5879793427c673$export$2e2bcd8739ae039), props, additionalWidgetProperties);
}


// Get current language from URL
function $c47a1e9543c3e082$var$getCurrentLanguage() {
    var params = new URLSearchParams(window.location.search);
    var sortBy = params.get("sortBy") || "PITAETCHOCOLAT_FR";
    if (sortBy === "PITAETCHOCOLAT_EN") return "en";
    if (sortBy === "PITAETCHOCOLAT_HE") return "he";
    return "fr";
}
// Translations for clear filters button
var $c47a1e9543c3e082$var$translations = {
    fr: "Enlever les filtres",
    en: "Clear filters",
    he: "\u05E0\u05E7\u05D4 \u05DE\u05E1\u05E0\u05E0\u05D9\u05DD"
};
function $c47a1e9543c3e082$export$974caec19ec0f86c() {
    var _useClearRefinements = (0, $e1ae1324f83d3503$export$60a47f8af66e226a)(), refine = _useClearRefinements.refine, canRefine = _useClearRefinements.canRefine;
    var lang = $c47a1e9543c3e082$var$getCurrentLanguage();
    var label = $c47a1e9543c3e082$var$translations[lang];
    return /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("div", {
        className: "ais-ClearRefinements",
        children: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("button", {
            className: "ais-ClearRefinements-button ".concat(!canRefine ? "ais-ClearRefinements-button--disabled" : ""),
            disabled: !canRefine,
            type: "button",
            onClick: refine,
            children: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)("div", {
                className: "clear-filters",
                children: [
                    /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "11",
                        height: "11",
                        viewBox: "0 0 11 11",
                        children: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)("g", {
                            fill: "none",
                            fillRule: "evenodd",
                            children: [
                                /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("path", {
                                    d: "M0 0h11v11H0z"
                                }),
                                /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("path", {
                                    fill: "#000",
                                    fillRule: "nonzero",
                                    d: "M8.26 2.75a3.896 3.896 0 1 0 1.102 3.262l.007-.056a.49.49 0 0 1 .485-.456c.253 0 .451.206.437.457 0 0 .012-.109-.006.061a4.813 4.813 0 1 1-1.348-3.887v-.987a.458.458 0 1 1 .917.002v2.062a.459.459 0 0 1-.459.459H7.334a.458.458 0 1 1-.002-.917h.928z"
                                })
                            ]
                        })
                    }),
                    label
                ]
            })
        })
    });
}



parcelRequire("4rNTR");

function $77f0d2bebc1a7390$export$9c81ee90e4f7ab4e(param) {
    var containerRef = param.containerRef;
    var refine = (0, $e1ae1324f83d3503$export$60a47f8af66e226a)().refine;
    function onClick() {
        refine();
        document.body.classList.remove("filtering");
        containerRef.current.scrollIntoView();
    }
    return /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("div", {
        className: "ais-ClearRefinements",
        children: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("button", {
            className: "ais-ClearRefinements-button",
            onClick: onClick,
            children: "Reset filters"
        })
    });
}



parcelRequire("4rNTR");

var $4rNTR = parcelRequire("4rNTR");



var $4rNTR = parcelRequire("4rNTR");



function $175e578cfecf27ad$var$_slicedToArray(arr, i) {
    return $175e578cfecf27ad$var$_arrayWithHoles(arr) || $175e578cfecf27ad$var$_iterableToArrayLimit(arr, i) || $175e578cfecf27ad$var$_unsupportedIterableToArray(arr, i) || $175e578cfecf27ad$var$_nonIterableRest();
}
function $175e578cfecf27ad$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $175e578cfecf27ad$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $175e578cfecf27ad$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $175e578cfecf27ad$var$_arrayLikeToArray(o, minLen);
}
function $175e578cfecf27ad$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $175e578cfecf27ad$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $175e578cfecf27ad$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $175e578cfecf27ad$export$deb5cc6ef1318024() {
    var search = (0, $16f0a1f9504e36e2$export$607655cdd66d2a68)();
    var searchIndex = (0, $e8c9c95883f15326$export$78be30f1ffebe6ed)();
    var _useState = (0, $4rNTR.useState)(function() {
        return (0, $a9ad9293f1baef7c$export$cb51f617c98f90d3)(searchIndex);
    }), _useState2 = $175e578cfecf27ad$var$_slicedToArray(_useState, 2), searchResults = _useState2[0], setSearchResults = _useState2[1];
    (0, $4rNTR.useEffect)(function() {
        function handleRender() {
            var results = searchIndex.getResults();
            // Results can be `null` when the first search is stalled.
            // In this case, we skip the update.
            // See: https://github.com/algolia/instantsearch/blob/20996c7a159988c58e00ff24d2d2dc98af8b980f/src/widgets/index/index.ts#L652-L657
            if (results !== null) setSearchResults({
                results: results,
                scopedResults: searchIndex.getScopedResults()
            });
        }
        search.addListener("render", handleRender);
        return function() {
            search.removeListener("render", handleRender);
        };
    }, [
        search,
        searchIndex
    ]);
    return searchResults;
}



var $4rNTR = parcelRequire("4rNTR");


function $fa812cb94a360563$var$_slicedToArray(arr, i) {
    return $fa812cb94a360563$var$_arrayWithHoles(arr) || $fa812cb94a360563$var$_iterableToArrayLimit(arr, i) || $fa812cb94a360563$var$_unsupportedIterableToArray(arr, i) || $fa812cb94a360563$var$_nonIterableRest();
}
function $fa812cb94a360563$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fa812cb94a360563$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $fa812cb94a360563$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $fa812cb94a360563$var$_arrayLikeToArray(o, minLen);
}
function $fa812cb94a360563$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $fa812cb94a360563$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $fa812cb94a360563$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $fa812cb94a360563$export$5fd14fa624074d55() {
    var search = (0, $16f0a1f9504e36e2$export$607655cdd66d2a68)();
    var searchIndex = (0, $e8c9c95883f15326$export$78be30f1ffebe6ed)();
    var indexId = searchIndex.getIndexId();
    var _useState = (0, $4rNTR.useState)(function() {
        return search.getUiState();
    }), _useState2 = $fa812cb94a360563$var$_slicedToArray(_useState, 2), uiState = _useState2[0], setLocalUiState = _useState2[1];
    var indexUiState = uiState[indexId];
    var _useState3 = (0, $4rNTR.useState)(function() {
        return search.renderState;
    }), _useState4 = $fa812cb94a360563$var$_slicedToArray(_useState3, 2), renderState = _useState4[0], setRenderState = _useState4[1];
    var indexRenderState = renderState[indexId] || {};
    var setUiState = (0, $4rNTR.useCallback)(function(nextUiState) {
        search.setUiState(nextUiState);
    }, [
        search
    ]);
    var setIndexUiState = (0, $4rNTR.useCallback)(function(nextIndexUiState) {
        searchIndex.setIndexUiState(nextIndexUiState);
    }, [
        searchIndex
    ]);
    (0, $4rNTR.useEffect)(function() {
        function handleRender() {
            setLocalUiState(search.getUiState());
            setRenderState(search.renderState);
        }
        search.addListener("render", handleRender);
        return function() {
            search.removeListener("render", handleRender);
        };
    }, [
        search
    ]);
    return {
        uiState: uiState,
        setUiState: setUiState,
        indexUiState: indexUiState,
        setIndexUiState: setIndexUiState,
        renderState: renderState,
        indexRenderState: indexRenderState
    };
}


function $6c0b277d5f13c389$export$c3584afb06ed387d() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, catchError = _ref.catchError;
    var search = (0, $16f0a1f9504e36e2$export$607655cdd66d2a68)();
    var _useSearchState = (0, $fa812cb94a360563$export$5fd14fa624074d55)(), uiState = _useSearchState.uiState, setUiState = _useSearchState.setUiState, indexUiState = _useSearchState.indexUiState, setIndexUiState = _useSearchState.setIndexUiState, renderState = _useSearchState.renderState, indexRenderState = _useSearchState.indexRenderState;
    var _useSearchResults = (0, $175e578cfecf27ad$export$deb5cc6ef1318024)(), results = _useSearchResults.results, scopedResults = _useSearchResults.scopedResults;
    var addMiddlewares = (0, $4rNTR.useCallback)(function() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
        search.use.apply(search, middlewares);
        return function() {
            search.unuse.apply(search, middlewares);
        };
    }, [
        search
    ]);
    var refresh = (0, $4rNTR.useCallback)(function() {
        search.refresh();
    }, [
        search
    ]);
    (0, $2a7c74f272413fda$export$700979bc83e7db82)(function() {
        if (catchError) {
            var onError = function onError() {};
            search.addListener("error", onError);
            return function() {
                return search.removeListener("error", onError);
            };
        }
        return function() {};
    }, [
        search,
        catchError
    ]);
    return {
        results: results,
        scopedResults: scopedResults,
        uiState: uiState,
        setUiState: setUiState,
        indexUiState: indexUiState,
        setIndexUiState: setIndexUiState,
        renderState: renderState,
        indexRenderState: indexRenderState,
        addMiddlewares: addMiddlewares,
        refresh: refresh,
        status: search.status,
        error: search.error
    };
}



// Get current language from URL
function $8d9653c9122e926d$var$getCurrentLanguage() {
    var params = new URLSearchParams(window.location.search);
    var sortBy = params.get("sortBy") || "PITAETCHOCOLAT_FR";
    if (sortBy === "PITAETCHOCOLAT_EN") return "en";
    if (sortBy === "PITAETCHOCOLAT_HE") return "he";
    return "fr";
}
// Translations for no results message
var $8d9653c9122e926d$var$translations = {
    fr: {
        title: "D\xe9sol\xe9 pas de r\xe9sultats \xe0 votre recherche !",
        withFilters: "Tentez d'enlever les filtres.",
        withoutFilters: "Tentez une autre recherche."
    },
    en: {
        title: "Sorry, no results for your search!",
        withFilters: "Try removing some filters.",
        withoutFilters: "Try another search."
    },
    he: {
        title: "\u05DE\u05E6\u05D8\u05E2\u05E8\u05D9\u05DD, \u05D0\u05D9\u05DF \u05EA\u05D5\u05E6\u05D0\u05D5\u05EA \u05DC\u05D7\u05D9\u05E4\u05D5\u05E9 \u05E9\u05DC\u05DA!",
        withFilters: "\u05E0\u05E1\u05D4 \u05DC\u05D4\u05E1\u05D9\u05E8 \u05DE\u05E1\u05E0\u05E0\u05D9\u05DD.",
        withoutFilters: "\u05E0\u05E1\u05D4 \u05D7\u05D9\u05E4\u05D5\u05E9 \u05D0\u05D7\u05E8."
    }
};
function $8d9653c9122e926d$export$ef6006467f04ee41() {
    var results = (0, $6c0b277d5f13c389$export$c3584afb06ed387d)().results;
    var lang = $8d9653c9122e926d$var$getCurrentLanguage();
    var t = $8d9653c9122e926d$var$translations[lang];
    var hasRefinements = results.getRefinements().length > 0;
    var description = hasRefinements ? t.withFilters : t.withoutFilters;
    return /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)("div", {
        className: "hits-empty-state",
        children: [
            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                xmlnsXlink: "http://www.w3.org/1999/xlink",
                width: "138",
                height: "138",
                className: "hits-empty-state-image",
                children: [
                    /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)("defs", {
                        children: [
                            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)("linearGradient", {
                                id: "c",
                                x1: "50%",
                                x2: "50%",
                                y1: "100%",
                                y2: "0%",
                                children: [
                                    /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("stop", {
                                        offset: "0%",
                                        stopColor: "#F5F5FA"
                                    }),
                                    /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("stop", {
                                        offset: "100%",
                                        stopColor: "#FFF"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("path", {
                                id: "b",
                                d: "M68.71 114.25a45.54 45.54 0 1 1 0-91.08 45.54 45.54 0 0 1 0 91.08z"
                            }),
                            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)("filter", {
                                id: "a",
                                width: "140.6%",
                                height: "140.6%",
                                x: "-20.3%",
                                y: "-15.9%",
                                filterUnits: "objectBoundingBox",
                                children: [
                                    /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("feOffset", {
                                        dy: "4",
                                        in: "SourceAlpha",
                                        result: "shadowOffsetOuter1"
                                    }),
                                    /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("feGaussianBlur", {
                                        in: "shadowOffsetOuter1",
                                        result: "shadowBlurOuter1",
                                        stdDeviation: "5.5"
                                    }),
                                    /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("feColorMatrix", {
                                        in: "shadowBlurOuter1",
                                        result: "shadowMatrixOuter1",
                                        values: "0 0 0 0 0.145098039 0 0 0 0 0.17254902 0 0 0 0 0.380392157 0 0 0 0.15 0"
                                    }),
                                    /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("feOffset", {
                                        dy: "2",
                                        in: "SourceAlpha",
                                        result: "shadowOffsetOuter2"
                                    }),
                                    /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("feGaussianBlur", {
                                        in: "shadowOffsetOuter2",
                                        result: "shadowBlurOuter2",
                                        stdDeviation: "1.5"
                                    }),
                                    /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("feColorMatrix", {
                                        in: "shadowBlurOuter2",
                                        result: "shadowMatrixOuter2",
                                        values: "0 0 0 0 0.364705882 0 0 0 0 0.392156863 0 0 0 0 0.580392157 0 0 0 0.2 0"
                                    }),
                                    /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)("feMerge", {
                                        children: [
                                            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("feMergeNode", {
                                                in: "shadowMatrixOuter1"
                                            }),
                                            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("feMergeNode", {
                                                in: "shadowMatrixOuter2"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)("g", {
                        fill: "none",
                        fillRule: "evenodd",
                        children: [
                            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("circle", {
                                cx: "68.85",
                                cy: "68.85",
                                r: "68.85",
                                fill: "#E84731",
                                opacity: ".07"
                            }),
                            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("circle", {
                                cx: "68.85",
                                cy: "68.85",
                                r: "52.95",
                                fill: "#E84731",
                                opacity: ".08"
                            }),
                            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("use", {
                                fill: "#000",
                                filter: "url(#a)",
                                xlinkHref: "#b"
                            }),
                            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("use", {
                                fill: "url(#c)",
                                xlinkHref: "#b"
                            }),
                            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("path", {
                                d: "M76.01 75.44c5-5 5.03-13.06.07-18.01a12.73 12.73 0 0 0-18 .07c-5 4.99-5.03 13.05-.07 18a12.73 12.73 0 0 0 18-.06zm2.5 2.5a16.28 16.28 0 0 1-23.02.09A16.29 16.29 0 0 1 55.57 55a16.28 16.28 0 0 1 23.03-.1 16.28 16.28 0 0 1-.08 23.04zm1.08-1.08l-2.15 2.16 8.6 8.6 2.16-2.15-8.6-8.6z",
                                fill: "#E84731"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("p", {
                className: "hits-empty-state-title",
                children: t.title
            }),
            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("p", {
                className: "hits-empty-state-description",
                children: description
            }),
            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)((0, $c47a1e9543c3e082$export$974caec19ec0f86c), {})
        ]
    });
}



parcelRequire("4rNTR");

function $dd61b68f240b4a45$export$2a19844878d7a6e0(param) {
    var children = param.children, fallback = param.fallback;
    var results = (0, $6c0b277d5f13c389$export$c3584afb06ed387d)().results;
    // The `__isArtificial` flag makes sure to not display the No Results message
    // when no hits have been returned yet.
    if (!results.__isArtificial && results.nbHits === 0) return /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)((0, $775bae712b15f178$exports.Fragment), {
        children: [
            fallback,
            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("div", {
                hidden: true,
                children: children
            })
        ]
    });
    return /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)((0, $775bae712b15f178$exports.Fragment), {
        children: children
    });
}



parcelRequire("4rNTR");
function $311406894213ed69$export$2ddb90ad54e5f587(param) {
    var children = param.children, header = param.header, footer = param.footer;
    return /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)("div", {
        className: "ais-Panel",
        children: [
            header && /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("div", {
                className: "ais-Panel-header",
                children: header
            }),
            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("div", {
                className: "ais-Panel-body",
                children: children
            }),
            footer && /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("div", {
                className: "ais-Panel-footer",
                children: footer
            })
        ]
    });
}


function $459190a2f84b955e$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $f73d694e64d0bc45$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $459190a2f84b955e$export$1e71eb4bef00f6b0)(target, key, source[key]);
        });
    }
    return target;
}


function $7c31678b39fa7340$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}


function $711f0fed5eb5e9e7$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $e904b27def31e6de$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $11a043dd57a82207$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $6484aa57c5aa4ed1$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $11a043dd57a82207$export$79e617b1955a2616)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $11a043dd57a82207$export$79e617b1955a2616)(o, minLen);
}


function $92f243d5f0acdb62$export$fdf2a89c76341bbf(arr, i) {
    return (0, $7c31678b39fa7340$export$e6256bf45c68d561)(arr) || (0, $711f0fed5eb5e9e7$export$2fd15edff6687200)(arr, i) || (0, $6484aa57c5aa4ed1$export$a5be06335b3a083c)(arr, i) || (0, $e904b27def31e6de$export$60dbc22abd7da546)();
}




var $4rNTR = parcelRequire("4rNTR");
var $c48cf1b3922f0f88$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $c48cf1b3922f0f88$var$__DEV__ = false;
var $c48cf1b3922f0f88$var$warning = function warning() {};
if ($c48cf1b3922f0f88$var$__DEV__) {
    var $c48cf1b3922f0f88$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $c48cf1b3922f0f88$var$warning = function warning(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $c48cf1b3922f0f88$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$c48cf1b3922f0f88$exports = $c48cf1b3922f0f88$var$warning;



var $4rNTR = parcelRequire("4rNTR");
var $faa1eb9e4d3f0cfc$var$e10 = Math.sqrt(50), $faa1eb9e4d3f0cfc$var$e5 = Math.sqrt(10), $faa1eb9e4d3f0cfc$var$e2 = Math.sqrt(2);
function $faa1eb9e4d3f0cfc$export$2e2bcd8739ae039(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $faa1eb9e4d3f0cfc$export$bc64d00cc98e7e95(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        var r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        var r01 = Math.round(start * step), r11 = Math.round(stop * step);
        if (r01 / step < start) ++r01;
        if (r11 / step > stop) --r11;
        ticks = new Array(n = r11 - r01 + 1);
        while(++i < n)ticks[i] = (r01 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $faa1eb9e4d3f0cfc$export$bc64d00cc98e7e95(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $faa1eb9e4d3f0cfc$var$e10 ? 10 : error >= $faa1eb9e4d3f0cfc$var$e5 ? 5 : error >= $faa1eb9e4d3f0cfc$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $faa1eb9e4d3f0cfc$var$e10 ? 10 : error >= $faa1eb9e4d3f0cfc$var$e5 ? 5 : error >= $faa1eb9e4d3f0cfc$var$e2 ? 2 : 1);
}
function $faa1eb9e4d3f0cfc$export$81087d9b915d4ede(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $faa1eb9e4d3f0cfc$var$e10) step1 *= 10;
    else if (error >= $faa1eb9e4d3f0cfc$var$e5) step1 *= 5;
    else if (error >= $faa1eb9e4d3f0cfc$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}


function $d00199b262a0773f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d00199b262a0773f$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d00199b262a0773f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d00199b262a0773f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d00199b262a0773f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d00199b262a0773f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d00199b262a0773f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d00199b262a0773f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d00199b262a0773f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d00199b262a0773f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $d00199b262a0773f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d00199b262a0773f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $d00199b262a0773f$var$_setPrototypeOf(subClass, superClass);
}
function $d00199b262a0773f$var$_getPrototypeOf(o) {
    $d00199b262a0773f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d00199b262a0773f$var$_getPrototypeOf(o);
}
function $d00199b262a0773f$var$_setPrototypeOf(o, p) {
    $d00199b262a0773f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d00199b262a0773f$var$_setPrototypeOf(o, p);
}
function $d00199b262a0773f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d00199b262a0773f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d00199b262a0773f$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $d00199b262a0773f$var$_assertThisInitialized(self);
}
function $d00199b262a0773f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d00199b262a0773f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $d00199b262a0773f$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $d00199b262a0773f$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $d00199b262a0773f$var$_possibleConstructorReturn(this, result);
    };
}
function $d00199b262a0773f$var$_slicedToArray(arr, i) {
    return $d00199b262a0773f$var$_arrayWithHoles(arr) || $d00199b262a0773f$var$_iterableToArrayLimit(arr, i) || $d00199b262a0773f$var$_unsupportedIterableToArray(arr, i) || $d00199b262a0773f$var$_nonIterableRest();
}
function $d00199b262a0773f$var$_toConsumableArray(arr) {
    return $d00199b262a0773f$var$_arrayWithoutHoles(arr) || $d00199b262a0773f$var$_iterableToArray(arr) || $d00199b262a0773f$var$_unsupportedIterableToArray(arr) || $d00199b262a0773f$var$_nonIterableSpread();
}
function $d00199b262a0773f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $d00199b262a0773f$var$_arrayLikeToArray(arr);
}
function $d00199b262a0773f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $d00199b262a0773f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $d00199b262a0773f$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $d00199b262a0773f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d00199b262a0773f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d00199b262a0773f$var$_arrayLikeToArray(o, minLen);
}
function $d00199b262a0773f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d00199b262a0773f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d00199b262a0773f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $d00199b262a0773f$var$prfx = "react-compound-slider:";
function $d00199b262a0773f$var$getSortByVal() {
    var reversed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return function sortByVal(a, b) {
        if (a.val > b.val) return reversed ? -1 : 1;
        if (b.val > a.val) return reversed ? 1 : -1;
        return 0;
    };
}
function $d00199b262a0773f$var$getUpdatedHandles(handles, updateKey, updateValue) {
    var reversed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var index = handles.findIndex(function(v) {
        return v.key === updateKey;
    });
    if (index !== -1) {
        var _handles$index = handles[index], key = _handles$index.key, val = _handles$index.val;
        if (val === updateValue) return handles;
        return [].concat($d00199b262a0773f$var$_toConsumableArray(handles.slice(0, index)), [
            {
                key: key,
                val: updateValue
            }
        ], $d00199b262a0773f$var$_toConsumableArray(handles.slice(index + 1))).sort($d00199b262a0773f$var$getSortByVal(reversed));
    }
    return handles;
}
function $d00199b262a0773f$var$getSliderDomain(slider, vertical) {
    if (!slider) return [
        0,
        0
    ];
    var s = slider.getBoundingClientRect();
    var d0 = vertical ? s.top : s.left;
    var d1 = vertical ? s.bottom : s.right;
    return [
        d0,
        d1
    ];
}
function $d00199b262a0773f$var$isNotValidTouch(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "" : _ref$type, touches = _ref.touches;
    return !touches || touches.length > 1 || type.toLowerCase() === "touchend" && touches.length > 0;
}
function $d00199b262a0773f$var$getTouchPosition(vertical, e) {
    return vertical ? e.touches[0].clientY : e.touches[0].pageX;
}
function $d00199b262a0773f$var$getHandles() {
    var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var reversed = arguments.length > 1 ? arguments[1] : undefined;
    var valueToStep = arguments.length > 2 ? arguments[2] : undefined;
    var warn = arguments.length > 3 ? arguments[3] : undefined;
    var changes = 0;
    var handles = values.map(function(x) {
        var val = valueToStep.getValue(x);
        if (x !== val) {
            changes += 1;
            (0, (/*@__PURE__*/$parcel$interopDefault($c48cf1b3922f0f88$exports)))(!warn, "".concat($d00199b262a0773f$var$prfx, " Invalid value encountered. Changing ").concat(x, " to ").concat(val, "."));
        }
        return val;
    }).map(function(val, i) {
        return {
            key: "$$-".concat(i),
            val: val
        };
    }).sort($d00199b262a0773f$var$getSortByVal(reversed));
    return {
        handles: handles,
        changes: changes
    };
}
// default mode
function $d00199b262a0773f$export$c5ea20539002ff76(_, next) {
    return next;
} // prevent duplicate values and crossing
function $d00199b262a0773f$export$83a6069c6ecf7b2d(curr, next) {
    for(var i = 0; i < curr.length; i++){
        if (curr[i].key !== next[i].key) return curr;
        if (next[i + 1] && next[i].val === next[i + 1].val) return curr;
    }
    return next;
} // pushable mode
function $d00199b262a0773f$export$6aa1b5580ef4932c(curr, next, step, reversed, getValue) {
    var indexForMovingHandle = -1;
    var handleMoveIsPositive = true;
    for(var i = 0; i < curr.length; i++){
        var c = curr[i];
        var n = next[i]; // make sure keys are in same order if not return curr
        if (!n || n.key !== c.key) return curr;
        else if (n.val !== c.val) {
            indexForMovingHandle = i;
            handleMoveIsPositive = n.val - c.val > 0;
        }
    } // nothing has changed (shouldn't happen but just in case).
    if (indexForMovingHandle === -1) return curr;
    else {
        var increment = handleMoveIsPositive ? step : -step;
        for(var _i = 0; _i < next.length; _i++){
            var n0 = next[_i];
            var n1 = next[_i + 1];
            if (n1 && n0.val === n1.val) {
                if (_i === indexForMovingHandle) {
                    var newStep = n1.val + increment;
                    if (getValue(newStep) === newStep) {
                        var clone = $d00199b262a0773f$var$getUpdatedHandles(next, n1.key, n1.val + increment, reversed);
                        var check = $d00199b262a0773f$export$6aa1b5580ef4932c(next, clone, step, reversed, getValue);
                        if (check === next) return curr;
                        else return check;
                    } else return curr;
                } else {
                    var _newStep = n0.val + increment;
                    if (getValue(_newStep) === _newStep) {
                        var _clone = $d00199b262a0773f$var$getUpdatedHandles(next, n0.key, n0.val + increment, reversed);
                        var _check = $d00199b262a0773f$export$6aa1b5580ef4932c(next, _clone, step, reversed, getValue);
                        if (_check === next) return curr;
                        else return _check;
                    } else return curr;
                }
            }
        }
    }
    return next;
}
function $d00199b262a0773f$var$callAll() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(e) {
        return fns.forEach(function(fn) {
            return fn && fn(e);
        });
    };
}
var $d00199b262a0773f$var$NOOP = function NOOP() {
    return {
        value: 0,
        percent: 0
    };
};
var $d00199b262a0773f$export$b57863d0ff6a6d2b = /*#__PURE__*/ function(_Component) {
    $d00199b262a0773f$var$_inherits(Rail, _Component);
    var _super = $d00199b262a0773f$var$_createSuper(Rail);
    function Rail() {
        var _this;
        $d00199b262a0773f$var$_classCallCheck(this, Rail);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.getRailProps = function() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _this$props = _this.props, emitMouse = _this$props.emitMouse, emitTouch = _this$props.emitTouch;
            return $d00199b262a0773f$var$_objectSpread2($d00199b262a0773f$var$_objectSpread2({}, props), {}, {
                onMouseDown: $d00199b262a0773f$var$callAll(props && props.onMouseDown, emitMouse),
                onTouchStart: $d00199b262a0773f$var$callAll(props && props.onTouchStart, emitTouch)
            });
        };
        return _this;
    }
    $d00199b262a0773f$var$_createClass(Rail, [
        {
            key: "render",
            value: function render() {
                var getRailProps = this.getRailProps, _this$props2 = this.props, getEventData = _this$props2.getEventData, _this$props2$activeHa = _this$props2.activeHandleID, activeHandleID = _this$props2$activeHa === void 0 ? "" : _this$props2$activeHa, children = _this$props2.children;
                var renderedChildren = children({
                    getEventData: getEventData || $d00199b262a0773f$var$NOOP,
                    activeHandleID: activeHandleID,
                    getRailProps: getRailProps
                });
                return renderedChildren && (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).Children.only(renderedChildren);
            }
        }
    ]);
    return Rail;
}((0, $4rNTR.Component));
var $d00199b262a0773f$export$e687473b8d6c8292 = /*#__PURE__*/ function(_Component) {
    $d00199b262a0773f$var$_inherits(Handles, _Component);
    var _super = $d00199b262a0773f$var$_createSuper(Handles);
    function Handles() {
        var _this;
        $d00199b262a0773f$var$_classCallCheck(this, Handles);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.autofocus = function(e) {
            if (e.target instanceof HTMLElement) e.target.focus();
        };
        _this.getHandleProps = function(id) {
            var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var _this$props = _this.props, emitKeyboard = _this$props.emitKeyboard, emitMouse = _this$props.emitMouse, emitTouch = _this$props.emitTouch;
            return $d00199b262a0773f$var$_objectSpread2($d00199b262a0773f$var$_objectSpread2({}, props), {}, {
                onKeyDown: $d00199b262a0773f$var$callAll(props && props.onKeyDown, function(e) {
                    return emitKeyboard && emitKeyboard(e, id);
                }),
                onMouseDown: $d00199b262a0773f$var$callAll(props && props.onMouseDown, _this.autofocus, function(e) {
                    return emitMouse && emitMouse(e, id);
                }),
                onTouchStart: $d00199b262a0773f$var$callAll(props && props.onTouchStart, function(e) {
                    return emitTouch && emitTouch(e, id);
                })
            });
        };
        return _this;
    }
    $d00199b262a0773f$var$_createClass(Handles, [
        {
            key: "render",
            value: function render() {
                var getHandleProps = this.getHandleProps, _this$props2 = this.props, _this$props2$activeHa = _this$props2.activeHandleID, activeHandleID = _this$props2$activeHa === void 0 ? "" : _this$props2$activeHa, children = _this$props2.children, _this$props2$handles = _this$props2.handles, handles = _this$props2$handles === void 0 ? [] : _this$props2$handles;
                var renderedChildren = children({
                    handles: handles,
                    activeHandleID: activeHandleID,
                    getHandleProps: getHandleProps
                });
                return renderedChildren && (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).Children.only(renderedChildren);
            }
        }
    ]);
    return Handles;
}((0, $4rNTR.Component));
var $d00199b262a0773f$var$LinearScale = /*#__PURE__*/ function() {
    function LinearScale() {
        $d00199b262a0773f$var$_classCallCheck(this, LinearScale);
        this.interpolator = void 0;
        this.domain = [
            0,
            1
        ];
        this.range = [
            0,
            1
        ];
        this.domain = [
            0,
            1
        ];
        this.range = [
            0,
            1
        ];
        this.interpolator = null;
    }
    $d00199b262a0773f$var$_createClass(LinearScale, [
        {
            key: "createInterpolator",
            value: function createInterpolator(domain, range) {
                var _this = this;
                var d0 = domain[0];
                var d1 = domain[1];
                var r0 = range[0];
                var r1 = range[1];
                if (d1 < d0) return function(x) {
                    return _this.interpolateValue(r1, r0)(_this.deinterpolateValue(d1, d0)(x));
                };
                else return function(x) {
                    return _this.interpolateValue(r0, r1)(_this.deinterpolateValue(d0, d1)(x));
                };
            }
        },
        {
            key: "interpolateValue",
            value: function interpolateValue(a, b) {
                return a = +a, b -= a, function i(t) {
                    return a + b * t;
                };
            }
        },
        {
            key: "deinterpolateValue",
            value: function deinterpolateValue(a, b) {
                return (b -= a = +a) ? function(x) {
                    return (x - a) / b;
                } : function() {
                    return b;
                };
            }
        },
        {
            key: "rescale",
            value: function rescale() {
                this.interpolator = null;
                return this;
            }
        },
        {
            key: "getValue",
            value: function getValue(x) {
                var domain = this.domain, range = this.range;
                return (this.interpolator || (this.interpolator = this.createInterpolator(domain, range)))(+x);
            }
        },
        {
            key: "setDomain",
            value: function setDomain(val) {
                this.domain = [
                    val[0],
                    val[1]
                ];
                this.rescale();
                return this;
            }
        },
        {
            key: "getDomain",
            value: function getDomain() {
                return this.domain;
            }
        },
        {
            key: "setRange",
            value: function setRange(val) {
                this.range = [
                    val[0],
                    val[1]
                ];
                return this;
            }
        },
        {
            key: "getRange",
            value: function getRange() {
                return this.range;
            }
        },
        {
            key: "getTicks",
            value: function getTicks(count) {
                var d = this.domain;
                return (0, $faa1eb9e4d3f0cfc$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count ? count : 10);
            }
        }
    ]);
    return LinearScale;
}();
var $d00199b262a0773f$var$defaultGetEventData$1 = function defaultGetEventData() {
    return {
        value: 0,
        percent: 0
    };
};
var $d00199b262a0773f$export$27c7467594ef87bd = /*#__PURE__*/ function(_Component) {
    $d00199b262a0773f$var$_inherits(Ticks, _Component);
    var _super = $d00199b262a0773f$var$_createSuper(Ticks);
    function Ticks() {
        $d00199b262a0773f$var$_classCallCheck(this, Ticks);
        return _super.apply(this, arguments);
    }
    $d00199b262a0773f$var$_createClass(Ticks, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, children = _this$props.children, values = _this$props.values, _this$props$scale = _this$props.scale, scale = _this$props$scale === void 0 ? new $d00199b262a0773f$var$LinearScale() : _this$props$scale, _this$props$count = _this$props.count, count = _this$props$count === void 0 ? 10 : _this$props$count, _this$props$getEventD = _this$props.getEventData, getEventData = _this$props$getEventD === void 0 ? $d00199b262a0773f$var$defaultGetEventData$1 : _this$props$getEventD, _this$props$activeHan = _this$props.activeHandleID, activeHandleID = _this$props$activeHan === void 0 ? "" : _this$props$activeHan;
                var ticks = (values ? values : scale.getTicks(count)).map(function(value) {
                    return {
                        id: "$$-".concat(value),
                        value: value,
                        percent: scale.getValue(value)
                    };
                });
                var renderedChildren = children({
                    getEventData: getEventData,
                    activeHandleID: activeHandleID,
                    ticks: ticks
                });
                return renderedChildren && (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).Children.only(renderedChildren);
            }
        }
    ]);
    return Ticks;
}((0, $4rNTR.Component));
var $d00199b262a0773f$var$defaultGetEventData = function defaultGetEventData() {
    return {
        value: 0,
        percent: 0
    };
};
var $d00199b262a0773f$export$76e817a61dd78922 = /*#__PURE__*/ function(_Component) {
    $d00199b262a0773f$var$_inherits(Tracks, _Component);
    var _super = $d00199b262a0773f$var$_createSuper(Tracks);
    function Tracks() {
        var _this;
        $d00199b262a0773f$var$_classCallCheck(this, Tracks);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.getTrackProps = function(props) {
            var _this$props = _this.props, emitMouse = _this$props.emitMouse, emitTouch = _this$props.emitTouch;
            return $d00199b262a0773f$var$_objectSpread2($d00199b262a0773f$var$_objectSpread2({}, props || {}), {}, {
                onMouseDown: $d00199b262a0773f$var$callAll(props && props.onMouseDown, emitMouse),
                onTouchStart: $d00199b262a0773f$var$callAll(props && props.onTouchStart, emitTouch)
            });
        };
        return _this;
    }
    $d00199b262a0773f$var$_createClass(Tracks, [
        {
            key: "render",
            value: function render() {
                var getTrackProps = this.getTrackProps, _this$props2 = this.props, children = _this$props2.children, _this$props2$left = _this$props2.left, left = _this$props2$left === void 0 ? true : _this$props2$left, _this$props2$right = _this$props2.right, right = _this$props2$right === void 0 ? true : _this$props2$right, _this$props2$scale = _this$props2.scale, scale = _this$props2$scale === void 0 ? new $d00199b262a0773f$var$LinearScale() : _this$props2$scale, _this$props2$handles = _this$props2.handles, handles = _this$props2$handles === void 0 ? [] : _this$props2$handles, _this$props2$getEvent = _this$props2.getEventData, getEventData = _this$props2$getEvent === void 0 ? $d00199b262a0773f$var$defaultGetEventData : _this$props2$getEvent, _this$props2$activeHa = _this$props2.activeHandleID, activeHandleID = _this$props2$activeHa === void 0 ? "" : _this$props2$activeHa;
                var domain = scale.getDomain();
                var tracks = [];
                for(var i = 0; i < handles.length + 1; i++){
                    var source = handles[i - 1];
                    var target = handles[i];
                    if (i === 0 && left === true) source = {
                        id: "$",
                        value: domain[0],
                        percent: 0
                    };
                    else if (i === handles.length && right === true) target = {
                        id: "$",
                        value: domain[1],
                        percent: 100
                    };
                    if (source && target) tracks.push({
                        id: "".concat(source.id, "-").concat(target.id),
                        source: source,
                        target: target
                    });
                }
                var renderedChildren = children({
                    getEventData: getEventData,
                    activeHandleID: activeHandleID,
                    tracks: tracks,
                    getTrackProps: getTrackProps
                });
                return renderedChildren && (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).Children.only(renderedChildren);
            }
        }
    ]);
    return Tracks;
}((0, $4rNTR.Component));
function $d00199b262a0773f$var$clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
var $d00199b262a0773f$var$DiscreteScale = /*#__PURE__*/ $d00199b262a0773f$var$_createClass(function DiscreteScale() {
    var _this = this;
    $d00199b262a0773f$var$_classCallCheck(this, DiscreteScale);
    this.step = 1;
    this.domain = [
        0,
        1
    ];
    this.range = [
        0,
        1
    ];
    this.setDomain = function(val) {
        _this.domain = [
            val[0],
            val[1]
        ];
        return _this;
    };
    this.setRange = function(val) {
        _this.range = [
            val[0],
            val[1]
        ];
        return _this;
    };
    this.setStep = function(val) {
        _this.step = val;
        return _this;
    };
    this.getValue = function(x) {
        var _this$domain = $d00199b262a0773f$var$_slicedToArray(_this.domain, 2), d0 = _this$domain[0], d1 = _this$domain[1], _this$range = $d00199b262a0773f$var$_slicedToArray(_this.range, 2), r0 = _this$range[0], r1 = _this$range[1], step = _this.step;
        var p = ($d00199b262a0773f$var$clamp(x, d0, d1) - d0) / (d1 - d0);
        var b = step * Math.round(p * (r1 - r0) / step) + r0;
        return $d00199b262a0773f$var$clamp(b, r0 < r1 ? r0 : r1, r1 > r0 ? r1 : r0);
    };
});
var $d00199b262a0773f$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
var $d00199b262a0773f$var$noop = function noop() {};
var $d00199b262a0773f$var$compare = function compare(b) {
    return function(m, d, i) {
        return m && b[i] === d;
    };
};
var $d00199b262a0773f$var$equal = function equal(a, b) {
    return a === b || a.length === b.length && a.reduce($d00199b262a0773f$var$compare(b), true);
};
var $d00199b262a0773f$var$isRCSComponent = function isRCSComponent(item) {
    if (!/*#__PURE__*/ (0, $4rNTR.isValidElement)(item)) return false;
    var type = item.type;
    var name = type ? type.name : "";
    return name === $d00199b262a0773f$export$e687473b8d6c8292.name || name === $d00199b262a0773f$export$b57863d0ff6a6d2b.name || name === $d00199b262a0773f$export$27c7467594ef87bd.name || name === $d00199b262a0773f$export$76e817a61dd78922.name;
};
var $d00199b262a0773f$var$getNextValue = function getNextValue(curr, step, domain, reversed) {
    var newVal = reversed ? curr - step : curr + step;
    return reversed ? Math.max(domain[0], newVal) : Math.min(domain[1], newVal);
};
var $d00199b262a0773f$var$getPrevValue = function getPrevValue(curr, step, domain, reversed) {
    var newVal = reversed ? curr + step : curr - step;
    return reversed ? Math.min(domain[1], newVal) : Math.max(domain[0], newVal);
};
var $d00199b262a0773f$var$defaultDomain = [
    0,
    100
];
var $d00199b262a0773f$export$472062a354075cee = /*#__PURE__*/ function(_PureComponent) {
    $d00199b262a0773f$var$_inherits(Slider, _PureComponent);
    var _super = $d00199b262a0773f$var$_createSuper(Slider);
    function Slider() {
        var _this;
        $d00199b262a0773f$var$_classCallCheck(this, Slider);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            step: 0.1,
            values: [],
            domain: $d00199b262a0773f$var$defaultDomain,
            handles: [],
            reversed: false,
            activeHandleID: "",
            valueToPerc: null,
            valueToStep: null,
            pixelToStep: null
        };
        _this.slider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createRef();
        _this.onKeyDown = function(e, handleID) {
            var validUpKeys = [
                "ArrowRight",
                "ArrowUp"
            ];
            var validDownKeys = [
                "ArrowDown",
                "ArrowLeft"
            ];
            var _assertThisInitialize = $d00199b262a0773f$var$_assertThisInitialized(_this), handles = _assertThisInitialize.state.handles, _assertThisInitialize2 = _assertThisInitialize.props, _assertThisInitialize3 = _assertThisInitialize2.step, step = _assertThisInitialize3 === void 0 ? 0.1 : _assertThisInitialize3, _assertThisInitialize4 = _assertThisInitialize2.reversed, reversed = _assertThisInitialize4 === void 0 ? false : _assertThisInitialize4, _assertThisInitialize5 = _assertThisInitialize2.vertical, vertical = _assertThisInitialize5 === void 0 ? false : _assertThisInitialize5, _assertThisInitialize6 = _assertThisInitialize2.domain, domain = _assertThisInitialize6 === void 0 ? [
                0,
                100
            ] : _assertThisInitialize6;
            var key = e.key || "".concat(e.keyCode);
            if (!validUpKeys.concat(validDownKeys).includes(key)) return;
            if (vertical) {
                var _ref = [
                    validDownKeys,
                    validUpKeys
                ];
                validUpKeys = _ref[0];
                validDownKeys = _ref[1];
            }
            e.stopPropagation && e.stopPropagation();
            e.preventDefault && e.preventDefault();
            var found = handles.find(function(value) {
                return value.key === handleID;
            });
            if (!found) return;
            var currVal = found.val;
            var newVal = currVal;
            if (validUpKeys.includes(key)) newVal = $d00199b262a0773f$var$getNextValue(currVal, step, domain, reversed);
            else if (validDownKeys.includes(key)) newVal = $d00199b262a0773f$var$getPrevValue(currVal, step, domain, reversed);
            var nextHandles = handles.map(function(v) {
                return v.key === handleID ? {
                    key: v.key,
                    val: newVal
                } : v;
            });
            _this.submitUpdate(nextHandles, true);
        };
        _this.onMouseDown = function(e, handleID) {
            _this.onStart(e, handleID, false);
        };
        _this.onTouchStart = function(e, handleID) {
            if ($d00199b262a0773f$var$isNotValidTouch(e)) return;
            _this.onStart(e, handleID, true);
        };
        _this.getEventData = function(e, isTouch) {
            var _assertThisInitialize7 = $d00199b262a0773f$var$_assertThisInitialized(_this), _assertThisInitialize8 = _assertThisInitialize7.state, pixelToStep = _assertThisInitialize8.pixelToStep, valueToPerc = _assertThisInitialize8.valueToPerc, vertical = _assertThisInitialize7.props.vertical; // double check the dimensions of the slider
            // @ts-ignore
            pixelToStep.setDomain($d00199b262a0773f$var$getSliderDomain(_this.slider.current, vertical));
            var value;
            if (isTouch && e instanceof TouchEvent) // @ts-ignore
            value = pixelToStep.getValue($d00199b262a0773f$var$getTouchPosition(vertical, e));
            else if (e instanceof MouseEvent) // @ts-ignore
            value = pixelToStep.getValue(vertical ? e.clientY : e.pageX);
            return {
                value: value,
                // @ts-ignore
                percent: valueToPerc.getValue(value)
            };
        };
        _this.onMouseMove = function(e) {
            var _assertThisInitialize9 = $d00199b262a0773f$var$_assertThisInitialized(_this), _assertThisInitialize10 = _assertThisInitialize9.state, curr = _assertThisInitialize10.handles, pixelToStep = _assertThisInitialize10.pixelToStep, _assertThisInitialize11 = _assertThisInitialize10.activeHandleID, activeHandleID = _assertThisInitialize11 === void 0 ? "" : _assertThisInitialize11, _assertThisInitialize12 = _assertThisInitialize9.props, vertical = _assertThisInitialize12.vertical, _assertThisInitialize13 = _assertThisInitialize12.reversed, reversed = _assertThisInitialize13 === void 0 ? false : _assertThisInitialize13; // double check the dimensions of the slider
            // @ts-ignore
            pixelToStep.setDomain($d00199b262a0773f$var$getSliderDomain(_this.slider.current, vertical)); // find the closest value (aka step) to the event location
            // @ts-ignore
            var updateValue = pixelToStep.getValue(vertical ? e.clientY : e.pageX); // generate a "candidate" set of values - a suggestion of what to do
            var nextHandles = $d00199b262a0773f$var$getUpdatedHandles(curr, activeHandleID, updateValue, reversed); // submit the candidate values
            _this.submitUpdate(nextHandles);
        };
        _this.onTouchMove = function(e) {
            var _assertThisInitialize14 = $d00199b262a0773f$var$_assertThisInitialized(_this), _assertThisInitialize15 = _assertThisInitialize14.state, curr = _assertThisInitialize15.handles, pixelToStep = _assertThisInitialize15.pixelToStep, activeHandleID = _assertThisInitialize15.activeHandleID, _assertThisInitialize16 = _assertThisInitialize14.props, vertical = _assertThisInitialize16.vertical, reversed = _assertThisInitialize16.reversed;
            if (pixelToStep === null || $d00199b262a0773f$var$isNotValidTouch(e)) return;
             // double check the dimensions of the slider
            // @ts-ignore
            pixelToStep.setDomain($d00199b262a0773f$var$getSliderDomain(_this.slider.current, vertical)); // find the closest value (aka step) to the event location
            // @ts-ignore
            var updateValue = pixelToStep.getValue($d00199b262a0773f$var$getTouchPosition(vertical, e)); // generate a "candidate" set of values - a suggestion of what to do
            var nextHandles = $d00199b262a0773f$var$getUpdatedHandles(curr, activeHandleID, updateValue, reversed); // submit the candidate values
            _this.submitUpdate(nextHandles);
        };
        _this.onMouseUp = function() {
            var _assertThisInitialize17 = $d00199b262a0773f$var$_assertThisInitialized(_this), _assertThisInitialize18 = _assertThisInitialize17.state, _assertThisInitialize19 = _assertThisInitialize18.handles, handles = _assertThisInitialize19 === void 0 ? [] : _assertThisInitialize19, activeHandleID = _assertThisInitialize18.activeHandleID, _assertThisInitialize20 = _assertThisInitialize17.props, _assertThisInitialize21 = _assertThisInitialize20.onChange, onChange = _assertThisInitialize21 === void 0 ? $d00199b262a0773f$var$noop : _assertThisInitialize21, _assertThisInitialize22 = _assertThisInitialize20.onSlideEnd, onSlideEnd = _assertThisInitialize22 === void 0 ? $d00199b262a0773f$var$noop : _assertThisInitialize22;
            onChange(handles.map(function(d) {
                return d.val;
            }));
            onSlideEnd(handles.map(function(d) {
                return d.val;
            }), {
                activeHandleID: activeHandleID
            });
            _this.setState({
                activeHandleID: ""
            });
            if ($d00199b262a0773f$var$isBrowser) {
                document.removeEventListener("mousemove", _this.onMouseMove);
                document.removeEventListener("mouseup", _this.onMouseUp);
            }
        };
        _this.onTouchEnd = function() {
            var _assertThisInitialize23 = $d00199b262a0773f$var$_assertThisInitialized(_this), _assertThisInitialize24 = _assertThisInitialize23.state, handles = _assertThisInitialize24.handles, activeHandleID = _assertThisInitialize24.activeHandleID, _assertThisInitialize25 = _assertThisInitialize23.props, _assertThisInitialize26 = _assertThisInitialize25.onChange, onChange = _assertThisInitialize26 === void 0 ? $d00199b262a0773f$var$noop : _assertThisInitialize26, _assertThisInitialize27 = _assertThisInitialize25.onSlideEnd, onSlideEnd = _assertThisInitialize27 === void 0 ? $d00199b262a0773f$var$noop : _assertThisInitialize27;
            onChange(handles.map(function(d) {
                return d.val;
            }));
            onSlideEnd(handles.map(function(d) {
                return d.val;
            }), {
                activeHandleID: activeHandleID
            });
            _this.setState({
                activeHandleID: ""
            });
            if ($d00199b262a0773f$var$isBrowser) {
                document.removeEventListener("touchmove", _this.onTouchMove);
                document.removeEventListener("touchend", _this.onTouchEnd);
            }
        };
        return _this;
    }
    $d00199b262a0773f$var$_createClass(Slider, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var pixelToStep = this.state.pixelToStep;
                var vertical = this.props.vertical; // @ts-ignore
                pixelToStep.setDomain($d00199b262a0773f$var$getSliderDomain(this.slider.current, vertical));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.removeListeners();
            }
        },
        {
            key: "removeListeners",
            value: function removeListeners() {
                if ($d00199b262a0773f$var$isBrowser) {
                    document.removeEventListener("mousemove", this.onMouseMove);
                    document.removeEventListener("mouseup", this.onMouseUp);
                    document.removeEventListener("touchmove", this.onTouchMove);
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "onStart",
            value: function onStart(e, handleID, isTouch) {
                var handles = this.state.handles, _this$props$onSlideSt = this.props.onSlideStart, onSlideStart = _this$props$onSlideSt === void 0 ? $d00199b262a0773f$var$noop : _this$props$onSlideSt;
                if (!isTouch) e.preventDefault && e.preventDefault();
                e.stopPropagation && e.stopPropagation();
                var found = handles.find(function(value) {
                    return value.key === handleID;
                });
                if (found) {
                    this.setState({
                        activeHandleID: handleID
                    });
                    onSlideStart(handles.map(function(d) {
                        return d.val;
                    }), {
                        activeHandleID: handleID
                    });
                    isTouch ? this.addTouchEvents() : this.addMouseEvents();
                } else {
                    this.setState({
                        activeHandleID: ""
                    });
                    this.handleRailAndTrackClicks(e, isTouch);
                }
            }
        },
        {
            key: "handleRailAndTrackClicks",
            value: function handleRailAndTrackClicks(e, isTouch) {
                var _this2 = this;
                var _this$state = this.state, curr = _this$state.handles, pixelToStep = _this$state.pixelToStep, _this$props = this.props, vertical = _this$props.vertical, _this$props$reversed = _this$props.reversed, reversed = _this$props$reversed === void 0 ? false : _this$props$reversed;
                var slider = this.slider; // double check the dimensions of the slider
                // @ts-ignore
                pixelToStep.setDomain($d00199b262a0773f$var$getSliderDomain(slider.current, vertical)); // find the closest value (aka step) to the event location
                var updateValue;
                if (isTouch) // @ts-ignore
                updateValue = pixelToStep.getValue($d00199b262a0773f$var$getTouchPosition(vertical, e));
                else // @ts-ignore
                updateValue = pixelToStep.getValue(vertical ? e.clientY : e.pageX);
                 // find the closest handle key
                var updateKey = "";
                var minDiff = Infinity;
                for(var i = 0; i < curr.length; i++){
                    var _curr$i = curr[i], key = _curr$i.key, val = _curr$i.val;
                    var diff = Math.abs(val - updateValue);
                    if (diff < minDiff) {
                        updateKey = key;
                        minDiff = diff;
                    }
                } // generate a "candidate" set of values - a suggestion of what to do
                var nextHandles = $d00199b262a0773f$var$getUpdatedHandles(curr, updateKey, updateValue, reversed); // submit the candidate values
                this.setState({
                    activeHandleID: updateKey
                }, function() {
                    _this2.submitUpdate(nextHandles, true);
                    isTouch ? _this2.addTouchEvents() : _this2.addMouseEvents();
                });
            }
        },
        {
            key: "addMouseEvents",
            value: function addMouseEvents() {
                if ($d00199b262a0773f$var$isBrowser) {
                    document.addEventListener("mousemove", this.onMouseMove);
                    document.addEventListener("mouseup", this.onMouseUp);
                }
            }
        },
        {
            key: "addTouchEvents",
            value: function addTouchEvents() {
                if ($d00199b262a0773f$var$isBrowser) {
                    document.addEventListener("touchmove", this.onTouchMove);
                    document.addEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "submitUpdate",
            value: function submitUpdate(next) {
                var callOnChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var _this$props2 = this.props, _this$props2$mode = _this$props2.mode, mode = _this$props2$mode === void 0 ? 1 : _this$props2$mode, _this$props2$step = _this$props2.step, step = _this$props2$step === void 0 ? 0.1 : _this$props2$step, _this$props2$onUpdate = _this$props2.onUpdate, onUpdate = _this$props2$onUpdate === void 0 ? $d00199b262a0773f$var$noop : _this$props2$onUpdate, _this$props2$onChange = _this$props2.onChange, onChange = _this$props2$onChange === void 0 ? $d00199b262a0773f$var$noop : _this$props2$onChange, _this$props2$reversed = _this$props2.reversed, reversed = _this$props2$reversed === void 0 ? false : _this$props2$reversed; //@ts-ignore
                var getValue = this.state.valueToStep.getValue;
                this.setState(function(_ref2) {
                    var curr = _ref2.handles;
                    var handles = []; // given the current handles and a candidate set, decide what to do
                    if (typeof mode === "function") {
                        handles = mode(curr, next, step, reversed, getValue);
                        (0, (/*@__PURE__*/$parcel$interopDefault($c48cf1b3922f0f88$exports)))(Array.isArray(handles), "Custom mode function did not return an array.");
                    } else switch(mode){
                        case 1:
                            handles = $d00199b262a0773f$export$c5ea20539002ff76(curr, next);
                            break;
                        case 2:
                            handles = $d00199b262a0773f$export$83a6069c6ecf7b2d(curr, next);
                            break;
                        case 3:
                            handles = $d00199b262a0773f$export$6aa1b5580ef4932c(curr, next, step, reversed, getValue);
                            break;
                        default:
                            handles = next;
                            (0, (/*@__PURE__*/$parcel$interopDefault($c48cf1b3922f0f88$exports)))(false, "".concat($d00199b262a0773f$var$prfx, " Invalid mode value."));
                    }
                    onUpdate(handles.map(function(d) {
                        return d.val;
                    }));
                    if (callOnChange) onChange(handles.map(function(d) {
                        return d.val;
                    }));
                    return {
                        handles: handles
                    };
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$state2 = this.state, handles = _this$state2.handles, valueToPerc = _this$state2.valueToPerc, activeHandleID = _this$state2.activeHandleID, _this$props3 = this.props, className = _this$props3.className, _this$props3$rootStyl = _this$props3.rootStyle, rootStyle = _this$props3$rootStyl === void 0 ? {} : _this$props3$rootStyl, _this$props3$rootProp = _this$props3.rootProps, rootProps = _this$props3$rootProp === void 0 ? {} : _this$props3$rootProp, _this$props3$componen = _this$props3.component, Comp = _this$props3$componen === void 0 ? "div" : _this$props3$componen, _this$props3$disabled = _this$props3.disabled, disabled = _this$props3$disabled === void 0 ? false : _this$props3$disabled, _this$props3$flatten = _this$props3.flatten, flatten = _this$props3$flatten === void 0 ? false : _this$props3$flatten;
                var mappedHandles = handles.map(function(_ref3) {
                    var key = _ref3.key, val = _ref3.val;
                    // @ts-ignore
                    return {
                        id: key,
                        value: val,
                        percent: valueToPerc.getValue(val)
                    };
                });
                var children = (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).Children.map(this.props.children, function(child) {
                    if ($d00199b262a0773f$var$isRCSComponent(child) === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).cloneElement(child, {
                        scale: valueToPerc,
                        handles: mappedHandles,
                        activeHandleID: activeHandleID,
                        getEventData: _this3.getEventData,
                        emitKeyboard: disabled ? $d00199b262a0773f$var$noop : _this3.onKeyDown,
                        emitMouse: disabled ? $d00199b262a0773f$var$noop : _this3.onMouseDown,
                        emitTouch: disabled ? $d00199b262a0773f$var$noop : _this3.onTouchStart
                    });
                    else return child;
                });
                return flatten ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement(Comp, $d00199b262a0773f$var$_objectSpread2($d00199b262a0773f$var$_objectSpread2({}, rootProps), {}, {
                    style: rootStyle,
                    className: className,
                    ref: this.slider
                })), children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4rNTR))).createElement(Comp, $d00199b262a0773f$var$_objectSpread2($d00199b262a0773f$var$_objectSpread2({}, rootProps), {}, {
                    style: rootStyle,
                    className: className,
                    ref: this.slider
                }), children));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var _nextProps$step = nextProps.step, step = _nextProps$step === void 0 ? 0.1 : _nextProps$step, values = nextProps.values, _nextProps$domain = nextProps.domain, domain = _nextProps$domain === void 0 ? $d00199b262a0773f$var$defaultDomain : _nextProps$domain, _nextProps$reversed = nextProps.reversed, reversed = _nextProps$reversed === void 0 ? false : _nextProps$reversed, _nextProps$onUpdate = nextProps.onUpdate, onUpdate = _nextProps$onUpdate === void 0 ? $d00199b262a0773f$var$noop : _nextProps$onUpdate, _nextProps$onChange = nextProps.onChange, onChange = _nextProps$onChange === void 0 ? $d00199b262a0773f$var$noop : _nextProps$onChange, _nextProps$warnOnChan = nextProps.warnOnChanges, warnOnChanges = _nextProps$warnOnChan === void 0 ? false : _nextProps$warnOnChan;
                var valueToPerc = prevState.valueToPerc;
                var valueToStep = prevState.valueToStep;
                var pixelToStep = prevState.pixelToStep;
                var nextState = {};
                if (!valueToPerc || !valueToStep || !pixelToStep) {
                    valueToPerc = new $d00199b262a0773f$var$LinearScale();
                    valueToStep = new $d00199b262a0773f$var$DiscreteScale();
                    pixelToStep = new $d00199b262a0773f$var$DiscreteScale();
                    nextState.valueToPerc = valueToPerc;
                    nextState.valueToStep = valueToStep;
                    nextState.pixelToStep = pixelToStep;
                }
                if (prevState.domain === $d00199b262a0773f$var$defaultDomain || prevState.step === null || prevState.domain === null || prevState.reversed === null || step !== prevState.step || domain[0] !== prevState.domain[0] || domain[1] !== prevState.domain[1] || reversed !== prevState.reversed) {
                    var _domain = $d00199b262a0773f$var$_slicedToArray(domain, 2), min = _domain[0], max = _domain[1];
                    valueToStep.setStep(step).setRange([
                        min,
                        max
                    ]).setDomain([
                        min,
                        max
                    ]);
                    if (reversed === true) {
                        valueToPerc.setDomain([
                            min,
                            max
                        ]).setRange([
                            100,
                            0
                        ]);
                        pixelToStep.setStep(step).setRange([
                            max,
                            min
                        ]);
                    } else {
                        valueToPerc.setDomain([
                            min,
                            max
                        ]).setRange([
                            0,
                            100
                        ]);
                        pixelToStep.setStep(step).setRange([
                            min,
                            max
                        ]);
                    }
                    (0, (/*@__PURE__*/$parcel$interopDefault($c48cf1b3922f0f88$exports)))(max > min, "".concat($d00199b262a0773f$var$prfx, " Max must be greater than min (even if reversed). Max is ").concat(max, ". Min is ").concat(min, "."));
                    var _getHandles = $d00199b262a0773f$var$getHandles(values || prevState.values, reversed, valueToStep, warnOnChanges), handles = _getHandles.handles, changes = _getHandles.changes;
                    if (changes || values === undefined || values === prevState.values) {
                        onUpdate(handles.map(function(d) {
                            return d.val;
                        }));
                        onChange(handles.map(function(d) {
                            return d.val;
                        }));
                    }
                    nextState.step = step;
                    nextState.values = values;
                    nextState.domain = domain === $d00199b262a0773f$var$defaultDomain ? $d00199b262a0773f$var$_toConsumableArray(domain) : domain;
                    nextState.handles = handles;
                    nextState.reversed = reversed;
                } else if (!$d00199b262a0773f$var$equal(values, prevState.values)) {
                    var _getHandles2 = $d00199b262a0773f$var$getHandles(values, reversed, valueToStep, warnOnChanges), _handles = _getHandles2.handles, _changes = _getHandles2.changes;
                    if (_changes) {
                        onUpdate(_handles.map(function(d) {
                            return d.val;
                        }));
                        onChange(_handles.map(function(d) {
                            return d.val;
                        }));
                    }
                    nextState.values = values;
                    nextState.handles = _handles;
                }
                if (Object.keys(nextState).length) return nextState;
                return null;
            }
        }
    ]);
    return Slider;
}((0, $4rNTR.PureComponent));


// This is the `Number.isFinite()` polyfill recommended by MDN.
// We do not provide any tests for this function.
// See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isFinite#Polyfill
// @MAJOR Replace with the native `Number.isFinite` method
function $19c332105d3b48fb$export$cf6c09818bd7035a(value) {
    return typeof value === "number" && isFinite(value);
}


function $e9b8c7583b630345$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $e9b8c7583b630345$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $e9b8c7583b630345$var$_typeof(obj);
}
function $e9b8c7583b630345$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e9b8c7583b630345$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e9b8c7583b630345$var$ownKeys(Object(source), !0).forEach(function(key) {
            $e9b8c7583b630345$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e9b8c7583b630345$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e9b8c7583b630345$var$_defineProperty(obj, key, value) {
    key = $e9b8c7583b630345$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e9b8c7583b630345$var$_toPropertyKey(arg) {
    var key = $e9b8c7583b630345$var$_toPrimitive(arg, "string");
    return $e9b8c7583b630345$var$_typeof(key) === "symbol" ? key : String(key);
}
function $e9b8c7583b630345$var$_toPrimitive(input, hint) {
    if ($e9b8c7583b630345$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($e9b8c7583b630345$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $e9b8c7583b630345$var$_slicedToArray(arr, i) {
    return $e9b8c7583b630345$var$_arrayWithHoles(arr) || $e9b8c7583b630345$var$_iterableToArrayLimit(arr, i) || $e9b8c7583b630345$var$_unsupportedIterableToArray(arr, i) || $e9b8c7583b630345$var$_nonIterableRest();
}
function $e9b8c7583b630345$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e9b8c7583b630345$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e9b8c7583b630345$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e9b8c7583b630345$var$_arrayLikeToArray(o, minLen);
}
function $e9b8c7583b630345$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e9b8c7583b630345$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $e9b8c7583b630345$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $e9b8c7583b630345$var$withUsage = (0, $44084963839a4436$export$2fde5bffc340821e)({
    name: "range-input",
    connector: true
}, {
    name: "range-slider",
    connector: true
});
var $e9b8c7583b630345$var$$$type = "ais.range";
// @MAJOR: potentially we should consolidate these types
function $e9b8c7583b630345$var$toPrecision(_ref) {
    var min = _ref.min, max = _ref.max, precision = _ref.precision;
    var pow = Math.pow(10, precision);
    return {
        min: min ? Math.floor(min * pow) / pow : min,
        max: max ? Math.ceil(max * pow) / pow : max
    };
}
/**
 * **Range** connector provides the logic to create custom widget that will let
 * the user refine results using a numeric range.
 *
 * This connectors provides a `refine()` function that accepts bounds. It will also provide
 * information about the min and max bounds for the current result set.
 */ var $e9b8c7583b630345$var$connectRange = function connectRange(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $5d3ef3e388d952bb$export$8793edee2d425525);
    (0, $c9c42a7fa64cf8eb$export$adc2a8e09aa583ee)(renderFn, $e9b8c7583b630345$var$withUsage());
    return function(widgetParams) {
        var _ref2 = widgetParams || {}, _ref2$attribute = _ref2.attribute, attribute = _ref2$attribute === void 0 ? "" : _ref2$attribute, minBound = _ref2.min, maxBound = _ref2.max, _ref2$precision = _ref2.precision, precision = _ref2$precision === void 0 ? 0 : _ref2$precision;
        if (!attribute) throw new Error($e9b8c7583b630345$var$withUsage("The `attribute` option is required."));
        if ((0, $19c332105d3b48fb$export$cf6c09818bd7035a)(minBound) && (0, $19c332105d3b48fb$export$cf6c09818bd7035a)(maxBound) && minBound > maxBound) throw new Error($e9b8c7583b630345$var$withUsage("The `max` option can't be lower than `min`."));
        var formatToNumber = function formatToNumber(v) {
            return Number(Number(v).toFixed(precision));
        };
        var rangeFormatter = {
            from: function from(v) {
                return v.toLocaleString();
            },
            to: function to(v) {
                return formatToNumber(v).toLocaleString();
            }
        };
        // eslint-disable-next-line complexity
        var getRefinedState = function getRefinedState(helper, currentRange, nextMin, nextMax) {
            var resolvedState = helper.state;
            var currentRangeMin = currentRange.min, currentRangeMax = currentRange.max;
            var _ref3 = resolvedState.getNumericRefinement(attribute, ">=") || [], _ref4 = $e9b8c7583b630345$var$_slicedToArray(_ref3, 1), min = _ref4[0];
            var _ref5 = resolvedState.getNumericRefinement(attribute, "<=") || [], _ref6 = $e9b8c7583b630345$var$_slicedToArray(_ref5, 1), max = _ref6[0];
            var isResetMin = nextMin === undefined || nextMin === "";
            var isResetMax = nextMax === undefined || nextMax === "";
            var _toPrecision = $e9b8c7583b630345$var$toPrecision({
                min: !isResetMin ? parseFloat(nextMin) : undefined,
                max: !isResetMax ? parseFloat(nextMax) : undefined,
                precision: precision
            }), nextMinAsNumber = _toPrecision.min, nextMaxAsNumber = _toPrecision.max;
            var newNextMin;
            if (!(0, $19c332105d3b48fb$export$cf6c09818bd7035a)(minBound) && currentRangeMin === nextMinAsNumber) newNextMin = undefined;
            else if ((0, $19c332105d3b48fb$export$cf6c09818bd7035a)(minBound) && isResetMin) newNextMin = minBound;
            else newNextMin = nextMinAsNumber;
            var newNextMax;
            if (!(0, $19c332105d3b48fb$export$cf6c09818bd7035a)(maxBound) && currentRangeMax === nextMaxAsNumber) newNextMax = undefined;
            else if ((0, $19c332105d3b48fb$export$cf6c09818bd7035a)(maxBound) && isResetMax) newNextMax = maxBound;
            else newNextMax = nextMaxAsNumber;
            var isResetNewNextMin = newNextMin === undefined;
            var isGreaterThanCurrentRange = (0, $19c332105d3b48fb$export$cf6c09818bd7035a)(currentRangeMin) && currentRangeMin <= newNextMin;
            var isMinValid = isResetNewNextMin || (0, $19c332105d3b48fb$export$cf6c09818bd7035a)(newNextMin) && (!(0, $19c332105d3b48fb$export$cf6c09818bd7035a)(currentRangeMin) || isGreaterThanCurrentRange);
            var isResetNewNextMax = newNextMax === undefined;
            var isLowerThanRange = (0, $19c332105d3b48fb$export$cf6c09818bd7035a)(newNextMax) && currentRangeMax >= newNextMax;
            var isMaxValid = isResetNewNextMax || (0, $19c332105d3b48fb$export$cf6c09818bd7035a)(newNextMax) && (!(0, $19c332105d3b48fb$export$cf6c09818bd7035a)(currentRangeMax) || isLowerThanRange);
            var hasMinChange = min !== newNextMin;
            var hasMaxChange = max !== newNextMax;
            if ((hasMinChange || hasMaxChange) && isMinValid && isMaxValid) {
                resolvedState = resolvedState.removeNumericRefinement(attribute);
                if ((0, $19c332105d3b48fb$export$cf6c09818bd7035a)(newNextMin)) resolvedState = resolvedState.addNumericRefinement(attribute, ">=", newNextMin);
                if ((0, $19c332105d3b48fb$export$cf6c09818bd7035a)(newNextMax)) resolvedState = resolvedState.addNumericRefinement(attribute, "<=", newNextMax);
                return resolvedState.resetPage();
            }
            return null;
        };
        var createSendEvent = function createSendEvent(instantSearchInstance) {
            return function() {
                if (arguments.length === 1) {
                    instantSearchInstance.sendEventToInsights(arguments.length <= 0 ? undefined : arguments[0]);
                    return;
                }
            };
        };
        function _getCurrentRange(stats) {
            var min;
            if ((0, $19c332105d3b48fb$export$cf6c09818bd7035a)(minBound)) min = minBound;
            else if ((0, $19c332105d3b48fb$export$cf6c09818bd7035a)(stats.min)) min = stats.min;
            else min = 0;
            var max;
            if ((0, $19c332105d3b48fb$export$cf6c09818bd7035a)(maxBound)) max = maxBound;
            else if ((0, $19c332105d3b48fb$export$cf6c09818bd7035a)(stats.max)) max = stats.max;
            else max = 0;
            return $e9b8c7583b630345$var$toPrecision({
                min: min,
                max: max,
                precision: precision
            });
        }
        function _getCurrentRefinement(helper) {
            var _ref7 = helper.getNumericRefinement(attribute, ">=") || [], _ref8 = $e9b8c7583b630345$var$_slicedToArray(_ref7, 1), minValue = _ref8[0];
            var _ref9 = helper.getNumericRefinement(attribute, "<=") || [], _ref10 = $e9b8c7583b630345$var$_slicedToArray(_ref9, 1), maxValue = _ref10[0];
            var min = (0, $19c332105d3b48fb$export$cf6c09818bd7035a)(minValue) ? minValue : -Infinity;
            var max = (0, $19c332105d3b48fb$export$cf6c09818bd7035a)(maxValue) ? maxValue : Infinity;
            return [
                min,
                max
            ];
        }
        function _refine(helper, currentRange) {
            return function() {
                var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
                    undefined,
                    undefined
                ], _ref12 = $e9b8c7583b630345$var$_slicedToArray(_ref11, 2), nextMin = _ref12[0], nextMax = _ref12[1];
                var refinedState = getRefinedState(helper, currentRange, nextMin, nextMax);
                if (refinedState) helper.setState(refinedState).search();
            };
        }
        return {
            $$type: $e9b8c7583b630345$var$$$type,
            init: function init(initOptions) {
                renderFn($e9b8c7583b630345$var$_objectSpread($e9b8c7583b630345$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: initOptions.instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                renderFn($e9b8c7583b630345$var$_objectSpread($e9b8c7583b630345$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: renderOptions.instantSearchInstance
                }), false);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $e9b8c7583b630345$var$_objectSpread($e9b8c7583b630345$var$_objectSpread({}, renderState), {}, {
                    range: $e9b8c7583b630345$var$_objectSpread($e9b8c7583b630345$var$_objectSpread({}, renderState.range), {}, $e9b8c7583b630345$var$_defineProperty({}, attribute, this.getWidgetRenderState(renderOptions)))
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref13) {
                var results = _ref13.results, helper = _ref13.helper, instantSearchInstance = _ref13.instantSearchInstance;
                var facetsFromResults = results && results.disjunctiveFacets || [];
                var facet = (0, $1578b04778e26176$export$71aa6c912b956294)(facetsFromResults, function(facetResult) {
                    return facetResult.name === attribute;
                });
                var stats = facet && facet.stats || {
                    min: undefined,
                    max: undefined
                };
                var currentRange = _getCurrentRange(stats);
                var start = _getCurrentRefinement(helper);
                var refine;
                if (!results) // On first render pass an empty range
                // to be able to bypass the validation
                // related to it
                refine = _refine(helper, {
                    min: undefined,
                    max: undefined
                });
                else refine = _refine(helper, currentRange);
                return {
                    refine: refine,
                    canRefine: currentRange.min !== currentRange.max,
                    format: rangeFormatter,
                    range: currentRange,
                    sendEvent: createSendEvent(instantSearchInstance),
                    widgetParams: $e9b8c7583b630345$var$_objectSpread($e9b8c7583b630345$var$_objectSpread({}, widgetParams), {}, {
                        precision: precision
                    }),
                    start: start
                };
            },
            dispose: function dispose(_ref14) {
                var state = _ref14.state;
                unmountFn();
                return state.removeDisjunctiveFacet(attribute).removeNumericRefinement(attribute);
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref15) {
                var searchParameters = _ref15.searchParameters;
                var _searchParameters$get = searchParameters.getNumericRefinements(attribute), _searchParameters$get2 = _searchParameters$get[">="], min = _searchParameters$get2 === void 0 ? [] : _searchParameters$get2, _searchParameters$get3 = _searchParameters$get["<="], max = _searchParameters$get3 === void 0 ? [] : _searchParameters$get3;
                if (min.length === 0 && max.length === 0) return uiState;
                return $e9b8c7583b630345$var$_objectSpread($e9b8c7583b630345$var$_objectSpread({}, uiState), {}, {
                    range: $e9b8c7583b630345$var$_objectSpread($e9b8c7583b630345$var$_objectSpread({}, uiState.range), {}, $e9b8c7583b630345$var$_defineProperty({}, attribute, "".concat(min, ":").concat(max)))
                });
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref16) {
                var uiState = _ref16.uiState;
                var widgetSearchParameters = searchParameters.addDisjunctiveFacet(attribute).setQueryParameters({
                    numericRefinements: $e9b8c7583b630345$var$_objectSpread($e9b8c7583b630345$var$_objectSpread({}, searchParameters.numericRefinements), {}, $e9b8c7583b630345$var$_defineProperty({}, attribute, {}))
                });
                if ((0, $19c332105d3b48fb$export$cf6c09818bd7035a)(minBound)) widgetSearchParameters = widgetSearchParameters.addNumericRefinement(attribute, ">=", minBound);
                if ((0, $19c332105d3b48fb$export$cf6c09818bd7035a)(maxBound)) widgetSearchParameters = widgetSearchParameters.addNumericRefinement(attribute, "<=", maxBound);
                var value = uiState.range && uiState.range[attribute];
                if (!value || value.indexOf(":") === -1) return widgetSearchParameters;
                var _value$split$map = value.split(":").map(parseFloat), _value$split$map2 = $e9b8c7583b630345$var$_slicedToArray(_value$split$map, 2), lowerBound = _value$split$map2[0], upperBound = _value$split$map2[1];
                if ((0, $19c332105d3b48fb$export$cf6c09818bd7035a)(lowerBound) && (!(0, $19c332105d3b48fb$export$cf6c09818bd7035a)(minBound) || minBound < lowerBound)) {
                    widgetSearchParameters = widgetSearchParameters.removeNumericRefinement(attribute, ">=");
                    widgetSearchParameters = widgetSearchParameters.addNumericRefinement(attribute, ">=", lowerBound);
                }
                if ((0, $19c332105d3b48fb$export$cf6c09818bd7035a)(upperBound) && (!(0, $19c332105d3b48fb$export$cf6c09818bd7035a)(maxBound) || upperBound < maxBound)) {
                    widgetSearchParameters = widgetSearchParameters.removeNumericRefinement(attribute, "<=");
                    widgetSearchParameters = widgetSearchParameters.addNumericRefinement(attribute, "<=", upperBound);
                }
                return widgetSearchParameters;
            }
        };
    };
};
var $e9b8c7583b630345$export$2e2bcd8739ae039 = $e9b8c7583b630345$var$connectRange;



function $a5a4eea03cc81e35$export$7f6d8a9c788c158e(props, additionalWidgetProperties) {
    return (0, $dc402206ef11e68a$export$7b345619fa263f7e)((0, $e9b8c7583b630345$export$2e2bcd8739ae039), props, additionalWidgetProperties);
}



function $ba57b4e4e7095621$export$f5dd818bff069720(number) {
    return Number(number).toLocaleString();
}
function $ba57b4e4e7095621$export$a274e22fb40f762e() {
    for(var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++){
        classNames[_key] = arguments[_key];
    }
    return classNames.filter(Boolean).join(" ");
}


function $7946b23a4ac56164$var$Handle(param) {
    var _param_domain = (0, $92f243d5f0acdb62$export$fdf2a89c76341bbf)(param.domain, 2), min = _param_domain[0], max = _param_domain[1], _param_handle = param.handle, id = _param_handle.id, value = _param_handle.value, percent = _param_handle.percent, disabled = param.disabled, getHandleProps = param.getHandleProps;
    return /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)((0, $775bae712b15f178$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("div", (0, $f73d694e64d0bc45$export$581ff339ea0ba762)({
                style: {
                    position: "absolute",
                    left: "".concat(percent, "%"),
                    width: 40,
                    height: 25,
                    transform: "translate(-50%, -100%)",
                    cursor: disabled ? "not-allowed" : "grab",
                    zIndex: 1
                },
                "aria-hidden": true
            }, getHandleProps(id))),
            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("div", (0, $f73d694e64d0bc45$export$581ff339ea0ba762)({
                role: "slider",
                className: "slider-handle",
                "aria-valuemin": min,
                "aria-valuemax": max,
                "aria-valuenow": value,
                style: {
                    left: "".concat(percent, "%"),
                    cursor: disabled ? "not-allowed" : "grab"
                }
            }, getHandleProps(id)))
        ]
    });
}
function $7946b23a4ac56164$var$convertToTicks(start, range) {
    var domain = range.min === 0 && range.max === 0 ? {
        min: undefined,
        max: undefined
    } : range;
    return [
        start[0] === -Infinity ? domain.min : start[0],
        start[1] === Infinity ? domain.max : start[1]
    ];
}
function $7946b23a4ac56164$export$ab4cabba918d1baf(param) {
    var attribute = param.attribute, min = param.min, max = param.max;
    var _useRange = (0, $a5a4eea03cc81e35$export$7f6d8a9c788c158e)({
        attribute: attribute,
        min: min,
        max: max
    }, {
        $$widgetType: "e-commerce.rangeSlider"
    }), range = _useRange.range, start = _useRange.start, refine = _useRange.refine, canRefine = _useRange.canRefine;
    var _useState = (0, $92f243d5f0acdb62$export$fdf2a89c76341bbf)((0, $4rNTR.useState)($7946b23a4ac56164$var$convertToTicks(start, range)), 2), ticksValues = _useState[0], setTicksValues = _useState[1];
    var _useState1 = (0, $92f243d5f0acdb62$export$fdf2a89c76341bbf)((0, $4rNTR.useState)(start), 2), prevStart = _useState1[0], setPrevStart = _useState1[1];
    if (start !== prevStart) {
        setTicksValues($7946b23a4ac56164$var$convertToTicks(start, range));
        setPrevStart(start);
    }
    var onChange = function(values) {
        refine(values);
    };
    var onUpdate = function(values) {
        setTicksValues(values);
    };
    if (!canRefine || ticksValues[0] === undefined || ticksValues[1] === undefined) return null;
    return /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)((0, $d00199b262a0773f$export$472062a354075cee), {
        mode: 2,
        step: 1,
        domain: [
            range.min,
            range.max
        ],
        values: start,
        disabled: !canRefine,
        onChange: onChange,
        onUpdate: onUpdate,
        rootStyle: {
            position: "relative",
            marginTop: "1.5rem"
        },
        className: "ais-RangeSlider",
        children: [
            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)((0, $d00199b262a0773f$export$b57863d0ff6a6d2b), {
                children: function(param) {
                    var getRailProps = param.getRailProps;
                    return /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("div", (0, $f73d694e64d0bc45$export$581ff339ea0ba762)({
                        className: "slider-rail"
                    }, getRailProps()));
                }
            }),
            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)((0, $d00199b262a0773f$export$76e817a61dd78922), {
                left: false,
                right: false,
                children: function(param) {
                    var tracks = param.tracks, getTrackProps = param.getTrackProps;
                    return /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("div", {
                        children: tracks.map(function(param) {
                            var id = param.id, source = param.source, target = param.target;
                            return /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("div", (0, $f73d694e64d0bc45$export$581ff339ea0ba762)({
                                className: "slider-track",
                                style: {
                                    left: "".concat(source.percent, "%"),
                                    width: "".concat(target.percent - source.percent, "%")
                                }
                            }, getTrackProps()), id);
                        })
                    });
                }
            }),
            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)((0, $d00199b262a0773f$export$e687473b8d6c8292), {
                children: function(param) {
                    var handles = param.handles, getHandleProps = param.getHandleProps;
                    return /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("div", {
                        children: handles.map(function(handle) {
                            return /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)($7946b23a4ac56164$var$Handle, {
                                handle: handle,
                                domain: [
                                    range.min,
                                    range.max
                                ],
                                getHandleProps: getHandleProps
                            }, handle.id);
                        })
                    });
                }
            }),
            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)((0, $d00199b262a0773f$export$27c7467594ef87bd), {
                values: ticksValues,
                children: function(param) {
                    var ticks = param.ticks;
                    return /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("div", {
                        children: ticks.map(function(param) {
                            var id = param.id, value = param.value, percent = param.percent;
                            return /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)("div", {
                                className: "slider-tick",
                                style: {
                                    left: "".concat(percent, "%")
                                },
                                children: [
                                    /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("span", {
                                        style: {
                                            color: "#e2a400",
                                            marginRight: 4
                                        },
                                        children: "$"
                                    }),
                                    (0, $ba57b4e4e7095621$export$f5dd818bff069720)(value)
                                ]
                            }, id);
                        })
                    });
                }
            })
        ]
    });
}




function $d2d1bfa4cfdab06f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d2d1bfa4cfdab06f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d2d1bfa4cfdab06f$var$_typeof(obj);
}
function $d2d1bfa4cfdab06f$var$_toConsumableArray(arr) {
    return $d2d1bfa4cfdab06f$var$_arrayWithoutHoles(arr) || $d2d1bfa4cfdab06f$var$_iterableToArray(arr) || $d2d1bfa4cfdab06f$var$_unsupportedIterableToArray(arr) || $d2d1bfa4cfdab06f$var$_nonIterableSpread();
}
function $d2d1bfa4cfdab06f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d2d1bfa4cfdab06f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $d2d1bfa4cfdab06f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $d2d1bfa4cfdab06f$var$_arrayLikeToArray(arr);
}
function $d2d1bfa4cfdab06f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d2d1bfa4cfdab06f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d2d1bfa4cfdab06f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d2d1bfa4cfdab06f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d2d1bfa4cfdab06f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d2d1bfa4cfdab06f$var$_defineProperty(obj, key, value) {
    key = $d2d1bfa4cfdab06f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d2d1bfa4cfdab06f$var$_toPropertyKey(arg) {
    var key = $d2d1bfa4cfdab06f$var$_toPrimitive(arg, "string");
    return $d2d1bfa4cfdab06f$var$_typeof(key) === "symbol" ? key : String(key);
}
function $d2d1bfa4cfdab06f$var$_toPrimitive(input, hint) {
    if ($d2d1bfa4cfdab06f$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($d2d1bfa4cfdab06f$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $d2d1bfa4cfdab06f$var$_slicedToArray(arr, i) {
    return $d2d1bfa4cfdab06f$var$_arrayWithHoles(arr) || $d2d1bfa4cfdab06f$var$_iterableToArrayLimit(arr, i) || $d2d1bfa4cfdab06f$var$_unsupportedIterableToArray(arr, i) || $d2d1bfa4cfdab06f$var$_nonIterableRest();
}
function $d2d1bfa4cfdab06f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d2d1bfa4cfdab06f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d2d1bfa4cfdab06f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d2d1bfa4cfdab06f$var$_arrayLikeToArray(o, minLen);
}
function $d2d1bfa4cfdab06f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d2d1bfa4cfdab06f$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $d2d1bfa4cfdab06f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $d2d1bfa4cfdab06f$var$withUsage = (0, $44084963839a4436$export$2fde5bffc340821e)({
    name: "rating-menu",
    connector: true
});
var $d2d1bfa4cfdab06f$var$$$type = "ais.ratingMenu";
var $d2d1bfa4cfdab06f$var$MAX_VALUES_PER_FACET_API_LIMIT = 1000;
var $d2d1bfa4cfdab06f$var$STEP = 1;
var $d2d1bfa4cfdab06f$var$createSendEvent = function createSendEvent(_ref) {
    var instantSearchInstance = _ref.instantSearchInstance, helper = _ref.helper, getRefinedStar = _ref.getRefinedStar, attribute = _ref.attribute;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 1) {
            instantSearchInstance.sendEventToInsights(args[0]);
            return;
        }
        var facetValue = args[1], _args$ = args[2], eventName = _args$ === void 0 ? "Filter Applied" : _args$;
        var _args$0$split = args[0].split(":"), _args$0$split2 = $d2d1bfa4cfdab06f$var$_slicedToArray(_args$0$split, 2), eventType = _args$0$split2[0], eventModifier = _args$0$split2[1];
        if (eventType !== "click") return;
        var isRefined = getRefinedStar() === Number(facetValue);
        if (!isRefined) instantSearchInstance.sendEventToInsights({
            insightsMethod: "clickedFilters",
            widgetType: $d2d1bfa4cfdab06f$var$$$type,
            eventType: eventType,
            eventModifier: eventModifier,
            payload: {
                eventName: eventName,
                index: helper.getIndex(),
                filters: [
                    "".concat(attribute, ">=").concat(facetValue)
                ]
            },
            attribute: attribute
        });
    };
};
/**
 * **StarRating** connector provides the logic to build a custom widget that will let
 * the user refine search results based on ratings.
 *
 * The connector provides to the rendering: `refine()` to select a value and
 * `items` that are the values that can be selected. `refine` should be used
 * with `items.value`.
 */ var $d2d1bfa4cfdab06f$var$connectRatingMenu = function connectRatingMenu(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $5d3ef3e388d952bb$export$8793edee2d425525);
    (0, $c9c42a7fa64cf8eb$export$adc2a8e09aa583ee)(renderFn, $d2d1bfa4cfdab06f$var$withUsage());
    return function(widgetParams) {
        var _ref2 = widgetParams || {}, attribute = _ref2.attribute, _ref2$max = _ref2.max, max = _ref2$max === void 0 ? 5 : _ref2$max;
        var sendEvent;
        if (!attribute) throw new Error($d2d1bfa4cfdab06f$var$withUsage("The `attribute` option is required."));
        var _getRefinedStar = function getRefinedStar(state) {
            var _values$;
            var values = state.getNumericRefinements(attribute);
            if (!((_values$ = values[">="]) !== null && _values$ !== void 0 && _values$.length)) return undefined;
            return values[">="][0];
        };
        var getFacetsMaxDecimalPlaces = function getFacetsMaxDecimalPlaces(facetResults) {
            var maxDecimalPlaces = 0;
            facetResults.forEach(function(facetResult) {
                var _facetResult$name$spl = facetResult.name.split("."), _facetResult$name$spl2 = $d2d1bfa4cfdab06f$var$_slicedToArray(_facetResult$name$spl, 2), _facetResult$name$spl3 = _facetResult$name$spl2[1], decimal = _facetResult$name$spl3 === void 0 ? "" : _facetResult$name$spl3;
                maxDecimalPlaces = Math.max(maxDecimalPlaces, decimal.length);
            });
            return maxDecimalPlaces;
        };
        var getFacetValuesWarningMessage = function getFacetValuesWarningMessage(_ref3) {
            var maxDecimalPlaces = _ref3.maxDecimalPlaces, maxFacets = _ref3.maxFacets, maxValuesPerFacet = _ref3.maxValuesPerFacet;
            var maxDecimalPlacesInRange = Math.max(0, Math.floor(Math.log10($d2d1bfa4cfdab06f$var$MAX_VALUES_PER_FACET_API_LIMIT / max)));
            var maxFacetsInRange = Math.min($d2d1bfa4cfdab06f$var$MAX_VALUES_PER_FACET_API_LIMIT, Math.pow(10, maxDecimalPlacesInRange) * max);
            var solutions = [];
            if (maxFacets > $d2d1bfa4cfdab06f$var$MAX_VALUES_PER_FACET_API_LIMIT) solutions.push('- Update your records to lower the precision of the values in the "'.concat(attribute, '" attribute (for example: ').concat(5.123456789.toPrecision(maxDecimalPlaces + 1), " to ").concat(5.123456789.toPrecision(maxDecimalPlacesInRange + 1), ")"));
            if (maxValuesPerFacet < maxFacetsInRange) solutions.push("- Increase the maximum number of facet values to ".concat(maxFacetsInRange, ' using the "configure" widget ').concat((0, $44084963839a4436$export$110679b26359d23d)({
                name: "configure"
            }), ' and the "maxValuesPerFacet" parameter https://www.algolia.com/doc/api-reference/api-parameters/maxValuesPerFacet/'));
            return "The ".concat(attribute, " attribute can have ").concat(maxFacets, " different values (0 to ").concat(max, " with a maximum of ").concat(maxDecimalPlaces, " decimals = ").concat(maxFacets, ") but you retrieved only ").concat(maxValuesPerFacet, " facet values. Therefore the number of results that match the refinements can be incorrect.\n    ").concat(solutions.length ? "To resolve this problem you can:\n".concat(solutions.join("\n")) : "");
        };
        function getRefinedState(state, facetValue) {
            var isRefined = _getRefinedStar(state) === Number(facetValue);
            var emptyState = state.resetPage().removeNumericRefinement(attribute);
            if (!isRefined) return emptyState.addNumericRefinement(attribute, "<=", max).addNumericRefinement(attribute, ">=", Number(facetValue));
            return emptyState;
        }
        var toggleRefinement = function toggleRefinement(helper, facetValue) {
            sendEvent("click:internal", facetValue);
            helper.setState(getRefinedState(helper.state, facetValue)).search();
        };
        var connectorState = {
            toggleRefinementFactory: function toggleRefinementFactory(helper) {
                return toggleRefinement.bind(null, helper);
            },
            createURLFactory: function createURLFactory(_ref4) {
                var state = _ref4.state, createURL = _ref4.createURL, getWidgetUiState = _ref4.getWidgetUiState, helper = _ref4.helper;
                return function(value) {
                    return createURL(function(uiState) {
                        return getWidgetUiState(uiState, {
                            searchParameters: getRefinedState(state, value),
                            helper: helper
                        });
                    });
                };
            }
        };
        return {
            $$type: $d2d1bfa4cfdab06f$var$$$type,
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($d2d1bfa4cfdab06f$var$_objectSpread($d2d1bfa4cfdab06f$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($d2d1bfa4cfdab06f$var$_objectSpread($d2d1bfa4cfdab06f$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $d2d1bfa4cfdab06f$var$_objectSpread($d2d1bfa4cfdab06f$var$_objectSpread({}, renderState), {}, {
                    ratingMenu: $d2d1bfa4cfdab06f$var$_objectSpread($d2d1bfa4cfdab06f$var$_objectSpread({}, renderState.ratingMenu), {}, $d2d1bfa4cfdab06f$var$_defineProperty({}, attribute, this.getWidgetRenderState(renderOptions)))
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref5) {
                var helper = _ref5.helper, results = _ref5.results, state = _ref5.state, instantSearchInstance = _ref5.instantSearchInstance, createURL = _ref5.createURL;
                var facetValues = [];
                if (!sendEvent) sendEvent = $d2d1bfa4cfdab06f$var$createSendEvent({
                    instantSearchInstance: instantSearchInstance,
                    helper: helper,
                    getRefinedStar: function getRefinedStar() {
                        return _getRefinedStar(helper.state);
                    },
                    attribute: attribute
                });
                var refinementIsApplied = false;
                var totalCount = 0;
                var facetResults = results === null || results === void 0 ? void 0 : results.getFacetValues(attribute, {});
                if (results && facetResults) {
                    var maxValuesPerFacet = facetResults.length;
                    var maxDecimalPlaces = getFacetsMaxDecimalPlaces(facetResults);
                    var maxFacets = Math.pow(10, maxDecimalPlaces) * max;
                    var refinedStar = _getRefinedStar(state);
                    var _loop = function _loop(star) {
                        var isRefined = refinedStar === star;
                        refinementIsApplied = refinementIsApplied || isRefined;
                        var count = facetResults.filter(function(f) {
                            return Number(f.name) >= star && Number(f.name) <= max;
                        }).map(function(f) {
                            return f.count;
                        }).reduce(function(sum, current) {
                            return sum + current;
                        }, 0);
                        totalCount += count;
                        if (refinedStar && !isRefined && count === 0) // skip count==0 when at least 1 refinement is enabled
                        // eslint-disable-next-line no-continue
                        return "continue";
                        var stars = $d2d1bfa4cfdab06f$var$_toConsumableArray(new Array(Math.floor(max / $d2d1bfa4cfdab06f$var$STEP))).map(function(_v, i) {
                            return i * $d2d1bfa4cfdab06f$var$STEP < star;
                        });
                        facetValues.push({
                            stars: stars,
                            name: String(star),
                            label: String(star),
                            value: String(star),
                            count: count,
                            isRefined: isRefined
                        });
                    };
                    for(var star = $d2d1bfa4cfdab06f$var$STEP; star < max; star += $d2d1bfa4cfdab06f$var$STEP){
                        var _ret = _loop(star);
                        if (_ret === "continue") continue;
                    }
                }
                facetValues = facetValues.reverse();
                var hasNoResults = results ? results.nbHits === 0 : true;
                return {
                    items: facetValues,
                    hasNoResults: hasNoResults,
                    canRefine: (!hasNoResults || refinementIsApplied) && totalCount > 0,
                    refine: connectorState.toggleRefinementFactory(helper),
                    sendEvent: sendEvent,
                    createURL: connectorState.createURLFactory({
                        state: state,
                        createURL: createURL,
                        helper: helper,
                        getWidgetUiState: this.getWidgetUiState
                    }),
                    widgetParams: widgetParams
                };
            },
            dispose: function dispose(_ref6) {
                var state = _ref6.state;
                unmountFn();
                return state.removeNumericRefinement(attribute);
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref7) {
                var searchParameters = _ref7.searchParameters;
                var value = _getRefinedStar(searchParameters);
                return $d2d1bfa4cfdab06f$var$removeEmptyRefinementsFromUiState($d2d1bfa4cfdab06f$var$_objectSpread($d2d1bfa4cfdab06f$var$_objectSpread({}, uiState), {}, {
                    ratingMenu: $d2d1bfa4cfdab06f$var$_objectSpread($d2d1bfa4cfdab06f$var$_objectSpread({}, uiState.ratingMenu), {}, $d2d1bfa4cfdab06f$var$_defineProperty({}, attribute, typeof value === "number" ? value : undefined))
                }), attribute);
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref8) {
                var uiState = _ref8.uiState;
                var value = uiState.ratingMenu && uiState.ratingMenu[attribute];
                var withDisjunctiveFacet = searchParameters.addDisjunctiveFacet(attribute).removeNumericRefinement(attribute).removeDisjunctiveFacetRefinement(attribute);
                if (!value) return withDisjunctiveFacet.setQueryParameters({
                    numericRefinements: $d2d1bfa4cfdab06f$var$_objectSpread($d2d1bfa4cfdab06f$var$_objectSpread({}, withDisjunctiveFacet.numericRefinements), {}, $d2d1bfa4cfdab06f$var$_defineProperty({}, attribute, {}))
                });
                return withDisjunctiveFacet.addNumericRefinement(attribute, "<=", max).addNumericRefinement(attribute, ">=", value);
            }
        };
    };
};
function $d2d1bfa4cfdab06f$var$removeEmptyRefinementsFromUiState(indexUiState, attribute) {
    if (!indexUiState.ratingMenu) return indexUiState;
    if (typeof indexUiState.ratingMenu[attribute] !== "number") delete indexUiState.ratingMenu[attribute];
    if (Object.keys(indexUiState.ratingMenu).length === 0) delete indexUiState.ratingMenu;
    return indexUiState;
}
var $d2d1bfa4cfdab06f$export$2e2bcd8739ae039 = $d2d1bfa4cfdab06f$var$connectRatingMenu;


parcelRequire("4rNTR");


function $803c56ff5f9f09ea$export$63624e0823f82b87(param) {
    var attribute = param.attribute;
    var _useConnector = (0, $dc402206ef11e68a$export$7b345619fa263f7e)((0, $d2d1bfa4cfdab06f$export$2e2bcd8739ae039), {
        attribute: attribute
    }, {
        $$widgetType: "e-commerce.ratingMenu"
    }), refine = _useConnector.refine, items = _useConnector.items, createURL = _useConnector.createURL;
    return /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("div", {
        className: "ais-RatingMenu",
        children: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("ul", {
            className: "ais-RatingMenu-list",
            children: items.map(function(rating) {
                return /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("li", {
                    className: (0, $ba57b4e4e7095621$export$a274e22fb40f762e)("ais-RatingMenu-item", rating.isRefined && "ais-RatingMenu-item--selected", rating.count === 0 && "ais-RatingMenu-item--disabled"),
                    children: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)("a", {
                        className: "ais-RatingMenu-link",
                        "aria-label": "".concat(rating.value, " & up"),
                        href: createURL(rating.value),
                        onClick: function(event) {
                            event.preventDefault();
                            refine(rating.value);
                        },
                        children: [
                            rating.stars.map(function(isStarFull, starIndex) {
                                return /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("svg", {
                                    className: (0, $ba57b4e4e7095621$export$a274e22fb40f762e)("ais-RatingMenu-starIcon", isStarFull ? "ais-RatingMenu-starIcon--full" : "ais-RatingMenu-starIcon--empty"),
                                    "aria-hidden": "true",
                                    viewBox: "0 0 16 16",
                                    children: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("path", {
                                        fillRule: "evenodd",
                                        d: "M10.472 5.008L16 5.816l-4 3.896.944 5.504L8 12.616l-4.944 2.6L4 9.712 0 5.816l5.528-.808L8 0z"
                                    })
                                }, starIndex);
                            }),
                            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("span", {
                                className: "ais-RatingMenu-count",
                                children: rating.count
                            })
                        ]
                    })
                }, rating.value);
            })
        })
    });
}



parcelRequire("4rNTR");


function $9264e8b12d7cb030$export$ee2d71e3fbd004ff() {
    var _useInstantSearch = (0, $6c0b277d5f13c389$export$c3584afb06ed387d)(), nbHits = _useInstantSearch.results.nbHits;
    return /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("strong", {
                children: (0, $ba57b4e4e7095621$export$f5dd818bff069720)(nbHits)
            }),
            " r\xe9sultats"
        ]
    });
}



parcelRequire("4rNTR");


function $736bce90f26fcb35$export$b5314781ab50943a(param) {
    var onClick = param.onClick;
    var _useInstantSearch = (0, $6c0b277d5f13c389$export$c3584afb06ed387d)(), nbHits = _useInstantSearch.results.nbHits;
    return /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)("button", {
        className: "button button-primary",
        onClick: onClick,
        children: [
            "See ",
            (0, $ba57b4e4e7095621$export$f5dd818bff069720)(nbHits),
            " r\xe9sultats"
        ]
    });
}






var $4rNTR = parcelRequire("4rNTR");

function $328737e057074e6f$export$30318940d8eafabd(param) {
    var children = param.children;
    var addMiddlewares = (0, $6c0b277d5f13c389$export$c3584afb06ed387d)().addMiddlewares;
    var containerRef = (0, $4rNTR.useRef)(null);
    (0, $4rNTR.useEffect)(function() {
        var middleware = function() {
            return {
                onStateChange: function() {
                    var _document_activeElement, _document_activeElement1;
                    var isFiltering = document.body.classList.contains("filtering");
                    var isTyping = ((_document_activeElement = document.activeElement) === null || _document_activeElement === void 0 ? void 0 : _document_activeElement.tagName) === "INPUT" && ((_document_activeElement1 = document.activeElement) === null || _document_activeElement1 === void 0 ? void 0 : _document_activeElement1.getAttribute("type")) === "search";
                    if (isFiltering || isTyping) return;
                    containerRef.current.scrollIntoView();
                }
            };
        };
        return addMiddlewares(middleware);
    }, [
        addMiddlewares
    ]);
    return /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("div", {
        ref: containerRef,
        className: "ais-ScrollTo",
        children: children
    });
}


/* eslint complexity: off */ 

var $52dac82273078f42$var$routeStateDefaultValues = {
    query: "",
    page: "1",
    categories: undefined,
    tags: undefined,
    // brands: undefined,
    // category: '',
    // rating: '',
    // price: '',
    // free_shipping: 'false',
    sortBy: "PITAETCHOCOLAT_FR",
    hitsPerPage: "20"
};
// const encodedCategories = {
//   Cameras: 'Cameras & Camcorders',
//   Cars: 'Car Electronics & GPS',
//   Phones: 'Cell Phones',
//   TV: 'TV & Home Theater',
// } as const;
// type EncodedCategories = typeof encodedCategories;
// type DecodedCategories = {
//   [K in keyof EncodedCategories as EncodedCategories[K]]: K;
// };
// const decodedCategories = Object.keys(
//   encodedCategories
// ).reduce<DecodedCategories>((acc, key) => {
//   const newKey = encodedCategories[key as keyof EncodedCategories];
//   const newValue = key;
//   return {
//     ...acc,
//     [newKey]: newValue,
//   };
// }, {} as any);
// Returns a slug from the category name.
// Spaces are replaced by "+" to make
// the URL easier to read and other
// characters are encoded.
// function getCategorySlug(name: string): string {
//   const encodedName =
//     decodedCategories[name as keyof DecodedCategories] || name;
//   return encodedName.split(' ').map(encodeURIComponent).join('+');
// }
// Returns a name from the category slug.
// The "+" are replaced by spaces and other
// characters are decoded.
// function getCategoryName(slug: string): string {
//   return decodeURIComponent(slug.replace(/\+/g, ' '));
// }
var $52dac82273078f42$var$originalWindowTitle = document.title;
var $52dac82273078f42$var$router = (0, $5d8d125229bfd881$export$2e2bcd8739ae039)({
    cleanUrlOnDispose: false,
    windowTitle: function(param) {
        var query = param.query;
        var queryTitle = query ? 'Results for "'.concat(query, '"') : "";
        return [
            queryTitle,
            $52dac82273078f42$var$originalWindowTitle
        ].filter(Boolean).join(" | ");
    },
    createURL: function(param) {
        var qsModule = param.qsModule, routeState = param.routeState, location = param.location;
        var protocol = location.protocol, hostname = location.hostname, _location_port = location.port, port = _location_port === void 0 ? "" : _location_port, pathname = location.pathname, hash = location.hash;
        var portWithPrefix = port === "" ? "" : ":".concat(port);
        var urlParts = location.href.match(/^(.*?)\/search/);
        var baseUrl = urlParts && urlParts[0] || "".concat(protocol, "//").concat(hostname).concat(portWithPrefix).concat(pathname, "search");
        // const categoryPath = routeState.category
        //   ? `${getCategorySlug(routeState.category)}/`
        //   : '';
        var queryParameters = {};
        if (routeState.query && routeState.query !== $52dac82273078f42$var$routeStateDefaultValues.query) queryParameters.query = encodeURIComponent(routeState.query);
        if (routeState.page && routeState.page !== $52dac82273078f42$var$routeStateDefaultValues.page) queryParameters.page = routeState.page;
        if (routeState.tags && routeState.tags !== $52dac82273078f42$var$routeStateDefaultValues.tags) queryParameters.tags = routeState.tags.map(encodeURIComponent);
        if (routeState.categories && routeState.categories !== $52dac82273078f42$var$routeStateDefaultValues.categories) queryParameters.categories = routeState.categories.map(encodeURIComponent);
        // if (
        //   routeState.brands &&
        //   routeState.brands !== routeStateDefaultValues.brands
        // ) {
        //   queryParameters.brands = routeState.brands.map(encodeURIComponent);
        // }
        // if (
        //   routeState.rating &&
        //   routeState.rating !== routeStateDefaultValues.rating
        // ) {
        //   queryParameters.rating = routeState.rating;
        // }
        // if (
        //   routeState.price &&
        //   routeState.price !== routeStateDefaultValues.price
        // ) {
        //   queryParameters.price = routeState.price;
        // }
        // if (
        //   routeState.free_shipping &&
        //   routeState.free_shipping !== routeStateDefaultValues.free_shipping
        // ) {
        //   queryParameters.free_shipping = routeState.free_shipping;
        // }
        if (routeState.sortBy && routeState.sortBy !== $52dac82273078f42$var$routeStateDefaultValues.sortBy) queryParameters.sortBy = routeState.sortBy;
        if (routeState.hitsPerPage && routeState.hitsPerPage !== $52dac82273078f42$var$routeStateDefaultValues.hitsPerPage) queryParameters.hitsPerPage = routeState.hitsPerPage;
        var queryString = qsModule.stringify(queryParameters, {
            addQueryPrefix: true,
            arrayFormat: "repeat"
        });
        // return `${baseUrl}/${categoryPath}${queryString}${hash}`;
        return "".concat(baseUrl, "/").concat(queryString).concat(hash);
    },
    parseURL: function(param) {
        var qsModule = param.qsModule, location = param.location;
        // const pathnameMatches = location.pathname.match(/search\/(.*?)\/?$/);
        // const category = getCategoryName(
        //   (pathnameMatches && pathnameMatches[1]) || ''
        // );
        var queryParameters = qsModule.parse(location.search.slice(1));
        var _queryParameters_query = queryParameters.query, query = _queryParameters_query === void 0 ? "" : _queryParameters_query, _queryParameters_page = queryParameters.page, page = _queryParameters_page === void 0 ? 1 : _queryParameters_page, _queryParameters_categories = queryParameters.categories, categories = _queryParameters_categories === void 0 ? [] : _queryParameters_categories, _queryParameters_tags = queryParameters.tags, tags = _queryParameters_tags === void 0 ? [] : _queryParameters_tags, // brands = [],
        // price,
        // free_shipping,
        // rating,
        hitsPerPage = queryParameters.hitsPerPage, sortBy = queryParameters.sortBy;
        // `qs` does not return an array when there's a single value.
        var allTags = Array.isArray(tags) ? tags : [
            tags
        ].filter(Boolean);
        var allCategories = Array.isArray(categories) ? categories : [
            categories
        ].filter(Boolean);
        // const allBrands = (
        //   Array.isArray(brands) ? brands : [brands].filter(Boolean)
        // ) as string[];
        return {
            // category,
            query: decodeURIComponent(query),
            page: page,
            // brands: allBrands.map(decodeURIComponent),
            tags: allTags.map(decodeURIComponent),
            categories: allCategories.map(decodeURIComponent),
            // rating: rating as string,
            // price: price as string,
            // free_shipping: free_shipping as string,
            sortBy: sortBy,
            hitsPerPage: hitsPerPage
        };
    }
});
var $52dac82273078f42$var$getStateMapping = function(param) {
    var indexName = param.indexName;
    return {
        stateToRoute: function(uiState) {
            var indexUiState = uiState[indexName];
            // Preserve sortBy from URL (for language switching) even without a SortBy widget
            var currentSortBy = new URLSearchParams(window.location.search).get("sortBy");
            return {
                query: indexUiState.query,
                page: indexUiState.page && String(indexUiState.page) || undefined,
                // brands: indexUiState.refinementList && indexUiState.refinementList.brand,
                categories: indexUiState.refinementList && indexUiState.refinementList.categories,
                tags: indexUiState.refinementList && indexUiState.refinementList.tags,
                // category:
                //   indexUiState.hierarchicalMenu &&
                //   indexUiState.hierarchicalMenu['hierarchicalCategories.lvl0'] &&
                //   indexUiState.hierarchicalMenu['hierarchicalCategories.lvl0'].join('/'),
                // rating:
                //   (indexUiState.ratingMenu &&
                //     indexUiState.ratingMenu.rating &&
                //     String(indexUiState.ratingMenu.rating)) ||
                //   undefined,
                // price: indexUiState.range && indexUiState.range.price,
                // free_shipping:
                //   (indexUiState.toggle && String(indexUiState.toggle.free_shipping)) ||
                //   undefined,
                // Preserve sortBy from URL for language switching (not from widget state)
                sortBy: currentSortBy || indexUiState.sortBy,
                hitsPerPage: indexUiState.hitsPerPage && String(indexUiState.hitsPerPage) || undefined
            };
        },
        routeToState: function(routeState) {
            // const hierarchicalMenu: { [key: string]: string[] } = {};
            // if (routeState.category) {
            //   hierarchicalMenu['hierarchicalCategories.lvl0'] =
            //     routeState.category.split('/');
            // }
            console.log("routeState", routeState);
            var refinementList = {};
            if (routeState.tags) refinementList.tags = routeState.tags;
            if (routeState.categories) refinementList.categories = routeState.categories;
            // if (routeState.brands) {
            //   refinementList.brand = routeState.brands;
            // }
            // const range: { [key: string]: string } = {};
            // if (routeState.price) {
            //   range.price = routeState.price;
            // }
            return (0, $459190a2f84b955e$export$1e71eb4bef00f6b0)({}, indexName, {
                query: routeState.query,
                page: Number(routeState.page),
                // hierarchicalMenu,
                refinementList: refinementList,
                // ratingMenu: {
                //   rating: Number(routeState.rating),
                // },
                // range,
                // toggle: {
                //   free_shipping: Boolean(routeState.free_shipping),
                // },
                sortBy: routeState.sortBy,
                hitsPerPage: Number(routeState.hitsPerPage)
            });
        }
    };
};
var $52dac82273078f42$var$getRouting = function(indexName) {
    return {
        router: $52dac82273078f42$var$router,
        stateMapping: $52dac82273078f42$var$getStateMapping({
            indexName: indexName
        })
    };
};
var $52dac82273078f42$export$2e2bcd8739ae039 = $52dac82273078f42$var$getRouting;







var $cb2c1e9ca868bb31$var$searchClient = (0, (/*@__PURE__*/$parcel$interopDefault($20094f40e815e9de$exports)))("LFA75E93U5", "4386543dd94c928dae7b34f9ffc7573b");
var $cb2c1e9ca868bb31$var$timerId = undefined;
var $cb2c1e9ca868bb31$var$timeout = 250;
function $cb2c1e9ca868bb31$var$queryHook(query, search) {
    if ($cb2c1e9ca868bb31$var$timerId) clearTimeout($cb2c1e9ca868bb31$var$timerId);
    $cb2c1e9ca868bb31$var$timerId = setTimeout(function() {
        return search(query);
    }, $cb2c1e9ca868bb31$var$timeout);
}
// Get language from URL parameter (using sortBy for routing compatibility)
function $cb2c1e9ca868bb31$var$getLanguageFromURL() {
    var params = new URLSearchParams(window.location.search);
    var sortBy = params.get("sortBy") || "PITAETCHOCOLAT_FR";
    // Map index name to language
    if (sortBy === "PITAETCHOCOLAT_EN") return "en";
    if (sortBy === "PITAETCHOCOLAT_HE") return "he";
    return "fr";
}
// Map language to Algolia index
function $cb2c1e9ca868bb31$var$getIndexName(lang) {
    var indexMap = {
        fr: "PITAETCHOCOLAT_FR",
        en: "PITAETCHOCOLAT_EN",
        he: "PITAETCHOCOLAT_HE"
    };
    return indexMap[lang];
}
// Also support legacy 'lang' parameter for backwards compatibility
function $cb2c1e9ca868bb31$var$getLegacyLanguageParam() {
    var params = new URLSearchParams(window.location.search);
    var lang = params.get("lang");
    if (lang === "en") return "PITAETCHOCOLAT_EN";
    if (lang === "he") return "PITAETCHOCOLAT_HE";
    if (lang === "fr") return "PITAETCHOCOLAT_FR";
    return null;
}
// Get translations for UI text
function $cb2c1e9ca868bb31$var$getTranslations(lang) {
    var translations = {
        fr: {
            tagline: "Cuisine juive d'aujourd'hui.",
            searchPlaceholder: "Recette, ingr\xe9dient, description, tag, cuisine\u2026",
            filters: "Filtres",
            tags: "Tags",
            categories: "Cat\xe9gories",
            searchTag: "Recherche par tag",
            searchCategory: "Recherche par cat\xe9gorie",
            loading: "Chargement\u2026",
            perPage: function(n) {
                return "".concat(n, " par page");
            }
        },
        en: {
            tagline: "Modern Jewish cuisine.",
            searchPlaceholder: "Recipe, ingredient, description, tag, cuisine\u2026",
            filters: "Filters",
            tags: "Tags",
            categories: "Categories",
            searchTag: "Search by tag",
            searchCategory: "Search by category",
            loading: "Loading\u2026",
            perPage: function(n) {
                return "".concat(n, " per page");
            }
        },
        he: {
            tagline: "\u05DE\u05D8\u05D1\u05D7 \u05D9\u05D4\u05D5\u05D3\u05D9 \u05E2\u05DB\u05E9\u05D5\u05D5\u05D9.",
            searchPlaceholder: "\u05DE\u05EA\u05DB\u05D5\u05DF, \u05E8\u05DB\u05D9\u05D1, \u05EA\u05D9\u05D0\u05D5\u05E8, \u05EA\u05D2, \u05DE\u05D8\u05D1\u05D7\u2026",
            filters: "\u05DE\u05E1\u05E0\u05E0\u05D9\u05DD",
            tags: "\u05EA\u05D2\u05D9\u05D5\u05EA",
            categories: "\u05E7\u05D8\u05D2\u05D5\u05E8\u05D9\u05D5\u05EA",
            searchTag: "\u05D7\u05D9\u05E4\u05D5\u05E9 \u05DC\u05E4\u05D9 \u05EA\u05D2",
            searchCategory: "\u05D7\u05D9\u05E4\u05D5\u05E9 \u05DC\u05E4\u05D9 \u05E7\u05D8\u05D2\u05D5\u05E8\u05D9\u05D4",
            loading: "\u05D8\u05D5\u05E2\u05DF\u2026",
            perPage: function(n) {
                return "".concat(n, " \u05DC\u05E2\u05DE\u05D5\u05D3");
            }
        }
    };
    return translations[lang];
}
// Support both ?sortBy=PITAETCHOCOLAT_EN and legacy ?lang=en
var $cb2c1e9ca868bb31$var$legacyIndex = $cb2c1e9ca868bb31$var$getLegacyLanguageParam();
if ($cb2c1e9ca868bb31$var$legacyIndex && !window.location.search.includes("sortBy")) {
    // Redirect from ?lang=X to ?sortBy=PITAETCHOCOLAT_X
    var $cb2c1e9ca868bb31$var$newUrl = new URL(window.location.href);
    $cb2c1e9ca868bb31$var$newUrl.searchParams.delete("lang");
    $cb2c1e9ca868bb31$var$newUrl.searchParams.set("sortBy", $cb2c1e9ca868bb31$var$legacyIndex);
    window.history.replaceState({}, "", $cb2c1e9ca868bb31$var$newUrl.toString());
}
var $cb2c1e9ca868bb31$var$currentLang = $cb2c1e9ca868bb31$var$getLanguageFromURL();
var $cb2c1e9ca868bb31$var$indexName = $cb2c1e9ca868bb31$var$getIndexName($cb2c1e9ca868bb31$var$currentLang);
var $cb2c1e9ca868bb31$var$routing = (0, $52dac82273078f42$export$2e2bcd8739ae039)($cb2c1e9ca868bb31$var$indexName);
var $cb2c1e9ca868bb31$var$t = $cb2c1e9ca868bb31$var$getTranslations($cb2c1e9ca868bb31$var$currentLang);
function $cb2c1e9ca868bb31$export$86fbec116b87613f() {
    var containerRef = (0, $4rNTR.useRef)(null);
    var headerRef = (0, $4rNTR.useRef)(null);
    function openFilters() {
        document.body.classList.add("filtering");
        window.scrollTo(0, 0);
        window.addEventListener("keyup", onKeyUp);
        window.addEventListener("click", onClick);
    }
    function closeFilters() {
        document.body.classList.remove("filtering");
        containerRef.current.scrollIntoView();
        window.removeEventListener("keyup", onKeyUp);
        window.removeEventListener("click", onClick);
    }
    function onKeyUp(event) {
        if (event.key !== "Escape") return;
        closeFilters();
    }
    function onClick(event) {
        if (event.target !== headerRef.current) return;
        closeFilters();
    }
    return /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("div", {
        dir: $cb2c1e9ca868bb31$var$currentLang === "he" ? "rtl" : "ltr",
        children: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)((0, $e029f0879523ffed$export$ad8f235d2c2c71c0), {
            searchClient: $cb2c1e9ca868bb31$var$searchClient,
            indexName: $cb2c1e9ca868bb31$var$indexName,
            routing: $cb2c1e9ca868bb31$var$routing,
            insights: true,
            children: [
                /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)("header", {
                    className: "header",
                    ref: headerRef,
                    children: [
                        /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("p", {
                            className: "header-logo",
                            children: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("a", {
                                href: "https://pitaetchocolat.com/",
                                children: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("img", {
                                    src: "https://pitaetchocolat.com/images/pita-et-chocolat-logo-white.png",
                                    alt: "logo pita & chocolat",
                                    width: 450
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("p", {
                            className: "header-title",
                            children: $cb2c1e9ca868bb31$var$t.tagline
                        }),
                        /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)((0, $af9fe37648bf2f63$export$5a58787633b0b5d8), {
                            placeholder: $cb2c1e9ca868bb31$var$t.searchPlaceholder,
                            submitIconComponent: $cb2c1e9ca868bb31$var$SubmitIcon,
                            queryHook: $cb2c1e9ca868bb31$var$queryHook,
                            loadingIconComponent: function() {
                                return $cb2c1e9ca868bb31$var$t.loading;
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)((0, $641ab7cdaedadbf8$export$de5f40ff1ff419d2), {
                    attributesToSnippet: [
                        "description:10"
                    ],
                    snippetEllipsisText: "\u2026",
                    removeWordsIfNoResults: "allOptional"
                }),
                /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)((0, $328737e057074e6f$export$30318940d8eafabd), {
                    children: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)("main", {
                        className: "container",
                        ref: containerRef,
                        children: [
                            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)("div", {
                                className: "container-wrapper",
                                children: [
                                    /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)("section", {
                                        className: "container-filters",
                                        onKeyUp: onKeyUp,
                                        children: [
                                            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)("div", {
                                                className: "container-header",
                                                children: [
                                                    /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("h2", {
                                                        children: $cb2c1e9ca868bb31$var$t.filters
                                                    }),
                                                    /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("div", {
                                                        className: "clear-filters",
                                                        "data-layout": "desktop",
                                                        children: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)((0, $c47a1e9543c3e082$export$974caec19ec0f86c), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("div", {
                                                        className: "clear-filters",
                                                        "data-layout": "mobile",
                                                        children: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)((0, $9264e8b12d7cb030$export$ee2d71e3fbd004ff), {})
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)("div", {
                                                className: "container-body",
                                                children: [
                                                    false,
                                                    /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)((0, $311406894213ed69$export$2ddb90ad54e5f587), {
                                                        header: $cb2c1e9ca868bb31$var$t.tags,
                                                        children: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)((0, $c72f67aaa3609706$export$40832886fec19653), {
                                                            attribute: "tags",
                                                            operator: "and",
                                                            showMore: true,
                                                            searchable: true,
                                                            searchablePlaceholder: $cb2c1e9ca868bb31$var$t.searchTag,
                                                            translations: {
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)((0, $311406894213ed69$export$2ddb90ad54e5f587), {
                                                        header: $cb2c1e9ca868bb31$var$t.categories,
                                                        children: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)((0, $c72f67aaa3609706$export$40832886fec19653), {
                                                            attribute: "categories",
                                                            operator: "or",
                                                            searchable: true,
                                                            searchablePlaceholder: $cb2c1e9ca868bb31$var$t.searchCategory
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)("footer", {
                                        className: "container-filters-footer",
                                        "data-layout": "mobile",
                                        children: [
                                            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("div", {
                                                className: "container-filters-footer-button-wrapper",
                                                children: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)((0, $77f0d2bebc1a7390$export$9c81ee90e4f7ab4e), {
                                                    containerRef: containerRef
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("div", {
                                                className: "container-filters-footer-button-wrapper",
                                                children: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)((0, $736bce90f26fcb35$export$b5314781ab50943a), {
                                                    onClick: closeFilters
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)("section", {
                                className: "container-results",
                                children: [
                                    /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)("header", {
                                        className: "container-header container-options",
                                        children: [
                                            false,
                                            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)((0, $681ad9c5be6e319a$export$1c363d4fc6896e21), {
                                                className: "container-option",
                                                items: [
                                                    {
                                                        label: $cb2c1e9ca868bb31$var$t.perPage(20),
                                                        value: 20,
                                                        default: true
                                                    },
                                                    {
                                                        label: $cb2c1e9ca868bb31$var$t.perPage(40),
                                                        value: 40
                                                    },
                                                    {
                                                        label: $cb2c1e9ca868bb31$var$t.perPage(60),
                                                        value: 60
                                                    }
                                                ],
                                                defaultValue: 20
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)((0, $dd61b68f240b4a45$export$2a19844878d7a6e0), {
                                        fallback: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)((0, $8d9653c9122e926d$export$ef6006467f04ee41), {}),
                                        children: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)((0, $c677a420a7e56b00$export$9abb8533010f1d93), {
                                            hitComponent: $cb2c1e9ca868bb31$var$Hit
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("footer", {
                                        className: "container-footer",
                                        children: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)((0, $93090f15413781f6$export$68f5e1453c188a82), {
                                            padding: 2,
                                            showFirst: false,
                                            showLast: false
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("aside", {
                    "data-layout": "mobile",
                    children: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)("button", {
                        className: "filters-button",
                        "data-action": "open-overlay",
                        onClick: openFilters,
                        children: [
                            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 16 14",
                                children: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("path", {
                                    d: "M15 1H1l5.6 6.3v4.37L9.4 13V7.3z",
                                    stroke: "#fff",
                                    strokeWidth: "1.29",
                                    fill: "none",
                                    fillRule: "evenodd",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            }),
                            $cb2c1e9ca868bb31$var$t.filters
                        ]
                    })
                })
            ]
        })
    });
}
function $cb2c1e9ca868bb31$var$SubmitIcon() {
    return /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 18 18",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.67",
            transform: "translate(1 1)",
            children: [
                /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("circle", {
                    cx: "7.11",
                    cy: "7.11",
                    r: "7.11"
                }),
                /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("path", {
                    d: "M16 16l-3.87-3.87"
                })
            ]
        })
    });
}
function $cb2c1e9ca868bb31$var$Hit(param) {
    var hit = param.hit;
    return /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)("article", {
        className: "hit",
        children: [
            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("header", {
                className: "hit-image-container",
                children: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("a", {
                    href: hit.permalink,
                    children: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("img", {
                        src: "https://pitaetchocolat.com/" + hit.images[0],
                        alt: hit.title,
                        className: "hit-image"
                    })
                })
            }),
            /*#__PURE__*/ (0, $775bae712b15f178$exports.jsxs)("div", {
                className: "hit-info-container",
                children: [
                    /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("p", {
                        className: "hit-category",
                        children: hit.categories[0]
                    }),
                    /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("h1", {
                        children: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("a", {
                            href: hit.permalink,
                            children: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)((0, $163a166b485c55d7$export$39dbc3f558091353), {
                                attribute: "title",
                                highlightedTagName: "mark",
                                hit: hit
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)("p", {
                        className: "hit-description",
                        children: /*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)((0, $649b7b0791a1bb9a$export$10c56fa12fda26f9), {
                            attribute: "description",
                            highlightedTagName: "mark",
                            hit: hit
                        })
                    }),
                    false
                ]
            })
        ]
    });
}


(0, $2c1f774f71163576$export$882461b6382ed46c)(document.getElementById("root")).render(/*#__PURE__*/ (0, $775bae712b15f178$exports.jsx)((0, $cb2c1e9ca868bb31$export$86fbec116b87613f), {}));

})();
//# sourceMappingURL=index.27fab19f.js.map
